/* SINH TỰ ĐỘNG bởi scripts/build-js-bundles.js — ĐỪNG SỬA TAY.
   Sửa file nguồn trong assets/ rồi chạy lại script. */

/* ===== aef-fsb.js ===== */
/* Thanh free-ship — phần JS, tách khỏi snippets/free-shipping-bar.liquid (M3).
   Trước đây khối này là <script> INLINE trong snippet, mà snippet được render
   3 lần ở /cart và 2 lần ở mọi trang khác ⇒ bản thứ hai/ba tải về rồi chết ngay
   ở `if (window.__aeFsbBound) return;`. Nay nó đi vào assets/aef-app.js (một
   lần, cuối body, defer); danh sách nguồn ở scripts/build-js-bundles.js.
   Nội dung chép nguyên văn — chỉ đổi CHỖ NẠP, không đổi một dòng hành vi.
   (Câu trên đúng ở lượt tách 15/9. Từ 27/9 khối phí ship ĐÃ đổi hành vi — xem
   "HỎI PHÍ SHIP BẰNG GIỎ PHỤ" bên dưới.) */
(function () {
  if (window.__aeFsbBound) return;
  window.__aeFsbBound = true;

  /* 23/10/2026 (GG1) — tiền đi qua MỘT hàm window.aefTien (layout/theme.liquid, <head>);
     dự phòng cũng có dấu phẩy. Người gác: scripts/test-tien-mot-dinh-dang.js */
  function money(cents) {
    if (cents == null) return '';
    if (typeof window.aefTien === 'function') return window.aefTien(cents);
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* i18n (P2 2026-06-08): the FSB strings + zone label/sub were hardcoded EN,
     so VI shoppers saw "Add $X to cart for free shipping" / "You've unlocked
     FREE shipping!" untranslated. Route every user-facing string through the
     ae_lang dict (window.aefT, defined in ae-delivery-widget.js — read-only, no
     DOM writes → single-source preserved). EN fallback if aefT/key missing.
     Fixing it here fixes BOTH the cart drawer and the /cart page (same snippet). */
  function t(key, fallback) {
    if (window.aefT) { var v = window.aefT(key); if (v && v !== key) return v; }
    return fallback;
  }
  /* zone-detection.js emits English label/sub literals; ae-delivery-widget.js
     owns the literal→dict-key maps (window.aefZoneLabelKey/aefZoneSubKey, kept
     next to the I18N dict so label+translation stay a one-file change —
     review 2026-06-10). Widget absent → no key → EN literal, same graceful
     degradation as t(). */
  function localizeLabel(label) {
    var k = window.aefZoneLabelKey && window.aefZoneLabelKey[label];
    return k ? t(k, label) : label;
  }
  function localizeSub(sub) {
    if (!sub) return '';
    var k = window.aefZoneSubKey && window.aefZoneSubKey[sub];
    return k ? t(k, sub) : sub;
  }
  /* String.replace with a function arg → the replacement is inserted literally,
     so a '$' in the money string can't trigger $&/$` substitution patterns. */
  function fill(tpl, token, value) {
    return tpl.replace(token, function () { return value; });
  }

  /* BUG-A (2026-05-29): /cart rendered MULTIPLE instances of this bar — mini-cart
     popup, cart drawer, page body — and back then they all carried id
     "aeFreeShipBar". getElementById returned only the first (popup), leaving the
     body instance stuck on its initial "Calculating shipping…" loading state.
     All element lookups go through querySelectorAll('.free-shipping-bar') and
     loop, so every instance on the page hydrates from the same zone+cart data.
     The class is uniquely-named so broadening the selector is safe.

     2026-08-14: the id was removed entirely (see the comment above the markup),
     so there is no longer any way to reach for getElementById here. Measured on
     staging: /cart renders 3 bars, home/collection/PDP render 2. */
  function allBars() {
    return document.querySelectorAll('.free-shipping-bar');
  }

  /* ══════════════════════════════════════════════════════════════════════════
     PHÍ GIAO THẬT — 2026-08-16 (Phase 4 "thanh ngưỡng thông minh" + Phase 5
     "minh bạch phí ship sớm").

     VÌ SAO
       ~52% đơn nằm ở vùng ngưỡng $79 với giỏ $36–56 (project_channel_reality).
       Với những khách đó, "Mua thêm $43 để được miễn phí giao" không phải một
       lời mời — nó là một con số họ sẽ không với tới, và nó GIẤU MẤT thứ họ
       thật sự cần biết: giao thật ra tốn bao nhiêu. 48% bỏ giỏ vì phí ship
       bất ngờ ở checkout.

     LẤY SỐ Ở ĐÂU
       Từ 27/9/2026 (vòng 53, L1): một GIỎ PHỤ của Storefront API — xem khối
       "HỎI PHÍ SHIP BẰNG GIỎ PHỤ" ngay dưới. Cùng bảng giá Shopify dùng ở
       checkout (đối chiếu LIVE 12/12 giỏ — 6 ZIP × 2 mức tạm tính — khớp tên + giá
       với /cart/shipping_rates.json, người gác ③), nhưng KHÔNG đụng giỏ của khách. Số ngày giao
       Storefront không trả ⇒ lấy từ metafield shop custom.delivery_days (cron máy
       chủ đo mỗi ngày trên giỏ riêng — xem ganNgay).
       Trước đó (16/8 → 27/9) là `/cart/shipping_rates.json` trên CHÍNH giỏ
       cookie của khách — một lượt GHI, đã làm mất món (xem khối dưới).

     LUẬT HIỂN THỊ
       · còn thiếu ÍT (khoảng cách ≤ 40% giá trị giỏ) → giữ nguyên cách cũ,
         thúc nhẹ "mua thêm $X" — với khách TX thiếu $2.50 đây là đòn bẩy dễ
         nhất toàn site.
       · còn thiếu NHIỀU (> 40%) → THÔI DÍ. Nói thẳng phí giao thật + ngưỡng.
         Đây đúng chỗ kế hoạch ghi "không dí bar khi khoảng cách quá xa".
       · vùng KHÔNG có ngưỡng (AK/HI/PR) → thay câu "tính khi thanh toán"
         bằng con số thật.
       Không lấy được giá thì im lặng lùi về cách cũ — không bao giờ hiện một
       con số đoán.
     ══════════════════════════════════════════════════════════════════════════ */

  /* ══════════════════════════════════════════════════════════════════════════
     "GIAO TẬN NƠI" LÀ LỜI HỨA VỀ CÁCH GIAO — CHỈ SHOPIFY TRẢ LỜI ĐƯỢC.
     25/9/2026, vòng 53 [ship-thresholds#5].

     Vùng 'dfw' của zone-detection.js là dải SỐ ZIP 75001–76299 — một vùng TIỀN
     (ngưỡng $59, y hệt tx_local). Nhưng nhãn của nó, "FREE local delivery" /
     "MIỄN PHÍ giao tận nơi", là lời hứa về CÁCH GIAO. Vùng Local Delivery thật
     nằm trong Admin (lúc đo 25/9: ~50 dặm quanh nơi cũ ở Kennedale; chính sách
     28/9: 30 dặm quanh Arlington, TX), còn dải số kia trùm cả Đông
     Texas. Đo LIVE 25/9, mỗi ZIP một giỏ mới, giỏ $58.61:
         76060 · 76017 · 75201 · 76201 · 75069 → Local Delivery $5.99 + Standard $6.99
         75701 Tyler · 75901 Lufkin · 75501 Texarkana · 75110 → CHỈ Standard $6.99
     mà thanh này vẫn hô "Add $0.39 to cart for free local delivery".

     Theme KHÔNG đọc được danh sách ZIP / bán kính trong Admin (token Admin cũng
     không có quyền deliveryProfiles), và chép bán kính sang đây là đẻ thêm một
     nguồn thứ hai. Nguồn đúng duy nhất thì đã nằm sẵn trong tay: danh sách rate
     mà fetchRate() hỏi — trước nay chỉ giữ giá rẻ nhất rồi vứt tên đi.

     LUẬT: nhãn nào nói "local delivery" chỉ được in khi Shopify ĐÃ chào Local
     Delivery cho đúng ZIP đó. Chưa biết (giỏ rỗng, đang hỏi, hỏi hỏng) ⇒ nhãn
     trung tính "FREE shipping" — luôn đúng, vì dfw và tx_local cùng ngưỡng.
     KHÔNG đụng ngưỡng, KHÔNG đụng số tiền.
     28/9/2026 (vòng 53, đợt 4) — MỘT NGUỒN. Trước đó nhãn "giao tận nơi" cần HAI thứ cùng
     nói có: bảng vùng (dfw tự nhận "FREE local delivery · Same-day" cho cả dải 75001–76299)
     VÀ Shopify. Bảng vùng nay trung tính; nhãn chỉ còn đến từ câu trả lời của Shopify cho
     đúng ZIP — cùng chữ ký giỏ phụ của dòng phí (không hỏi thêm lượt nào). Shopify chào
     Local cho một ZIP ngoài dải dfw (Admin nới bán kính) thì thanh cũng nói theo.

     CHỈ NHỚ CHIỀU "CÓ", theo ZIP (không theo tổng giỏ), giữ trong phiên. Shopify
     hay rớt dòng Local Delivery: giỏ ≥$59 lúc có lúc không, và hỏi nhiều ZIP trên
     CÙNG một giỏ thì các lượt sau mất hẳn — kể cả ZIP cách kho 3 dặm. Một lần
     thấy là đủ; một lần không thấy KHÔNG xoá. sessionStorage chỉ để khỏi nhảy
     chữ mỗi lần sang trang; bị khoá thì vẫn chạy bằng bộ nhớ trong trang.
     Người gác: scripts/test-nhan-giao-tan-noi-theo-shopify.js
     ══════════════════════════════════════════════════════════════════════════ */
  var LA_GIAO_TAN_NOI = /local\s*delivery/i;
  var NHAN_TRUNG_TINH = 'FREE shipping';
  /* Chữ EN của nhãn giao tận nơi; aefZoneLabelKey (ae-delivery-widget.js) đổi nó sang khoá fsb.label_local. */
  var NHAN_GIAO_TAN_NOI = 'FREE local delivery';
  var GTN_KHO = 'aef_ld_zip_v1';
  var zipCoGiaoTanNoi = {};  // "STATE|ZIP" → true, chỉ khi Shopify đã chào Local Delivery
  try {
    var gtnDaNho = JSON.parse(window.sessionStorage.getItem(GTN_KHO) || '{}');
    if (gtnDaNho && typeof gtnDaNho === 'object' && !Array.isArray(gtnDaNho)) zipCoGiaoTanNoi = gtnDaNho;
  } catch (e) {}
  function khoaZip(z) { return ((z && z.state) || '') + '|' + ((z && z.postal) || ''); }
  function laRateGiaoTanNoi(r) {
    return !!r && (LA_GIAO_TAN_NOI.test(String(r.name || ''))
      || LA_GIAO_TAN_NOI.test(String(r.presentment_name || ''))
      || LA_GIAO_TAN_NOI.test(String(r.code || '')));
  }
  function ghiNhanGiaoTanNoi(zoneInfo) {
    var k = khoaZip(zoneInfo);
    if (zipCoGiaoTanNoi[k] === true) return;
    zipCoGiaoTanNoi[k] = true;
    try { window.sessionStorage.setItem(GTN_KHO, JSON.stringify(zipCoGiaoTanNoi)); } catch (e) {}
  }
  function nhanTheoShopify(zoneInfo) {
    if (zoneInfo && zoneInfo.postal && zipCoGiaoTanNoi[khoaZip(zoneInfo)] === true) return NHAN_GIAO_TAN_NOI;
    var nhan = (zoneInfo && zoneInfo.label) || NHAN_TRUNG_TINH;
    /* Nhãn vùng nào còn tự nhận "local delivery" mà Shopify chưa xác nhận ⇒ trung tính. */
    return LA_GIAO_TAN_NOI.test(nhan) ? NHAN_TRUNG_TINH : nhan;
  }

  /* ══════════════════════════════════════════════════════════════════════════
     "MẤY NGÀY THÌ TỚI" — MỘT KHÁI NIỆM, HAI NGUỒN.  5/9/2026, vòng 42.

     Trên CÙNG một trang, CÙNG một ZIP, khách đọc được hai con số ngày giao khác
     nhau, do hai bộ máy độc lập vẽ ra:

       thanh này (dòng rateLine bên dưới)   ← delivery_days của Shopify, tức bảng
                                              giá THẬT dùng ở checkout
       viên thuốc trên header               ← TIER_DEFS trong
         [data-aef-dw-promise]                assets/ae-delivery-widget.js:1371,
                                              một bảng tự tính bằng khoảng cách

     Dựng lại được, ZIP 90001, khách không gõ gì (pill tự lấy ZIP từ cache
     ae_zone_v1):
         delivery_days=[5,8] → PILL "📦 3-5 day delivery"  ·  GIỎ "~8 days"
         delivery_days=[3,5] → PILL "📦 3-5 day delivery"  ·  GIỎ "~5 days"
         delivery_days=[7]   → PILL "📦 3-5 day delivery"  ·  GIỎ "~7 days"
     Đổi ĐÚNG MỘT biến thì số ở giỏ nhảy, pill ĐỨNG YÊN ⇒ pill mù hoàn toàn
     trước lời của hãng vận chuyển. Từ tier3 trở đi Shopify mới là bản gốc;
     TIER_DEFS chỉ đáng tin cho tier1/tier2 (xe của tiệm).

     ⚠️ BẢN VÁ NÀY MỚI ĐI ĐƯỢC MỘT NỬA, và nửa còn lại KHÔNG nằm trong file này.
     Chỗ vẽ pill là assets/ae-delivery-widget.js:1580-1583 (nhánh tier4/tier5 của
     buildPromise) — ngoài phạm vi sửa của lượt 5/9. Ở đây làm phần làm được:
     PHƠI RA con số có thẩm quyền, kèm sự kiện, để bên kia chỉ còn phải đọc chứ
     không phải tự đi lấy lần thứ hai (đi lấy lần hai là đẻ ra nguồn thứ ba).

     Việc còn lại, nguyên văn: trong buildPromise, hai nhánh tier4/tier5 ưu tiên
     window.AEF_RATE_DAYS khi nó có và `postal` của nó trùng ZIP đang tính —
     dùng min/max của nó thay cho transitMin/transitMax — và nghe
     `aef:rate-days` để vẽ lại. Không có nó thì rơi về TIER_DEFS như cũ.

     27/9/2026 (vòng 53, L1): con số có thẩm quyền nay đến từ metafield shop
     custom.delivery_days (scripts/sync-delivery-days.js, cron mỗi ngày) thay cho
     delivery_days của /cart/shipping_rates.json — xem ganNgay(). Cầu nối
     AEF_RATE_DAYS + aef:rate-days giữ nguyên hình dạng.

     🔴 9/10/2026 (vòng 53, đợt 3 — người thử trình duyệt thật) — MẤT SỐ NGÀY THÌ
     PHƠI "KHÔNG CÓ SỐ", ĐỪNG IM.
     Bản 27/9 thoát sớm khi best.days == null ⇒ không phơi gì ⇒ viên header, dòng
     PDP và dòng "Deliver to" của ngăn giỏ rơi về TIER_DEFS — bảng KHOẢNG CÁCH, hứa
     NHANH HƠN Shopify. Đo STAGING 9/10 (metafield cũ 11,4 ngày, giỏ có món):
         80202 Denver  "📦 2-day delivery · Wed 14/10"   ← Shopify/LIVE 5-8 ngày
         20001 · 90001 · 90012  "📦 3-5 day delivery"     ← 5-8
         98101 Seattle "📦 5-7 day delivery"             ← 5-8
     20/36 ô. LIVE không có trạng thái "cũ" (đọc thẳng shipping_rates khi giỏ có
     món). Và chốt chặn "bất thường" của chính cron (tam_dung) cũng đi đúng đường đó.
     Nay: giỏ có món, đã có giá rẻ nhất (best) cho ZIP mà KHÔNG có số ngày dùng được
     ⇒ phơi gói { khongSo: true, min: null, max: null, lyDo } cho đúng ZIP đó, bắn
     aef:rate-days như thường; ae-delivery-widget.js (tier3/4/5) nói câu KHÔNG SỐ
     copy.overseas thay cho TIER_DEFS. lyDo chỉ để soi (window.AEF_RATE_DAYS):
     'thieu' · 'cu' · 'tam_dung' · 'khong_trung_ten' · 'theo_hang' · 'so_vo_ly' —
     do ngayTheoBang() trả cùng lượt tra, không phán lần thứ hai.
     Không có best (giỏ rỗng, giỏ phụ chưa trả lời / rỗng / hỏng / lệch) ⇒ vẫn KHÔNG
     phơi gì — (từ 10/10/2026, làn giao-hang) viên đọc số theo BANG qua window.aefSoNgayTheoBang
     (ngayKhiChuaCoGia ở dưới), không còn rơi về TIER_DEFS.
     Người gác: scripts/test-vien-giao-hang-mat-so-ngay-khong-hua-nhanh.js (chuỗi
     metafield → thanh → viên → PDP → ngăn giỏ) · scripts/test-so-ngay-giao-mot-nguon.js.
     ══════════════════════════════════════════════════════════════════════════ */
  function congBoNgay(zoneInfo, best) {
    if (!best) return;
    var postal = (zoneInfo && zoneInfo.postal) || null;
    /* 🔴 9/10/2026 (vòng 53, dot3b — K2) — CÂU TRẢ LỜI CỦA ZIP CŨ VỀ MUỘN KHÔNG ĐƯỢC ĐÈ GÓI.
       Câu hỏi giỏ phụ của ZIP A còn bay thì khách đổi sang B; B về trước (phơi gói B), A về SAU ⇒
       bản trước phơi gói A ⇒ viên / PDP / ngăn giỏ của B thấy postal A ≠ B ⇒ rơi về TIER_DEFS.
       Người soi df5da3c dựng lại (jsdom): 90001 đang "📦 Delivery date at checkout" thì lúc câu trả
       lời của 80202 về (1,7 s) thành "📦 3-5 day delivery" — kẹt tới khi tải lại. Từ khi có nhánh
       phơi lại của traPhi (K1) lượt veLaiSauGia() ngay sau đó kéo gói B về, nhưng vẫn LẬT gói hai
       lần (A rồi B): viên xin vẽ TIER_DEFS rồi xin vẽ lại, hai sự kiện aef:rate-days thừa.
       ZIP của câu trả lời không còn là ZIP đang tính (window.AE_ZONE) ⇒ KHÔNG phơi. Kết quả vẫn
       nằm trong rateCache + đệm phiên (hoiPhi ghi TRƯỚC khi gọi tới đây) nên khách quay về A thì
       nhánh trúng rateCache của traPhi phơi đúng gói của A. Chưa có AE_ZONE ⇒ phơi như cũ.
       Người gác: ca (d) của scripts/test-vien-giao-hang-mat-so-ngay-khong-hua-nhanh.js. */
    var vungDangTinh = window.AE_ZONE;
    if (postal && vungDangTinh && vungDangTinh.postal && String(vungDangTinh.postal) !== String(postal)) return;
    var state = (zoneInfo && zoneInfo.state) || null;
    /* 16/10/2026 (vòng 53, làn giao-hang) — `local`: phương thức rẻ nhất là Local Delivery (xe nhà).
       Viên giao hàng bỏ qua gói đó cho ZIP ngoài vòng xe nhà (đọc số Standard theo bang) — nếu không,
       dải biên 26–30 dặm lật "3-5 day" (giỏ rỗng) → câu không số (có món, Local rẻ nhất). Thêm trường,
       hình dạng cũ giữ nguyên. */
    var goi = best.days != null ? {
      min: (best.daysMin == null ? best.days : best.daysMin),
      max: best.days,
      local: !!best.local,
      postal: postal,
      state: state,
      nguon: 'metafield shop custom.delivery_days'
    } : {
      min: null,
      max: null,
      khongSo: true,
      lyDo: best.lyDoKhongSo || null,
      local: !!best.local,
      postal: postal,
      state: state,
      nguon: 'metafield shop custom.delivery_days'
    };
    window.AEF_RATE_DAYS = goi;
    try { document.dispatchEvent(new CustomEvent('aef:rate-days', { detail: goi })); } catch (e) {}
  }
  /* Gói đang phơi (window.AEF_RATE_DAYS) có phải của ZIP z không — cùng phép so ae-delivery-widget.js
     ngayTheoHangVanChuyen() dùng để nhận gói (String(postal)). Đọc window chứ không nhớ biến riêng:
     thứ viên header thấy là window.AEF_RATE_DAYS, congBoNgay là nơi ghi duy nhất. */
  function goiCuaZip(z) {
    var g = window.AEF_RATE_DAYS;
    return !!g && String(g.postal || '') === String((z && z.postal) || '');
  }

  /* ══════════════════════════════════════════════════════════════════════════
     HỎI PHÍ SHIP BẰNG GIỎ PHỤ — KHÔNG BAO GIỜ GHI VÀO GIỎ CỦA KHÁCH.
     27/9/2026, vòng 53 [L1]. Số đo: D:/AI-Works/wt53/_stg/ket-qua-wf-0b32bd5e.json
     (result.l1.goc). Người gác: scripts/test-hoi-phi-ship-khong-ghi-gio.js (①)
     và scripts/test-phi-ship-gio-phu-khop-shipping-rates.js (③, LIVE).

     VÌ SAO
       Trước hôm nay khối này hỏi GET /cart/shipping_rates.json. Đó là một lượt
       GHI lên giỏ cookie (phản hồi mang Set-Cookie cart 94/94, xếp nối với
       add.js như mọi lượt ghi). Máy chủ Shopify đôi khi chạy SONG SONG hai lượt
       ghi của cùng một giỏ, và lượt về sau đè bằng ảnh chụp cũ: 14/18 cặp song
       song mất món. Theme tự bắn lượt ghi ấy 2–17 ms sau mỗi add ⇒ trên LIVE,
       món vừa thêm biến khỏi giỏ 1/14 lượt bấm thật dù add.js trả 200.
       Còn một cái giá nữa: shipping_rates GẮN địa chỉ ước tính lên giỏ, rồi
       total_price của change.js/update.js phồng thêm phí ship (BUG-H — xem
       scripts/test-cart-total-basis.js).

     CÁCH MỚI
       Mỗi câu hỏi là một cartCreate của Storefront API (tokenless, cùng nguồn,
       credentials:'omit' ⇒ không cookie, không phiên) trên một giỏ PHỤ có id
       riêng, mang đúng các dòng của bản chụp /cart.js. Không có đường nào để
       câu hỏi đó chạm vào giỏ của khách. Hình dạng phản hồi — tài liệu Shopify:
         shopify.dev/docs/api/storefront/2026-07/objects/CartDeliveryGroup
         shopify.dev/docs/api/storefront/2026-07/objects/CartDeliveryOption
         shopify.dev/docs/api/storefront/2026-07/enums/DeliveryMethodType
         shopify.dev/docs/storefronts/headless/building-with-the-storefront-api/defer
       Giá tính theo hãng vận chuyển (AK/HI/PR — USPS) chỉ về trong một mảnh
       @defer (withCarrierRates) ⇒ hỏi thêm đúng một lượt khi giá tĩnh rỗng.
       GIỚI HẠN (nói thẳng): vùng CÓ giá tĩnh thì KHÔNG hỏi giá hãng. Đường AJAX
       cũ gộp cả hai rồi lấy rẻ nhất; nếu một vùng vừa có giá tĩnh vừa có giá hãng
       RẺ HƠN, thanh sẽ in giá không phải rẻ nhất. Đo 28/9: không vùng nào có cả
       hai (HI chỉ USPS, còn lại chỉ giá tĩnh). Đổi hồ sơ giao hàng trong Admin ⇒
       chạy lại scripts/test-phi-ship-gio-phu-khop-shipping-rates.js (đỏ "giỏ phụ
       THIẾU" khi AJAX có giá hãng mà giỏ phụ không).

     BỐN CHỐT, mỗi chốt có đột biến riêng trong người gác ①
       (1) Chỉ hỏi về giỏ MÁY CHỦ: bản chụp /cart.js (hoặc thân giỏ máy chủ đi kèm
           cart:updated ở detail.anhGio — nhanAnhSuKien) phải có đúng tổng + số món
           đang vẽ. Tổng lạc quan (cart:updated trước khi máy chủ xác nhận) thì
           chờ bản chụp — không bao giờ gắn giá của giỏ cũ vào tổng mới (lượt lạc quan
           CÓ KHAI thì giữ lần vẽ cuối trong lúc chờ — "LƯỢT LẠC QUAN CÓ KHAI").
       (2) Giá chỉ dùng khi tạm tính + số món của giỏ phụ KHỚP bản chụp. Lệch
           (giá B2B, quà $0 bị bỏ, …) ⇒ không in số nào.
       (3) Rỗng (không nhóm giao, nhóm không phương án, @defer trả rỗng) là
           "CHƯA CÓ SỐ", KHÔNG BAO GIỜ là $0 — HI 96813 lượt đầu trả rỗng 2/2.
       (4) Hỏng (HTTP lỗi, mất mạng, errors — đủ SF_LOI_TOI_DA lần) ⇒ thôi hỏi
           cả trang: chữ ký CHƯA đo nhận 'none' (không in số) — và KHÔNG lùi về
           shipping_rates.json. Cầu dao SF_TRAN_TRANG cũng chỉ chặn chữ ký MỚI:
           quá số đó thì chữ ký chưa đo nhận 'none', chữ ký ĐÃ đo vẫn 'done' và
           vẫn in. Trang đang prerender KHÔNG phải hỏng: 'pending' tới
           prerenderingchange rồi mới hỏi.

     NHỚ THEO CHỮ KÝ, TRẦN THEO NHỊP (28/9, hồi quy H1 của L1 trên STAGING)
       Chữ ký = khoaAnh(): bang + ZIP + các dòng cần ship + mã giảm + tạm tính.
       Chữ ký đã có câu trả lời thì dùng lại (rateCache trong trang, đệm phiên
       xuyên trang) — KHÔNG hỏi lại và KHÔNG tính vào trần nào, nên khách quay
       về một giỏ đã đo thì dòng phí hiện ngay.
       Bản đầu có trần CỨNG 20 câu một trang: câu thứ 21 trở đi trả 'none' mãi
       mãi ⇒ sau 10 vòng thêm-bớt trên cùng trang, thanh ở giỏ $36.97 rơi từ
       "Delivery to 76133: $5.99 · free at $59.00" về "Add $22.03…" và không
       bao giờ lên lại (LIVE không có trần). Nay trần chỉ chặn nhịp DỒN DẬP:
       tối đa SF_CUA_SO_TOI_DA câu MỚI trong mọi SF_CUA_SO_MS. Quá nhịp ⇒
       'pending' + hẹn MỘT lượt vẽ lại khi cửa sổ trống; lượt đó hỏi chữ ký
       ĐANG hiện, chữ ký trung gian đã trôi qua thì bỏ. Chưa đo được thì im
       (không in số của chữ ký khác, không bao giờ $0). SF_TRAN_TRANG chỉ là
       cầu dao chống vòng lặp máy (mỗi chữ ký hỏi tối đa một lần mỗi trang, nên
       số câu = số giỏ KHÁC NHAU khách tạo ra). Người gác: kịch bản T của
       scripts/test-hoi-phi-ship-khong-ghi-gio.js.

     MỘT NGUỒN: window.aefPhiShip. sections/aef-gap-closer.liquid hỏi qua đây,
     nên trên trang chủ thanh free-ship và khối đóng khe chia MỘT câu hỏi cho
     mỗi bản chụp giỏ. Luật tiền (items_subtotal_price, lùi total_price) sống
     đúng ở tongGio() — gap-closer đưa JSON /cart.js vào đó chứ không tự tính.
     ══════════════════════════════════════════════════════════════════════════ */
  var SF_PHIEN_BAN = '2026-07';
  var SF_API = '/api/' + SF_PHIEN_BAN + '/graphql.json';
  var SF_CUA_SO_MS = 10000;
  var SF_CUA_SO_TOI_DA = 8;
  var SF_TRAN_TRANG = 120;
  var SF_LOI_TOI_DA = 2;
  var SF_KHO = 'aef_phi_ship_v1';
  var SF_HAN_KHO_MS = 30 * 60 * 1000;
  var SF_KHO_TOI_DA = 40;
  var sfDaHoi = 0;         // mọi lượt Storefront (cartCreate + mảnh @defer)
  var sfSoTao = 0;         // cartCreate = số chữ ký khác nhau đã hỏi trong trang
  var sfLanTao = [];       // mốc các cartCreate còn trong cửa sổ trượt
  var henCuaSo = null;
  var sfHong = false;
  /* Bộ đếm CHỈ ĐỌC — để đo tỉ lệ thanh im trên staging, không điều khiển gì. */
  var sfDem = { cauHoi: 0, loi: 0, khongKhop: 0, rong: 0, trungKho: 0, choAnh: 0, prerender: 0, choCuaSo: 0, anhSuKien: 0 };
  var anhGio = null;       // bản chụp giỏ MÁY CHỦ mới nhất (/cart.js, hoặc khoá anhGio đi kèm cart:updated)
  var soDocGui = 0, soDocNhan = 0;
  var mocAnh = 0;         // GIO-CU: soDocNhan do bản chụp đi kèm sự kiện gần nhất đặt (nhanAnhSuKien)
  var henDoc = null, lanHenDoc = -Infinity;
  /* ĐỒNG HỒ ĐƠN ĐIỆU cho hai hẹn giờ của lượt hỏi phí: cửa sổ trượt (choCuaSo) và
     hẹn đọc /cart.js (henDocGio). Date.now theo giờ MÁY — đổi giờ tay hay đồng bộ
     giờ lùi D ms thì mốc cũ nằm ở "tương lai": cửa sổ không trôi, hẹn đọc chờ thêm
     D, và mọi chữ ký mới kẹt 'pending' suốt D (thanh không dòng phí, khối đóng khe
     đứng 'loading'). performance.now không lùi. Đệm phiên (layKho/ghiKho) VẪN dùng
     Date.now: nó sống xuyên trang, còn performance.now đếm lại từ 0 ở mỗi trang.
     lanHenDoc khởi đầu -Infinity (không phải 0) để lượt hẹn đầu vẫn chờ 150 ms như
     cũ — performance.now của trang mới nạp còn nhỏ, 0 sẽ thành "vừa đọc xong".
     Người gác: kịch bản DH + đột biến M16 của scripts/test-hoi-phi-ship-khong-ghi-gio.js. */
  var coDongHoDonDieu = !!(window.performance && typeof window.performance.now === 'function');
  function dongHo() { return coDongHoDonDieu ? window.performance.now() : Date.now(); }
  var rateCache = {};      // khoá bản chụp → {price, name, local, days, daysMin} | null
  var rateInFlight = {};

  function tongGio(cart) {
    if (!cart || typeof cart !== 'object') return null;
    var v = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price;
    return typeof v === 'number' && isFinite(v) ? v : null;
  }
  function dongGioPhu(cart) {
    var ra = [];
    ((cart && cart.items) || []).forEach(function (it) {
      /* Dòng $0 (quà theo ngưỡng) bỏ ra: giỏ phụ không có luật tặng nên sẽ định
         giá nó bằng giá thật ⇒ lệch tạm tính ⇒ không in được gì. */
      if (!it || !it.variant_id || !(it.quantity > 0) || !(it.final_line_price > 0)) return;
      var l = { merchandiseId: 'gid://shopify/ProductVariant/' + it.variant_id, quantity: it.quantity };
      var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.id;
      if (sp) l.sellingPlanId = 'gid://shopify/SellingPlan/' + sp;
      ra.push(l);
    });
    return ra;
  }
  function maGiam(cart) {
    return ((cart && cart.discount_codes) || []).filter(function (d) { return d && d.code && d.applicable !== false; })
      .map(function (d) { return String(d.code); });
  }
  function khoaAnh(z, cart) {
    var ky = dongGioPhu(cart).map(function (l) {
      return l.merchandiseId.split('/').pop() + 'x' + l.quantity + (l.sellingPlanId ? 's' + l.sellingPlanId.split('/').pop() : '');
    }).sort().join(',');
    return (z.state || '') + '|' + (z.postal || '') + '|' + ky + '|' + maGiam(cart).join(',') + '|' + tongGio(cart);
  }
  /* CHỐT (1): bản chụp nào được phép đại diện cho tổng đang vẽ. */
  function timAnh(total, count, cartJson) {
    if (cartJson && tongGio(cartJson) === total && cartJson.item_count === count) return cartJson;
    if (anhGio && tongGio(anhGio) === total && anhGio.item_count === count) return anhGio;
    return null;
  }
  /* 🔴 28/9/2026 (vòng 53, đợt 3) — HẸN ĐỌC BÙ LÚC MỘT LƯỢT ĐỌC ĐANG BAY.
     Soi STAGING, 🖥, giỏ có món + đã biết ZIP: 4/4 lượt tải trang ra 2 GET /cart.js. Liquid
     in sẵn số món lên thanh ⇒ hỏi phí lúc nạp ⇒ chưa có bản chụp ⇒ hẹn 150 ms ⇒ refresh()
     đang bay (ăn chung lượt đọc đầu trang) thì ae-zone-ready bắn LẦN HAI ⇒ lại "thiếu ảnh"
     ⇒ hẹn thêm một lượt ~1 s sau lượt trước ⇒ nổ sau pha dựng trang của perf-instant.js ⇒
     ra mạng — dù lượt đang bay về đã đủ cho mọi người hỏi.
     Vá: GHI LẠI ai phải hẹn (canAnh: tổng + số món), hẹn Y NHƯ CŨ, và chỉ BỎ hẹn khi một lượt
     đọc về THÀNH CÔNG mà bản chụp đó đủ cho TẤT CẢ (boHenNeuDu). Lượt bay hỏng / treo / về
     thiếu ⇒ hẹn vẫn nổ đúng như trước — không đổi bảo đảm "thiếu ảnh thì ~1 s sau có lượt
     đọc" lấy một lời hứa rằng lượt đang bay sẽ về.
     Người gác: ⑫ (tải trang, rớt trên e7b55b1) và ⑫b (lượt bay đứt mạng, đừng khoá hẹn) của
     scripts/test-mot-cu-bam-mot-luot-hoi-gio.js. */
  var canAnh = {};
  function henDocGio(total, count) {
    canAnh[total + '|' + count] = [total, count];
    if (henDoc) return;
    var cho = Math.max(150, lanHenDoc + 1000 - dongHo());
    henDoc = setTimeout(function () { henDoc = null; lanHenDoc = dongHo(); refresh(); }, cho);
  }
  function boHenNeuDu() {
    if (!henDoc) return;
    for (var k in canAnh) {
      if (Object.prototype.hasOwnProperty.call(canAnh, k) && !timAnh(canAnh[k][0], canAnh[k][1], null)) return;
    }
    clearTimeout(henDoc);
    henDoc = null;
    canAnh = {};
  }
  function dangPrerender() {
    try { return document.prerendering === true; } catch (e) { return false; }
  }
  /* Còn phải chờ bao nhiêu ms thì được hỏi một chữ ký MỚI (0 = hỏi được ngay). */
  function choCuaSo() {
    var n = dongHo();
    while (sfLanTao.length && n - sfLanTao[0] >= SF_CUA_SO_MS) sfLanTao.shift();
    return sfLanTao.length < SF_CUA_SO_TOI_DA ? 0 : Math.max(1, sfLanTao[0] + SF_CUA_SO_MS - n);
  }
  /* Một hẹn duy nhất: khi cửa sổ trống thì vẽ lại — thanh và khối đóng khe tự hỏi
     chữ ký CỦA LÚC ĐÓ (veLaiSauGia dùng đúng bộ số đang treo, aef:phi-ship đánh
     thức khối đóng khe). Không nhớ chữ ký nào để hỏi bù: chữ ký đã trôi qua thì thôi. */
  function henHoiLai(ms) {
    if (henCuaSo) return;
    henCuaSo = setTimeout(function () { henCuaSo = null; veLaiSauGia(); }, ms + 50);
  }

  /* Đệm xuyên trang (sessionStorage): khớp TUYỆT ĐỐI khoá bản chụp, hạn 30 phút.
     Không suy gì từ mẫu khác — trùng khoá mới dùng. Bị khoá thì chạy như không có. */
  var khoPhi = null;
  function docKho() {
    if (khoPhi) return khoPhi;
    khoPhi = {};
    try {
      var o = JSON.parse(window.sessionStorage.getItem(SF_KHO) || '{}');
      if (o && typeof o === 'object' && !Array.isArray(o)) khoPhi = o;
    } catch (e) {}
    return khoPhi;
  }
  function layKho(k) {
    var o = docKho()[k];
    var tuoi = o && typeof o.t === 'number' ? Date.now() - o.t : -1;
    if (!o || tuoi < 0 || tuoi > SF_HAN_KHO_MS) return undefined;
    if (o.r === null) return null;
    if (!o.r || typeof o.r.price !== 'number' || !isFinite(o.r.price)) return undefined;
    return o.r;
  }
  function ghiKho(k, r) {
    var kho = docKho();
    kho[k] = { t: Date.now(), r: r ? { price: r.price, name: r.name, local: !!r.local } : null };
    var ds = Object.keys(kho).filter(function (x) {
      var o = kho[x];
      var tuoi = o && typeof o.t === 'number' ? Date.now() - o.t : -1;
      if (tuoi < 0 || tuoi > SF_HAN_KHO_MS) { delete kho[x]; return false; }
      return true;
    }).sort(function (a, b) { return kho[b].t - kho[a].t; });
    ds.slice(SF_KHO_TOI_DA).forEach(function (x) { delete kho[x]; });
    try { window.sessionStorage.setItem(SF_KHO, JSON.stringify(kho)); } catch (e) {}
  }

  /* SỐ NGÀY GIAO — metafield shop custom.delivery_days, do scripts/sync-delivery-days.js
     (cron .github/workflows/sync-delivery-days.yml) đo mỗi ngày trên giỏ RIÊNG của cron,
     layout/theme.liquid in ra <script type="application/json" id="aef-ngay-giao">.
     Chỉ dùng phương thức giá TĨNH (nguon 'shopify'): số ngày của nó là cấu hình của
     vùng giao, đúng cho mọi ZIP trong bang. Giá theo hãng (USPS) đổi theo từng ZIP và
     từng ngày ⇒ không in. Thiếu metafield, cũ quá 3 ngày, tạm dừng, không có phương
     thức trùng tên ⇒ KHÔNG in số ngày — và (9/10/2026) congBoNgay phơi gói KHÔNG SỐ
     để viên header nói câu không số thay cho TIER_DEFS; giỏ rỗng đọc số theo bang (ngayKhiChuaCoGia).
     MỘT nguồn cho câu hỏi "có số ngày dùng được không": docBangNgay() + ngayTheoBang().
     Đối số thứ ba `vi` (tuỳ chọn) chỉ để nhận LÝ DO khi trả null — cùng một lượt tra,
     kết quả trả về không đổi. */
  var NGAY_HAN_MS = 3 * 24 * 60 * 60 * 1000;
  var bangNgay;
  var lyDoBangNgay = 'thieu';   // vì sao docBangNgay() trả null: 'thieu' · 'cu' · 'tam_dung' (null khi dùng được)
  function docBangNgay() {
    if (bangNgay !== undefined) return bangNgay;
    bangNgay = null;
    lyDoBangNgay = 'thieu';
    try {
      var el = document.getElementById('aef-ngay-giao');
      var o = el ? JSON.parse(el.textContent || 'null') : null;
      var t = o ? Date.parse(o.updated_at) : NaN;
      var tuoi = Date.now() - t;
      var coBang = !!(o && o.bang && typeof o.bang === 'object');
      var conHan = isFinite(tuoi) && tuoi >= -3600000 && tuoi <= NGAY_HAN_MS;
      /* tam_dung: cron vừa chặn một lượt đo "bất thường" (vd đổi thời gian giao trong
         Admin) — số trong bang là số CŨ giữ lại để so, KHÔNG được in. */
      if (coBang && !o.tam_dung && conHan) bangNgay = o;
      lyDoBangNgay = !coBang ? 'thieu' : (o.tam_dung ? 'tam_dung' : (conHan ? null : 'cu'));
    } catch (e) { bangNgay = null; lyDoBangNgay = 'thieu'; }
    return bangNgay;
  }
  function ngayTheoBang(state, ten, vi) {
    var o = docBangNgay();
    var khong = function (ly) { if (vi) vi.lyDo = ly; return null; };
    if (!o) return khong(lyDoBangNgay);
    var b = state ? o.bang[String(state)] : null;
    if (!b || !Array.isArray(b.phuong_thuc)) return khong('thieu');
    if (!ten) return khong('khong_trung_ten');
    var ly = 'khong_trung_ten';
    for (var i = 0; i < b.phuong_thuc.length; i++) {
      var p = b.phuong_thuc[i];
      if (!p || p.ten !== ten) continue;
      /* Trùng tên mà giá theo hãng (USPS…): số ngày đổi theo từng ZIP/ngày ⇒ không in. */
      if (p.nguon !== 'shopify') { if (ly === 'khong_trung_ten') ly = 'theo_hang'; continue; }
      var mn = Math.round(Number(p.min)), mx = Math.round(Number(p.max));
      if (isFinite(mn) && isFinite(mx) && mn >= 1 && mx >= mn && mx <= 30) return { min: mn, max: mx };
      ly = 'so_vo_ly';
    }
    return khong(ly);
  }
  function ganNgay(z, r) {
    if (!r) return null;
    var vi = {};
    var n = ngayTheoBang(z && z.state, r.name, vi);
    return { price: r.price, name: r.name, local: !!r.local, days: n ? n.max : null, daysMin: n ? n.min : null,
      lyDoKhongSo: n ? null : (vi.lyDo || null) };
  }
  /* 10/10/2026 (vòng 53, làn giao-hang) — SỐ NGÀY KHI CHƯA CÓ GIÁ (giỏ rỗng, giỏ phụ chưa trả lời).
     Bản trước: không có gói ⇒ viên giao hàng rơi về TIER_DEFS — bảng KHOẢNG CÁCH, hứa nhanh hơn
     Shopify ("2-day" khi checkout nói 3–5; "Next-day" cho Houston khi checkout nói 3–5). Không có tên
     phương thức rẻ nhất (chưa có giá) ⇒ lấy MỌI phương thức giá tĩnh (nguon 'shopify') của bang:
     cùng một cặp số ⇒ cặp đó; khác nhau ⇒ KHÔNG số ('nhieu_phuong_thuc' — không đoán khách chọn
     cái nào). Luật "số dùng được" (cũ · tạm dừng · 1 ≤ min ≤ max ≤ 30) vẫn là ngayTheoBang() ở trên,
     không phán lần thứ hai. Trả { min, max, ten } hoặc { khongSo: true, lyDo }. Chỉ đọc. */
  function ngayKhiChuaCoGia(state) {
    var o = docBangNgay();
    if (!o) return { khongSo: true, lyDo: lyDoBangNgay };
    var b = state ? o.bang[String(state)] : null;
    if (!b || !Array.isArray(b.phuong_thuc)) return { khongSo: true, lyDo: 'thieu' };
    var ra = null, ly = 'khong_trung_ten';
    for (var i = 0; i < b.phuong_thuc.length; i++) {
      var p = b.phuong_thuc[i];
      if (!p || !p.ten) continue;
      var vi = {};
      var n = ngayTheoBang(state, p.ten, vi);
      if (!n) { if (vi.lyDo === 'theo_hang') { if (ly === 'khong_trung_ten') ly = 'theo_hang'; } else ly = vi.lyDo || ly; continue; }
      if (ra && (ra.min !== n.min || ra.max !== n.max)) return { khongSo: true, lyDo: 'nhieu_phuong_thuc' };
      if (!ra) ra = { min: n.min, max: n.max, ten: p.ten };
    }
    return ra || { khongSo: true, lyDo: ly };
  }
  window.aefSoNgayTheoBang = function (state) { return ngayKhiChuaCoGia(state); };


  /* CHỈ phương án GIAO mới là phí giao. Enum DeliveryMethodType (Storefront 2026-07):
     LOCAL · NONE · PICK_UP · PICKUP_POINT · RETAIL · SHIPPING. Nhận tại kho / điểm
     nhận ($0) KHÔNG phải "giao miễn phí" — đường AJAX cũ không bao giờ trả chúng, nên
     bật Local Pickup trong Admin mà không lọc là thanh hô "đã mở khoá" ở giỏ $20.
     Người gác: kịch bản N + đột biến M5 của scripts/test-hoi-phi-ship-khong-ghi-gio.js. */
  var LOAI_GIAO = ['SHIPPING', 'LOCAL'];
  /* CHỐT (3): rẻ nhất trong TỪNG nhóm giao rồi cộng. Rỗng ở bất kỳ tầng nào ⇒ null. */
  function giaTuNhom(nodes) {
    if (!nodes || !nodes.length) return null;
    var tong = 0, ten = [], coLocal = false;
    for (var i = 0; i < nodes.length; i++) {
      var best = null;
      ((nodes[i] && nodes[i].deliveryOptions) || []).forEach(function (o) {
        if (!o || LOAI_GIAO.indexOf(o.deliveryMethodType) < 0) return;
        if (o.deliveryMethodType === 'LOCAL' || LA_GIAO_TAN_NOI.test(String(o.title || '')) || LA_GIAO_TAN_NOI.test(String(o.code || ''))) coLocal = true;
        var cents = Math.round(parseFloat(o.estimatedCost && o.estimatedCost.amount) * 100);
        if (!isFinite(cents) || cents < 0) return;
        if (!best || cents < best.price) best = { price: cents, name: o.title || '' };
      });
      if (!best) return null;
      tong += best.price;
      ten.push(best.name);
    }
    return { price: tong, name: ten.join(' + '), local: coLocal };
  }
  /* JSON thường, hoặc multipart/mixed của @defer — trả mảng các khối JSON. */
  function tachKhoi(txt) {
    var s = String(txt || '').trim();
    var ra = [];
    if (s.charAt(0) === '{') { try { ra.push(JSON.parse(s)); } catch (e) {} return ra; }
    s.split(/--graphql/).forEach(function (p) {
      var i = p.indexOf('{'), k = p.lastIndexOf('}');
      if (i < 0 || k < i) return;
      try { ra.push(JSON.parse(p.slice(i, k + 1))); } catch (e) {}
    });
    return ra;
  }
  function goiSf(query, variables, hoan) {
    sfDem.cauHoi++;
    return fetch(SF_API, {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json',
        'Accept': hoan ? 'multipart/mixed; deferSpec=20220824, application/json' : 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) {
      if (!r.ok) throw new Error('storefront ' + r.status);
      return r.text();
    }).then(tachKhoi);
  }
  var Q_TAO = 'mutation aefPhiShip($input: CartInput!) { cartCreate(input: $input) { cart { id totalQuantity cost { subtotalAmount { amount } } deliveryGroups(first: 10) { nodes { deliveryOptions { title code deliveryMethodType estimatedCost { amount } } } } } userErrors { field message } } }';
  var Q_HANG = 'query aefPhiShipHang($id: ID!) { cart(id: $id) { id ...AefHang @defer } } fragment AefHang on Cart { deliveryGroups(first: 10, withCarrierRates: true) { nodes { deliveryOptions { title code deliveryMethodType estimatedCost { amount } } } } }';
  function hoiGioPhu(z, cart) {
    var lines = dongGioPhu(cart);
    var input = { lines: lines, delivery: { addresses: [{ address: { deliveryAddress: {
      countryCode: 'US', provinceCode: String(z.state), zip: String(z.postal) } }, selected: true, oneTimeUse: true }] } };
    var ma = maGiam(cart);
    if (ma.length) input.discountCodes = ma;
    return goiSf(Q_TAO, { input: input }, false).then(function (khoi) {
      var c = null;
      khoi.forEach(function (j) { if (j && j.data && j.data.cartCreate && j.data.cartCreate.cart) c = j.data.cartCreate.cart; });
      if (!c) throw new Error('storefront: không có giỏ phụ');
      /* CHỐT (2) */
      var sub = Math.round(parseFloat(c.cost && c.cost.subtotalAmount && c.cost.subtotalAmount.amount) * 100);
      var soMon = lines.reduce(function (s, l) { return s + l.quantity; }, 0);
      if (sub !== tongGio(cart) || c.totalQuantity !== soMon) return { loai: 'khong-khop' };
      var g = giaTuNhom(c.deliveryGroups && c.deliveryGroups.nodes);
      if (g) return { loai: 'co', rate: g };
      /* Mảnh @defer: tối đa MỘT lượt cho mỗi cartCreate ⇒ trần của cartCreate
         cũng là trần của nó (≤ 2 lượt Storefront cho mỗi chữ ký). */
      if (sfHong || !c.id) return { loai: 'rong' };
      sfDaHoi++;
      return goiSf(Q_HANG, { id: c.id }, true).then(function (khoi2) {
        var nodes = null;
        khoi2.forEach(function (j) {
          if (j && j.data && j.data.cart && j.data.cart.deliveryGroups) nodes = j.data.cart.deliveryGroups.nodes;
          ((j && j.incremental) || []).forEach(function (x) { if (x && x.data && x.data.deliveryGroups) nodes = x.data.deliveryGroups.nodes; });
        });
        var g2 = giaTuNhom(nodes);
        return g2 ? { loai: 'co', rate: g2 } : { loai: 'rong' };
      });
    });
  }
  function veLaiSauGia() {
    /* Vẽ lại bằng ĐÚNG bộ số đang treo trên từng thanh — không tự đi lấy
       lại /cart.js, tránh đè lên trạng thái mới hơn (bài học BUG-U). */
    allBars().forEach(function (bar) {
      renderOne(bar, window.AE_ZONE, parseInt(bar.dataset.cartTotal || '0', 10), parseInt(bar.dataset.cartCount || '0', 10));
    });
    try { document.dispatchEvent(new CustomEvent('aef:phi-ship')); } catch (e) {}
  }
  /* Tra, KHÔNG gọi mạng — tác dụng phụ: nạp đệm phiên vào bộ nhớ trang (kèm công bố số ngày của mục
     vừa nạp), và phơi lại gói số ngày khi trúng rateCache mà gói đang phơi là của ZIP KHÁC (K1, dưới). */
  function traPhi(z, total, count, cartJson) {
    /* Vùng KHÔNG GIAO (zone-detection.js `giao: false`): checkout ra 0 cách giao ⇒ không
       có phí nào để hỏi. Không tốn lượt Storefront nào (thanh này lẫn khối đóng khe). */
    if (!z || z.giao === false || !z.state || !z.postal || !count) return { status: 'none' };
    var cart = timAnh(total, count, cartJson);
    if (!cart) return { status: 'pending', thieuAnh: true, giu: choGiuLacQuan(z, total, count) };
    var k = khoaAnh(z, cart);
    if (k in rateCache) {
      /* 🔴 9/10/2026 (vòng 53, dot3b — K1) — TRÚNG rateCache THÌ PHƠI LẠI GÓI CỦA ĐÚNG ZIP.
         congBoNgay() chỉ chạy lúc câu trả lời VỀ (giỏ phụ, đệm phiên). Khách đổi ZIP A → B → A trên
         CÙNG trang: lần về A trúng rateCache ⇒ không ai phơi lại ⇒ AEF_RATE_DAYS kẹt ở gói của B ⇒
         viên header (ngayTheoHangVanChuyen thấy postal B ≠ A), dòng PDP và dòng "Deliver to" của
         ngăn giỏ rơi về TIER_DEFS — bảng khoảng cách, hứa NHANH hơn Shopify — tới khi tải lại, trong
         khi thanh này cùng màn in "~8 days". Đo LIVE 9/10 (df5da3c): 80202 → 75701 → 80202 ⇒
         "📦 2-day delivery · Thu 15/10" (metafield 5-8) giữ ≥ 6 s; C5 VI 90001 "Giao 3-5 ngày" cạnh
         "khoảng 8 ngày" (gói kẹt ở 96813).
         Phơi lại CHỈ khi gói đang phơi không phải của ZIP đang hỏi (goiCuaZip) — cùng ZIP thì không
         phơi, không thêm sự kiện / lượt vẽ nào so với trước. rateCache[k] null (giỏ phụ rỗng / lệch /
         hỏng) ⇒ không có gì để phơi, viên đọc số theo bang như mọi ca "chưa có câu trả lời".
         GIỚI HẠN (nói thẳng): viên vẽ câu của ZIP mới TRƯỚC khi zone-detection phát ae-zone-ready
         (resolveZip của ae-delivery-widget.js vẽ rồi mới bắn aef:zone-changed) ⇒ lượt xin vẽ đầu vẫn
         là TIER_DEFS, lượt xin thứ hai (gói vừa phơi lại) tới ngay trong cùng tác vụ. render() ghi
         chữ sau 80 ms theo TỪNG lượt xin ⇒ chữ TIER_DEFS nằm trong DOM giữa hai hẹn giờ đó rồi bị
         đè (jsdom: hai lượt xin cách ~5 ms, chữ cũ nằm 1–17 ms). Bỏ hẳn khe đó phải đổi render()
         (hẹn giờ ghi trạng thái xin SAU CÙNG) — ngoài phạm vi bản vá này.
         Cùng ZIP mà khác giỏ (giỏ dưới/trên ngưỡng mang tên phương thức khác nhau) KHÔNG phơi lại —
         cấu hình kho 9/10 không có ca đó (mọi bang chỉ một tên "Standard Shipping").
         Người gác: ca (c) của scripts/test-vien-giao-hang-mat-so-ngay-khong-hua-nhanh.js. */
      if (rateCache[k] && !goiCuaZip(z)) congBoNgay(z, rateCache[k]);
      return { status: 'done', rate: rateCache[k] };
    }
    var tuKho = layKho(k);
    if (tuKho !== undefined) {
      sfDem.trungKho++;
      rateCache[k] = ganNgay(z, tuKho);
      if (tuKho && tuKho.local) ghiNhanGiaoTanNoi(z);
      congBoNgay(z, rateCache[k]);
      return { status: 'done', rate: rateCache[k] };
    }
    if (rateInFlight[k]) return { status: 'pending' };
    if (sfHong || sfSoTao >= SF_TRAN_TRANG) return { status: 'none' };
    if (dangPrerender()) return { status: 'pending', prerender: true };
    var cho = choCuaSo();
    if (cho > 0) return { status: 'pending', choCuaSo: cho };
    return { status: 'pending', canHoi: true, k: k, cart: cart };
  }
  function hoiPhi(z, total, count, cartJson) {
    var hp = traPhi(z, total, count, cartJson);
    if (hp.thieuAnh) { sfDem.choAnh++; henDocGio(total, count); }
    if (hp.prerender) sfDem.prerender++;
    if (hp.choCuaSo) { sfDem.choCuaSo++; henHoiLai(hp.choCuaSo); }
    if (hp.canHoi) {
      var k = hp.k;
      rateInFlight[k] = true;
      sfDaHoi++;
      sfSoTao++;
      sfLanTao.push(dongHo());
      hoiGioPhu(z, hp.cart).then(function (kq) {
        if (kq.loai === 'co') {
          if (kq.rate.local) ghiNhanGiaoTanNoi(z);
          rateCache[k] = ganNgay(z, kq.rate);
          ghiKho(k, kq.rate);
          congBoNgay(z, rateCache[k]);
        } else if (kq.loai === 'khong-khop') {
          sfDem.khongKhop++;
          rateCache[k] = null;
          ghiKho(k, null);
        } else {
          /* Rỗng: CHƯA CÓ SỐ. Nhớ trong trang để khỏi hỏi dồn; không ghi đệm phiên
             để trang sau còn được hỏi lại (lượt đầu của hãng vận chuyển hay rỗng). */
          sfDem.rong++;
          rateCache[k] = null;
        }
      }).catch(function () {
        sfDem.loi++;
        rateCache[k] = null;
        if (sfDem.loi >= SF_LOI_TOI_DA) sfHong = true;
      }).then(function () {
        delete rateInFlight[k];
        veLaiSauGia();
      });
    }
    return { status: hp.status, rate: hp.rate || null, giu: !!hp.giu };
  }
  function fetchRate(zoneInfo, totalCents, count) {
    if (!zoneInfo || !zoneInfo.state || !zoneInfo.postal || !count) return;
    hoiPhi(zoneInfo, totalCents, count, null);
  }
  function knownRate(zoneInfo, totalCents, count) {
    var hp = traPhi(zoneInfo, totalCents, count, null);
    return hp.status === 'done' ? (hp.rate || null) : null;
  }
  window.aefPhiShip = {
    phienBan: SF_PHIEN_BAN,
    tongGio: tongGio,
    hoi: function (z, total, count, cartJson) { return hoiPhi(z, total, count, cartJson); },
    dem: function () {
      var o = {}; for (var x in sfDem) o[x] = sfDem[x];
      o.daHoi = sfDaHoi; o.soTao = sfSoTao; o.hong = sfHong; o.tran = SF_TRAN_TRANG;
      o.cuaSo = SF_CUA_SO_TOI_DA + '/' + SF_CUA_SO_MS + 'ms';
      return o;
    }
  };
  if (dangPrerender()) {
    document.addEventListener('prerenderingchange', function () { veLaiSauGia(); }, { once: true });
  }

  function renderOne(bar, zoneInfo, totalCents, count) {
    if (!bar) return;
    const msgEl = bar.querySelector('[data-fsb-msg]');
    const fillEl = bar.querySelector('[data-fsb-fill]');
    if (!msgEl || !fillEl) return;

    const threshold = zoneInfo && zoneInfo.threshold;
    /* Nhãn "giao tận nơi" phải được Shopify xác nhận cho đúng ZIP — xem khối
       "GIAO TẬN NƠI LÀ LỜI HỨA VỀ CÁCH GIAO" phía trên. */
    const label = localizeLabel(nhanTheoShopify(zoneInfo));
    /* 28/9/2026 (vòng 53, đợt 4) — VÙNG KHÔNG GIAO. Cờ `giao: false` của zone-detection.js
       (USVI · Guam · Bắc Marianas · American Samoa · APO/FPO/DPO — checkout ra 0 cách
       giao). Trước đó các mã này nằm ở 'remote' ⇒ thanh hứa "Shipping calculated at
       checkout (USPS …)" cho một chuyến giao không tồn tại. Nói thẳng, không thanh tiến
       trình, không hỏi phí. Câu nằm ở từ điển ('zone.khong_giao'); chữ dự phòng dưới chỉ
       dùng khi từ điển chưa nạp — người gác scripts/test-vung-khong-giao-mot-nguon.js đòi nó
       TRÙNG bản EN của từ điển. */
    if (zoneInfo && zoneInfo.giao === false) {
      bar.dataset.state = 'khong-giao';
      msgEl.textContent = t('zone.khong_giao', "We don't ship to your area yet");
      fillEl.style.width = '0%';
      return;
    }
    /* sub ("Same-day delivery") intentionally NOT rendered in any state — see the
       progress + unlocked blocks below (ticket_cart_polish_round2 #1). localizeSub
       kept for the zone-key map; no message appends it anymore. */

    fetchRate(zoneInfo, totalCents, count);
    var rate = knownRate(zoneInfo, totalCents, count);
    /* Câu "Giao tới {zip}: $X" dùng lại ở hai trạng thái, gom về một chỗ để
       hai chỗ không bao giờ nói khác nhau. */
    function rateLine() {
      var s = fill(t('fsb.rate_to', 'Delivery to {zip}: {price}'), '{zip}', (zoneInfo && zoneInfo.postal) || '');
      s = fill(s, '{price}', '<strong>' + money(rate.price) + '</strong>');
      /* 16/10/2026 (làn giao-hang) — số ngày của Shopify là NGÀY LÀM VIỆC (viên giao hàng cùng ngăn giỏ đếm như vậy); bản
         trước in "· ~8 days" đọc như ngày lịch, sớm hơn "8 business days" của checkout. Chữ đơn vị trong khoá
         fsb.rate_days phải trùng 'ship.don_vi_ngay' (test-chu-chinh-sach-khop-so-ngay.js CA 1). */
      if (rate.days) s += ' ' + fill(t('fsb.rate_days', '· ~{n} business days'), '{n}', String(rate.days));
      return s;
    }

    /* MÁY CHỦ NÓI MIỄN PHÍ THÌ MIỄN PHÍ — bảng ngưỡng của mình chỉ là bản sao.
       Nếu Shopify trả phí $0 mà bảng ngưỡng vẫn bảo "mua thêm $X để được miễn
       phí", câu đó là NÓI DỐI, dù bảng có được cập nhật đúng hồi nào đi nữa.
       Nhánh này cũng là cái lưới bắt lệch giữa zone-detection.js và hồ sơ giao
       hàng thật trong Admin — thứ trước nay không có cách nào phát hiện. */
    if (count > 0 && rate && rate.price === 0) {
      bar.dataset.state = 'success';
      var fmsg = t('fsb.unlocked', "🎉 You've unlocked {label}!");
      msgEl.innerHTML = fill(fmsg, '{label}', '<span class="fsb-success">' + label + '</span>');
      fillEl.style.width = '100%';
      return;
    }

    /* Remote zone — no free shipping available */
    if (threshold == null) {
      bar.dataset.state = 'remote';
      /* Có giá thật thì nói giá thật. "Tính khi thanh toán" đúng nhưng vô dụng:
         khách phải đi tới cuối mới biết, và đó chính là 48% bỏ giỏ. */
      msgEl.innerHTML = rate ? rateLine() : t('fsb.remote', 'Shipping calculated at checkout (USPS rate)');
      fillEl.style.width = '0%';
      return;
    }

    /* "Add $X to cart for {label}" — the in-text label is lowercased (EN
       "free shipping"; toLowerCase on the VI "MIỄN PHÍ giao hàng" → "miễn phí
       giao hàng", which is the wording Boss approved for the progress state).
       The unlocked message keeps the canonical casing for celebratory emphasis.
       The sub "(Same-day delivery)" used to be appended here too — it overflowed
       the nowrap box → CSS ellipsis dangled "…" (round-1 fix #2 only patched the
       unlocked state; ticket_cart_polish_round2 #1 patches THIS state the same way). */
    if (count == 0 || totalCents < threshold) {
      const amount = (count == 0) ? threshold : (threshold - totalCents);
      /* KHOẢNG CÁCH QUÁ XA → THÔI DÍ, NÓI THẲNG PHÍ THẬT.
         Ngưỡng 40% giá trị giỏ: khách giỏ $45 ở vùng $79 còn thiếu $34 — dí
         thêm là bảo họ mua gần gấp đôi những gì họ định mua. Chỉ chuyển khi
         ĐÃ CÓ giá thật; chưa có thì giữ nguyên cách cũ chứ không để trống. */
      if (count > 0 && rate && amount > totalCents * 0.4) {
        bar.dataset.state = 'far';
        var far = rateLine() + ' ' + fill(t('fsb.rate_free_at', '· free at {amount}'), '{amount}', money(threshold));
        msgEl.innerHTML = far;
        fillEl.style.width = Math.max(2, Math.min(100, (totalCents / threshold) * 100)).toFixed(1) + '%';
        return;
      }
      bar.dataset.state = (count == 0) ? 'empty' : 'progress';
      let msg = t('fsb.add_progress', 'Add {amount} to cart for {label}');
      msg = fill(msg, '{amount}', '<strong>' + money(amount) + '</strong>');
      msg = fill(msg, '{label}', String(label).toLowerCase());
      msgEl.innerHTML = msg;
      fillEl.style.width = (count == 0) ? '0%'
        : Math.max(2, Math.min(100, (totalCents / threshold) * 100)).toFixed(1) + '%';
      return;
    }

    /* 🔴 18/8 — LƯỚI CHIỀU NGƯỢC LẠI, trước nay bỏ trống.
       Nhánh đầu file bắt được chiều "bảng của mình nói còn thiếu, máy chủ nói
       miễn phí". Chiều kia thì LỌT: giỏ đã vượt ngưỡng trong BẢNG của mình
       (zone-detection.js) mà hồ sơ giao hàng thật trong Admin vẫn tính phí —
       lúc đó thanh này hô "🎉 Đã mở khoá MIỄN PHÍ giao hàng!" và khách đi tới
       checkout mới thấy $10.99.

       Đó đúng là cú phí-ship-bất-ngờ mà cả khối này sinh ra để dập (48% bỏ
       giỏ). Và nó là chiều TỆ HƠN: chiều kia chỉ làm mình bán hụt, chiều này
       làm khách thấy mình nói dối ngay tại bước trả tiền.

       Bảng ngưỡng là BẢN SAO — hồ sơ giao hàng trong Admin mới là bản gốc. Có
       giá thật mà giá đó > 0 thì tin giá thật, và nói luôn con số đó ra.
       `rate` chỉ tồn tại khi giỏ phụ đã trả lời cho ĐÚNG bản chụp; chưa có thì
       giữ nguyên nhánh ăn mừng như cũ, chứ không im lặng. */
    if (rate && rate.price > 0) {
      bar.dataset.state = 'far';
      msgEl.innerHTML = rateLine();
      fillEl.style.width = '100%';
      return;
    }

    /* unlocked — celebratory single line. The sub ("Same-day delivery") is
       DROPPED here on purpose: appended, "🎉 You've unlocked FREE local
       delivery! Same-day delivery" overflowed the nowrap message box and the
       CSS text-overflow:ellipsis showed a dangling "…" (ticket_cart_lean_visual_deltas
       #2). The label alone matches the mockup and never truncates. */
    bar.dataset.state = 'success';
    let umsg = t('fsb.unlocked', '🎉 You\'ve unlocked {label}!');
    umsg = fill(umsg, '{label}', '<span class="fsb-success">' + label + '</span>');
    msgEl.innerHTML = umsg;
    fillEl.style.width = '100%';
  }

  function render(zoneInfo, totalCents, count) {
    allBars().forEach(function (bar) {
      renderOne(bar, zoneInfo, totalCents, count);
    });
  }

  /* 🔴 9/10/2026 (vòng 53, đợt 3 — người soi lượt 3) — LƯỢT ĐỌC HỎNG KHÔNG ĐƯỢC NUỐT CHỖ ĐANG CHỜ.
     refresh() xoá hẹn đọc bù (henDoc / canAnh) lúc BẮT ĐẦU, vì lượt đang đi sẽ lo cho mọi người đã
     hẹn. Lượt đó HỎNG thì không còn ai lo: GET /cart.js sau cú Add thẻ TREO quá trần giữ rồi HỎNG ⇒
     hẹn giờ đã nhả giữ, hẹn đọc bù của nhaGiu đi CHUNG chính lượt GET đang treo (lớp gộp đọc giỏ chia
     lượt đang bay, bay bao lâu cũng chia), lượt đó hỏng ⇒ thanh đứng mãi ở "Add $X…" của tổng lạc
     quan, khối ở khung chờ — 1720d99 (be7e68a hội tụ vì nhả giữ ĐÚNG lúc hỏng; LIVE đúng).
     Vá: lượt đọc hỏng ⇒ báo người giữ (khiHong) như cũ, rồi nếu thanh còn đang vẽ một tổng CHƯA có
     bản chụp thì hẹn đọc lại. Lỗi mạng / HTTP không-OK: lớp gộp đã vứt lượt hỏng nên lượt sau ra
     mạng thật. HTTP 200 mà thân KHÔNG phải giỏ: lớp gộp còn giữ phản hồi đó CUA_SO_TUOI_MS (300 ms)
     ⇒ lượt đọc lại đầu có thể ăn lại thân hỏng, lượt sau mới ra mạng (người soi lượt 3b đo: hội tụ
     ~1,25 s, 2 GET). Tối đa DOC_LAI_HONG_TOI_DA hẹn LIỀN NHAU do chính docHong đặt — hẹn đọc từ lượt
     vẽ của nhaGiu không tính ở đây, nên sau một lần hỏng có thể tới 3 lượt đọc — đếm lại từ 0 ở mỗi
     lượt đọc thành công và mỗi cart:updated: mạng chết hẳn thì thôi, đợi thao tác kế tiếp, không gõ
     /cart.js mỗi giây (đo: /cart.js chết 8 s ⇒ 4 GET rồi dừng).
     Người gác: bước "Y treo rồi hỏng" (H7) của scripts/test-noi-phat-gio-khong-chop-add.js. */
  var DOC_LAI_HONG_TOI_DA = 2;
  var soLanDocLaiHong = 0;
  function docHong(so, khiHong) {
    if (typeof khiHong === 'function') khiHong(so);
    if (soLanDocLaiHong >= DOC_LAI_HONG_TOI_DA || !window.AE_ZONE) return;
    var bar = allBars()[0];
    if (!bar) return;
    var tong = parseInt(bar.dataset.cartTotal || '0', 10), dem = parseInt(bar.dataset.cartCount || '0', 10);
    if (!dem || timAnh(tong, dem, null)) return;
    if (!henDoc) soLanDocLaiHong++;
    henDocGio(tong, dem);
  }

  /* khiHong (tuỳ chọn): gọi với số thứ tự lượt đọc khi lượt đó HỎNG (mạng / thân không phải
     giỏ) — người giữ lần vẽ cuối (nhaGiu) dùng nó để không treo thanh ở giỏ cũ. */
  function refresh(khiHong) {
    const bars = allBars();
    if (!bars.length || !window.AE_ZONE) return;
    /* Số thứ tự: một phản hồi /cart.js cũ về SAU phản hồi mới không được đè bản
       chụp mới (bản chụp là thứ câu hỏi phí ship tin — xem timAnh). */
    var so = ++soDocGui;
    /* Một lượt đọc đang đi thì hẹn đọc bù (henDocGio) thành thừa — nó lo cho mọi người
       đã hẹn tới giờ này; ai hẹn SAU lúc này thì boHenNeuDu xét khi lượt đọc về. */
    if (henDoc) { clearTimeout(henDoc); henDoc = null; }
    canAnh = {};
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        if (so < soDocNhan) {
          /* GIO-CU (10/10, người soi độc lập) — GET này bị bỏ vì bắt đầu TRƯỚC mốc của một bản chụp đi kèm
             sự kiện. Thường nó cũ hơn bản chụp — nhưng sự kiện có thể tới MUỘN mang bản chụp cũ (trên /cart:
             hàng ghi của bảng và hàng ghi chung ngăn giỏ/thẻ là hai hàng; chuỗi kéo sàn lúc tải trang). Thân
             nó KHÁC bản chụp đang giữ mà chưa có GET nào của thanh mở SAU mốc ⇒ đọc lại MỘT lần (lượt đó
             mở sau mốc nên được nhận) — thanh không đứng ở bản chụp cũ, như trước khi có mốc thanh tự sửa
             nhờ nhận GET đó. Giống bản chụp, hay đã có GET sau mốc ⇒ thôi (không thêm lượt GET nào). */
          if (so < mocAnh && soDocGui < mocAnh && cart && typeof cart.item_count === 'number' && anhGio
              && (tongGio(cart) !== tongGio(anhGio) || cart.item_count !== anhGio.item_count)) refresh();
          return;
        }
        if (!cart || typeof cart.item_count !== 'number') { docHong(so, khiHong); return; }
        soDocNhan = so;
        soLanDocLaiHong = 0;
        anhGio = cart;
        /* Giỏ máy chủ đã về cho lượt lạc quan đang giữ ⇒ thôi giữ: thanh vẽ ngay dưới đây,
           khối đóng khe được đánh thức bằng aef:phi-ship. */
        var hetGiu = !!giuLacQuan && so >= giuLacQuan.tuSo;
        if (hetGiu) boGiu();
        /* BUG-U (2026-05-21) — Keep dataset attrs in sync with server truth.
           Previously: user removes items in drawer → fetch hook triggers
           refresh → render(progress) but dataset.cartTotal stayed at the
           page-load value (e.g. 5000). Then ZIP switch → ae-zone-ready
           listener reads stale dataset.cartTotal=5000 → renders 'success'
           against the new threshold even though cart is now near-empty.
           Sync dataset after every server fetch so all subsequent zone
           renders see current cart state. */
        bars.forEach(function (bar) {
          /* Cùng cơ sở với chip và với ba nơi phát cart:updated — xem chú thích
             ở data-cart-total phía trên. Lệch cơ sở là thanh và chip cãi nhau
             về tiền ngay trên cùng một màn hình. */
          var coSo = tongGio(cart);
          bar.dataset.cartTotal = String(coSo);
          bar.dataset.cartCount = String(cart.item_count);
          renderOne(bar, window.AE_ZONE, coSo, cart.item_count);
        });
        boHenNeuDu();
        if (hetGiu || canDanhThucKhe) {
          canDanhThucKhe = false;
          try { document.dispatchEvent(new CustomEvent('aef:phi-ship')); } catch (e) {}
        }
      })
      .catch(() => { docHong(so, khiHong); });
  }

  /* Listen for zone resolution */
  document.addEventListener('ae-zone-ready', function (e) {
    allBars().forEach(function (bar) {
      const total = parseInt(bar.dataset.cartTotal || '0', 10);
      const count = parseInt(bar.dataset.cartCount || '0', 10);
      renderOne(bar, e.detail, total, count);
    });
  });

  /* Re-render in the new language on a runtime EN⇄VI switch (P2 2026-06-08).
     ae-delivery-widget.setLang() runs applyTranslations() first (which localizes
     the loading <span data-i18n="fsb.calculating">) then dispatches this. We only
     re-paint once a zone is resolved — before that the bar sits in its loading
     state, already handled by applyTranslations. Reads per-bar dataset like the
     ae-zone-ready path; still the sole writer of its own message (single-source). */
  /* 🔴 24/8/2026 — NGHE THÊM `aef:i18n-ready`, KHÔNG CHỈ `aef:lang-changed`.

     Khối này là script INLINE trong thân trang; `ae-delivery-widget.js` nạp
     bằng `defer` nên chạy SAU. Lần vẽ đầu tiên `window.aefT` chưa tồn tại ⇒
     `t()` rơi về chuỗi tiếng Anh dự phòng. Và `aef:lang-changed` chỉ bắn khi
     khách BẤM NÚT đổi ngôn ngữ, nên khách đã chọn tiếng Việt từ phiên trước
     thì không có gì gọi vẽ lại — chữ Anh nằm đó tới khi họ đụng vào nút.

     Đo được ở /cart và trong NGĂN GIỎ (tức trên mọi trang), `ae_lang='vi'`:
         "Add $74.02 to cart for free shipping"
     trong khi từ điển có sẵn "Mua thêm {amount} để được {label}".

     Vẫn giữ nguyên `single-source`: khối này vẫn là NGƯỜI DUY NHẤT ghi câu chữ
     của chính nó, chỉ là nay nó được đánh thức thêm một lần nữa. */
  function veLaiHet() {
    if (!window.AE_ZONE) return;
    allBars().forEach(function (bar) {
      const total = parseInt(bar.dataset.cartTotal || '0', 10);
      const count = parseInt(bar.dataset.cartCount || '0', 10);
      renderOne(bar, window.AE_ZONE, total, count);
    });
  }
  document.addEventListener('aef:lang-changed', veLaiHet);
  document.addEventListener('aef:i18n-ready', veLaiHet);

  /* 🔴 28/9/2026 (vòng 53, đợt 3 — người thử STAGING) — BẢN CHỤP ĐI KÈM SỰ KIỆN.
     Trang /cart đổi số lượng: cart.js cầm thân /cart/change.js (CẢ GIỎ máy chủ vừa
     ghi) rồi bắn cart:updated chỉ với {count,total}. Chốt (1) không thấy bản chụp khớp
     ⇒ 'pending' ⇒ thanh vẽ nhánh progress "Add $X…", 150–250 ms sau (lượt GET
     /cart.js) mới quay về "Delivery to 76133: $5.99 · free at $59.00" — kể cả khi chữ
     ký đó ĐÃ có giá trong rateCache. STAGING 🖥 42 lần chớp / 38 lần đổi, 📱 30; LIVE
     (nhớ theo tổng) 0.
     Nay bên phát cầm thân giỏ của MÁY CHỦ thì đính vào detail.anhGio; thanh nhận nó làm
     bản chụp CHỈ KHI nó khớp đúng count + total của chính sự kiện (cùng phép so của
     timAnh) — lệch thì bỏ, như chưa từng có, không đè bản chụp đang có. Chốt (1) giữ
     nguyên: vẫn chỉ tin giỏ máy chủ; tổng lạc quan không kèm bản chụp vẫn chờ /cart.js.
     ⛔ KHÔNG dùng detail.cart: khoá đó là gói /cart.js của ngăn giỏ (aef-cart-drawer.js
     lightUpdate vẽ cả total_price), mà thân change.js có total_price PHỒNG (BUG-H —
     mệnh đề GÓI GIỎ của scripts/test-cart-total-basis.js). Thanh này đọc tiền của bản
     chụp chỉ qua tongGio (items_subtotal_price).
     Đây là chỗ DUY NHẤT thanh đọc bản chụp đi kèm sự kiện, và detail.anhGio là khoá
     DUY NHẤT — mọi nơi phát đang cầm giỏ máy chủ đều đính nó (danh sách: người gác
     thứ hai dưới đây đọc từ nguồn, đừng chép vào đây).
     Người gác: scripts/test-trang-gio-khong-chop-add.js (/cart) ·
     scripts/test-noi-phat-gio-khong-chop-add.js (mọi nơi phát, đọc từ nguồn) */
  function nhanAnhSuKien(d) {
    var c = d && d.anhGio;
    if (!c || typeof c !== 'object' || !Array.isArray(c.items)) return;
    if (c.item_count !== d.count || tongGio(c) !== d.total) return;
    anhGio = c;
    sfDem.anhSuKien++;
    /* 🔴 10/10/2026 vòng 53 (GIO-CU, người soi lượt 3b) — BẢN CHỤP ĐI KÈM SỰ KIỆN MỚI HƠN MỌI LƯỢT ĐỌC
       ĐÃ ĐI TRƯỚC NÓ. Số thứ tự soDocGui/soDocNhan chỉ xếp các GET với nhau: một GET bắt đầu TRƯỚC sự
       kiện mà về SAU sự kiện (và trước GET mới) vẫn được nhận ⇒ thanh vẽ lùi về giỏ trước một nhịp
       (jsdom: GET sau cú Add treo tới lúc khách bấm "+" ở ngăn giỏ ⇒ "Add $6.83…" của giỏ $52.17 hiện
       lại sau khi thanh đã in $55.16). Bản chụp vừa nhận là giỏ MÁY CHỦ vừa ghi (thân change.js /
       /cart.js, đã khớp count + total ở trên) ⇒ mọi GET đang bay bắt đầu trước nó chỉ mang giỏ cũ hơn
       hoặc bằng ⇒ bỏ khi về. GET mở SAU vẫn nhận như cũ. Sự kiện KHÔNG kèm bản chụp (tổng lạc quan)
       giữ luật cũ — GET đó có thể là nguồn sự thật duy nhất. Đặt mốc NGAY ĐÂY (không ở người nghe):
       phía thanh free-ship chỉ được MỘT chỗ đọc khoá anhGio của sự kiện (S2 của test-noi-phat-gio-khong-chop-add.js,
       miễn riêng aef-qua-tang.js: module đó chỉ vẽ khung quà).
       Người gác: K1 của scripts/test-gio-luot-cu-khong-ve-de.js (đột biến M4). */
    soDocNhan = soDocGui + 1;
    mocAnh = soDocNhan;
  }
  /* 🔴 9/10/2026 (vòng 53, đợt 3 — người soi sau 6c546aa) — NHẬN BẢN CHỤP Ở PHA BẮT CỦA WINDOW.
     Thanh không phải người dùng duy nhất của window.aefPhiShip: khối đóng khe trang chủ
     (sections/aef-gap-closer.liquid) là script NỘI TUYẾN, đăng ký người nghe cart:updated trên
     document lúc trang còn đang phân tích — TRƯỚC bản gộp defer này. Cùng một lượt phát, người
     nghe của nó chạy trước ⇒ hỏi aefPhiShip.hoi khi bản chụp đi kèm CHƯA được nhận ⇒ 'pending'
     ⇒ khung chờ "Calculating shipping…" rồi mới về dòng phí, kể cả với sự kiện CÓ anhGio. Người
     soi đo STAGING (tiêm 6c546aa), trang chủ, ngăn giỏ mở, +/−: 🖥 10/10 lần (trung vị 155 ms,
     dài nhất 230 ms); LIVE 0.
     Pha bắt của window chạy trước MỌI người nghe trên document và trên phần tử, ai đăng ký
     trước cũng vậy ⇒ thứ tự nạp tệp thôi quyết định ai thấy bản chụp. Vẫn MỘT chỗ đọc
     (nhanAnhSuKien), MỘT khoá (anhGio); không cần AE_ZONE — bản chụp giỏ máy chủ đúng với mọi
     vùng. Người gác: H5 + S2 của scripts/test-noi-phat-gio-khong-chop-add.js. */
  /* 🔴 9/10/2026 (vòng 53, đợt 3 — người soi sau 6c546aa) — LƯỢT LẠC QUAN CÓ KHAI: GIỮ LẦN VẼ
     CUỐI TỚI KHI GIỎ MÁY CHỦ VỀ.
     Đường thêm hàng phổ biến nhất (nút Add thẻ/PDP → mini-cart-popup.js queueAdd) phát lượt chốt
     với count/total đọc lại từ huy hiệu + tổng header — số máy chủ CHƯA xác nhận, và không có giỏ
     nào để đính anhGio (/cart/add.js chỉ trả DÒNG hàng). Chốt (1) cấm gắn phí của giỏ cũ vào tổng
     đó ⇒ trước đây thanh vẽ "Add $X…", khối đóng khe vẽ khung chờ, rồi một vòng GET /cart.js sau
     mới quay về dòng phí — kể cả khi giỏ vừa thêm là giỏ ĐÃ biết phí. Người soi đo STAGING tiêm
     6c546aa: thanh 🖥 20 · 📱 20 lần chớp / 10 vòng gỡ ⇄ Add (110–170 ms); LIVE 0.
     Hai cách đã cân, chọn cách KHÔNG đụng đường thêm hàng:
       · đọc /cart.js trên hàng ghi rồi mới phát kèm anhGio ⇒ thẻ đổi sang ô tăng/giảm, toast,
         huy hiệu chậm thêm một vòng mạng (BUG-F — perf-instant.js đã ghi lý do không làm), và lớp
         gộp đọc giỏ xé lượt đọc chung ở cart:updated ⇒ 2 GET/cú Add (trần của phu3 là 1);
       · KHAI + GIỮ (cách này): queueAdd khai detail.lacQuan. Thanh đang in dòng phí ('far', hoặc
         'success' vì máy chủ nói miễn phí) mà tổng mới còn dưới ngưỡng thì KHÔNG vẽ và KHÔNG nhận
         tổng mới (dataset giữ nguyên ⇒ phí in ra và tổng của thanh luôn thuộc CÙNG một giỏ máy
         chủ), rồi đọc /cart.js NGAY — dùng chung lượt GET của mini-cart (lớp gộp đọc giỏ) — và vẽ
         khi giỏ máy chủ về. Khối đóng khe hỏi aefPhiShip.hoi ⇒ 'pending' kèm giu ⇒ cũng giữ.
     GIỚI HẠN (nói thẳng): trong lúc giữ — một vòng GET /cart.js, nối sau vòng add.js mà header
     đã hiện số lạc quan từ lúc bấm — thanh/khối hiện trạng thái của giỏ TRƯỚC. Phí dưới ngưỡng của
     cửa hàng là giá phẳng theo vùng nên dòng đó vẫn đúng tiền; vùng không ngưỡng (AK/HI/PR, USPS
     tính theo cân) KHÔNG giữ, vượt ngưỡng cũng KHÔNG giữ — vẽ như cũ. Chỉ sự kiện CÓ KHAI mới được
     giữ: nơi phát nào đang cầm giỏ máy chủ mà quên anhGio vẫn chớp, để người gác thấy.
     ĐƯỜNG HỎNG (9/10, người soi lượt 2 — bản đầu chỉ đọc khi có THANH bị giữ; khối đóng khe ở chế
     độ dí ⇔ thanh đang 'progress' nên không thanh nào giữ, không ai cầm đường hỏng, một lượt GET
     hỏng là khối đứng mãi ở khe của giỏ cũ "You're $8.02…" trong khi khe thật $6.83; LIVE in đúng):
       · phán quyết giữ (choGiu) có hiệu lực là ĐỌC NGAY, bất kể có thanh nào đang giữ hay không;
       · lượt đọc đó hỏng ⇒ nhaGiu: thôi giữ, thanh vẽ số lạc quan như cũ, khối đóng khe được đánh
         thức (về khung chờ — không còn số của giỏ cũ); lượt đọc thành công KẾ TIẾP (hẹn đọc bù của
         thanh) lại đánh thức khối, vì pullCart riêng của nó đã hỏng cùng lượt GET dùng chung;
       · giữ tối đa GIU_TOI_DA_MS: lượt GET treo, trang không có thanh — hẹn giờ vẫn nhả (một bảo
         đảm, không phải một lời hứa rằng lượt đọc sẽ về). Quá mức đó mới thấy lại kiểu cũ ("Add
         $X…" / khung chờ) — đúng hơn là giữ mãi khe của giỏ trước.
       · lượt đọc hỏng mà thanh còn thiếu bản chụp thì hẹn đọc lại (docHong) — kể cả khi hẹn giờ đã
         nhả giữ trước lúc hỏng.
     Người gác: kịch bản Y + lượt HỎNG (Y hỏng · Y treo · Y treo rồi hỏng, chế độ phí và chế độ dí)
     — H1 + H4 + H5 + H5b + H6 + H7 + H8 của scripts/test-noi-phat-gio-khong-chop-add.js. */
  var giuLacQuan = null;   // { total, count, tuSo } — lượt lạc quan có khai đang chờ giỏ máy chủ
  var GIU_TOI_DA_MS = 3000;  // trần cho lượt đọc TREO, không phải lượt đọc chậm (GET /cart.js trên STAGING ~150–600 ms)
  var henGiu = null;
  var canDanhThucKhe = false;  // đã nhả giữ vì đọc hỏng / quá hạn ⇒ lượt đọc thành công kế tiếp đánh thức khối đóng khe
  function choGiuLacQuan(z, total, count) {
    return !!giuLacQuan && giuLacQuan.total === total && giuLacQuan.count === count
      && !!z && z.threshold != null && count > 0 && total < z.threshold;
  }
  function boGiu() {
    giuLacQuan = null;
    if (henGiu) { clearTimeout(henGiu); henGiu = null; }
  }
  function nhaGiu(so) {
    var g = giuLacQuan;
    if (!g || so < g.tuSo) return;
    boGiu();
    canDanhThucKhe = true;
    if (window.AE_ZONE) {
      allBars().forEach(function (bar) {
        renderOne(bar, window.AE_ZONE, g.total, g.count);
        bar.dataset.cartTotal = g.total;
        bar.dataset.cartCount = g.count;
      });
    }
    try { document.dispatchEvent(new CustomEvent('aef:phi-ship')); } catch (e) {}
  }
  window.addEventListener('cart:updated', function (e) {
    nhanAnhSuKien(e.detail);
    var d = e.detail;
    boGiu();
    soLanDocLaiHong = 0;
    if (d && d.lacQuan === true && typeof d.total === 'number' && typeof d.count === 'number') {
      giuLacQuan = { total: d.total, count: d.count, tuSo: soDocGui + 1 };
      henGiu = setTimeout(function () { henGiu = null; nhaGiu(Infinity); }, GIU_TOI_DA_MS);
    }
  }, true);

  /* 1/11/2026 (fix-gio) — trang về từ bfcache: thanh đang vẽ giỏ lúc rời đi. Khối pageshow của card-stepper.js. */
  window.addEventListener('pageshow', function (e) { if (e && e.persisted) refresh(); });

  /* Listen for cart updates — supports optimistic detail payload */
  document.addEventListener('cart:updated', function (e) {
    if (!window.AE_ZONE) return;
    if (e.detail && typeof e.detail.total === 'number' && typeof e.detail.count === 'number') {
      var tong = e.detail.total, dem = e.detail.count;
      /* Lượt lạc quan có khai, chưa có bản chụp khớp: thanh đang in dòng phí thì giữ; có thanh nào
         giữ hay không cũng ĐỌC NGAY — khối đóng khe giữ theo cùng phán quyết (aefPhiShip.hoi → giu),
         và lượt đọc này là người duy nhất cầm đường hỏng (nhaGiu). */
      var choGiu = choGiuLacQuan(window.AE_ZONE, tong, dem) && !timAnh(tong, dem, null);
      /* Optimistic — render immediately, no fetch */
      allBars().forEach(function (bar) {
        var st = bar.dataset.state;
        if (choGiu && (st === 'far' || st === 'success')) return;
        renderOne(bar, window.AE_ZONE, tong, dem);
        bar.dataset.cartTotal = tong;
        bar.dataset.cartCount = dem;
      });
      if (choGiu) refresh(nhaGiu);
    } else {
      refresh();
    }
  });

  /* Fetch interception — catch all cart mutations */
  if (!window.__aeFsbFetchHooked) {
    window.__aeFsbFetchHooked = true;
    const origFetch = window.fetch;
    window.fetch = function () {
      const args = arguments;
      const url = (args[0] && args[0].url) || args[0] || '';
      const result = origFetch.apply(this, args);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        result.then(() => setTimeout(refresh, 80)).catch(() => {});
      }
      return result;
    };
  }

  /* Expose render globally so callers (cart-notification.js after drawer replace)
     can sync-render without the /cart.js round-trip that caused 0%→actual flash. */
  window.aeRenderBar = render;

  /* If zone already resolved by the time this script runs, render immediately */
  if (window.AE_ZONE) {
    allBars().forEach(function (bar) {
      const total = parseInt(bar.dataset.cartTotal || '0', 10);
      const count = parseInt(bar.dataset.cartCount || '0', 10);
      renderOne(bar, window.AE_ZONE, total, count);
    });
  }

  /* sections/aef-gap-closer.liquid là script NỘI TUYẾN, chạy TRƯỚC bản gộp defer
     này ⇒ nó chờ tín hiệu này để biết window.aefPhiShip đã có. */
  try { document.dispatchEvent(new CustomEvent('aef:phi-ship')); } catch (e) {}
})();

;

/* ===== wbcustom.js ===== */
/* ---------------------------------------------------------------------------
   Nạp-theo-yêu-cầu cho các plugin jQuery chỉ dùng ở một chỗ.

   fancybox (20 KB) · wbquickview (1 KB) · countdown (2 KB) và 2 file CSS đi kèm
   trước đây nằm trong layout/theme.liquid nên MỌI trang đều tải — trong khi người
   dùng duy nhất của chúng là section `special`, vốn không nằm trong template nào.
   Không đặt được vào chính section: script trong thân trang chạy trước
   jquery.min.js (nạp ở cuối layout), mà cả ba đều là plugin jQuery.

   Đường dẫn lấy từ window.aefLazyAssets (layout in ra, có vân tay phiên bản).
   Cache theo URL nên gọi nhiều lần chỉ chèn một thẻ.
--------------------------------------------------------------------------- */
var aefAssetPromises = {};
function aefLoadAsset(url, kind) {
  if (!url) return Promise.reject(new Error("aefLoadAsset: thiếu URL"));
  if (aefAssetPromises[url]) return aefAssetPromises[url];
  aefAssetPromises[url] = new Promise(function (resolve, reject) {
    var el;
    if (kind === "css") {
      el = document.createElement("link");
      el.rel = "stylesheet";
      el.href = url;
    } else {
      el = document.createElement("script");
      el.src = url;
      el.async = false; // giữ đúng thứ tự khi nạp fancybox rồi mới tới wbquickview
    }
    el.onload = function () { resolve(); };
    el.onerror = function () {
      delete aefAssetPromises[url]; // cho phép thử lại, không ướp lỗi vĩnh viễn
      reject(new Error("aefLoadAsset: không tải được " + url));
    };
    document.head.appendChild(el);
  });
  return aefAssetPromises[url];
}

/* ---------------------------------------------------------------------------
   Chân giả cho slick khi template không nạp sẵn.

   layout/theme.liquid không nạp slick ở product/collection/search/cart vì 4
   template đó không dùng section carousel nào. Nhưng 7 section carousel vẫn
   THÊM ĐƯỢC vào chúng qua theme editor — và nếu điều đó xảy ra, dòng
   `$(".owl-slider").slick(...)` bên dưới ném TypeError, làm CHẾT toàn bộ phần
   còn lại của $(document).ready — kể cả đoạn giỏ hàng. Cắt file mà không có
   chân giả này là đổi 3 request lấy một quả mìn.

   Nuốt lời gọi khi tập rỗng (trường hợp thường), nạp slick thật khi có carousel
   thật. slick.min.js nạp xong sẽ tự ghi đè $.fn.slick, nên lượt gọi lại là bản
   thật chứ không đệ quy vào chân giả.
--------------------------------------------------------------------------- */
if (window.jQuery && !window.jQuery.fn.slick) {
  var aefSlickStub = function (cfg) {
    var $els = this;
    if (!$els.length) return $els; // không có carousel nào → khỏi tải gì
    var L = window.aefLazyAssets || {};
    aefLoadAsset(L.slickCss, "css");
    aefLoadAsset(L.slickThemeCss, "css");
    aefLoadAsset(L.slickJs, "js")
      .then(function () {
        // Bản thật đã thay chỗ chân giả thì mới gọi lại — nếu không thì thôi,
        // chứ gọi lại chính chân giả là đệ quy vô tận.
        if (window.jQuery.fn.slick !== aefSlickStub) $els.slick(cfg);
        else console.warn("[aef] slick: tải xong mà $.fn.slick vẫn là chân giả");
      })
      .catch(function (err) { console.warn("[aef] slick:", err.message); });
    return $els;
  };
  window.jQuery.fn.slick = aefSlickStub;
}

$(document).ready(function () {
  var AEF_LAZY = window.aefLazyAssets || {};

  /* Quick-view: chỉ nạp khi trang thật sự có nút gọi. wbquickview.js gắn handler
     uỷ quyền trên <body> nên nạp muộn vẫn bắt được mọi cú bấm sau đó. */
  if (document.querySelector(".js-wbquickview-link")) {
    aefLoadAsset(AEF_LAZY.fancyboxCss, "css");
    aefLoadAsset(AEF_LAZY.quickviewCss, "css");
    aefLoadAsset(AEF_LAZY.fancyboxJs, "js")
      .then(function () { return aefLoadAsset(AEF_LAZY.quickviewJs, "js"); })
      .catch(function (err) { console.warn("[aef] quick-view:", err.message); });
  }

  // 25/9/2026 (vòng 53) — ĐÃ GỠ lời khởi tạo tooltip Bootstrap cho mọi phần tử
  // mang data-toggle="tooltip". Plugin đó (cùng Popper) đã rời aef-vendor.js, nên
  // gọi lại là TypeError giết phần còn lại của hàm ready này (≈400 dòng: slick,
  // tab, …). Đích DUY NHẤT của nó là nút "+" ĐÃ disabled khi dòng giỏ chạm trần
  // (sections/main-cart-items.liquid) — theo tài liệu Bootstrap, tooltip không
  // bắn trên phần tử disabled, còn lượt khởi tạo thì dời title sang
  // data-original-title rồi để title rỗng (đo trong jsdom, chưa đo trình duyệt
  // thật). Nay nút dùng title gốc của trình duyệt, đã dịch qua data-i18n-title.
  // Nó cũng không chạy lại sau khi giỏ vẽ lại bằng Section Rendering API, tức
  // nút "+" vẽ lại vốn đã dùng title gốc từ trước.
  // Người gác: scripts/test-vendor-khong-cho-thu-vien-thua.js (M3).

  // Đã GỠ khối "Auto play iphone safari banner video" (15/9/2026).
  // Nó đăng ký `document.addEventListener('DOMContentLoaded', …)` từ BÊN TRONG
  // callback này, mà callback này chỉ chạy SAU khi DOMContentLoaded đã bắn
  // (aef-app.js nạp `defer`, nên jQuery 3 thấy readyState "interactive" và hẹn
  // ready bằng setTimeout) ⇒ thân nó không bao giờ chạy, hỏng CÂM.
  // Đích `#bannerVideo` cũng không tồn tại: chỗ duy nhất còn khai nó là
  // sections/slideshow.liquid:61, và cả thẻ <video> đó nằm trong chú thích
  // HTML; sections/aef-marketdeals-home.liquid:58 ghi đã gỡ từ 12/8.
  // KHÔNG mất bảo đảm nào: thẻ <video> ấy vốn mang sẵn autoplay/playsinline/
  // muted/loop, tức tự phát mà không cần JS.
  // ⚠️ Đừng chép lại nếp này: DOMContentLoaded đăng ký trong ready là chết câm.

  // Tab Append
  $(".appendtabfea").appendTo("#tab-fea-0");
  $(".appendtablatest").appendTo("#tab-latest-0");
  $(".appendtabbest").appendTo("#tab-best-0");

  // Slideshow
  $(".owl-slider").slick({
    slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
dots: true,
    arrows: false,
  });

  // Special Product
  $(".owl-catt").slick({
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1410,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
  $(".owl-catt").show();

  // Special Product
  $(".wbspeprod").slick({
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".wbspeprod").show();

  // Countdown Timer — plugin countdown.min.js chỉ nạp khi trang có [data-countdown]
  // (hiện chỉ section `special` sinh ra). Không có thì bỏ qua, 0 request.
  var $aefCountdowns = $("[data-countdown]");
  if ($aefCountdowns.length) {
    aefLoadAsset(AEF_LAZY.countdownJs, "js")
      .then(function () {
        $aefCountdowns.each(function () {
          var $this = $(this),
            finalDate = $(this).data("countdown");
          Date.prototype.yyyymmdd = function () {
            var yyyy = this.getFullYear().toString();
            var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
            var dd = this.getDate().toString();
            return (
              yyyy +
              "/" +
              (mm[1] ? mm : "0" + mm[0]) +
              "/" +
              (dd[1] ? dd : "0" + dd[0])
            ); // padding
          };
          var date = new Date();
          if (finalDate > date.yyyymmdd()) {
            $(this).parents(".timer_outer").css("display", "block");
          } else {
            $(this).parents(".timer_outer").css("display", "none");
          }
          $this.countdown(finalDate, function (event) {
            $this.html(
              event.strftime(
                "<span>%D</span><span>%H</span><span>%M</span><span>%S</span>"
              )
            );
          });
        });
      })
      .catch(function (err) { console.warn("[aef] countdown:", err.message); });
  }

  // Home Tab Product
  // Nhịp hàng sản phẩm — 5 thẻ mỗi hàng trên desktop (thẻ 246px).
  // Con số này chốt bằng hai lần Boss xem thật:
  //   7 thẻ → 168px → "nhỏ quá, không đọc nổi nhãn"
  //   4 thẻ → 315px → "to quá"
  // 246px là đúng điểm giữa. Weee để 200px (tức 6 thẻ với khung của mình) —
  // nếu muốn sát Weee hơn nữa thì đổi 5 → 6, mọi chỗ khác giữ nguyên.
  // KEEP IN SYNC với assets/lazy-sections.js → SLICK_CONFIG
  // và mốc breakpoint trong assets/aef-personalized-rows.css.
  //
  // `.not('.slick-initialized')` — dãy lazy có hai đường khởi tạo và chúng đua
  // nhau. lazy-sections.js bơm HTML lúc IntersectionObserver bắn (có thể trước
  // khi jQuery ready chạy) rồi tự gọi .slick(); dòng này chạy sau và gọi .slick()
  // lần hai lên đúng phần tử đó. Slick không chịu được: initADA() đọc trạng thái
  // slide dở dang và ném "Cannot read properties of null (reading 'add')" —
  // console dính một TypeError mỗi lần tải trang. lazy-sections.js đã tự chặn
  // bằng hasClass('slick-initialized'), phía này thì chưa bao giờ có.
  $(".wbfea,.wbnew,.wbbest,.wbtopr").not(".slick-initialized").slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
  $(".wbfea").show();
  $(".wbnew").show();
  $(".wbbest").show();
  $(".wbtopr").show();

  // Testimonial
  $(".testi").slick({
    dots: true,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $(".testi").show();

  // Blog
  $(".wbblog").slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".wbblog").show();

  // Logo Slider
  $(".wblogobar").slick({
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1410,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
  $(".wblogobar").show();

  // Scroll To top
  $("#scroll").addClass("scrollhide");
  $(window).scroll(function () {
    if ($(this).scrollTop() === 0) {
      $("#scroll").addClass("scrollhide");
    } else {
      $("#scroll").removeClass("scrollhide");
    }
  });
  $("#scroll").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

  // Mobile Menu Toggle
  if ($(window).width() <= 991) {
    $(".wbmegamainhd").on("click", function () {
      var targetMenu = "#" + $(this).data("submenu");
      $(targetMenu).slideToggle(300);
      $(this).toggleClass("active");
      return false;
    });
    $("#megamenu").prependTo(".headlogo");
  }
  if ($(window).width() <= 767) {
    $("localization-form").appendTo(".customer_account ul");
  }

  // Collection Grid/List View
  $(document).on("click", ".wblistgridbtn", function (e) {
    $(this).addClass("active").siblings().removeClass("active");
    if ($(this).hasClass("listv")) {
      $("#product-grid").addClass("product-list").removeClass("product-grid");
    } else if ($(this).hasClass("gridv")) {
      $("#product-grid").addClass("product-grid").removeClass("product-list");
    }
  });

  // Popup Product — chỉ đặt nhịp khi trang THẬT SỰ có popup.
  // Markup do máy chủ sinh (sections/popup-products.liquid, bọc trong
  // `{% if section.settings.popup_product %}`) nên lúc ready đã có sẵn hoặc
  // không bao giờ có; công tắc đó đang TẮT, tức `.popinner` = 0 trên mọi trang.
  // Không có vế này thì `setInterval(…, 5000)` chạy vĩnh viễn ở mọi tab để quét
  // một phần tử không tồn tại. Cùng nếp với khối countdown phía trên.
  if ($(".wbpopup-popducts .popinner").length) {
    $(".wbpopup-popducts .popinner").hide();
    var i = 0;
    // Hàm BIỂU THỨC chứ không phải khai báo: khai báo hàm nằm trong khối `if`
    // rơi vào ngữ nghĩa Annex B, khác nhau giữa strict/sloppy — biểu thức thì
    // một nghĩa ở mọi nơi. Vì vậy phải định nghĩa TRƯỚC lời gọi đầu tiên.
    var setIntervalFun = function () {
      $(".wbpopup-popducts .popinner").eq(i).fadeIn(400);
      setTimeout(function () {
        $(".wbpopup-popducts .popinner").eq(i).fadeOut(400);
        i++;
        if ($(".wbpopup-popducts .popinner").length <= i) {
          i = 0;
        }
      }, parseInt(7000));
    };
    setIntervalFun();
    var totalTimer = parseInt(3000) + parseInt(2000);
    setInterval(setIntervalFun, totalTimer);
  }
  $(document).on("click", ".wbclosepopup", function () {
    $(".wbpopup-popducts").fadeOut(400).remove();
  });

  // Box Layout
  $(".wbboxdemo").click(function () {
    $(".wbboxlt").attr("id", "wbboxlayout");
  });
  $(".wbwidedemo").click(function () {
    $(".wbboxlt").removeAttr("id");
  });
  // Color Customizer
  $("body").on("click", ".wbinnerclr a", function (e) {
    e.preventDefault();
    $(".wbinnerclr").find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbcolorname=""]').remove();
    if (!$(this).hasClass($("html").attr("")))
      $("body").append(
        '<link rel="stylesheet" type="text/css" wbcolorname href="' +
          $(this).attr("href") +
          '">'
      );
  });
  // Rtl Mode
  $("body").on("click", ".wbrtlmode a", function (e) {
    e.preventDefault();
    $(".wbrtlmode").find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbrtl=""]').remove();
    if (!$(this).hasClass($("html").attr("")))
      $("body").append(
        '<link rel="stylesheet" type="text/css" wbrtl href="' +
          $(this).attr("href") +
          '">'
      );
  });
  // Color Open/Close
  $(".wbopen-closeclr").click(function () {
    if ($(this).hasClass("wbclrdisable")) {
      $(this).removeClass("wbclrdisable");
      $(this).addClass("wbclrenable");
      $(".wbcolor_box").animate({ right: "30px" }, 450);
      $(".wbcolor_box").css({
        "box-shadow": "0 10px 35px 10px rgba(0,0,0,.06)",
        background: "#fff",
        "border-radius": "4px 0 4px 4px",
      });
      $(".wbcolor_option,.wbcolor_title").animate({ opacity: "1" }, 450);
    } else {
      $(this).removeClass("wbclrenable");
      $(this).addClass("wbclrdisable");
      $(".wbcolor_box").animate({ right: "-250px" }, 450);
      $(".wbcolor_box").css({
        "box-shadow": "none",
        background: "transparent",
      });
      $(".wbcolor_option,.wbcolor_title").animate({ opacity: "0" }, 450);
    }
  });
}); // Document Ready Div End

$(window).on("load", function () {
  $(".s-panel .loader").removeClass("wrloader");
});

// Menu For Mobile
function w3_open() {
  document.getElementById("myOverlay").style.display = "block";
  document.getElementById("megamenu").className = "active";
  $("body").addClass("wbbodyscroll");
}
function w3_close() {
  document.getElementById("myOverlay").style.display = "none";
  document.getElementById("megamenu").className = "";
  $("body").removeClass("wbbodyscroll");
}

/* ---------------------------------------------------------------------------
   NÚT "LÊN ĐẦU TRANG" NHƯỜNG CHỖ CHO THỨ BẤM ĐƯỢC NẰM CHỒNG VỚI NÓ.
   26/9/2026 (vòng 53, lỗi có sẵn trên LIVE — người thử đợt 1 ghi).
   Nút `a#scroll` (sections/footer.liquid) neo cố định bottom:92px/right:20px,
   40×40, z-index 2, trên MỌI trang. Nội dung cuộn qua nó, nên ở những dải cuộn
   nhất định nó chồng lên đúng thứ khách đang định bấm. Đo trên LIVE 26/9 (📱 390):
     · biểu tượng Google Pay ở chân trang: nút CƯỚP 62–83% diện tích nhận chạm của
       nó; cùng kiểu, trên trang chủ: tab hàng cuộn, "View all", nút đăng ký bản
       tin, liên kết "xem thêm"… (21–59%);
     · nút "Add to cart" của thẻ CỘT PHẢI trong lưới danh mục: KHÔNG mất cú chạm
       (thẻ để z-index 4, đứng TRÊN nút) nhưng nút lấp ló sau mép phải của nó —
       khách thấy hai thứ chồng nhau (ảnh người thử mobile-live-B1-trang4.png);
     · trang /cart: con số tổng tiền — đã vá riêng bằng cờ aef-tong-tien-trong-tam.
   Mỗi chỗ một cờ riêng là đuổi theo từng ca. Ở đây hỏi thẳng một câu chung, mỗi
   khung hình khi cuộn: "trên hay dưới nút có THỨ BẤM ĐƯỢC (hoặc biểu tượng/ảnh)
   mà hộp nút chiếm ≥ 8% phần nhìn thấy CỦA CHÍNH NÓ không?" — có thì nút ẩn (cùng
   khuôn ẩn với cờ tổng tiền: opacity + pointer-events + visibility, luật ở
   aef-cart-drawer.css), không thì hiện lại.
   Vì sao hỏi theo diện tích của VẬT BỊ CHE, không hỏi "hai hộp có giao nhau":
   nút nhỏ đứng trên ẢNH SẢN PHẨM to (mất ~5% mặt ảnh) là chồng chứ không cướp —
   ẩn cả ở đó thì trên lưới danh mục nút gần như không bao giờ hiện. Nút "Add to
   cart", tên SP, liên kết chân trang, ô nhập, biểu tượng thanh toán mới là thứ bị
   cướp chỗ thật. (reference_chong_len_nhau_khong_phai_cuop_cho)
   Tìm vật bị che bằng document.elementsFromPoint ở 17 điểm trên mặt nút — hỏi
   trình duyệt thứ gì thật sự nằm dưới, không quét cả cây DOM.
   Người gác: scripts/test-nut-len-dau-khong-che-vat-bam.js
--------------------------------------------------------------------------- */
(function nutLenDauNhuongCho() {
  var CO = 'aef-nut-len-dau-nhuong';
  var TI_LE_NHUONG = 0.08;
  var BAM_DUOC = 'a[href],button,input,select,textarea,summary,label,[role="button"],[role="link"],[role="tab"],[role="checkbox"],[tabindex]:not([tabindex="-1"])';
  var HINH = { IMG: 1, SVG: 1, PICTURE: 1, VIDEO: 1, CANVAS: 1, IFRAME: 1 };
  /* Lưới 4×4 + tâm: vật nhỏ chỉ chạm một dải mép nút vẫn rơi vào ít nhất một điểm. */
  var DIEM = [[0.5, 0.5]];
  [0.1, 0.37, 0.63, 0.9].forEach(function (fx) { [0.1, 0.37, 0.63, 0.9].forEach(function (fy) { DIEM.push([fx, fy]); }); });
  var hen = 0;

  function vatBiChe(e) {
    if (!e || e === document.body || e === document.documentElement) return null;
    var bam = e.closest ? e.closest(BAM_DUOC) : null;
    if (bam && bam !== document.body) return bam;
    var hinh = e.closest ? e.closest('svg') : null;
    if (hinh) return hinh;
    return HINH[String(e.tagName || '').toUpperCase()] ? e : null;
  }

  /* Hộp của vật = hợp hộp của phần tử bấm được (v) và phần tử trình duyệt thật sự
     trúng (e). Vì sao hợp: `<a>` inline bọc một <img> khối có getBoundingClientRect
     chỉ bằng một dòng chữ — đo theo nó là đo sai cả diện tích lẫn vị trí (đã gặp:
     banner offerbnr, lúc nhường lúc không tuỳ độ cuộn). */
  function phanThay(v, e, x, y) {
    var q = v.getBoundingClientRect();
    var p = e.getBoundingClientRect();
    var L0 = Math.max(Math.min(q.left, p.left), 0), R0 = Math.min(Math.max(q.right, p.right), window.innerWidth);
    var T0 = Math.max(Math.min(q.top, p.top), 0), B0 = Math.min(Math.max(q.bottom, p.bottom), window.innerHeight);
    var L = L0, R = R0, T = T0, B = B0;
    /* Cắt theo TỪNG TRỤC: `overflow-x: clip` không cắt chiều dọc. */
    for (var a = e.parentElement; a && a !== document.body && a !== document.documentElement; a = a.parentElement) {
      var cs = window.getComputedStyle(a);
      var cx = cs.overflowX !== 'visible', cy = cs.overflowY !== 'visible';
      if (cx || cy) {
        var b = a.getBoundingClientRect();
        if (cx) { L = Math.max(L, b.left); R = Math.min(R, b.right); }
        if (cy) { T = Math.max(T, b.top); B = Math.min(B, b.bottom); }
      }
    }
    /* Trình duyệt vừa trả `e` Ở CHÍNH điểm (x,y) ⇒ điểm đó chắc chắn nhìn thấy. Phép
       cắt suy từ overflow mà loại mất điểm ấy là phép cắt SAI (tổ tiên không phải
       khối chứa của phần tử định vị tuyệt đối…) ⇒ bỏ phép cắt, chỉ giữ khung nhìn. */
    if (!(x >= L && x <= R && y >= T && y <= B)) return [L0, R0, T0, B0];
    return [L, R, T, B];
  }

  function kiem() {
    hen = 0;
    var nut = document.getElementById('scroll');
    var than = document.body;
    if (!nut || !than) return;
    var dat = false;
    var r = nut.getBoundingClientRect();
    if (!nut.classList.contains('scrollhide') && r.width >= 1 && r.height >= 1) {
      var daXet = [];
      for (var i = 0; i < DIEM.length && !dat; i++) {
        var x = r.left + DIEM[i][0] * r.width;
        var y = r.top + DIEM[i][1] * r.height;
        var ds = document.elementsFromPoint(x, y);
        for (var j = 0; j < ds.length; j++) {
          var e = ds[j];
          if (e === nut || nut.contains(e)) continue;
          var v = vatBiChe(e);
          if (v && daXet.indexOf(e) < 0) {
            daXet.push(e);
            /* Chỉ phần NHÌN THẤY của vật — khung nhìn giao với mọi tổ tiên đang cắt
               (overflow ≠ visible). Phần bị CẮT không phải phần bị CƯỚP: ảnh trong
               hàng cuộn ngang chỉ lộ 76px thì 76px đó mới là thứ khách chạm được. */
            var hop = phanThay(v, e, x, y);
            var vl = hop[0], vr = hop[1], vt = hop[2], vb = hop[3];
            var dt = Math.max(0, vr - vl) * Math.max(0, vb - vt);
            var gx = Math.max(0, Math.min(vr, r.right) - Math.max(vl, r.left));
            var gy = Math.max(0, Math.min(vb, r.bottom) - Math.max(vt, r.top));
            if (dt > 0 && (gx * gy) / dt >= TI_LE_NHUONG) dat = true;
          }
          break; /* chỉ xét thứ nằm NGAY dưới nút ở điểm này */
        }
      }
    }
    if (than.classList.contains(CO) !== dat) than.classList.toggle(CO, dat);
  }

  function henKiem() {
    if (hen) return;
    hen = (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(kiem);
  }

  if (typeof document.elementsFromPoint !== 'function') return;
  window.addEventListener('scroll', henKiem, { passive: true });
  window.addEventListener('resize', henKiem);
  window.addEventListener('load', henKiem);
  document.addEventListener('transitionend', function (ev) {
    if (ev.target && ev.target.id === 'scroll') henKiem();
  });
  if (typeof ResizeObserver === 'function') {
    var gan = function () { try { new ResizeObserver(henKiem).observe(document.body); } catch (e) {} };
    if (document.body) gan(); else document.addEventListener('DOMContentLoaded', gan);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', henKiem);
  else henKiem();
})();

;

/* ===== cart-card-indicator.js ===== */
// Lightweight passive cart indicator — MỘT việc duy nhất: đọc /cart.js rồi giữ
// huy hiệu số lượng ở header (`<span id="Cartcount">`) khớp với máy chủ, cả lúc
// tải trang lẫn sau mỗi lượt ghi giỏ. mini-cart-popup.js dựng MutationObserver
// trên chính huy hiệu đó (mini-cart-popup.js:6-8) nên lượt ghi này là ngòi nổ
// của popup — đừng gỡ.
//
// 15/9/2026 (vòng 49) — ĐÃ GỠ hai việc file này từng tự khai mà KHÔNG ai nhìn thấy:
//   · `card.classList.add('in-cart')`: không một luật CSS nào trong cả kho tiêu
//     thụ `.in-cart`. Thứ thật sự ẩn nút "+" là `.is-in-cart`, và card-stepper.js
//     tự khai là NGƯỜI GHI DUY NHẤT của lớp đó (card-stepper.js:8-10).
//   · `[data-cart-badge]` (snippets/product-card.liquid:194) bị
//     assets/aef-product-card.css:590 tắt cứng `display: none !important`, kèm
//     chú thích "In-cart badge intentionally hidden — visual noise".
// ⇒ Muốn BẬT huy hiệu "đang có N trong giỏ" trên thẻ thì đó là quyết định của
//    Boss, và đường đúng là mở luật CSS kia ra rồi để card-stepper.js điền —
//    KHÔNG phải cho file này ghi `.is-in-cart` để thành NGƯỜI GHI THỨ HAI
//    (Pattern 1 của HARD GATE cart-UI: hai ngòi bút trên một ô = race).
// PASSIVE only — no click handling, no morph button. Decoupled from cart UX.

(function () {
  function syncFromCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // 1. Update header count badge
        // BUG-Z (2026-05-21) — Defer header-badge reconciliation while
        // mini-cart-popup's add-queue is mid-flight. Otherwise rapid
        // clicks flicker the badge down to the server-truth-at-this-
        // instant (e.g. 5 optimistic clicks done → fetch 1 finishes →
        // we'd write "1" → user sees the count fall back) before
        // climbing back up as each queued add resolves. The LAST
        // syncFromCart (fires after the counter returns to 0) is the
        // one that writes the final accurate count.
        var pending = (typeof window.__aefCartAddPending === 'number')
          ? window.__aefCartAddPending : 0;
        var countEl = document.getElementById('Cartcount');
        if (countEl && pending === 0) countEl.textContent = cart.item_count || 0;
      })
      .catch(function () {});
  }

  /* "Vừa có một lượt ghi giỏ chưa?" — 15/9/2026 (vòng 49).
   *
   * LUẬT CŨ BẮT BUỘC ĐUÔI `.js`:  /\/cart\/(add|change|update|clear)\.js/
   * Nhưng theme có HAI họ nơi gọi, và chỉ MỘT họ mang đuôi đó:
   *   · viết cứng có đuôi — aef-cart-drawer.js, card-stepper.js:311,
   *     mini-cart-popup.js:1006/1115, aef-marketdeals.js:255, aef-fbt.liquid:561,
   *     aef-reorder.liquid:265, main-article.liquid:801;
   *   · dựng từ `window.routes.*` KHÔNG đuôi — product-form.js:134 (chính là nút
   *     "Add to cart" của PDP), cart.js:239 và :379, wbcartdropdown.js:104,
   *     main-cart-footer.liquid:135.
   * Đo trên LIVE 15/9: window.routes = '/cart/add' · '/cart/change' ·
   * '/cart/update' — trần, không đuôi. ⇒ luật cũ MÙ trước cả họ thứ hai, trong đó
   * có đường đông khách nhất. Hôm nay huy hiệu vẫn đúng nhờ cart-notification.js
   * lo hộ, nên không ai thấy gì; nhưng cái lưới an toàn mà chú thích này hứa thì
   * không tồn tại trên đường PDP.
   *
   * CHỮA BẰNG CÁCH HỎI NGUỒN, KHÔNG CHÉP THÊM MỘT BẢN LUẬT NỮA. snippets
   * free-shipping-bar / assets/aef-fsb.js:396 cũng tự chế một biểu thức cho cùng
   * khái niệm này, và hai bản đã trôi khỏi nhau — đúng họ "một khái niệm, hai
   * nguồn dữ liệu". Nên ở đây hỏi thẳng `window.routes` (layout/theme.liquid:
   * 1002-1005) — ĐÚNG cái mà 5 nơi kia dùng để dựng URL — thay vì đoán hình dạng
   * URL. Shopify đổi tiền tố (cửa hàng đa ngôn ngữ trả '/vi/cart/add') thì luật
   * này theo luôn, không cần ai nhớ sửa. Danh sách đường trần bên dưới chỉ là
   * lưới cho các nơi viết cứng và cho '/cart/clear' (routes không có khoá đó).
   * Đuôi `.js` được cắt TRƯỚC khi so, nên một đường khớp ở cả hai dạng. */
  function laLuotGhiGio(url) {
    if (typeof url !== 'string' || !url) return false;
    var duong = url.split('?')[0].split('#')[0].replace(/\.js$/, '');
    var r = window.routes || {};
    var dich = [r.cart_add_url, r.cart_change_url, r.cart_update_url];
    for (var i = 0; i < dich.length; i++) {
      var d = dich[i] ? String(dich[i]).split('?')[0].replace(/\.js$/, '') : '';
      if (d && duong.length >= d.length && duong.slice(-d.length) === d) return true;
    }
    /* Neo `$` ở cuối: '/cart' (trang giỏ) và '/cart.js' (chính lượt đọc của file
     * này) KHÔNG được khớp — khớp là tự gọi lại chính mình, vòng vô tận. */
    return /\/cart\/(add|change|update|clear)$/.test(duong);
  }

  // Re-sync after any cart-mutating fetch (add / change / update / clear)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (laLuotGhiGio(url)) {
      p.then(function () { setTimeout(syncFromCart, 200); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromCart);
  } else {
    syncFromCart();
  }
})();

;

/* ===== aef-qua-tang.js ===== */
/* ============================================================================
 * 🎁 AE Foodstore — QUÀ TẶNG THEO NGƯỠNG, NHƯ WEEE (31/10/2026; dòng quà trong giỏ 1/11/2026).
 *
 * BOSS 1/11: đủ ngưỡng thì quà TỰ NHẢY VÀO GIỎ giá $0, tụt dưới ngưỡng thì TỰ MẤT, tới checkout khách
 * thấy một dòng quà, "đâu phải ai cũng đọc chữ". Thanh báo vẫn giữ, chỉ là phần phụ.
 *
 * DÒNG QUÀ LÀ BIẾN THỂ GIÁ $0 RIÊNG (product Unlisted, ẩn khỏi tìm kiếm + danh mục, chỉ lên Online Store),
 *   KHÔNG phải giảm giá. Đây là cách duy nhất qua được ba lỗi của bản BXGY (nhánh v53/qua-tang, không merge):
 *   gõ mã ở checkout thì quà thành $6.37, ~70% đơn quà bị tách một món làm 2 dòng, sale và quà giành nhau.
 *   $0 là giá thật nên mã, sale, giảm tự động không chạm tới được.
 *
 * DẤU NHẬN DÒNG QUÀ: original_price === 0 (đo 1/11: 1/3.334 biến thể có giá 0, chính là món quà). Cùng dấu với
 *   Liquid (`item.original_price == 0`), Flow (dongQua) và mọi bộ đếm [[reference_qua_tang_gia_0_lam_hong_thuoc_so_luong]].
 *
 * NHÂN VIÊN ĐẶT QUÀ: metaobject free_gift_promotion, chọn biến thể $0 ở ô free_item. Chọn nhầm hàng có giá thì
 *   bien_the = 0 ⇒ chỉ báo, không ghi giỏ, Flow gắn tag cho kho như trước: tuyệt đối không tính tiền khách.
 *   Sản phẩm quà để Product type = "Free Gift": nhờ đó quà lỡ bị đổi giá vẫn bị gỡ, hàng thường cùng món thì không.
 *
 * CHỦ SỞ HỮU (feedback_cart_ui_anti_regression.md): người ghi DUY NHẤT của [data-aef-qua-tang] và của DÒNG QUÀ.
 *   Thêm/gỡ xong chỉ phát `cart:updated` như mọi đường ghi giỏ, người vẽ sẵn có tự lo phần của họ. Không ghi
 *   badge, tổng, thanh free-ship. Ảnh giỏ đến từ window.aefNgheGio (assets/perf-instant.js), hoặc detail.anhGio.
 *
 * CẤU HÌNH: layout/theme.liquid in MẢNG đợt vào script[data-aef-qua-cau-hinh]. Trang có thể nằm trong cache nên đợt
 *   được chọn ở đây theo giờ, tới giờ là chạy mà không cần đẩy theme.
 *
 * LUẬT BOSS 31/10, Y CHANG WEEE: đủ ngưỡng là có quà, kể cả có mã hay hàng sale. Tiền xét ngưỡng là tiền hàng
 *   theo GIÁ ĐANG BÁN, TRƯỚC MÃ: sale tự động được trừ, mã không trừ.
 *
 * LƯỚI ĐỠ: nút ví nhanh (Shop Pay, PayPal), "Buy it now" và lượt JS hỏng đi thẳng checkout không qua tệp này. Flow
 *   xét lại đơn đã chốt (scripts/qua-tang-flow-run-code.js): đủ ngưỡng mà thiếu dòng quà ⇒ gắn tag cho kho bỏ thêm;
 *   có dòng quà mà không đủ ngưỡng ⇒ báo QUA-SAI. Sửa luật ở một bên thì sửa cả bên kia.
 *
 * XẤU NHẤT LÀ GÌ: mọi lỗi của tệp này dừng ở "không có dòng quà", giỏ y như cũ, Flow vẫn đỡ.
 *
 * Người gác: scripts/test-qua-tang-logic.js · test-qua-tang-theme.js · test-qua-tang-dong-gio.js
 * ============================================================================ */
(function () {
  if (window.__aefQuaTang) return;
  window.__aefQuaTang = true;

  var KHOA_VUNG_XA = 'aef_qua_vung_xa';
  /* Chờ giỏ thôi đổi rồi mới ra tay: lượt ghi này không được chen vào giữa lúc khách đang bấm. Hai mốc là SÀN. */
  var CHO_ON_DINH_MS = 350;
  var CHO_RANH_TAY_MS = 700;
  /* Chốt chống đu đưa: hai tab hay một cấu hình lệch không được ghi vô tận. */
  var TRAN_GHI = 10;
  var CUA_SO_GHI_MS = 60000;
  var SO_LUOT_XU_LY = 4;
  /* Ghi hỏng vì mạng/429/5xx: nghỉ rồi mới thử ở ảnh giỏ kế tiếp, kẻo thành vòng lặp đập vào máy chủ đang quá tải. */
  var NGHI_SAU_LOI_MS = 5000;
  var LOAI_QUA = 'Free Gift';

  /* Tên ngắn của quà, một luật với Flow: bỏ tiền tố "FREE GIFT - ", "[HÃNG] " và đuôi " - Default Title". */
  function tenGon(s) {
    return String(s || '').replace(/^FREE GIFT\s*-\s*/i, '').replace(/^\[[^\]]*\]\s*/, '').replace(/ - Default Title$/, '');
  }
  function laDongQua(it) { return !!it && it.original_price === 0; }

  function docCauHinh() {
    var el = document.querySelector('script[data-aef-qua-cau-hinh]');
    if (!el) return null;
    try {
      var ds = JSON.parse(el.textContent);
      if (Array.isArray(ds)) ds.forEach(function (d) { if (d) d.ten = tenGon(d.ten); });
      return ds;
    } catch (e) { return null; }
  }

  /* ── CÁC HÀM THUẦN (tenGon · dotHong · chonDot · tienHang): đổi hàm nào thì đổi cả bản ở scripts/qua-tang-flow-run-code.js ── */
  function dotHong(d) {
    return !d || !d.ten || !(d.nguong_cents > 0) || typeof d.bat_dau !== 'number'
      || typeof d.ket_thuc !== 'number' || !(d.bat_dau < d.ket_thuc);
  }
  /* Đợt còn hàng có bat_dau <= luc < ket_thuc. Đợt hết hàng nhường đợt thay thế. Trùng nhau thì lấy đợt bắt đầu
     sớm nhất, cùng giờ bắt đầu thì lấy handle đứng trước: hai đợt có thể cùng một món nên tên không phá được hoà. */
  function chonDot(ds, luc) {
    var chon = null;
    (Array.isArray(ds) ? ds : []).forEach(function (d) {
      if (dotHong(d) || !d.con_hang || !(d.bat_dau <= luc && luc < d.ket_thuc)) return;
      if (!chon || d.bat_dau < chon.bat_dau || (d.bat_dau === chon.bat_dau && d.handle < chon.handle)) chon = d;
    });
    return chon;
  }
  /* original_line_price là giá đang bán, chưa trừ giảm giá nào. Trừ giảm giá gắn trên dòng và giảm tự động cấp đơn,
     chừa phần của mã (type 'discount_code'). Ở đơn Shopify rải giảm cấp đơn xuống dòng nên Flow trừ cùng số đó. */
  function tienHang(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      n += it.original_line_price;
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var ap = a.discount_application;
        if (!ap || ap.type !== 'discount_code') n -= a.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (ap) {
      if (ap.type !== 'discount_code') n -= ap.total_allocated_amount;
    });
    return n;
  }
  /* Giỏ vào, việc ra.
     thanh: null · 'moi' (còn thiếu) · 'du' (đủ, quà sắp vào hoặc đợt chỉ báo) · 'co' (quà đã nằm trong giỏ).
     viec:  null · 'them' · 'go' + keys · 'ha' + key (đưa dòng quà về 1). biChoi: máy chủ đã từ chối quà ở trang này. */
  function quyet(cart, dot, vungXa, biChoi) {
    var dong = (cart && cart.items) || [];
    var qua = dong.filter(laDongQua);
    var go = function (kq, ds) {
      if (ds.length) { kq.viec = 'go'; kq.keys = ds.map(function (d) { return d.key; }); }
      return kq;
    };
    /* Nhân viên đổi giá món quà lúc nó đang nằm trong giỏ: dòng quà mang tiền, dấu giá 0 không nhận ra. Khách không được
       trả tiền cho quà: gỡ, thôi tặng ở trang này. Nhận bằng Product type vì trang dựng sau lúc đổi giá không còn in
       bien_the, và ô free_item có thể trỏ món có giá mà khách mua thật. bien_the đỡ thêm cho trang cũ. */
    var coGia = dong.filter(function (d) { return !laDongQua(d) && (d.product_type === LOAI_QUA || (!!dot && !!dot.bien_the && d.variant_id === dot.bien_the)); });
    if (coGia.length) { var r = go({ thanh: dot ? 'du' : null }, coGia); r.coGia = true; return r; }
    if (!dot || vungXa || !(dong.length > qua.length)) return go({ thanh: null }, qua);
    var tien = tienHang(cart);
    if (!(tien >= 0)) return { thanh: null };
    if (tien < dot.nguong_cents) return go({ thanh: 'moi', thieu: dot.nguong_cents - tien }, qua);
    var dung = dot.bien_the ? qua.filter(function (d) { return d.variant_id === dot.bien_the; })[0] : null;
    if (!dung) {
      var kq = go({ thanh: 'du' }, qua);
      if (!kq.viec && dot.bien_the && !biChoi) kq.viec = 'them';
      return kq;
    }
    var thua = qua.filter(function (d) { return d !== dung; });
    if (thua.length) return go({ thanh: 'co' }, thua);
    return dung.quantity > 1 ? { thanh: 'co', viec: 'ha', key: dung.key } : { thanh: 'co' };
  }
  window.aefQuaTangThu = { quyet: quyet, chonDot: chonDot, tenGon: tenGon, laDongQua: laDongQua };

  /* ── VẼ: người ghi duy nhất của [data-aef-qua-tang] ─────────────────────── */
  function tungKhung(fn) {
    var ds = document.querySelectorAll('[data-aef-qua-tang]');
    for (var i = 0; i < ds.length; i++) fn(ds[i]);
  }
  function an() {
    tungKhung(function (el) { el.hidden = true; el.setAttribute('data-trang-thai', ''); });
  }
  function chu(k) { return window.aefTFb ? window.aefTFb(k, '') : ''; }
  function thay(s, tk, v) { return s.replace(tk, function () { return v; }); }
  function chuThanh(kq, dot) {
    if (kq.thanh === 'moi') return thay(thay(chu('qua.moi'), '{x}', window.aefTien(kq.thieu)), '{ten}', dot.ten);
    return thay(chu(kq.thanh === 'co' ? 'qua.co' : 'qua.du'), '{ten}', dot.ten);
  }
  function ve(kq, dot) {
    var txt = kq.thanh ? chuThanh(kq, dot) : '';
    if (!txt) { an(); return; }
    tungKhung(function (el) {
      if (!el.firstChild) el.innerHTML = '<span class="aef-qua-moi__icon" aria-hidden="true">🎁</span><span class="aef-qua-moi__chu"></span>';
      el.hidden = false;
      el.setAttribute('data-trang-thai', kq.thanh);
      var c = el.querySelector('.aef-qua-moi__chu');
      if (c.textContent !== txt) c.textContent = txt;
    });
  }

  /* Không có cấu hình (đợt đã gỡ, trang mới dựng) vẫn phải chạy tiếp: dòng quà của đợt cũ còn trong giỏ phải được dọn. */
  var ds = docCauHinh() || [];

  /* Thiếu hàm hỏi vùng ⇒ coi như vùng xa cho THANH: mọi lỗi của tệp này phải dừng ở chỗ thanh ẩn. Nhưng không được
     GHI theo câu trả lời đó (coTheGhi): trang chưa nạp xong mà gỡ quà là gỡ oan. isRemoteZone() ở assets/ae-delivery-widget.js. */
  function laVungXa() { return typeof window.aefLaVungXa === 'function' ? !!window.aefLaVungXa() : true; }
  function coTheGhi() { return typeof window.aefLaVungXa === 'function'; }
  /* Khung in sẵn từ máy chủ mà vùng chỉ biết sau lượt đọc giỏ/IP ⇒ khách vùng xa thấy khoảng trống rồi trang nhảy.
     Nhớ vùng cho lần sau: thẻ đầu trang trong layout/theme.liquid đọc khoá này, CSS ẩn khung trước lượt vẽ đầu. */
  function nhoVungXa() {
    if (typeof window.aefLaVungXa !== 'function') return;
    var xa = !!window.aefLaVungXa();
    try {
      if (xa) window.localStorage.setItem(KHOA_VUNG_XA, '1');
      else window.localStorage.removeItem(KHOA_VUNG_XA);
    } catch (e) {}
    if (xa) document.documentElement.setAttribute('data-aef-qua-xa', '1');
    else document.documentElement.removeAttribute('data-aef-qua-xa');
  }

  var CHO_ANH_MS = 6000;
  var anh = null;
  var lucAnh = 0;
  var lucBam = 0;       // lần cuối khách đụng vào ô số lượng
  var hen = null;
  var ghiLuc = [];
  var thuLaiSau = 0;
  var biChoi = false;
  var goc = document.documentElement;

  function dotBayGio() { return chonDot(ds, Date.now()); }
  /* Giỏ này có dính tới dòng quà không: đợt đang chạy có quà để ghi, hoặc giỏ đang mang dòng quà. Giỏ thường khỏi tốn lượt nào. */
  function coChoQua(cart) {
    var d = dotBayGio();
    return (!!d && !!d.bien_the) || (!!cart && (cart.items || []).some(laDongQua));
  }
  function tinh(cart) { return quyet(cart, dotBayGio(), laVungXa(), biChoi); }
  function veTheo(kq) { ve(kq, dotBayGio()); }
  function henXet(ms) {
    if (hen) clearTimeout(hen);
    hen = setTimeout(function () { hen = null; xetGhi(); }, Math.max(0, ms));
  }
  function xet() {
    try {
      /* Chưa có ảnh giỏ mà đợt đang chạy: giữ khung chờ ảnh đầu, đừng thu lại rồi trang nhảy. */
      if (anh || !dotBayGio()) veTheo(tinh(anh));
      if (anh && coTheGhi() && tinh(anh).viec) henXet(CHO_ON_DINH_MS);
    } catch (e) { an(); }
  }
  function nhan(cart) { anh = cart; lucAnh = Date.now(); xet(); }

  document.addEventListener('aef:lang-changed', xet);
  document.addEventListener('aef:i18n-ready', xet);
  document.addEventListener('ae-zone-ready', function () { nhoVungXa(); xet(); });
  /* Tab mở lâu hoặc trang khôi phục từ bfcache: chọn lại đợt theo giờ hiện tại, đừng giữ lời hứa đã hết hạn.
     Quay lại tab: tab khác có thể đã đổi giỏ, ảnh này cũ thì bangLech() không thấy bảng /cart lệch. Lượt đọc về qua aefNgheGio. */
  function docLaiKhiVe() { if (coChoQua(anh)) docGio(); }
  window.addEventListener('pageshow', function (e) { xet(); if (e && e.persisted) docLaiKhiVe(); });
  document.addEventListener('visibilitychange', function () { xet(); if (document.visibilityState === 'visible') docLaiKhiVe(); });
  /* Bên phát cầm cả giỏ máy chủ thì vẽ ngay cùng nhịp thanh free-ship, khỏi chờ lượt GET. Thiếu trường tiền thì không
     tin: bản chụp không đủ để tính tiền hàng, lượt GET theo sau sẽ mang ảnh thật tới. */
  document.addEventListener('cart:updated', function (e) {
    var c = e.detail && e.detail.anhGio;
    if (c && typeof c.item_count === 'number' && typeof c.original_total_price === 'number' && Array.isArray(c.items)) nhan(c);
  });

  /* ── GHI GIỎ: một lượt một lúc, trên hàng ghi chung của cả theme ──────── */
  function conCho() {
    var bay = Date.now();
    /* Khách đang gõ số ở /cart: lượt ghi này làm bảng vẽ lại và xoá mất số chưa gửi. Chờ tới khi số đã đi. */
    if (banRon(0) || oChuaGui()) return 250;
    return Math.max(lucBam + CHO_RANH_TAY_MS - bay, lucAnh + CHO_ON_DINH_MS - bay, 0);
  }
  function xetGhi() {
    if (!anh || !coTheGhi()) return;
    /* Đang nghỉ sau lỗi: hẹn đúng lúc hết nghỉ. Khách đứng yên thì không có sự kiện nào khác đánh thức tệp này. */
    var nghi = thuLaiSau - Date.now();
    if (nghi > 0) { henXet(nghi); return; }
    /* Trang đang prerender (assets/perf-instant.js, luật speculation) chưa có khách xem: không ghi giỏ
       thay họ, kẻo chen với trang đang mở. Ảnh giỏ vẫn giữ, tới lúc trang hiện thì xét. */
    if (document.prerendering) {
      document.addEventListener('prerenderingchange', function () { henXet(0); }, { once: true });
      return;
    }
    var cho = conCho();
    if (cho > 0) { henXet(cho); return; }
    if (!tinh(anh).viec || hetLuotGhi()) return;
    xepViec();
  }
  function nghiSauLoi(cart) {
    thuLaiSau = Date.now() + NGHI_SAU_LOI_MS;
    anh = cart;
    henXet(NGHI_SAU_LOI_MS);
    return cart;
  }
  function hetLuotGhi() {
    var bay = Date.now();
    ghiLuc = ghiLuc.filter(function (t) { return bay - t < CUA_SO_GHI_MS; });
    return ghiLuc.length >= TRAN_GHI;
  }

  /* KHOÁ Ô SỐ LƯỢNG Ở /cart TRONG QUÃNG ĐỔI DÒNG. Shopify chèn dòng mới lên ĐẦU giỏ, còn form /cart gửi `updates[]`
     theo VỊ TRÍ: bảng chưa vẽ lại mà khách bấm là [quà:1, A:3, B:1] nhận 3,1 thành quà ×3, A ×1. Khoá bằng CSS
     (html[data-aef-qua-ghi], assets/aef-cart-drawer.css), mở khi từng ô đã khớp từng dòng giỏ theo đúng thứ tự.
     Trang khác không có ô nào nên mở ngay. bangLech() giữ cửa thanh toán: quá hạn chờ mà bảng còn lệch thì vẫn chặn. */
  function khoaO(bat) { if (bat) goc.setAttribute('data-aef-qua-ghi', '1'); else goc.removeAttribute('data-aef-qua-ghi'); }
  function bangLech(cart) {
    var o = document.querySelectorAll('cart-items input[name="updates[]"][data-line-key]');
    if (!o.length || !cart) return false;
    var dong = cart.items || [];
    if (o.length !== dong.length) return true;
    for (var i = 0; i < o.length; i++) {
      if (o[i].getAttribute('data-line-key') !== dong[i].key || parseInt(o[i].getAttribute('value'), 10) !== dong[i].quantity) return true;
    }
    return false;
  }
  function choBangMoi(cart, lan) {
    if (!bangLech(cart) || lan >= 16) { khoaO(false); return; }
    setTimeout(function () { choBangMoi(cart, lan + 1); }, 150);
  }
  function docGio() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { return c && typeof c.item_count === 'number' ? c : null; })
      .catch(function () { return null; });
  }
  /* keepalive như cart.js, card-stepper.js: hạn cứng ở cửa thanh toán có thể rời trang lúc lượt này đang bay, đo LIVE
     thì không có nó trình duyệt huỷ lượt ghi (net::ERR_ABORTED). */
  function lenhGhi(than) {
    return {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(than)
    };
  }
  function dat(key, sl) {
    ghiLuc.push(Date.now());
    return fetch('/cart/change.js', lenhGhi({ id: key, quantity: sl })).then(function (r) { return r.ok; }, function () { return false; });
  }
  function themQua(vid) {
    ghiLuc.push(Date.now());
    return fetch('/cart/add.js', lenhGhi({ items: [{ id: vid, quantity: 1 }] })).then(function (r) { return r.status; }, function () { return 0; });
  }
  function goLanLuot(keys) {
    return keys.reduce(function (truoc, k) { return truoc.then(function (ok) { return ok ? dat(k, 0) : false; }); }, Promise.resolve(true));
  }
  function xepViec() {
    window.__aefCartAddQueue = window.__aefCartAddQueue || Promise.resolve();
    window.__aefCartAddPending = (window.__aefCartAddPending || 0) + 1;
    var xong = function (cart) {
      window.__aefCartAddPending = Math.max(0, (window.__aefCartAddPending || 1) - 1);
      if (cart) choBangMoi(cart, 0); else khoaO(false);
    };
    window.__aefCartAddQueue = window.__aefCartAddQueue.then(lam).then(xong, xong);
    return window.__aefCartAddQueue;
  }
  /* `line` đi kèm để toast của ngăn giỏ gọi đúng tên quà lúc ngăn đang đóng: khách thấy món vào mà không phải mở giỏ. */
  function phat(cart, line) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { source: 'aef-qua-tang', count: cart.item_count, total: cart.items_subtotal_price, line: line || null, cart: cart, anhGio: cart }
      }));
    } catch (e) {}
  }
  /* Ghi xong mà không đọc lại được giỏ (hoặc mất phản hồi nên không biết lượt ghi có ăn không): vẫn phải báo
     "giỏ có thể vừa đổi", kẻo stepper, ngăn giỏ, bảng /cart giữ line key đã chết. Không kèm giỏ ⇒ từng người tự hỏi lại. */
  function phatMu() {
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'aef-qua-tang' } })); } catch (e) {}
  }
  /* Tới lượt mình trong hàng ghi: đọc giỏ TƯƠI, quyết lại, làm, đọc lại, lặp tới khi hết việc. */
  function lam() {
    var ghiThat = false;
    var moHo = false;
    var daThem = false;
    function chot(cart, kq) { anh = cart; lucAnh = Date.now(); veTheo(kq); return cart; }
    function buoc(lan) {
      return docGio().then(function (cart) {
        if (!cart) return null;
        var kq = tinh(cart);
        /* Máy chủ nhận lệnh thêm mà dòng quà không có: thêm nữa cũng vậy, thôi ở trang này, Flow đỡ. */
        if (kq.viec === 'them' && daThem) { biChoi = true; return chot(cart, tinh(cart)); }
        if (!kq.viec || lan >= SO_LUOT_XU_LY || hetLuotGhi()) return chot(cart, kq);
        if (Date.now() - lucBam < CHO_RANH_TAY_MS || banRon(1) || oChuaGui()) {
          chot(cart, kq);
          henXet(CHO_ON_DINH_MS);
          return cart;
        }
        khoaO(true);
        var tiep = function () { return buoc(lan + 1); };
        if (kq.viec === 'them') {
          return themQua(dotBayGio().bien_the).then(function (ma) {
            if (ma >= 200 && ma < 300) { ghiThat = true; daThem = true; return tiep(); }
            /* 422 = hết hàng hoặc biến thể đã gỡ: không thử lại ở trang này, Flow đỡ. */
            if (ma === 422) { biChoi = true; return tiep(); }
            /* mạng / 429 / 5xx: nghỉ rồi thử lại, chốt 10 lượt/phút vẫn áp. Mất phản hồi (ma 0) thì có thể lượt ghi ĐÃ ăn. */
            if (ma === 0) moHo = true;
            return nghiSauLoi(cart);
          });
        }
        if (kq.coGia) biChoi = true;
        /* Không nhận được lời đáp thì không biết lượt ghi có ăn không: nghỉ, và báo mù ở cuối lượt. */
        var sauSua = function (ok) {
          if (ok) { ghiThat = true; return tiep(); }
          moHo = true;
          return nghiSauLoi(cart);
        };
        if (kq.viec === 'go') return goLanLuot(kq.keys).then(sauSua);
        return dat(kq.key, 1).then(sauSua);
      });
    }
    return buoc(1).then(function (cart) {
      /* moHo trước: giỏ trong tay đọc TRƯỚC lượt ghi mất phản hồi, phát nó ra là vẽ lại giỏ cũ. */
      if (moHo || (ghiThat && !cart)) { phatMu(); return null; }
      if (ghiThat) phat(cart, daThem ? (cart.items || []).filter(laDongQua)[0] : null);
      return ghiThat ? cart : null;
    });
  }

  /* ── BẤM THANH TOÁN LÚC GIỎ CHƯA YÊN ─────────────────────────────────────
     Tệp này cố ý chờ khách ngơi tay rồi mới ghi, nên có một quãng ~1 giây dòng quà còn sai. Các cửa:
       · ảnh giỏ mới nhất còn việc: khách vừa đủ ngưỡng mà quà chưa vào, hay vừa tụt ngưỡng mà quà chưa ra;
       · khách vừa đổi số lượng mà đợt có quà để ghi hoặc giỏ có dòng quà: cú bấm còn trong hẹn gom hoặc đang bay, ảnh
         giỏ chưa biết, kể cả cú vượt ngưỡng ngay trước lúc bấm thanh toán;
       · đang ghi, hoặc bảng /cart lệch giỏ: form gửi `updates[]` theo VỊ TRÍ, xem khoaO().
     Vào cửa thì chờ giỏ yên, đọc TƯƠI, sửa xong đi thẳng /checkout, KHÔNG gửi lại form: máy chủ đã giữ số đúng,
     form thì đang cũ. Vì không gửi form nên `updates[]` và ghi chú không đi theo: số khách gõ và ghi chú phải tới máy
     chủ TRƯỚC khi đi. Hẹn gom 300 ms của cart.js tính từ `change` lúc blur, không tính được từ giờ gõ ⇒ chờ đúng cờ
     của nó (bangCoViec); ghi chú không có cờ nào ⇒ đọc giỏ xong tự gửi nếu giỏ chưa có (guiGhiChu).
     Máy chủ từ chối số khách gõ thì ở lại: câu lỗi đang hiện, đi tiếp là âm thầm mất số.
     Hạn cứng: quá hạn vẫn đi, thà sót quà còn hơn kẹt nút thanh toán.
     Trong quãng chờ html[data-aef-qua-di] làm mờ nút (assets/aef-cart-drawer.css): nút không đáp thì khách tưởng hỏng. */
  var HAN_THANH_TOAN_MS = 2500;
  var HAN_CON_CHU_MS = 6000;    // còn số hay ghi chú chưa tới máy chủ: đi sớm là mất chữ của khách
  var CHO_HEN_GOM_MS = 450;     // hẹn gom 280 ms của card-stepper, tính từ cú bấm cuối
  var VUA_BAM_MS = 1500;
  var dangDi = false;
  var henDi = null;
  var soGoDo = false;           // lượt đi này đang chờ số khách gõ
  var CHO_TAI_CHECKOUT_MS = 4000;
  function boCho() { dangDi = false; clearTimeout(henDi); goc.removeAttribute('data-aef-qua-di'); }
  function diThanhToan() {
    if (!dangDi) return;
    dangDi = false;
    window.location.href = '/checkout';
    /* Khách bấm Stop lúc /checkout đang tải thì không có pagehide: nút không được kẹt mờ tới lúc tải lại trang. */
    setTimeout(boCho, CHO_TAI_CHECKOUT_MS);
  }
  /* Rời trang giữa lúc chờ (Back) thì huỷ lượt đi, kẻo bfcache trả trang về rồi hẹn cũ tự đẩy khách sang checkout. */
  window.addEventListener('pagehide', boCho);
  function bangCoViec() {
    var b = document.querySelector('cart-items');
    return !!b && (!!b.doiCho || (b.soDangGhi || 0) > 0);
  }
  /* Giỏ đang có lượt ghi nào không. cuaMinh: số lượt của chính tệp này đang nằm trong hàng ghi. */
  function banRon(cuaMinh) {
    return (window.__aefCartAddPending || 0) > cuaMinh || (window.aefDangGhiGio && window.aefDangGhiGio() > 0) || bangCoViec();
  }
  function oChuaGui() {
    var o = document.querySelectorAll('cart-items input[name="updates[]"]');
    for (var i = 0; i < o.length; i++) { if (o[i].value !== o[i].getAttribute('value')) return true; }
    return false;
  }
  function oGhiChu() { return document.querySelector('textarea[name="note"]'); }
  function coGhiChuMoi() { var t = oGhiChu(); return !!t && t.value !== t.defaultValue; }
  function guiGhiChu(cart) {
    var t = oGhiChu();
    if (!coGhiChuMoi() || t.value === (cart.note || '')) return Promise.resolve();
    return fetch('/cart/update.js', lenhGhi({ note: t.value })).catch(function () {});
  }
  function choYenRoiDi(moc) {
    if (!dangDi) return;
    if (Date.now() < moc || banRon(0)) { setTimeout(function () { choYenRoiDi(moc); }, 120); return; }
    var loi = document.getElementById('cart-errors');
    if (soGoDo && loi && loi.textContent.trim()) { boCho(); return; }
    docGio().then(function (cart) {
      if (!cart) { diThanhToan(); return; }
      anh = cart; lucAnh = Date.now(); lucBam = 0;
      guiGhiChu(cart).then(function () {
        if (coTheGhi() && tinh(cart).viec) xepViec().then(diThanhToan, diThanhToan);
        else diThanhToan();
      });
    });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || (f.id !== 'cart' && f.id !== 'aef-drawer-checkout-form')) return;
    /* Cú bấm thứ hai lúc đang chờ: giỏ trông yên cũng không được gửi form, bảng còn cũ và lượt đi đã hẹn. */
    if (dangDi) { e.preventDefault(); return; }
    var viec = anh && coTheGhi() ? tinh(anh).viec : null;
    var moiBam = Date.now() - lucBam < VUA_BAM_MS;
    var chuaGui = oChuaGui();
    if (!viec && !goc.hasAttribute('data-aef-qua-ghi') && !bangLech(anh) && !(coChoQua(anh) && (moiBam || chuaGui || banRon(0)))) return;
    e.preventDefault();
    dangDi = true;
    goc.setAttribute('data-aef-qua-di', '1');
    soGoDo = chuaGui;
    /* iOS chạm nút không rời ô đang nhập ⇒ chưa có `change`. Rời ô để cart.js nhận số, và đặt hạn sau bước này. */
    var dangO = document.activeElement;
    if (dangO && (dangO.name === 'updates[]' || dangO.name === 'note') && dangO.blur) dangO.blur();
    henDi = setTimeout(diThanhToan, chuaGui || coGhiChuMoi() ? HAN_CON_CHU_MS : HAN_THANH_TOAN_MS);
    choYenRoiDi(moiBam ? lucBam + CHO_HEN_GOM_MS : 0);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-step-up], [data-step-down], .quantity__button')) lucBam = Date.now();
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'updates[]') lucBam = Date.now();
  }, true);

  if (window.AE_ZONE) nhoVungXa();
  xet();
  if (typeof window.aefNgheGio === 'function') window.aefNgheGio(nhan);
  else an();
  /* Không có ảnh giỏ nào (mọi GET /cart.js đều hỏng): thu khung, đừng để khoảng trống. Ảnh tới muộn vẫn vẽ lại. */
  setTimeout(function () { if (!anh) an(); }, CHO_ANH_MS);
})();

;

/* ===== card-stepper.js ===== */
/* ============================================================================
 * AE Foodstore — product-card inline quantity stepper (Đợt 2, Layer 2 core)
 * Spec: .cowork-context/project_weee_addcart_feature_spec.md
 * Anti-regression rules: .cowork-context/feedback_cart_ui_anti_regression.md
 *
 * SINGLE SOURCE OF TRUTH — what THIS file is allowed to write:
 *   - The per-card stepper UI ONLY: the .card__stepper element (qty number,
 *     +/−/trash buttons, its labels) and the .is-in-cart class on the card
 *     (which hides the "+"). Nothing else in the theme writes these.
 *   - It NEVER writes #Cartcount, #CartTotalText, or the mini-cart popup. Those
 *     have ONE writer — syncCountAndState() in mini-cart-popup.js — driven by the
 *     `cart:updated` event. After a qty change we dispatch cart:updated{count,total}
 *     with values taken STRAIGHT FROM the /cart/change.js response (full cart
 *     state), so there is no delta math to get wrong (BUG-B).
 *
 * SERIALIZATION — qty changes share the SAME window-level queue the "+" add uses
 *   (window.__aefCartAddQueue) and bump window.__aefCartAddPending, so adds and
 *   qty changes never run in parallel and cart-card-indicator.js skips reconciling
 *   mid-flight (BUG-O / BUG-Z). One /cart/change.js per click-burst (debounced).
 *
 * FIRST ADD still flows through the existing "+" path (mini-cart queueAdd). We
 *   only listen for the resulting cart:updated and reveal the stepper. Stepper
 *   buttons are type="button" (NOT submit) so neither perf-instant.js nor the
 *   mini-cart add-queue (both match .card__quick-add / [type=submit]) touch them.
 *
 * Endpoint shapes (Shopify): /cart/change.js {id, quantity} sets ABSOLUTE qty and
 *   returns full CART STATE; /cart.js returns full CART STATE. `id` accepts
 *   EITHER the numeric variant id OR a LINE KEY ("<variant>:<hash>" = cart
 *   item.key).
 * 🔴 21/9/2026 — HAI VAI, ĐỪNG TRỘN. variantId là DANH TÍNH (khoá đồng bộ giao
 *   diện); line key là ĐỊA CHỈ GỬI ĐI. Xem khối chú thích ở diaChiGui() bên
 *   dưới. Thẻ sản phẩm và PDP không có line key ⇒ ở đó địa chỉ vẫn là
 *   variantId, đường lùi đó phải còn nguyên.
 * 🔴 25/9/2026, vòng 53 — biến thể nằm trên ≥2 dòng giỏ (quà kèm) thì mỗi dòng
 *   khoá TRẠNG THÁI theo line key của nó: số trên ô, gốc để cộng/trừ và lượt vẽ
 *   đều là của RIÊNG dòng đó. Biến thể một dòng giữ nguyên khoá vid. Tổng biến
 *   thể (serverQty) vẫn còn, cho thẻ ngoài trang và cho TRẦN MUA — trần là của
 *   biến thể, không của dòng. Xem khoaTrangThai() và khối "ĐÃ TRẢ NỢ 8".
 *
 * Layer 2 scope: core mechanics with min=1 / no max. MIN jump + min>1 stuck land
 *   in L3; MAX cap + tooltip in L4; mobile count-circle in L5.
 * ========================================================================== */
(function () {
  'use strict';
  if (window.__aefCardStepperBound) return;
  window.__aefCardStepperBound = true;

  var COMMIT_DEBOUNCE_MS = 280; // collapse a click-burst into one /cart/change.js
  var SETTLE_MS = 50;           // let Shopify's cart-cookie lock release between ops

  // state key -> optimistic target qty while a burst/change is in flight. The
  // key is the variant id, or a cart LINE KEY when the variant spans ≥2 cart
  // lines (25/9/2026, nợ 8 — see khoaTrangThai). While set for a key, server
  // reconciles skip its hosts so the optimistic number isn't clobbered by a
  // stale /cart.js mid-burst.
  var optimistic = {};
  /* 🔴 1/11/2026 (fix-gio) — Ý ĐỊNH NHẬN DẠNG BẰNG SỐ THỨ TỰ, KHÔNG BẰNG GIÁ TRỊ.
     Từ 3 bấm + + − mạng chậm: lượt POST 4 đang bay, lượt POST 5 đã xếp hàng, cú "−" đưa ý định về lại 4
     rồi chờ hẹn gom. Lượt 4 về, so giá trị thấy "đúng bằng ý định mới nhất" nên xoá ý định; lượt 5 bay,
     hẹn gom bắn thấy không còn ý định nên không gửi gì: giỏ đứng ở 5, cú "−" mất trắng (kiểu ABA).
     soYDinh[sk] tăng ở MỖI cú bấm được nhận. Mỗi lượt ghi mang số của ý định nó gửi; chỉ lượt mang số
     MỚI NHẤT mới được xoá ý định, tự vẽ số của mình, và lùi số khi hỏng.
     Giá phải trả: cú bấm đưa số về đúng con số đang bay gửi thêm một lượt ghi đặt lại cùng số (vô hại,
     change.js đặt số tuyệt đối). Người gác: T5 của scripts/test-gio-luot-cu-khong-ve-de.js */
  var soYDinh = {};
  var burstTimer = {}; // state key -> debounce timer
  // STEPPER-RACE-2 (post-LIVE 2026-06-02): last AUTHORITATIVE cart qty per
  // variant, cached from every full-cart response (/cart/change.js, /cart.js)
  // and the /cart/add.js cart:updated{line}. The +/- buttons base their count
  // on THIS, never on qtyEl.textContent — which can still read "0" in the
  // window between a "+" add firing and its response painting the real qty,
  // making the first stepper click start from 0 → one lost click.
  var serverQty = {};

  /* 🔴 21/9/2026 — ĐỊA CHỈ GỬI ĐI TÁCH KHỎI DANH TÍNH.

     ĐO ĐƯỢC (jsdom, cảnh ngăn giỏ có HAI dòng CÙNG một biến thể: dòng quà $0
     qty 1 + dòng đã trả tiền qty 2). Bấm "+" ĐÚNG MỘT cái trên dòng đã trả
     tiền, bản cũ gửi lên /cart/change.js {"id":"111","quantity":4} — địa chỉ là
     BIẾN THỂ, không phải dòng — và máy chủ kéo CẢ HAI dòng lên 4: giỏ 3 món
     thành 8 món, dòng quà tặng tự nhân lên. Bấm "−" trên dòng quà đang ở sàn
     thì bản cũ gửi {"id":"111","quantity":2}: dòng quà KHÔNG bị xoá mà còn
     TĂNG từ 1 lên 2 — nút giảm làm việc của nút tăng.
     Cùng phép đo đó đã ghi trong assets/aef-cart-drawer.js (khối 19/9/2026, đo
     trên LIVE): change.js theo variantId khi cùng biến thể nằm trên hai dòng
     thì chạm CẢ HAI; theo line key thì chạm đúng một dòng.
     ⚠️ 25/9/2026 (vòng 53) — câu cũ ở đây ("quà tặng theo ngưỡng chiếm 10,4%
     dòng đơn nên KHÔNG phải ca hiếm") SAI TẬP ĐO: 10,4% là dòng quà của đơn
     kênh WEEE. Giỏ WEB đo 25/9 bằng Admin API chỉ đọc: 0/1.829 đơn có cùng
     biến thể trên ≥2 dòng, 0 giảm giá tự động/BXGY, theme không có
     `properties[`. Tức hôm nay là lỗi NẰM NGẦM — nó lộ ra đúng ngày tiệm bật
     quà tặng kèm trên web. [[reference_qua_tang_gia_0_lam_hong_thuoc_so_luong]]

     ⚠️ BẪY CHO NGƯỜI SAU — vì sao KHÔNG đổi thẳng `vid` thành line key ở
     MỌI chỗ: thẻ sản phẩm ngoài trang và PDP KHÔNG có line key, và số của
     chúng là TỔNG biến thể (serverQty[vid]) — thứ giữ cho thẻ khớp với giỏ.
     Khi biến thể chỉ có MỘT dòng (mọi giỏ web hôm nay), thẻ và dòng giỏ phải
     chung MỘT ô optimistic: bấm "+" trên thẻ rồi mở giỏ bấm tiếp trước khi
     lượt kia về là chuyện thường trên 📱 mạng chậm. Trần mua cũng là của biến
     thể. Nên khoá trạng thái chỉ tách sang line key khi biến thể nằm trên ≥2
     dòng — xem khoaTrangThai(). [[feedback_dung_doi_bao_dam_lay_loi_goi]]

     `data-line-key` chỉ do sections/aef-cart-drawer.liquid in ra (một nguồn
     duy nhất, lấy thẳng từ `item.key` của dòng giỏ), trên DÒNG bọc ngoài chứ
     không trên ô stepper. Thẻ sản phẩm và PDP không có thuộc tính này ⇒ tự rơi
     về variantId, đúng như bản cũ.

     ⛔ Line key CŨ thì máy chủ trả 422 "Cannot find variant" (thân không có
     item_count) ⇒ rơi vào luiVe(): lùi số về + toast. CỐ Ý KHÔNG âm thầm bắn
     lại bằng variantId — đó đúng là "cửa diện rộng" mà assets/aef-cart-drawer.js
     đã đóng ngày 20/9 vì nó mở lại chính cái bug này. Dòng mang key cũ cũng đã
     có người dọn: lightUpdate() trong aef-cart-drawer.js gỡ khỏi DOM mọi dòng
     có key không còn trong giỏ.

     ✅ ĐÃ TRẢ NỢ 8 — 25/9/2026, vòng 53. Bản 21/9 chỉ cắt phần phá hoại (lượt
     bấm không chạm sang DÒNG KHÁC nữa) nhưng để lại số HIỂN THỊ và số làm
     GỐC là TỔNG biến thể (qtyOfVariant). Đo bằng jsdom, cảnh quà 1 + đã trả 2
     (Liquid in đúng 1 và 2, rồi lượt reconcile đầu vẽ đè cả hai ô thành 3):
       · "+" MỘT cái trên dòng đã trả ⇒ gửi quantity 4 ⇒ dòng 2→4: nhích HAI bậc;
       · "−" trên dòng quà đang ở sàn ⇒ `cur` đọc 3 nên `cur <= rules.min` sai ⇒
         gửi quantity 2 ⇒ dòng quà TĂNG 1→2, không thùng rác, không xoá;
       · "Save for later" (aef-cart-drawer.js) chụp số trên ô ⇒ dòng đã trả qty 2
         mà bản ghi để dành lưu 3 ⇒ bấm Add ở danh sách là thêm DƯ một món.
     Nay: khoá trạng thái sk = khoaTrangThai(hàng, vid). Biến thể nằm trên ≥2
     dòng ⇒ mỗi dòng giỏ đọc/ghi optimistic[sk] · burstTimer[sk] · serverLine[sk]
     (số của ĐÚNG dòng, chép từ mọi phản hồi cả giỏ) và chỉ vẽ lên chính nó
     (paintKey). Biến thể một dòng và thẻ/PDP ⇒ sk = vid ⇒ đi y nguyên đường cũ.
     Trần mua vẫn tính trên TỔNG biến thể (tongSau) — không thì dòng đã trả được
     cộng vượt trần, vì phần của dòng quà không còn nằm trong số của nó.
     ✅ 1/11/2026 (fix-gio): "+"/"−" trên THẺ ngoài trang/PDP gửi variantId, mà change.js
     theo variantId đặt MỌI dòng của biến thể. Nay biến thể nằm trên ≥2 dòng thì thẻ
     không gửi gì, mở ngăn giỏ để khách chọn đúng dòng. Xem nhánh `thẻ hỏi dòng nào`.
     Người gác: scripts/test-stepper-gui-dia-chi-dong.js (cảnh 1 · 2 · 4 · 5 ·
     6 · 7 · 8).

     ⚠️ 21/9/2026, LƯỢT SOI LẠI — MỘT NGƯỜI GÁC ĐỎ VÌ BẢN VÁ NÀY, VÀ ĐỎ OAN.
     ĐỪNG GỠ BẢN VÁ ĐỂ CHO NÓ XANH LẠI. Đo được:
     `node scripts/test-drawer-jsdom.js --mock` — bản trước bản vá 96/96, sau
     bản vá 93/96, rớt đúng ba mệnh đề của nút "+" (đo bằng cách TRÁO file này
     bằng `git show HEAD:` qua `fs.readFileSync`, đúng cơ chế `che=trao` mà
     chính bộ gác đó đã dựng — không đụng một byte nào trong kho).
     Thủ phạm là MÁY CHỦ GIẢ của bộ gác, không phải cửa hàng: `sim.change()`
     tra `CATALOG[id]` bằng ĐÚNG số biến thể, nên địa chỉ dạng line key
     ("<vid>:mock" — do chính nó in ra ở `cartHtml`) không tra thấy gì và rơi
     vào nhánh `else this.lines.delete(id)` ⇒ giỏ đứng yên, "+" không nhích.
     Máy chủ THẬT nhận line key: kho này đã đo trên LIVE 19/9, và `removeLine()`
     trong assets/aef-cart-drawer.js gửi line key làm CỬA ĐẦU TIÊN từ hôm đó —
     nó không đỏ theo chỉ vì phía sau còn đường lùi variantId, thứ file này CỐ Ý
     không có.
     ⇒ Chỗ phải sửa là máy chủ giả, KHÔNG phải file này: cho `sim.change` tách
     phần trước dấu hai chấm (`String(id).split(":")[0]`) rồi mới tra CATALOG.
     Chưa sửa thì mọi lượt chạy chế độ mock còn đỏ ba mệnh đề đó — gồm lượt CI
     / lúc mất mạng (real rơi xuống mock) và các tiến trình con của `--tu-thu`. */
  var diaChiCho = {}; // khoá trạng thái -> địa chỉ gửi đi của hàng vừa bấm, chờ burst bắn

  function diaChiGui(card, vid) {
    var key = card && card.getAttribute ? card.getAttribute('data-line-key') : null;
    key = key == null ? '' : String(key).trim();
    return key || String(vid);
  }

  /* 25/9/2026, vòng 53 — KHOÁ TRẠNG THÁI CỦA MỘT HÀNG (xem "ĐÃ TRẢ NỢ 8" ở trên).
     serverLine: line key -> số lượng của ĐÚNG dòng đó; dongCua: vid -> các line
     key của biến thể; cả hai lấy từ phản hồi CẢ GIỎ gần nhất. Xoá sạch rồi ghi
     lại mỗi lượt (clear-then-set): dòng đã rời giỏ không được để lại một con số
     ma làm gốc cho lượt bấm sau. */
  var serverLine = {};
  var dongCua = {};
  /* 1/11/2026 (fix-gio) — SỐ DÒNG THẬT của biến thể, CHỈ đếm từ ảnh chụp giỏ đầy đủ. dongCua còn nhận khoá từ
     add.js (nhánh cart:updated), mà hàng giảm tự động ĐỔI line key khi đổi số lượng (đo STAGING: MAMA pack 20,
     1 món 4aff…, 2 món aa7e…, vẫn một dòng): khoá mới cộng vào khoá cũ thành "hai dòng" ảo tới lượt hoà giải.
     Câu "biến thể nằm trên mấy dòng" của cổng dưới chỉ được hỏi ở đây. */
  var soDongAnh = {};
  function laDong(sk, vid) { return sk !== String(vid); }
  function themDong(vid, key) {
    var v = String(vid), ds = dongCua[v] || (dongCua[v] = []);
    if (ds.indexOf(key) < 0) ds.push(key);
  }
  function ghiServerLine(cart) {
    var items = (cart && cart.items) || [];
    serverLine = {};
    dongCua = {};
    soDongAnh = {};
    for (var i = 0; i < items.length; i++) {
      if (!items[i] || items[i].key == null) continue;
      serverLine[String(items[i].key)] = items[i].quantity;
      themDong(items[i].variant_id != null ? items[i].variant_id : items[i].id, String(items[i].key));
    }
    for (var v in dongCua) if (Object.prototype.hasOwnProperty.call(dongCua, v)) soDongAnh[v] = dongCua[v].length;
  }
  /* KHOÁ TRẠNG THÁI của một chủ (optimistic/burstTimer/lượt vẽ):
       · thẻ / PDP (không line key)                    ⇒ vid
       · dòng giỏ, biến thể nằm trên ĐÚNG dòng này      ⇒ vid — y như bản cũ:
         số của dòng và tổng biến thể là MỘT con số, và thẻ ngoài trang với dòng
         giỏ phải dùng CHUNG một ô optimistic. Tách ra thì bấm "+" trên thẻ rồi
         mở giỏ bấm tiếp trước khi lượt kia về (mạng 📱 chậm) là dòng giỏ cộng từ
         số máy chủ CŨ ⇒ mất những cú bấm trên thẻ.
       · dòng giỏ, biến thể nằm trên ≥2 dòng (quà kèm) ⇒ line key của dòng;
       · dòng giỏ mà line key không còn trong giỏ      ⇒ line key (vẽ ra 0 —
         dòng đó đã đi, đừng vẽ số của dòng anh em lên nó).
     Chưa có ảnh chụp giỏ nào (trước lượt reconcile đầu) ⇒ vid, như bản cũ. */
  function khoaTrangThai(card, vid) {
    var dc = diaChiGui(card, vid);
    if (!laDong(dc, vid)) return dc;
    var ds = dongCua[String(vid)];
    if (!ds) return String(vid);
    if (ds.length > 1 || ds.indexOf(dc) < 0) return dc;
    return String(vid);
  }
  // Số của khoá `sk` trong một giỏ đầy đủ: dòng ⇒ số của dòng; thẻ ⇒ tổng biến thể.
  function soCuaKhoa(cart, sk, vid) {
    if (!laDong(sk, vid)) return qtyOfVariant(cart, vid);
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i] && String(items[i].key) === sk) return items[i].quantity;
    }
    return 0;
  }
  /* TỔNG biến thể nếu khoá `sk` đứng ở số `soDong` — để hỏi TRẦN (trần mua và
     tồn kho là của biến thể). Phần của các dòng KHÁC = tổng máy chủ − số máy
     chủ của dòng này, hai số lấy từ CÙNG một ảnh chụp giỏ. Chưa biết đủ hai số
     (trước lượt reconcile đầu) thì coi như biến thể chỉ có một dòng — đúng
     hành vi bản cũ. */
  function tongSau(vid, sk, soDong) {
    if (!laDong(sk, vid)) return soDong;
    var tong = serverQty[vid], dong = serverLine[sk];
    if (typeof tong !== 'number' || typeof dong !== 'number') return soDong;
    return Math.max(soDong, tong - dong + soDong);
  }

  var TRASH_SVG =
    '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"' +
    ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<polyline points="3 6 5 6 21 6"></polyline>' +
    '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
    '</svg>';
  var MINUS_HTML = '&minus;';

  // PDP instant-add (2026-06-06): the PDP buy area hosts a stepper too, but it
  // can NOT carry .wbproduct-container — product-card.liquid's global <style>
  // (present on any page that renders cards, e.g. PDP recommendations) hides
  // `product-form` inside that class, which would kill the PDP Add button.
  // Hosts therefore match EITHER selector; [data-aef-stepper-host] is the
  // PDP/none-card marker (sections/main-product.liquid).
  var HOST_SEL = '.wbproduct-container, [data-aef-stepper-host]';

  function cardsFor(vid) {
    // querySelectorAll (not getElementById) — the same variant can appear on
    // multiple cards across sections (anti-regression Pattern 3).
    return document.querySelectorAll(
      '.wbproduct-container[data-variant-id="' + vid + '"],' +
      ' [data-aef-stepper-host][data-variant-id="' + vid + '"]'
    );
  }

  // Per-product quantity rules from the card's metafield-driven data attributes
  // (set in product-card.liquid / main-product.liquid). min defaults to 1,
  // max 0 means "no cap".
  //
  // Inventory cap (ticket_BUG_stepper_inventory_cap 2026-06-07): data-stock-qty
  // carries variant.inventory_quantity ONLY when tracked + policy DENY
  // (-1 = untracked/CONTINUE = no stock cap). Effective max = min(max_qty,
  // stock). Server /cart/change.js already caps at stock; this keeps the
  // optimistic display from drifting past it under rapid clicks (Boss saw
  // 70 shown vs 66 in cart). stockCapped marks WHICH bound is binding so the
  // tooltip can say "Only N in stock" vs the max_qty purchase-limit message.
  function rulesFor(card) {
    var min = parseInt(card.getAttribute('data-min-qty'), 10);
    var max = parseInt(card.getAttribute('data-max-qty'), 10);
    var stock = parseInt(card.getAttribute('data-stock-qty'), 10);
    if (!(min >= 1)) min = 1;
    if (!(max >= 1)) max = 0;
    if (!(stock >= 0)) stock = -1; // absent / -1 / NaN -> no stock cap
    var eff = max;
    var stockCapped = false;
    if (stock >= 0 && (eff === 0 || stock < eff)) {
      eff = stock;
      stockCapped = true;
    }
    return { min: min, max: eff, stockCapped: stockCapped };
  }

  /* 🔴 14/9/2026, vòng 48 — TÊN KHẢ TRUY CẬP CỦA HAI NÚT −/+ (phát hiện tro-nang-2).
     Đo trên LIVE bằng curl: RIÊNG trang chủ in ra 22 `aria-label="Decrease quantity"`
     + 22 `aria-label="Increase quantity"`, và 0 cái mang `data-i18n-aria-label`.
     Dựng phiên thật (2 biến thể Hao Hao) rồi mở ngăn giỏ: 4 nút stepper, đếm tên
     khả truy cập ra ĐÚNG 2 giá trị. Khi cả hai dòng về sàn (qty = min — rất
     thường ở giỏ tạp hoá) thì dòng 132 cũ lật nút − thành "Remove from cart" cho
     CẢ HAI ⇒ hai cái thùng rác cùng một tên, không tên món: bấm nhầm là XOÁ nhầm
     món khỏi đơn.
     Hai việc file này làm được MỘT MÌNH (markup nằm ở 5 file .liquid không thuộc
     lượt vá này):
       ① ghép TÊN MÓN đọc từ chính ô chủ ⇒ tên duy nhất theo từng dòng;
       ② lấy động từ qua `window.aefTFb(khoá, dự phòng)` — cây cầu dựng vòng 43 mà
          tới nay CHƯA AI GỌI (ae-delivery-widget.js:1434). Thiếu khoá thì nó trả
          về CÂU DỰ PHÒNG tiếng Anh, không trả về chuỗi khoá trần như `aefT` ⇒
          hôm nay chưa có khoá trong từ điển mà vẫn KHÔNG hỏng câm; ngày ai thêm
          `card.qty_down` / `card.qty_up` / `card.remove` (cả EN lẫn VI) là nhãn
          tự nói tiếng Việt, không phải sửa thêm dòng JS nào.
     ⛔ CỐ Ý KHÔNG ghi `data-i18n-aria-label` lên hai nút này: bộ dịch
     (ae-delivery-widget.js:1214) ghi đè aria-label bằng ĐÚNG câu trong từ điển,
     tức nó sẽ CẮT MẤT tên món mình vừa ghép — và lúc đó một thuộc tính có HAI
     người ghi, đúng cái bẫy Pattern 1 của hàng rào chống hồi quy giỏ. Nhãn của
     stepper vẫn chỉ một người ghi: file này (xem tuyên bố ở đầu file). */
  var TEN_MON_SEL = '.aef-drawer__name, .aef-seasonal__name, .mdh-pc__nm,' +
    ' .product-title, .card__text, .card__heading';
  var TEN_MON_TOI_DA = 80; // đủ cho tên dài nhất của kho; dài hơn thì cắt ở khoảng trắng

  function tenMon(card) {
    var el = card.querySelector(TEN_MON_SEL);
    var t = el ? el.textContent : '';
    // Ảnh của ngăn giỏ cố ý để alt="" (trang trí) nên chỉ nhận alt khác rỗng.
    if (!t) {
      var img = card.querySelector('img[alt]');
      if (img) t = img.getAttribute('alt') || '';
    }
    t = String(t).replace(/\s+/g, ' ').trim();
    if (t.length > TEN_MON_TOI_DA) {
      var cat = t.slice(0, TEN_MON_TOI_DA);
      var khoang = cat.lastIndexOf(' ');
      t = (khoang > 40 ? cat.slice(0, khoang) : cat).trim();
    }
    return t;
  }

  // Dấu hai chấm cho trình đọc màn hình ngắt nhịp giữa ĐỘNG TỪ và TÊN MÓN, và
  // không phải chêm chữ nối ("for") — chữ nối là thứ không dịch được.
  function nhanTroNang(khoa, duPhong, ten) {
    var t = window.aefTFb ? window.aefTFb(khoa, duPhong) : duPhong;
    return ten ? t + ': ' + ten : t;
  }

  function paintCard(card, qty) {
    var stepper = card.querySelector('[data-card-stepper]');
    if (!stepper) return;
    var qtyEl = stepper.querySelector('[data-step-qty]');
    var downBtn = stepper.querySelector('[data-step-down]');
    var downIcon = stepper.querySelector('[data-step-down-icon]');
    var upBtn = stepper.querySelector('[data-step-up]');
    var rules = rulesFor(card);

    if (qty > 0) {
      card.classList.add('is-in-cart');
      stepper.hidden = false;
      stepper.setAttribute('aria-hidden', 'false');
      if (qtyEl) qtyEl.textContent = String(qty);
      // Left button: at the floor (qty <= min) the "−" becomes a TRASH that
      // removes the whole line — for ANY min, including min>1 (Boss 23/06,
      // LENH-CHO-DEV T6: replaces the old min>1 "stuck disabled −"). You can't
      // go below the minimum, so the only move at the floor is remove-entirely.
      // Above the floor the "−" decrements normally. Never disabled now.
      var atMin = qty <= rules.min;
      var isRemove = atMin;
      if (downIcon) downIcon.innerHTML = isRemove ? TRASH_SVG : MINUS_HTML;
      var ten = (downBtn || upBtn) ? tenMon(card) : '';
      if (downBtn) {
        downBtn.classList.toggle('card__step--trash', isRemove);
        downBtn.disabled = false;
        downBtn.setAttribute('aria-disabled', 'false');
        // vòng 48, 14/9/2026 — xem khối chú thích ở tenMon(): động từ qua aefTFb
        // (dịch được khi có khoá), tên món ghép sau để 4 nút không còn 2 tên.
        downBtn.setAttribute('aria-label', isRemove
          ? nhanTroNang('card.remove', 'Remove from cart', ten)
          : nhanTroNang('card.qty_down', 'Decrease quantity', ten));
      }
      // At the cap (metafield max OR stock — rules.max is the effective min of
      // both), fade the + and mark it aria-disabled. It intentionally stays
      // CLICKABLE: a hard `disabled` would mute the explanation toast — the
      // click is refused in the handler and shows "Only N in stock"/limit msg.
      if (upBtn) {
        // 25/9/2026 — ô dòng giỏ nay hiện số của DÒNG; trần hỏi TỔNG biến thể.
        var vidC = card.getAttribute('data-variant-id');
        var tongC = vidC ? tongSau(vidC, khoaTrangThai(card, vidC), qty) : qty;
        var atCap = (rules.max > 0 || rules.stockCapped) && tongC >= rules.max;
        upBtn.classList.toggle('card__step--maxed', atCap);
        upBtn.setAttribute('aria-disabled', atCap ? 'true' : 'false');
        // vòng 48, 14/9/2026 — nút "+" trước nay KHÔNG ai ghi nhãn lúc chạy, nên
        // nó đứng nguyên câu tiếng Anh trần của markup. Đưa nó về CÙNG một người
        // ghi với nút "−" (file này, theo tuyên bố đầu file) thay vì mở thêm một
        // người ghi thứ hai ở bộ dịch.
        upBtn.setAttribute('aria-label', nhanTroNang('card.qty_up', 'Increase quantity', ten));
      }
    } else {
      card.classList.remove('is-in-cart');
      stepper.hidden = true;
      stepper.setAttribute('aria-hidden', 'true');
      if (qtyEl) qtyEl.textContent = '0';
    }
  }

  /* 25/9/2026 — thay paintVariant (vẽ MỌI chủ của biến thể cùng một số).
     Một chủ thuộc khoá `sk` khi và chỉ khi khoaTrangThai(chủ) === sk: khoá
     line key chỉ vẽ đúng hàng mang key đó; khoá vid vẽ thẻ/PDP và (khi biến thể
     chỉ có một dòng) cả dòng giỏ — đúng như paintVariant cũ. Một định nghĩa. */
  function paintKey(sk, vid, qty) {
    var cards = cardsFor(vid);
    for (var i = 0; i < cards.length; i++) {
      if (khoaTrangThai(cards[i], vid) === sk) paintCard(cards[i], qty);
    }
  }
  /* Vẽ MỌI chủ của biến thể từ một giỏ đầy đủ, mỗi chủ bằng số CỦA NÓ. Chủ
     đang có lượt bấm dở dang thì để yên (lượt đó tự vẽ khi xong) — trừ khi đó
     chính là lượt vừa commit (`skVua`, ý định số `soVua`): STEPPER-RACE-1. */
  function veTuGio(cart, vid, skVua, soVua) {
    var cards = cardsFor(vid);
    for (var i = 0; i < cards.length; i++) {
      var k = khoaTrangThai(cards[i], vid);
      if (optimistic[k] != null && !(k === skVua && soYDinh[k] === soVua)) continue;
      paintCard(cards[i], soCuaKhoa(cart, k, vid));
    }
  }

  function qtyOfVariant(cart, vid) {
    var q = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(vid)) q += items[i].quantity;
    }
    return q;
  }

  function dispatchCartUpdated(count, total, anhGio) {
    // Hand the new totals to the single source (mini-cart syncCountAndState).
    var detail = { source: 'card-stepper' };
    if (typeof count === 'number') detail.count = count;
    if (typeof total === 'number') detail.total = total;
    /* 28/9/2026 (vòng 53, đợt 3) — `anhGio` = thân /cart/change.js (CẢ GIỎ máy chủ
       vừa ghi). Thanh free-ship (aef-fsb.js nhanAnhSuKien) nhận nó làm bản chụp khi
       khớp count + total, nên bấm +/− quay về một giỏ đã biết phí không còn chớp
       "Add $X…" 150–300 ms chờ GET /cart.js. KHÔNG đặt vào `cart` (gói /cart.js của
       ngăn giỏ — total_price của change.js phồng, BUG-H).
       Người gác: scripts/test-noi-phat-gio-khong-chop-add.js */
    if (anhGio) detail.anhGio = anhGio;
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    } catch (e) {
      var ev = document.createEvent('Event');
      ev.initEvent('cart:updated', true, true);
      document.dispatchEvent(ev);
    }
  }

  function settle(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // MAX-limit notice — black tooltip above the + for ~1.6s. `message` overrides
  // the default text (stock cap: "Only N in stock" via aefT); without it the
  // metafield-limit copy is restored from aefT/data-i18n default.
  var tooltipTimers = {};
  /* 🔴 15/9/2026, vòng 49 — HAI HẸN GIỜ, CHỈ MỘT CÁI CÓ NGƯỜI GIỮ DÂY.
     Lượt hiện bong bóng đặt HAI hẹn giờ nối nhau: 1600ms để mờ đi (gỡ
     `is-visible`), rồi 220ms nữa để `hidden = true` khi hiệu ứng mờ chạy xong.
     Trước hôm nay chỉ cái NGOÀI được cất vào `tooltipTimers[key]`; cái TRONG
     không ai giữ ⇒ không ai huỷ được. Khách bấm "+" lần nữa đúng trong 220ms
     đó thì lượt mới bật bong bóng lên, rồi hẹn giờ MỒ CÔI của lượt trước bắn
     và dập tắt nó — bấm hai lần, không thấy một chữ giải thích nào.
     `clearTimeout` ở lượt mới vô dụng với cái ngoài vì nó ĐÃ bắn xong.
     ⇒ Cất nốt cái trong vào bảng thứ hai, lượt sau huỷ CẢ HAI.
     KHÔNG đổi sang nghe `transitionend`: `aef-marketdeals.css:287` tắt hẳn
     transition cho chính bong bóng này, sự kiện có thể không bao giờ bắn —
     đó là đem BẢO ĐẢM (hẹn giờ luôn chạy) đổi lấy một LỜI GỌI có thể không có. */
  var tooltipHideTimers = {};
  function showTooltip(stepper, message) {
    var tip = stepper.querySelector('[data-step-tooltip]');
    if (!tip) return;
    var fallback = (window.aefT ? window.aefT('card.max_tooltip') : null) || 'Max reached';
    /* 🔴 17/8 vòng 15 — MỘT NODE, HAI NGƯỜI GHI (Pattern 1 của hàng rào chống
       hồi quy). Bong bóng này mang sẵn `data-i18n="card.max_tooltip"` trong
       markup thẻ. Khi mình truyền `message` riêng (ví dụ «Chỉ còn 3 trong
       kho» — con số duy nhất có ích ở đây), textContent bị ghi ở ĐÂY, nhưng
       `applyTranslations()` quét TOÀN TÀI LIỆU vẫn coi node này là của nó và
       kéo về chữ mặc định «Đã đạt giới hạn mua».
       Dựng lại được: ở /search bấm "+" tới trần tồn kho → bong bóng hiện 1,6s;
       trong 1,6s đó sửa từ khoá tìm kiếm → sau 300ms debounce,
       predictive-search.js gọi applyTranslations() → con số biến mất, đổi
       thành câu chung chung. Vòng 14 mình thêm đúng lời gọi đó.
       ⇒ Làm như sections/aef-quiz.liquid:519 đã làm: dùng chữ riêng thì GỠ
       khoá ra, rơi về mặc định thì GẮN lại. Một node, một người ghi. */
    if (message) tip.removeAttribute('data-i18n');
    else tip.setAttribute('data-i18n', 'card.max_tooltip');
    tip.textContent = message || fallback;
    var key = stepper.getAttribute('data-variant-id') || '';
    tip.hidden = false;
    void tip.offsetWidth; // reflow so the opacity transition runs
    tip.classList.add('is-visible');
    if (tooltipTimers[key]) clearTimeout(tooltipTimers[key]);
    if (tooltipHideTimers[key]) clearTimeout(tooltipHideTimers[key]);
    tooltipTimers[key] = setTimeout(function () {
      tip.classList.remove('is-visible');
      tooltipHideTimers[key] = setTimeout(function () { tip.hidden = true; }, 220);
    }, 1600);
  }

  // Commit the final target qty for one variant via /cart/change.js, serialized
  // on the shared add/change queue.
  /* 🔴 17/8 vòng 16 — ĐƯỜNG LÙI CHO SỐ LƯỢNG LẠC QUAN.
     Đây là chỗ optimistic thật nhất theme: `paintKey(sk, vid, next)` (trước
     25/9 là paintVariant) vẽ số mới
     TRƯỚC khi hỏi máy chủ. Nhưng trước hôm nay nhánh hỏng chỉ có `console.warn`
     — không lùi số, không toast, và (nặng nhất) không phát `cart:updated` nên
     `scheduleReconcile()` cũng không bao giờ chạy. Màn hình đứng ở CON SỐ SAI
     cho tới khi khách tự tải lại trang.
     Ca thật dựng được: giỏ để lâu, hàng bán hết dưới tay khách ⇒
     `/cart/change.js` trả 422, thân JSON là `{status:422,…}` KHÔNG có
     `item_count` ⇒ rơi đúng nhánh `else`. Khách bấm "+" thấy 4, giỏ thật có 3,
     tới checkout mới biết.
     `grep aefShowAddError assets/card-stepper.js` trước hôm nay = 0 kết quả:
     cả file không có một đường báo lỗi nào.

     ⚠️ Chốt chống tranh chấp: chỉ lùi khi ý định lạc quan vẫn ĐÚNG BẰNG lượt
     vừa gửi. Có lượt bấm mới hơn đang chờ thì lượt đó tự lo — lùi ở đây là
     giật số xuống dưới tay khách đang bấm. Cùng một chốt với nhánh vẽ thành
     công ở trên (STEPPER-RACE-1).

     🔴 25/9/2026, vòng 53 — CÂU BÁO PHẢI ĐÚNG CHIỀU KHÁCH VỪA BẤM.
     Trước hôm nay lời gọi dưới đây KHÔNG kèm kiểu, nên showAddErrorToast()
     (aef-cart-drawer.js) hiểu mọi lượt hỏng là lượt THÊM. Đo bằng jsdom: dòng
     qty 1, bấm "−" (đã thành 🗑), mất mạng/429 ⇒ "Couldn't add to cart —
     please try again" / "Không thêm được vào giỏ"; 422 ⇒ "Couldn't add — item
     limit reached or out of stock". Khách vừa BỎ món mà đọc "không thêm được".
     Hàm này đã có sẵn đủ dữ kiện để biết chiều: `qty` là đích vừa gửi, `chuan`
     là số máy chủ TRƯỚC lượt đó. Về 0 ⇒ 'xoa' · dưới số máy chủ ⇒ 'cap-nhat'
     · còn lại (tăng) ⇒ giữ nguyên câu của đường thêm như cũ.
     Người gác: scripts/test-bot-hang-hong-noi-dung-thao-tac.js
     25/9/2026 (nợ 8) — `sk` là khoá trạng thái của hàng vừa bấm (thiếu thì
     rơi về vid); `chuan` là số máy chủ CỦA ĐÚNG khoá đó (dòng ⇒ serverLine). */
  function luiVe(vid, qty, status, sk, so) {
    sk = sk || String(vid);
    if (optimistic[sk] != null && soYDinh[sk] !== so) return;
    delete optimistic[sk];
    var chuan = laDong(sk, vid) ? serverLine[sk] : serverQty[vid];
    if (typeof chuan === 'number') paintKey(sk, vid, chuan);
    var kieu = qty === 0 ? 'xoa' : (typeof chuan === 'number' && qty < chuan ? 'cap-nhat' : undefined);
    if (typeof window.aefShowAddError === 'function') {
      try { window.aefShowAddError(status || 0, kieu); } catch (e) {}
    }
  }

  /* `diaChi` = ĐỊA CHỈ GỬI ĐI (line key khi hàng có, không thì chính vid) — xem
     khối chú thích ở diaChiGui(). `khoa` (25/9/2026, nợ 8) = KHOÁ TRẠNG THÁI
     của burst vừa bắn — xem khoaTrangThai(); nó chỉ khác vid khi biến thể nằm
     trên ≥2 dòng giỏ. `vid` vẫn là DANH TÍNH: tổng biến thể serverQty[vid] và
     bộ chọn cardsFor(vid). Thiếu tham số (bên gọi cũ / bên gọi mới nào đó quên)
     thì rơi về vid, y như bản trước. */
  function commitChange(vid, qty, diaChi, khoa) {
    var sk = khoa || String(vid);
    /* Số của ý định lượt này gửi (khối chú thích ở `soYDinh`). Đọc ở đây chứ không truyền thêm tham số:
       hàm chỉ được gọi từ hẹn gom và từ lượt gửi thay lúc rời trang, cả hai đều đúng lúc ý định mới nhất. */
    var so = soYDinh[sk];
    /* 27/9/2026 vòng 53 (C3) — `ngay` = lượt này được gửi lúc RỜI TRANG
       (guiNgayKhiRoiTrang, ngay dưới): bay NGAY, không đợi tới lượt trong hàng
       ghi chung — trang sắp đi, lượt nào còn phải đợi là lượt không bao giờ bay.
       (Mọi lượt đều mang keepalive — xem thân fetch.) Hàng ghi chung vẫn phải đợi nó xong (nối promise của nó vào đuôi
       hàng) để trang còn sống (ẩn tab) thì lượt sau vẫn nối tiếp. Lượt thường thì
       ghi sổ `choGui` (đã xếp hàng, chưa bay) để lúc rời trang còn gửi thay được
       và HUỶ bản xếp hàng — không gửi đôi, không để số cũ đè số mới. */
    var ngay = dangRoiTrang;
    /* `goi` = NGUYÊN bộ tham số của lượt này, để lúc rời trang gửi thay đúng y
       lượt đó. Cố ý chép `arguments` chứ không nêu lại từng tên tham số: người gác
       scripts/test-stepper-gui-dia-chi-dong.js dựng "bản cũ" bằng cách gỡ tham số
       địa chỉ khỏi chữ ký — nêu tên nó thêm một chỗ là bản cũ ném ReferenceError và
       mốc đỏ của nó đỏ vì nạp lỗi (đã dính, 27/9). */
    var viec = { goi: Array.prototype.slice.call(arguments), huy: false };
    window.__aefCartAddQueue = window.__aefCartAddQueue || Promise.resolve();
    window.__aefCartAddPending = (window.__aefCartAddPending || 0) + 1;
    cuaToi[sk] = (cuaToi[sk] || 0) + 1;
    if (!ngay) (choGui[sk] = choGui[sk] || []).push(viec);

    var gui = function () {
      if (!ngay) boKhoiCho(sk, viec);
      if (viec.huy) { traLuot(sk); return; } // đã gửi thay lúc rời trang
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: diaChi || String(vid), quantity: qty }),
        // C3 (27/9) — keepalive cho MỌI lượt: lượt ĐANG BAY lúc trang đi cũng phải
        // sống (đo LIVE: không keepalive thì trình duyệt huỷ nó — net::ERR_ABORTED).
        keepalive: true,
      })
        .then(function (r) {
          return r.json().catch(function () { return null; })
            .then(function (body) { return { ok: r.ok, status: r.status, cart: body }; });
        })
        .then(function (res) {
          var cart = res.cart;
          if (cart && typeof cart.item_count === 'number') {
            // Paint from the authoritative response, then hand totals to the
            // single source. NEVER write the badge/total here directly.
            // STEPPER-RACE-1: only paint when this commit is still the latest
            // intent for its key. If a newer burst raised optimistic[sk]
            // after we were queued, painting the (now stale) server qty would
            // snap the visible number back down; the newer burst's own commit
            // (already scheduled via burstTimer) paints the right value.
            // 25/9 (nợ 8): mỗi chủ của biến thể vẽ số CỦA NÓ (veTuGio) — dòng
            // giỏ số của dòng, thẻ ngoài trang tổng biến thể.
            serverQty[vid] = qtyOfVariant(cart, vid); // authoritative — refresh stepper base
            ghiServerLine(cart);
            veTuGio(cart, vid, sk, so);
            // BUG-H: /cart/change.js returns an INFLATED total_price for
            // ~200-400ms (a phantom +$10.99 constant from some server-side
            // source — verified no discount/Function in play; total_discount:0).
            // items_subtotal_price (= sum of line_prices) and the follow-up
            // /cart.js GET are correct. Hand the reliable subtotal to the single
            // writer so the header total never flashes the ghost value. Fallbacks
            // keep it working if a future Shopify response omits the field.
            var reliableTotal =
              typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price :
              typeof cart.original_total_price === 'number' ? cart.original_total_price :
              cart.total_price;
            // INVARIANT (bug-prevention 2026-06-04): only hand a real,
            // non-negative number to the single total writer. A bad/absent
            // total must not paint the header — log + sync count only.
            if (typeof reliableTotal === 'number' && reliableTotal >= 0) {
              dispatchCartUpdated(cart.item_count, reliableTotal, cart);
            } else {
              if (window.console && console.warn) console.warn('[card-stepper] commitChange: bad total in cart response, syncing count only', cart);
              dispatchCartUpdated(cart.item_count, undefined, cart);
            }
          } else {
            if (window.console && console.warn) console.warn('[card-stepper] commitChange: bad cart response shape, skipping UI sync', cart);
            luiVe(vid, qty, res.status, sk, so);
          }
          return settle(SETTLE_MS);
        })
        .catch(function (err) {
          if (window.console && console.warn) console.warn('[card-stepper] change failed', err);
          luiVe(vid, qty, 0, sk, so);
        })
        .then(function () {
          // STEPPER-RACE-1: clear the in-flight marker only if we're still the
          // latest target. A newer burst's value must survive so its queued
          // commit reads the right qty — otherwise the next commitChange fires
          // with optimistic[sk] === undefined → /cart/change.js quantity:undefined
          // → the increment is silently lost.
          if (soYDinh[sk] === so) delete optimistic[sk];
          traLuot(sk);
        });
    };
    if (ngay) {
      var dangBay = gui();
      window.__aefCartAddQueue = window.__aefCartAddQueue.then(function () { return dangBay; });
    } else {
      window.__aefCartAddQueue = window.__aefCartAddQueue.then(gui);
    }
  }

  /* 27/9/2026 vòng 53 (C3) — RỜI TRANG GIỮA HẸN GOM.
     Đo trên LIVE (Chromium, MAMA đang giữ 4): bấm "+" trên thẻ ở /search rồi
     history.back() sau 50 ms / 150 ms ⇒ giỏ vẫn 4, KHÔNG một lượt change.js nào
     rời máy (📱 chạm cũng vậy). Bấm liên kết sau 50–150 ms thì lượt ghi bay ở
     ~320 ms rồi bị trình duyệt HUỶ (net::ERR_ABORTED) — tới được chỉ vì trang sau
     về chậm hơn hẹn gom. Hẹn giờ COMMIT_DEBOUNCE_MS chết cùng trang (hoặc đóng
     băng trong bfcache) ⇒ thay đổi khách đã thấy trên ô số không bao giờ tới.
     Nay `pagehide` / `visibilitychange`→hidden: với mỗi khoá còn ý định CHƯA BAY
     (đang trong hẹn gom, hoặc đã xếp hàng sau một lượt đang bay) ⇒ gửi NGAY số MỚI
     NHẤT bằng fetch keepalive — cùng thân, cùng địa chỉ (line key) mà hẹn gom sẽ
     gửi; hẹn giờ bị huỷ, bản xếp hàng bị đánh dấu huỷ ⇒ đúng một lần. Lượt ĐANG
     BAY lúc trang đi thì sống nhờ keepalive có sẵn trên mọi lượt (đo LIVE với bản
     chỉ-gửi-lúc-rời-trang: /cart back sau 150 ms, hẹn gom bắn ~360 ms, trang đi
     ~400 ms ⇒ lượt đang bay bị huỷ, giỏ vẫn 4).
     ⛔ Hàng ghi chung còn lượt của NGƯỜI KHÁC (thêm hàng của mini-cart/ngăn giỏ,
     hoặc stepper của món khác) chờ/bay ⇒ KHÔNG gửi: hai lượt ghi song song trên
     một giỏ là đúng cửa sổ L1 (lượt về sau ghi đè bằng ảnh chụp cũ — có thể làm
     mất chính món vừa thêm). Ca đó để nguyên như cũ: hẹn gom tự bắn nếu trang còn
     sống. Không chặn lối ra nào, không thêm hàng đợi, không giữ trang lại.
     ⚠️ Ngoại lệ duy nhất của luật "không chạy song song" ở đầu tệp là pagehide khi
     lượt của CHÍNH khoá đang bay (trang đi rồi thì lượt xếp hàng không bao giờ bay).
     CHỈ ẩn tab thì không — xem `chiAn` ở guiNgayKhiRoiTrang().
     Người gác: scripts/test-roi-trang-giua-hen-gom.js */
  var banBurst = {};   // khoá trạng thái -> hàm bắn hẹn gom đang chờ (chính hàm setTimeout sẽ gọi)
  var choGui = {};     // khoá trạng thái -> các lượt đã xếp hàng, CHƯA gọi fetch
  var cuaToi = {};     // khoá trạng thái -> số lượt của file này còn trong hàng ghi (chờ + đang bay)
  var dangRoiTrang = false;
  function boKhoiCho(sk, viec) {
    var ds = choGui[sk];
    if (!ds) return;
    var i = ds.indexOf(viec);
    if (i >= 0) ds.splice(i, 1);
    if (!ds.length) delete choGui[sk];
  }
  function traLuot(sk) {
    window.__aefCartAddPending = Math.max(0, (window.__aefCartAddPending || 1) - 1);
    cuaToi[sk] = (cuaToi[sk] || 1) - 1;
    if (cuaToi[sk] <= 0) delete cuaToi[sk];
  }
  /* `chiAn` (27/9, lượt soi thứ hai) — true khi CHỈ ẩn tab (visibilitychange→hidden:
     đổi tab / khoá máy / đổi app), tức trang VẪN SỐNG và hàng ghi chung vẫn giao được
     lượt kế tiếp đúng thứ tự. Khoá nào còn lượt của CHÍNH nó đang bay (cuaToi trừ số
     đang xếp hàng trong choGui) thì bỏ qua: gửi ngay lúc đó là hai lượt ghi SONG SONG
     trên cùng một dòng = cửa sổ L1 (đã dựng lại bằng máy chủ giả lost-update: bấm tới
     6, giỏ về 5, số trên thẻ tụt theo). Bản trước bản vá C3 xếp nối ở ca này và đúng.
     Tệ nhất của lối bỏ qua: tab bị hệ điều hành giết ngay trong lúc ẩn mà không có
     pagehide ⇒ lượt sau mất — đúng bằng trước bản vá C3, không tệ hơn.
     pagehide (chiAn false) thì trang chắc chắn đi, lượt xếp hàng không bao giờ bay
     nữa ⇒ vẫn gửi ngay; tệ nhất là số cũ thắng, cũng đúng bằng trước bản vá. */
  function guiNgayKhiRoiTrang(chiAn) {
    var ds = {}, k;
    for (k in banBurst) if (Object.prototype.hasOwnProperty.call(banBurst, k)) ds[k] = 1;
    for (k in choGui) if (Object.prototype.hasOwnProperty.call(choGui, k) && choGui[k].length) ds[k] = 1;
    for (k in ds) {
      if (!Object.prototype.hasOwnProperty.call(ds, k)) continue;
      if ((window.__aefCartAddPending || 0) - (cuaToi[k] || 0) > 0) continue; // có lượt ghi KHÁC
      if (chiAn === true && (cuaToi[k] || 0) - (choGui[k] || []).length > 0) continue; // chỉ ẩn tab, lượt của CHÍNH khoá đang bay
      var cho = choGui[k] || [];
      var cuoi = cho.length ? cho[cho.length - 1] : null;
      for (var i = 0; i < cho.length; i++) cho[i].huy = true;
      delete choGui[k];
      dangRoiTrang = true;
      try {
        if (banBurst[k]) { clearTimeout(burstTimer[k]); banBurst[k](); }
        else if (cuoi) commitChange.apply(null, cuoi.goi);
      } finally { dangRoiTrang = false; }
    }
  }
  window.addEventListener('pagehide', function () { guiNgayKhiRoiTrang(false); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') guiNgayKhiRoiTrang(true);
  });

  /* 🔴 1/11/2026 (fix-gio) — DÒNG SẮP BỊ XOÁ THÌ BỎ HẸN GOM CỦA NÓ.
     Bấm "+" trên dòng ngăn giỏ rồi bấm thùng rác trong 280 ms: lượt xoá vào hàng ghi trước, hẹn gom bắn
     sau và gửi số mới tới line key đã vắng ⇒ 400 ⇒ luiVe() hiện toast đỏ dù món đã rời giỏ đúng ý khách.
     removeLine() (aef-cart-drawer.js) gọi hàm này ngay trong cú bấm, khuôn CartRemoveButton của cart.js.
     Dòng biến thể một dòng dùng chung khoá vid với thẻ ngoài trang nên hỏi cả hai khoá. Chỉ bỏ cú còn nằm
     trong hẹn gom: lượt đã xếp hàng đứng TRƯỚC lượt xoá, dòng còn sống, không lỗi gì. Số trên ô về số máy
     chủ: xoá hỏng thì dòng ở lại đúng số thật, xoá được thì lượt hoà giải vẽ tiếp.
     Người gác: T6 của scripts/test-gio-luot-cu-khong-ve-de.js */
  window.aefHuyHenGomDong = function (vid, key) {
    var v = String(vid);
    [key == null ? '' : String(key), v].forEach(function (sk) {
      if (!sk || !banBurst[sk]) return;
      clearTimeout(burstTimer[sk]);
      delete burstTimer[sk];
      delete banBurst[sk];
      delete diaChiCho[sk];
      delete optimistic[sk];
      var chuan = laDong(sk, v) ? serverLine[sk] : serverQty[v];
      if (typeof chuan === 'number') paintKey(sk, v, chuan);
    });
  };

  // ---- stepper +/− clicks (delegated; buttons are type=button, no submit) ----
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var up = e.target.closest('[data-step-up]');
    var down = up ? null : e.target.closest('[data-step-down]');
    if (!up && !down) return;
    var btn = up || down;
    var stepper = btn.closest('[data-card-stepper]');
    var card = btn.closest(HOST_SEL);
    if (!stepper || !card) return;
    e.preventDefault();

    var vid = card.getAttribute('data-variant-id');
    if (!vid) return;

    // 25/9/2026 (nợ 8) — khoá trạng thái của ĐÚNG hàng vừa bấm (khoaTrangThai):
    // line key khi biến thể nằm trên ≥2 dòng giỏ, còn lại là vid như bản cũ.
    var sk = khoaTrangThai(card, vid);
    /* 🔴 1/11/2026 (fix-gio) — THẺ HỎI DÒNG NÀO. Thẻ/PDP không có line key, số trên ô là TỔNG biến thể, mà
       change.js theo variantId đặt MỌI dòng về cùng số: biến thể trên hai dòng (1 + 3) bấm "+" ⇒ gửi 5 ⇒
       giỏ 4 lên 10 (đo ở máy chủ giả, ngữ nghĩa đo LIVE 19/9). Chọn CHẶN chứ không tự gửi theo line key: máy
       không biết khách muốn đổi dòng nào, mà đoán sai thì đổi tiền. Ngăn giỏ có từng dòng, khoá theo line
       key đúng. Hôm nay chưa có đường vào (0 nhóm gói định kỳ, 0 BXGY, quà web chốt sau đơn); đây là chốt
       cho ngày nó có. Chưa có ảnh chụp giỏ thì soDongAnh rỗng, đi đường cũ. Người gác: cảnh 9 của
       scripts/test-stepper-gui-dia-chi-dong.js */
    if (!laDong(sk, vid) && (soDongAnh[String(vid)] || 0) > 1) {
      if (typeof window.aefOpenCartDrawer === 'function') window.aefOpenCartDrawer();
      else window.location.href = '/cart';
      return;
    }
    var qtyEl = stepper.querySelector('[data-step-qty]');
    // Base = optimistic (burst in flight) -> cached authoritative server qty
    // (dòng ⇒ serverLine[sk], thẻ ⇒ serverQty[vid]) -> textContent (last
    // resort). The cache kills the lost-click race where textContent still
    // reads "0" because the "+" add has not painted yet.
    var goc = laDong(sk, vid) ? serverLine[sk] : serverQty[vid];
    var cur = optimistic[sk] != null
      ? optimistic[sk]
      : (goc != null
          ? goc
          : (parseInt(qtyEl && qtyEl.textContent, 10) || 0));
    var rules = rulesFor(card);

    var next;
    if (up) {
      next = cur + 1;
      // NB: max 0 normally means "no cap", but a stock-bound 0 (tracked+DENY,
      // sold out under our feet) IS a real cap — hence the stockCapped check.
      // 25/9 — trần hỏi TỔNG biến thể sau cú bấm, không hỏi số của riêng dòng.
      if ((rules.max > 0 || rules.stockCapped) && tongSau(vid, sk, next) > rules.max) {
        // At the effective cap — refuse the increment (no local bump, no
        // enqueue) + notify. Stock-bound cap says how many are left.
        var msg = null;
        if (rules.stockCapped) {
          var tpl = (window.aefT ? window.aefT('card.stock_tooltip') : null) || 'Only {n} in stock';
          msg = tpl.replace('{n}', String(rules.max));
        }
        showTooltip(stepper, msg);
        return;
      }
    } else if (cur <= rules.min) {
      // At the floor (any min) the "−"/trash removes the ENTIRE line — you can't
      // sit below the minimum, so min>1 packs go straight to 0 (Boss 23/06, T6).
      next = 0;
    } else {
      next = cur - 1;
    }
    if (next === cur) return;

    // ticket_BUG_fly_to_cart_no_motion (2026-06-11): stepper "+" cũng bay vào
    // giỏ như mọi nút add khác — chỉ khi TĂNG và cap đã cho qua (refuse ở trên
    // return rồi). aefFlyToCart tự tìm ảnh trong card host + fallback bounce.
    if (up && window.aefFlyToCart) { try { window.aefFlyToCart(btn); } catch (flyErr) {} }

    // 21/9/2026 — địa chỉ gửi đi của ĐÚNG hàng vừa bấm. Ghi ở ĐÂY chứ không ghi
    // ngay lúc vào hàm: lượt bấm bị từ chối vì chạm trần (return ở trên) không
    // được quyền đổi địa chỉ của burst đang chờ.
    // 25/9/2026 (nợ 8) — optimistic/burstTimer/diaChiCho khoá theo `sk`. Biến
    // thể nằm trên ≥2 dòng ⇒ mỗi DÒNG một burst riêng, chỉ vẽ lên chính nó.
    // Biến thể một dòng ⇒ sk = vid: thẻ ngoài trang và dòng giỏ chung một
    // burst, gửi tới địa chỉ của hàng bấm SAU CÙNG — y như bản 21/9.
    diaChiCho[sk] = diaChiGui(card, vid);
    soYDinh[sk] = (soYDinh[sk] || 0) + 1;
    optimistic[sk] = next;
    paintKey(sk, vid, next); // optimistic, instant — monotonic display under rapid clicks

    if (burstTimer[sk]) clearTimeout(burstTimer[sk]);
    // 27/9/2026 (C3) — hàm bắn được cất vào banBurst[sk] để lúc rời trang
    // guiNgayKhiRoiTrang() gọi CHÍNH nó (sau khi huỷ hẹn giờ) — một thân, một đường.
    banBurst[sk] = function () {
      delete burstTimer[sk];
      delete banBurst[sk];
      // STEPPER-RACE-1: if an earlier resolve already committed+cleared this
      // key (e.g. a net-zero burst that landed back on the committed qty),
      // there's nothing new to send — never call change.js with quantity:undefined.
      if (optimistic[sk] == null) { delete diaChiCho[sk]; return; }
      var dc = diaChiCho[sk];
      delete diaChiCho[sk];
      commitChange(vid, optimistic[sk], dc, sk);
    };
    burstTimer[sk] = setTimeout(banBurst[sk], COMMIT_DEBOUNCE_MS);
  }, false);

  // ---- mobile count-circle (<=480px): collapsed stepper is a circle showing the
  // qty; first tap expands to the full [🗑/− N +], a tap elsewhere (or 3s idle)
  // collapses it back. Pure class toggle — the <=480px CSS does the visual; on
  // desktop .is-expanded is inert so this is a no-op there. Runs in CAPTURE so a
  // tap on the collapsed circle can stop the +/− handler from also firing. ----
  /* 🔴 15/9/2026, vòng 49 — CỤM NÀY ĐANG NGỦ. ĐỌC TRƯỚC KHI ĐỤNG VÀO.

     Không còn trang nào thu ô thành vòng tròn nữa: luật ẩn hai nút
     (`aef-product-card.css:343`, trong `@media (max-width: 480px)`) bị chính
     file đó khai LẠI ở `:1154` — `@media (max-width: 600px)` … `.card__stepper
     :not(.is-expanded) .card__step { display: inline-flex }` — CÙNG độ ưu tiên
     (0,5,0) nhưng nằm SAU nên thắng ở mọi khổ ≤480px. Bộ thẻ Harris Farm (B16)
     cố ý mở lại: "ô nằm ở hàng nút, có sẵn cả bề ngang thẻ" (chú thích :1146).
     ⇒ `dangThuVongTron()` luôn trả false ⇒ `.is-expanded` không bao giờ được
     gắn ⇒ nhánh chặn không bao giờ chạy.

     GIỮ chứ không gỡ, vì đây là LƯỚI AN TOÀN: hễ một khối CSS nào đó giấu +/−
     trở lại (trang mới, app mới, luật đè mới) thì cú chạm đầu phải bung ô chứ
     không được rơi vào ô-thu-mà-vẫn-đổi-số. `scripts/test-cu-cham-dau-tien-
     khong-bi-nuot.js` CA 3 dàn dựng đúng cảnh đó và đòi thấy hành vi chặn quay
     lại — gỡ cụm này là cổng phát hành đỏ.

     MUỐN TRẢ LẠI VÒNG TRÒN thì phải bật CẢ HAI cùng lúc: khối CSS ≤480px
     (:333-350) và khối ≤600px (:1148-1156) phải thôi đá nhau. Bật một mình JS
     không đổi được gì.

     ── 20/8/2026, vòng 24 — vì sao điều kiện là CSS chứ không phải bề ngang màn ──
     `isMobile()` một mình là SAI. Cơ chế "chạm lần đầu để bung" chỉ có nghĩa khi
     ô THẬT SỰ đang thu. Hồi đó trang chủ có khối đè riêng giữ nguyên thanh ngang
     đầy đủ (khối đó nay đã thành luật chung cho MỌI trang, xem trên), nên ở trang
     chủ 📱: `isMobile()` đúng, `.is-expanded` chưa có ⇒ nhánh chặn chạy ⇒
     `stopPropagation()` NUỐT cú chạm. Nút "+" đo được 44×34 và `display:flex`
     (hiện rõ, bấm trúng) mà số lượng không đổi; sau 3 giây `scheduleCollapse` gỡ
     class ⇒ lần chạm sau lại mất tiếp. Khách bấm hai lần mới ăn một.
     Hỏi thẳng trình duyệt "nút +/− có đang bị giấu không" là hỏi ĐÚNG cái điều
     kiện sinh ra cơ chế này, nên nó tự đúng ở mọi trang và mọi khổ máy. */
  var collapseTimer = {};
  /* Chừng nào chưa ô nào từng bung thì KHÔNG có `.is-expanded` nào trong tài
     liệu — mọi việc dọn dẹp bên dưới là dọn cái trống. Cờ này CHỈ ĐI MỘT CHIỀU
     (false→true, ngay tại dòng gắn class) nên không thể lệch xuống dưới sự
     thật: lệch lên trên cùng lắm là làm thừa đúng việc bản cũ vẫn làm.
     Nhờ nó, mỗi cú chạm trên 📱 ở bản hôm nay không còn quét toàn tài liệu và
     không còn đặt hẹn giờ 3 giây để gỡ một class không tồn tại. */
  var daTungBung = false;
  function isMobile() { return window.matchMedia('(max-width: 480px)').matches; }
  function dangThuVongTron(stepper) {
    var nut = stepper.querySelector('[data-step-up]');
    if (!nut) return false;
    var win = (stepper.ownerDocument && stepper.ownerDocument.defaultView) || window;
    var st = null;
    try { st = win.getComputedStyle(nut); } catch (e) {}
    // Không đọc được kiểu dáng thì KHÔNG chặn — thà để cú chạm đi thẳng tới +/−
    // (hỏng nhiều nhất là bung sớm một nhịp) còn hơn nuốt mất nó.
    return !!st && st.display === 'none';
  }
  function scheduleCollapse(stepper) {
    var key = stepper.getAttribute('data-variant-id') || '';
    if (collapseTimer[key]) clearTimeout(collapseTimer[key]);
    collapseTimer[key] = setTimeout(function () { stepper.classList.remove('is-expanded'); }, 3000);
  }
  document.addEventListener('click', function (e) {
    if (!isMobile() || !e.target || !e.target.closest) return;
    var stepper = e.target.closest('[data-card-stepper]');
    // PDP instant-add (2026-06-06): the PDP stepper ([data-aef-stepper-host])
    // is always full-size — it never collapses to the count-circle, so the
    // expand-on-first-tap interception must NOT eat its +/− clicks.
    if (stepper && !stepper.closest('.wbproduct-container')) return;
    if (!stepper) {
      // tap outside any stepper → collapse all expanded circles
      if (!daTungBung) return; // chưa ô nào từng bung ⇒ không có gì để gỡ
      var open = document.querySelectorAll('[data-card-stepper].is-expanded');
      for (var i = 0; i < open.length; i++) open[i].classList.remove('is-expanded');
      return;
    }
    if (!stepper.classList.contains('is-expanded') && dangThuVongTron(stepper)) {
      // collapsed circle tapped → expand only (do NOT change qty); stop the
      // +/− bubble handler from seeing this tap.
      // `dangThuVongTron` là vế MỚI (20/8/2026): thiếu nó thì trang chủ — nơi
      // nút +/− vẫn hiện đầy đủ — cũng bị nuốt cú chạm đầu tiên. Xem chú thích
      // dài ở chỗ khai hàm.
      e.preventDefault();
      e.stopPropagation();
      if (daTungBung) {
        var others = document.querySelectorAll('[data-card-stepper].is-expanded');
        for (var j = 0; j < others.length; j++) {
          if (others[j] !== stepper) others[j].classList.remove('is-expanded');
        }
      }
      stepper.classList.add('is-expanded');
      daTungBung = true;
    }
    // expanded already → let the +/− handler run; either way keep it open a bit
    if (daTungBung) scheduleCollapse(stepper);
  }, true);

  // ---- reconcile all steppers from server cart state ----
  /* 25/9/2026 (nợ 8) — mỗi chủ vẽ số CỦA NÓ (soCuaKhoa): dòng giỏ số của dòng,
     thẻ/PDP tổng biến thể. serverQty + serverLine ghi cho CẢ trang từ CÙNG một
     ảnh chụp, kể cả khi có lượt dở dang — hai bảng đó là số máy chủ, không phải
     số hiển thị, và tongSau() cần chúng cùng một thời điểm. Chỉ lượt VẼ mới
     phải nhường hàng đang có burst.
     🔴 1/11/2026 (fix-gio) — HỎI DẠNG GIỎ TRƯỚC KHI TIN. Thân lỗi JSON của /cart.js (Shopify bóp 429 trả
     {status, message}) đi lọt r.json(), không có `items` ⇒ qtyOfVariant ra 0 ⇒ MỌI thẻ về "chưa có
     trong giỏ" và serverQty thành 0: bấm "+" gửi quantity 1, giỏ 3 tụt về 1. Cùng cửa kiểm với
     mini-cart-popup.js refreshFromServer. Người gác: T3 của scripts/test-gio-luot-cu-khong-ve-de.js */
  function reconcileAll(cart) {
    if (!cart || typeof cart.item_count !== 'number' || !Array.isArray(cart.items)) return;
    ghiServerLine(cart);
    var cards = document.querySelectorAll('.wbproduct-container[data-variant-id], [data-aef-stepper-host][data-variant-id]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var vid = card.getAttribute('data-variant-id');
      var k = khoaTrangThai(card, vid);
      serverQty[vid] = qtyOfVariant(cart, vid); // authoritative — refresh stepper base
      if (optimistic[k] != null) continue; // a burst/change is in flight — leave it
      paintCard(card, soCuaKhoa(cart, k, vid));
    }
  }

  /* 🔴 1/11/2026 (fix-gio) — THÂN GET BẮT ĐẦU TRƯỚC LƯỢT GHI CUỐI KHÔNG ĐƯỢC VẼ.
     GET chậm về SAU một lượt "+" đã xong (và sau cả GET mới) vẽ ô lùi 4 → 3 và đặt serverQty về 3:
     cú "+" kế tiếp gửi lại 4, khách bấm mà giỏ đứng yên. perf-instant.js (nhịp) chỉ xếp người hỏi
     với nhau, không biết thân về lúc nào. theGio tăng ở MỌI cart:updated; mọi lượt ghi thành công
     đều phát sự kiện đó, và chính sự kiện đó hẹn lượt GET kế tiếp nên bỏ thân ở đây không mất lượt
     chốt nào. Lượt ghi HỎNG không phát sự kiện: giỏ máy chủ không đổi, thân GET vẫn đúng.
     Cùng cơ chế với theGio của aef-cart-drawer.js. Người gác: T4a của
     scripts/test-gio-luot-cu-khong-ve-de.js */
  var theGio = 0;
  var reconcileTimer = null;
  function hoiGio() {
    var theLucDi = theGio;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (theLucDi === theGio) reconcileAll(cart);
      })
      .catch(function () {});
  }
  function scheduleReconcile() {
    if (reconcileTimer) clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      reconcileTimer = null;
      hoiGio();
    }, 120);
  }

  /* 🔴 1/11/2026 (fix-gio) — TRANG VỀ TỪ BFCACHE: SỐ TRÊN Ô LÀ SỐ CŨ, VÀ NÓ LÀ GỐC CỘNG CỦA CÚ BẤM SAU.
     Tài liệu trang có cache-control private, max-age=0, must-revalidate nên trình duyệt được giữ trang
     trong bfcache: Lùi không chạy lại script nào, không có cart:updated nào. Thẻ giữ 3, sang PDP nâng
     lên 5, Lùi, bấm "+" ⇒ cộng từ serverQty 3 ⇒ gửi 4 ⇒ giỏ TỤT từ 5 về 4.
     Chỉ khi `persisted`: lượt tải thường đã có lượt hoà giải đầu, thêm một lượt là GET thừa. Hỏi NGAY,
     không qua hẹn 120 ms: khách vừa Lùi có thể bấm luôn. Mọi tệp nghe cùng sự kiện hỏi trong cùng một
     nhịp nên lớp gộp đọc giỏ của perf-instant.js chỉ ra MỘT lượt mạng.
     Người nghe anh em: mini-cart-popup.js (huy hiệu + tổng) · aef-fsb.js (thanh free-ship) · cart.js
     (bảng /cart) · aef-cart-drawer.js (bản chụp + hàng ngăn giỏ). Người gác: T2 + P6 của
     scripts/test-gio-luot-cu-khong-ve-de.js */
  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted) return;
    theGio++;                 // GET đang bay từ trước lúc đóng băng là thân cũ
    if (reconcileTimer) { clearTimeout(reconcileTimer); reconcileTimer = null; }
    hoiGio();
  });

  // Reveal stepper after the first "+" add + keep all cards in sync with any cart
  // mutation. READ + paint of our own stepper DOM only — never writes shared cart UI.
  //
  // BUG-F fast path: the mini-cart add-queue's cart:updated carries detail.line
  // (the /cart/add.js response: variant_id + cumulative quantity — see BUG-7/BUG-B).
  // Paint that variant's stepper IMMEDIATELY so the card transforms in the SAME tick
  // as the header badge, instead of waiting ~1s for the debounced /cart.js reconcile
  // (which would leave "+Add" showing while the cart already has the item → users
  // re-tap → an extra add). The full reconcile still runs as a backstop.
  // Skipped when an optimistic stepper burst is in flight for that variant (its own
  // resolve paints it) and for our own cart:updated (source 'card-stepper', no line).
  document.addEventListener('cart:updated', function (e) {
    theGio++;
    var line = e && e.detail && e.detail.line;
    if (line) {
      var vid = line.variant_id != null ? String(line.variant_id)
              : (line.id != null ? String(line.id) : null);
      if (vid && typeof line.quantity === 'number') {
        // 25/9/2026 (nợ 8) — /cart/add.js trả ĐÚNG MỘT dòng (có `key`): số
        // của dòng đó vào serverLine. Khoá vid vẽ thẻ/PDP (và dòng giỏ khi biến
        // thể chỉ có một dòng) y như cũ; biến thể nằm trên ≥2 dòng thì chỉ vẽ
        // ĐÚNG hàng giỏ mang key đó (paintKey tự lọc theo khoaTrangThai).
        var lk = line.key != null ? String(line.key) : '';
        if (lk) { serverLine[lk] = line.quantity; themDong(vid, lk); }
        if (optimistic[vid] == null) {
          serverQty[vid] = line.quantity; // /cart/add.js -> cumulative variant qty
          paintKey(String(vid), vid, line.quantity);
        }
        if (lk && optimistic[lk] == null) paintKey(lk, vid, line.quantity);
      }
    }
    scheduleReconcile();
  });

  // Homepage Nhóm B1 (2026-06-06): lazy-injected best-product rows dispatch
  // aef:cards-injected (assets/lazy-sections.js) after inserting card DOM.
  // Re-run the debounced /cart.js reconcile so a variant already in the cart
  // paints its stepper qty on the newly injected cards. Read + paint of our
  // own stepper DOM only — same single-source rules as the cart:updated path
  // (no badge/total writes; optimistic in-flight variants are skipped).
  document.addEventListener('aef:cards-injected', scheduleReconcile);

  /* vòng 48, 14/9/2026 — ĐỔI TIẾNG THÌ NHÃN PHẢI ĐỔI THEO.
     Nhãn của hai nút −/+ được dựng lúc PAINT (nhanTroNang → aefTFb), mà lượt
     paint gần nhất thường đã chạy xong từ lâu trước khi khách bấm nút VI.
     Bộ dịch chỉ quét `[data-i18n-aria-label]`, mà hai nút này cố ý KHÔNG mang
     thuộc tính đó (xem chú thích ở tenMon) ⇒ không ai vẽ lại giúp. Nghe
     `aef:lang-changed` (ae-delivery-widget.js:1103) rồi vẽ lại TỪ SỐ ĐÃ BIẾT —
     không hỏi /cart.js, không đụng badge/tổng tiền, không sinh lượt mạng nào. */
  document.addEventListener('aef:lang-changed', function () {
    var cards = document.querySelectorAll('.wbproduct-container[data-variant-id], [data-aef-stepper-host][data-variant-id]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var vid = card.getAttribute('data-variant-id');
      var k = khoaTrangThai(card, vid); // 25/9 (nợ 8) — số của ĐÚNG khoá của hàng
      var q = optimistic[k] != null ? optimistic[k] : (laDong(k, vid) ? serverLine[k] : serverQty[vid]);
      if (typeof q === 'number') paintCard(card, q);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReconcile);
  } else {
    scheduleReconcile();
  }
})();

;

/* ===== aef-cart-drawer.js ===== */
/* ============================================================================
 * AE Foodstore — Cart Drawer behavior. ticket_cart_drawer_redesign.md.
 *
 * SINGLE-SOURCE OWNERSHIP (feedback_cart_ui_anti_regression.md):
 *   This file writes ONLY drawer-internal display: open/close state, per-row
 *   line-totals, footer totals (subtotal/savings/total), the item count spans,
 *   the is-empty state, and removes a row on trash. It NEVER writes:
 *     - the stepper qty number  → owned by assets/card-stepper.js (reused; the
 *       drawer rows carry its [data-aef-stepper-host] + .card__stepper markup, so
 *       +/- go through the SHARED /cart/change.js queue with the SAME stock-cap).
 *     - #Cartcount badge / #CartTotalText → owned by mini-cart-popup.js
 *       syncCountAndState (via the cart:updated event).
 *     - the free-ship bar → owned by free-shipping-bar.js (.free-shipping-bar
 *       class, BUG-A).
 *
 * REFRESH MODEL:
 *   - On OPEN, if dirty (cart changed in THIS tab): re-fetch the whole section
 *     (Section Rendering API) so items added while the drawer was closed appear
 *     with correct stock-cap/min-max data (the /cart.js JSON lacks
 *     inventory_quantity + our custom metafields).
 *   - On OPEN, if NOT dirty: the same LIGHTWEIGHT /cart.js pass as below. `dirty`
 *     only sees writes from this tab, so a cart changed in another tab / at /cart
 *     (bfcache back) / already checked out would otherwise leave rows + footer at
 *     the page-load snapshot. (vòng 49)
 *   - While OPEN, on cart:updated: a LIGHTWEIGHT /cart.js pass updates line
 *     totals + footer + count and drops emptied rows — it does NOT replace the
 *     stepper DOM, so a rapid +/- burst is never yanked out from under the user.
 *     card-stepper.js paints the stepper qty itself off the same /cart.js.
 * ========================================================================== */
(function () {
  'use strict';
  if (window.__aefCartDrawerBound) return;
  window.__aefCartDrawerBound = true;

  var MOBILE_BP = 768;
  var drawer, panel, backdrop, itemsEl, footEl;
  var isOpen = false;
  var lastFocused = null;
  var refreshTimer = null;
  // The server-rendered drawer (in the layout) goes stale after an AJAX add while
  // closed. Mark dirty on any cart:updated; a dirty OPEN pulls fresh rows from the
  // drawer SECTION ALONE (/cart?section_id=aef-cart-drawer — see taiNganGio()).
  var dirty = false;
  // Gói /cart.js mà chính lượt ghi giỏ vừa rồi đã nhận, đính kèm trong sự kiện
  // `cart:updated`. Dùng ĐÚNG MỘT LẦN rồi xoá — xem lightUpdate().
  var gioTuSuKien = null; // gói /cart.js do chính lượt ghi giỏ vừa rồi trả về

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // 23/10/2026 (GG1) — tiền đi qua MỘT hàm: window.aefTien (layout/theme.liquid, <head>),
  // cùng định dạng với filter money của Liquid ("$1,019.32"). Bản cũ in "$1019.32" nên tổng
  // ngăn giỏ đổi kiểu số ngay lúc mở. Dự phòng (giàn jsdom, layout khác) cũng có dấu phẩy.
  // Người gác: scripts/test-tien-mot-dinh-dang.js
  function money(cents) {
    var xu = Number(cents || 0);
    if (typeof window.aefTien === 'function') return window.aefTien(xu);
    return '$' + (xu / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function lockBody(on) {
    document.body.classList.toggle('aef-drawer-open', !!on);
  }

  function open() {
    drawer = drawer || $('[data-aef-cart-drawer]');
    if (!drawer || isOpen) return;
    lastFocused = document.activeElement;
    isOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockBody(true);
    fillZip();
    // Seed the drawer's OWN header count from the authoritative badge (mini-cart-popup
    // keeps #Cartcount correct) the instant we open — otherwise opening via the toast
    // "View cart" flashes the stale page-load "0 items" until fullRefresh's section fetch
    // resolves ~700ms later (ticket_cart_polish_round2 #2). Badge is READ-only here;
    // the drawer owns data-aef-drawer-count, so no single-source conflict.
    seedDrawerCount();
    /* 🔴 15/9/2026 vòng 49 — MỞ GIỎ MÀ `dirty` CÒN false THÌ NỬA TRÊN VÀ NỬA DƯỚI
       CỦA CÙNG MỘT PANEL NÓI HAI CÁI GIỎ KHÁC NHAU.
       `dirty` chỉ bật trong người nghe `cart:updated` ⇒ chỉ khi giỏ đổi TRONG CHÍNH
       TAB NÀY. Giỏ đổi ở tab khác, ở trang /cart rồi back bằng bfcache, hay khách
       vừa thanh toán xong ở tab kia — `dirty` vẫn false. Bản cũ lúc đó vẫn gọi
       refreshExtrasFromServer(): nó GET /cart.js, CẦM NGUYÊN cái giỏ thật trong tay,
       nhưng chỉ vẽ coupon + các khối phụ (chip free-ship, điểm thưởng, gợi ý mua
       chung, quà tặng). HÀNG, tạm tính, tiết kiệm, TỔNG, số món, lớp is-empty và
       nút Thanh toán vẫn là bản máy chủ in lúc TẢI TRANG — vì chỉ paintFooter ghi
       những ô đó, mà không ai gọi nó.
       Vá bằng `else scheduleLightUpdate()`: lightUpdate cũng tự đi hỏi /cart.js
       (nên KHÔNG thêm một lượt mạng nào so với refreshExtrasFromServer nó thay),
       nhưng nó dựng lại hàng khi có dòng mới, gỡ dòng đã biến mất, rồi kết bằng
       paintFooter — và paintFooter gọi luôn renderCouponRow + paintExtras, tức phủ
       trọn phần việc cũ.
       KHÔNG gọi cả hai: hai lượt /cart.js cho một lượt mở.
       KHÔNG chỉ nhét paintFooter vào refreshExtrasFromServer: hàng vẫn cũ, mà
       paintFooter tính "tiết kiệm" bằng data-unit-save đọc trên chính các dòng cũ đó.
       Nhánh dirty không đổi — fullRefresh() lấy cả hàng lẫn chân giỏ từ HTML máy chủ
       rồi tự gọi refreshExtrasFromServer() ở cuối (:171), nên lượt gọi vô điều kiện
       ở đây trước giờ chỉ là một lượt /cart.js thừa trên nhánh đó.
       Người gác: scripts/test-mo-gio-sach-van-lam-moi-chan-gio.js */
    if (dirty) fullRefresh(); // pull fresh server-rendered rows (adds while closed)
    else scheduleLightUpdate(); // giỏ đổi ở NƠI KHÁC: /cart.js → hàng + chân giỏ + khối phụ
    renderSaved();          // v2: saved-for-later list + count
    var closeBtn = $('[data-aef-drawer-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!drawer || !isOpen) return;
    isOpen = false;
    /* 🔴 6/9/2026 vòng 43 — DÂY AN TOÀN THỨ HAI CHO GÓI /cart.js ĐÍNH KÈM.
       `gioTuSuKien` chỉ được NHẬN khi ngăn giỏ đang mở, nhưng nó nằm CHỜ tới
       lúc lightUpdate chạy (debounce 160ms). Đóng ngăn giỏ trong khoảng ấy thì
       gói treo lại vô thời hạn, rồi một lượt vẽ RẤT LÂU SAU (nút VI/EN gọi
       thẳng scheduleLightUpdate ở cuối file) đem nó ra vẽ chân giỏ — số của
       một cái giỏ đã cũ, và KHÔNG có lượt /cart.js nào để tự sửa.
       Đóng giỏ là vứt gói VÀ huỷ hẹn giờ đang treo. Không mất gì: `dirty` đã
       bật từ cart:updated nên lần mở sau open() tự gọi fullRefresh(), lấy cả
       hàng lẫn chân giỏ mới từ máy chủ.
       Người gác: scripts/test-them-hang-khong-hoi-gio-hai-lan.js (kịch bản 2) */
    gioTuSuKien = null;
    if (refreshTimer) { clearTimeout(refreshTimer); refreshTimer = null; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lockBody(false);
    if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} }
  }

  /* 27/9/2026 — MỘT chỗ ghi số món của ngăn giỏ (đầu ngăn + dòng tạm tính). Ghi SỐ và
     data-aef-dem trên cùng phần tử: nhãn "item/items/món" đứng sau là chữ tĩnh của từ
     điển (snippets/aef-nhan-dem-mon.liquid) và luật CSS duy nhất chọn số ít/số nhiều
     theo thuộc tính này. Trước đây nhãn cố định "items" ⇒ LIVE in "Cart · 1 items". */
  function veSoMon(n) {
    $all('[data-aef-drawer-count]', drawer).forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-aef-dem', String(n));
    });
  }

  // Read the authoritative badge (#Cartcount, owned by mini-cart-popup) and mirror it
  // onto the drawer's own count spans so the header never shows a stale "0 items".
  function seedDrawerCount() {
    var badge = document.getElementById('Cartcount');
    if (!badge) return;
    var n = parseInt((badge.textContent || '').trim(), 10);
    if (isNaN(n)) return;
    veSoMon(n);
  }

  function fillZip() {
    var zip = '';
    try { zip = localStorage.getItem('ae_zip_code') || ''; } catch (e) {}
    // Fallback to the geolocation cache so an AUTO-located ZIP shows in the drawer
    // too — must match the header pill (ticket_QA_batch #1). All READ-only; fillZip
    // stays the single writer of the deliv-line state (anti-regression Pattern 1).
    if (!/^\d{5}$/.test(zip)) {
      try { if (window.AE_ZONE && /^\d{5}$/.test(String(window.AE_ZONE.postal || ''))) zip = String(window.AE_ZONE.postal); } catch (e) {}
    }
    if (!/^\d{5}$/.test(zip)) {
      try { var c = JSON.parse(localStorage.getItem('ae_zone_v1') || 'null'); if (c && /^\d{5}$/.test(String(c.postal || ''))) zip = String(c.postal); } catch (e) {}
    }
    if (!/^\d{5}$/.test(zip)) zip = '';
    // 23/10/2026 (vòng 53, đợt 5b, GG4) — VÙNG KHÔNG GIAO: hỏi cờ `giao` của zone-detection.js
    //   (window.aeZoneForZip — thuần đọc; không giữ danh sách mã nào ở đây). Không giao ⇒ lớp
    //   .is-khong-giao trên dòng ZIP; aef-cart-drawer.css ẩn nhãn "Deliver to/Giao tới" khi có
    //   lớp đó (📱 vốn đã ẩn nhãn) ⇒ 🖥 đọc "📍 96910 · We don't ship to your area yet" thay vì
    //   "Deliver to 96910 · We don't ship…" (đo LIVE 18/10). GIỮ câu chép từ viên bên dưới: giỏ
    //   RỖNG ẩn thanh free-ship nên dòng này là câu báo không giao DUY NHẤT còn lại.
    //   Thiếu hàm ⇒ không lớp ⇒ hành vi cũ. Người gác:
    //   scripts/test-ngan-gio-vung-khong-giao-khong-noi-giao-toi.js
    var khongGiao = false;
    if (zip) {
      try {
        var vung = typeof window.aeZoneForZip === 'function' ? window.aeZoneForZip(zip) : null;
        khongGiao = !!(vung && vung.giao === false);
      } catch (e) {}
    }
    // SINGLE WRITER of the delivery-line state. No ZIP → compact one-liner via
    // .is-zip-unset (.aef-drawer__deliv-none) so it can't wrap to 3 rows; ZIP
    // known → "Deliver to {zip} · …" (ticket_cart_lean_visual_deltas #3).
    $all('[data-aef-deliv]', drawer).forEach(function (el) {
      el.classList.toggle('is-zip-unset', !zip);
      el.classList.toggle('is-khong-giao', khongGiao);
    });

    // 2026-08-16 — CÂU HỨA GIAO HÀNG THEO VÙNG.
    //   Dòng phụ này trước đây ghi cứng "giao trong ngày nếu đặt trước 2 giờ
    //   chiều" cho MỌI khách. Giao trong ngày chỉ đúng với DFW, mà ~90% lưu
    //   lượng web là CA/NY ⇒ đa số khách mở giỏ ra là đọc một lời hứa không có
    //   thật. Nay SOI LẠI đúng câu mà header đang hiện — ae-delivery-widget.js
    //   là nơi DUY NHẤT tính câu đó theo vùng (render() → [data-aef-dw-promise]).
    //   Chỉ ĐỌC, không tính lại: giữ đúng một người tính, giống seedDrawerCount()
    //   soi #Cartcount. Không có nguồn (widget chưa dựng xong) thì để nguyên chữ
    //   cũ còn hơn ghi đè bằng chuỗi rỗng.
    var promiseSrc = document.querySelector('[data-aef-dw-promise]');
    var promiseTxt = promiseSrc ? (promiseSrc.textContent || '').trim() : '';
    if (promiseTxt) {
      $all('[data-aef-drawer-promise]', drawer).forEach(function (el) { el.textContent = promiseTxt; });
    }
    $all('[data-aef-drawer-zip]', drawer).forEach(function (el) {
      el.textContent = zip || (window.aefT ? window.aefT('drawer.zip_unset') : 'your area');
    });
  }

  // ---- Lấy NGĂN GIỎ dựng theo giỏ HIỆN TẠI (fullRefresh + rebuildItems) ------
  /* 🔴 25/9/2026 vòng 53 [code-cart#3] — HỎI ĐÚNG SECTION, ĐỪNG TẢI CẢ TRANG /cart.
     Hai lượt dưới đây từng GET nguyên trang /cart (~67 KB br, ~246 KB thô) rồi
     DOMParser cả trang, chỉ để lấy [data-aef-drawer-items] + [data-aef-drawer-foot]
     + lớp is-empty — vì một tiền đề SAI: "Section Rendering API không dựng được
     {% section %} đặt trong layout". Section tĩnh trong layout có id = TÊN FILE,
     nên /cart?section_id=aef-cart-drawer trả đúng ngăn giỏ này (~5,4 KB br, ~20 KB
     thô) — cùng khuôn "gọi bằng tên file" với aef-drawer-crosssell. Đo LIVE
     22–25/9, giỏ 0/1/2 món: vùng hàng giống TỪNG KÝ TỰ, chân giỏ chỉ khác chuỗi
     JWT của nút thanh toán nhanh (chuỗi đó đổi theo từng lượt hỏi, kể cả giữa hai
     lượt /cart với nhau). Giữ đường /cart, đừng dùng location.pathname.
     ĐƯỜNG LÙI — cộng thêm, không thay thế: lượt section ném lỗi mạng, hoặc trả về
     mà KHÔNG có [data-aef-drawer-items] (file section đổi tên ⇒ 404, trang 429,
     "200 mà rỗng") thì hỏi lại /cart y như bản cũ. Xấu nhất = hiện trạng cũ cộng
     một lượt nhỏ, không bao giờ là ngăn giỏ đứng im với hàng cũ.
     Người gác: scripts/test-ngan-gio-hoi-section-khong-tai-ca-trang.js */
  var NGAN_GIO_URL = '/cart?section_id=aef-cart-drawer';
  function taiNganGio() {
    function hoi(url) {
      return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    return hoi(NGAN_GIO_URL).then(
      function (doc) { return doc.querySelector('[data-aef-drawer-items]') ? doc : hoi('/cart'); },
      function () { return hoi('/cart'); }
    );
  }

  // ---- FULL re-fetch (on a dirty open) — pulls fresh rows + footer from the
  //      drawer section rendered against the current cart (taiNganGio).
  function fullRefresh() {
    taiNganGio()
      .then(function (doc) {
        var freshItems = doc.querySelector('[data-aef-drawer-items]');
        var freshFoot = doc.querySelector('[data-aef-drawer-foot]');
        var freshDrawer = doc.querySelector('[data-aef-cart-drawer]');
        itemsEl = $('[data-aef-drawer-items]', drawer);
        footEl = $('[data-aef-drawer-foot]', drawer);
        if (freshItems && itemsEl) itemsEl.innerHTML = freshItems.innerHTML;
        if (freshFoot && footEl) footEl.innerHTML = freshFoot.innerHTML;
        if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        dirty = false;
        if (window.applyTranslations) { try { window.applyTranslations(); } catch (e) {} }
        // let card-stepper.js seed its serverQty cache for the freshly injected steppers
        try { document.dispatchEvent(new CustomEvent('aef:cards-injected', { detail: { sectionId: 'cart-drawer' } })); } catch (e) {}
        // Dòng hàng vừa bị thay mới ⇒ gợi ý combo trên mỗi dòng đang trống chữ
        // "(thêm N nữa)". Vẽ lại cả 6 khối v2 theo bản trạng thái mới nhất.
        refreshExtrasFromServer();
      })
      .catch(function () {});
  }

  // ---- Rebuild the server-rendered ROW LIST -------------------------------
  // A BRAND-NEW line (added via chip / cross-sell / buy-again while the drawer is
  // open) CANNOT be built from /cart.js — that JSON lacks inventory_quantity + our
  // custom min/max/combo metafields the row + stepper need. So re-fetch the drawer
  // section rendered against the current cart (taiNganGio) and swap ONLY
  // the items list. The footer + reco blocks are updated in-place from /cart.js by
  // the caller, so the footer's express dynamic-checkout buttons are NEVER re-injected
  // / re-hydrated. (ticket_BUG_cart_v2_rows_not_rebuilt)
  function rebuildItems(done) {
    taiNganGio()
      .then(function (doc) {
        var freshItems = doc.querySelector('[data-aef-drawer-items]');
        itemsEl = $('[data-aef-drawer-items]', drawer);
        if (freshItems && itemsEl) itemsEl.innerHTML = freshItems.innerHTML;
        dirty = false; // rows now match the server
        if (window.applyTranslations) { try { window.applyTranslations(); } catch (e) {} }
        // let card-stepper.js seed its serverQty cache for the freshly injected steppers
        try { document.dispatchEvent(new CustomEvent('aef:cards-injected', { detail: { sectionId: 'cart-drawer' } })); } catch (e) {}
      })
      .catch(function () {})
      .then(function () { if (done) done(); });
  }

  // ---- LIGHTWEIGHT update (while open, on cart:updated) ---------------------
  // Reconciles the row list with /cart.js + repaints footer/reco WITHOUT touching the
  // steppers of existing rows. A pure qty change / removal stays in-place (never yanks
  // a stepper mid-burst); a NEW line triggers a server rows-rebuild (see rebuildItems).
  function lightUpdate() {
    /* 🔴 6/9/2026 vòng 43 — ĐỌC GÓI MÁY CHỦ VỪA TRẢ, ĐỪNG HỎI LẠI CÙNG MỘT CÂU.
       `aefCartAdd` đã GET /cart.js và cầm nguyên cái giỏ trong tay TRƯỚC KHI bắn
       `cart:updated`; người nghe ở cuối file đính gói đó vào `gioTuSuKien`. Bản cũ
       vứt gói ấy đi rồi tự hỏi /cart.js lần nữa 160ms sau, cho ĐÚNG cùng một câu
       trả lời — và phải chờ hết một RTT nữa mới dám vẽ chân giỏ, nên trên 📱 mạng
       yếu khách nhìn số cũ lâu hơn hẳn.
       KHÔNG đổi chủ sở hữu ô nào: vẫn đúng một người vẽ chân giỏ, chỉ đổi NGUỒN số
       liệu từ "tự đi hỏi" sang "đọc gói máy chủ đã trả". Sự kiện nào không mang giỏ
       theo (đổi số lượng, xoá dòng, đổi ngôn ngữ…) thì vẫn tự hỏi như cũ.
       Người gác: scripts/test-them-hang-khong-hoi-gio-hai-lan.js
       ⚠ DÒNG TIÊU THỤ NẰM TRÊN `if (!isOpen) return;` LÀ CÓ CHỦ Ý (vòng 43,
       phản biện #99). Gói chỉ đúng cho ĐÚNG MỘT lượt vẽ. Đặt nó dưới lối thoát
       sớm thì mỗi lượt thoát sớm để gói lại nguyên vẹn, và lượt vẽ kế tiếp —
       có thể rất lâu sau, sau khi giỏ đã đổi ở tab khác / trang /cart — sẽ vẽ
       chân giỏ bằng số cũ mà không có lượt mạng nào để tự sửa; tệ hơn nữa,
       vòng `if (!it) row.remove()` bên dưới sẽ XOÁ khỏi mắt khách một dòng
       hàng có thật nhưng vắng trong gói cũ. Vứt gói rồi mới thoát: cùng lắm
       mất một lượt tiết kiệm, không bao giờ vẽ sai. */
    var gioSan = gioTuSuKien; gioTuSuKien = null;
    if (!isOpen) return;
    /* 🔴 1/11/2026 (fix-gio) — GET về sau một cart:updated mới hơn lúc nó đi là thân CŨ: vẽ nó là
       thành tiền dòng và chân giỏ lùi về giỏ trước, tệ hơn nữa vòng `if (!it)` bên dưới gỡ mất
       dòng vừa thêm. Sự kiện đó đã hẹn lượt lightUpdate kế tiếp (người nghe cuối tệp) nên bỏ thân
       này không mất lượt vẽ nào. theGio là bộ đếm sẵn có của bản chụp giỏ.
       Người gác: T4b của scripts/test-gio-luot-cu-khong-ve-de.js */
    var theLucDi = theGio;
    (gioSan
      ? Promise.resolve(gioSan)
      : fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); })
    )
      .then(function (cart) {
        if (!gioSan && theLucDi !== theGio) return;
        if (!cart || typeof cart.item_count !== 'number') return;
        var byKey = {};
        (cart.items || []).forEach(function (it) { byKey[it.key] = it; });

        // Is there a cart line the DOM doesn't render yet? (added via saved-list
        // Add or any external add path). If so the row list must be REBUILT from the
        // server — /cart.js alone can't seed a full new row. (ticket_BUG_cart_v2_rows_not_rebuilt)
        var domKeys = {};
        $all('[data-aef-drawer-items] .aef-drawer__row', drawer).forEach(function (row) {
          domKeys[row.getAttribute('data-line-key')] = true;
        });
        var hasNewLine = (cart.items || []).some(function (it) { return !domKeys[it.key]; });
        /* 🔴 1/11/2026 (fix-gio) — ĐƠN GIÁ ĐỔI THÌ VẼ LẠI CẢ DÒNG. Từ khi dòng in `item.final_price`, đơn giá,
           giá gạch và phần trăm theo số máy chủ tính, mà nhánh vá tại chỗ dưới kia chỉ ghi thành tiền: giảm
           theo số lượng hay mã giảm vừa áp là dòng in đơn giá cũ cạnh thành tiền mới. Ba ô đó do Liquid tính,
           JS không tự tính lại (một nguồn): dòng mang `data-unit-cents`, lệch thì lấy lại hàng từ máy chủ, đúng
           đường của dòng mới. Thiếu thuộc tính (HTML cũ trong trang) thì đi đường cũ.
           Người gác: T7b của scripts/test-gio-luot-cu-khong-ve-de.js */
        var giaDoi = false;
        if (!hasNewLine) {
          $all('[data-aef-drawer-items] .aef-drawer__row', drawer).forEach(function (row) {
            var it = byKey[row.getAttribute('data-line-key')];
            var cu = row.getAttribute('data-unit-cents');
            if (it && cu != null && cu !== '' && Number(cu) !== it.final_price) giaDoi = true;
          });
        }

        if (hasNewLine || giaDoi) {
          // rebuild rows first (server data), THEN paint footer so the savings
          // sum reads the freshly rendered rows' data-unit-save.
          rebuildItems(function () { paintFooter(cart, byKey); });
        } else {
          // pure qty change / removal — update each line-total, drop emptied rows
          $all('[data-aef-drawer-items] .aef-drawer__row', drawer).forEach(function (row) {
            var it = byKey[row.getAttribute('data-line-key')];
            if (!it) { row.parentNode && row.parentNode.removeChild(row); return; }
            var lt = row.querySelector('.aef-drawer__linetot');
            if (lt) lt.textContent = money(it.final_line_price);
          });
          paintFooter(cart, byKey);
        }
      })
      .catch(function () {});
  }

  /* 🔴 25/9/2026 vòng 53 (cart-api#3) — LUẬT MUA TỐI THIỂU Ở CỬA THANH TOÁN NÀY.
     Luật sàn là luật RIÊNG của theme; máy chủ + checkout Shopify không ép nó
     (đo LIVE: add.js qty 1 cho món sàn 4 → 200). Trang /cart kéo dòng lên sàn
     (assets/cart.js keoDongDuoiSanLenSan) nhưng cart.js chỉ nạp ở /cart, còn ngăn
     giỏ có form thanh toán RIÊNG trên MỌI trang ⇒ đơn dưới sàn đi lọt (#37253).
     Máy chủ dựng sẵn trạng thái khoá (sections/aef-cart-drawer.liquid, cờ
     `drawer_duoi_san`); hàm này là người ghi DUY NHẤT lúc chạy của ba thứ đó —
     `hidden` trên câu nhắc từng dòng, `data-khoa-san` của form (CSS ẩn ví nhanh)
     và `hidden` trên câu giải thích — và trả về cờ để paintFooter khoá nút.
     CÙNG điều kiện với Liquid: sàn (data-min-qty do máy chủ in) > 1, số lượng MÁY
     CHỦ (/cart.js, không đọc chữ trong ô stepper) > 0 và < sàn, bỏ dòng giá cuối $0
     (quà). Đọc số lượng theo LINE KEY nên hai dòng cùng biến thể không lẫn nhau.
     CỐ Ý KHÔNG tự kéo số lượng lên sàn ở đây: nâng số là động vào tiền của khách.
     Khách tự bấm "+" (đủ sàn là cửa mở) hoặc "−"/thùng rác để bỏ dòng.
     🔴 26/9 (soi cuối ③): dòng HẾT HÀNG không tính là dưới sàn — bấm "+" không
     bao giờ được, nên khoá vì nó là khoá cả giỏ mà không lối ra (nhãn "Sold out"
     của cart-api#1 đã bảo khách bỏ nó). "Còn bán" đọc từ `data-con-ban` do máy
     chủ in (biến `d_con_ban` của section) — /cart.js không có trường đó, và JS
     không tự suy từ data-stock-qty (hàng đặt trước tồn 0 vẫn còn bán). Thiếu
     thuộc tính (HTML cũ) ⇒ coi là còn bán: giữ nguyên luật cũ, không nới cửa.
     Người gác: scripts/test-ngan-gio-khoa-thanh-toan-duoi-san.js */
  function veKhoaSan(byKey) {
    var co = false;
    $all('[data-aef-drawer-items] .aef-drawer__row', drawer).forEach(function (row) {
      var it = byKey && byKey[row.getAttribute('data-line-key')];
      var san = parseInt(row.getAttribute('data-min-qty'), 10) || 1;
      var conBan = row.getAttribute('data-con-ban') !== 'false';
      var duoi = conBan && !!it && san > 1 && it.quantity > 0 && it.quantity < san && it.final_price !== 0;
      if (duoi) co = true;
      var nhac = row.querySelector('[data-aef-min-note]');
      if (nhac) nhac.hidden = !duoi;
    });
    var form = $('#aef-drawer-checkout-form', drawer);
    if (form) form.setAttribute('data-khoa-san', co ? 'true' : 'false');
    var giaiThich = $('[data-aef-floor-note]', drawer);
    if (giaiThich) giaiThich.hidden = !co;
    return co;
  }

  // Footer totals (subtotal/savings/total/count) + empty state + coupon + saved —
  // repainted in ONE pass from the authoritative /cart.js (single-source invariant; the
  // cohesive "1 pipeline" the ticket calls out). Runs AFTER the rows are correct.
  // Lean drawer (2026-06-10, Boss duyệt): chips/cross-sell/buy-again/gift/combo/points
  // gỡ khỏi drawer — pipeline một pass giờ chỉ còn footer + coupon (honest) + saved-list.
  function paintFooter(cart, byKey) {
    // footer — target dedicated data-attrs (NOT positional span:last-child, which
    // clobbered the "items" label; see ticket_BUG_cart_drawer_subtotal). Subtotal MUST
    // recompute alongside Total on every qty/add/remove change.
    var subtotalEl = $('[data-aef-drawer-foot] [data-aef-drawer-subtotal]', drawer);
    if (subtotalEl) subtotalEl.textContent = money(cart.items_subtotal_price);
    var totalEl = $('[data-aef-drawer-foot] [data-aef-drawer-total]', drawer);
    if (totalEl) totalEl.textContent = money(cart.total_price);

    // savings = Σ (unit_save × qty) — compare prices aren't in /cart.js, read the
    // per-row data-unit-save (cents) the section rendered.
    var saved = 0;
    $all('[data-aef-drawer-items] .aef-drawer__row', drawer).forEach(function (row) {
      var us = parseInt(row.getAttribute('data-unit-save'), 10) || 0;
      var it = byKey[row.getAttribute('data-line-key')];
      if (us > 0 && it) saved += us * it.quantity;
    });
    var saveLine = $('[data-aef-drawer-foot] [data-aef-drawer-save]', drawer);
    if (saveLine) {
      saveLine.textContent = '−' + money(saved); // U+2212 minus, matches &minus;
      var saveRow = saveLine.closest('.aef-drawer__sline');
      if (saveRow) saveRow.style.display = saved > 0 ? '' : 'none';
    }

    // count spans (drawer-internal — NOT the header badge)
    veSoMon(cart.item_count);

    // empty state
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    // Gọi veKhoaSan() TRƯỚC, không đặt sau `||`: giỏ rỗng mà nó bị đoản mạch là
    // cờ khoá + câu nhắc của lượt trước treo lại.
    var khoaSan = veKhoaSan(byKey);
    var coBtn = $('.aef-drawer__checkout', drawer);
    if (coBtn) coBtn.disabled = cart.item_count === 0 || khoaSan;

    renderCouponRow(cart);
    renderSaved();
    paintExtras(cart, byKey);
  }

  // MỘT lượt vẽ cho cả 6 khối v2. Gọi từ ĐÚNG hai chỗ — paintFooter (mọi thay
  // đổi giỏ) và lượt mở drawer — để không có khối nào tự đi hỏi máy chủ riêng.
  function paintExtras(cart, byKey) {
    try { renderChips(cart); } catch (e) {}
    try { renderCrossSell(cart); } catch (e) {}
    try { renderReorder(cart); } catch (e) {}
    try { renderGift(cart); } catch (e) {}
    try { renderPoints(cart); } catch (e) {}
    try { renderCombo(cart, byKey || {}); } catch (e) {}
  }

  function scheduleLightUpdate() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(lightUpdate, 160);
  }

  // ---- trash (remove a whole line — works even when min>1 stuck the stepper) -
  /* 🔴 20/8/2026 vòng 24 — LỚP VÁ THỨ NHẤT, VẪN CÒN HIỆU LỰC.
     Bản trước đó NUỐT MỌI THẤT BẠI trong khi bên gọi đã làm mờ dòng hàng:
     nơi bấm (cuối file, nhánh [data-aef-drawer-remove]) đặt
     `row.style.opacity = 0.45` NGAY khi chạm rồi trông chờ `cart:updated` gỡ
     hẳn dòng đó đi — mà rớt mạng, 422, hay thân trả lời hỏng cú pháp đều
     KHÔNG phát `cart:updated` và cũng không báo gì. Dòng hàng mờ đi đúng như
     khi bị xoá thật, khách tin là đã xoá, rồi tới trang thanh toán món đó vẫn
     nằm đó. Từ vòng 24, hàm này TRẢ VỀ PHÁN QUYẾT để bên gọi lùi giao diện về,
     và tự bật toast khi không chắc. Hai bảo đảm đó GIỮ NGUYÊN ở bản 19/9 dưới
     đây — chỉ đổi cách LẤY phán quyết, từ "đọc mã HTTP" sang "đọc giỏ".
     [[feedback_dung_doi_bao_dam_lay_loi_goi]] */
  /* ═══ 🔴 19/9/2026 — DÒNG HÀNG HẾT KẸT CỨNG: MỘT CỬA, MỘT ĐỊA CHỈ, KHÔNG HỎI LẠI ═══
   *
   * ĐO THẬT trên LIVE hôm nay (phiên node fetch giữ cookie, aefoodstore.com —
   * mỗi dòng dưới đây là một lượt đo, không phải suy luận):
   *   · POST /cart/add.js  KÈM X-Requested-With, biến thể tồn 0 + policy DENY
   *                                                → 422 "already sold out"
   *   · POST /cart/add     (cửa FORM) KHÔNG X-Requested-With, CÙNG biến thể đó
   *                                                → 302 và MÓN VÀO GIỎ
   *     (điều kiện header ở hai dòng trên là SUY RA từ kết quả — bản ghi 19/9
   *     không ghi header; lượt 422 của add.js cũng khớp với dạng items[] KHÔNG
   *     XRW)
   *     🔴 25/9 ĐO LẠI: kết luận 19/9 "cửa form và cửa .js KHÔNG dùng chung luật
   *       kiểm" là SAI — hai lượt trên lệch nhau cả cửa LẪN header. Đổi ĐÚNG
   *       MỘT header `X-Requested-With: XMLHttpRequest` (XRW) trên CÙNG biến
   *       thể: add.js id phẳng · cửa FORM /cart/add · update.js kèm XRW → 422;
   *       KHÔNG XRW → nhận luôn hàng hết và số vượt tồn. Cửa change (.js lẫn
   *       FORM) và add.js items[] kiểm tồn bất kể header. BIẾN SỐ LÀ HEADER,
   *       KHÔNG PHẢI CỬA. Mọi lời gọi add.js · update.js · /cart/add của theme
   *       (kể cả ba cửa xoá dưới đây) đều gửi XRW. Bảng đo đủ + "dòng ma"
   *       trong thân change.js: đầu scripts/test-xoa-duoc-hang-het.js.
   *       Header vì vậy KHÔNG phải lý do có nhiều cửa xoá. Dòng hết hàng có
   *       địa chỉ ĐÚNG thì xoá về 0 cửa nào cũng đi (19/9 đo cả ba cửa; 25/9
   *       chỉ đo lại change.js). Nhưng với LINE KEY CŨ: change.js → 400, còn
   *       update.js → 200 và gỡ DÒNG ĐẦU của biến thể (đo 25/9, xem đầu
   *       scripts/lib/tiem-gio-line-key.js) — tức cửa sau CÓ đi khi cửa trước
   *       thua, và đó là đường mất dòng đã trả tiền (CA 6 của
   *       scripts/test-xoa-duoc-hang-het.js) — từ 25/9 ngăn giỏ đọc giỏ trước
   *       và không gõ update.js vào key đã vắng (`dsCua`). Chỉ cửa FORM là PHÒNG HỜ chưa
   *       đo: chưa ca đo nào nó thắng khi hai cửa .js đều thua.
   *   · Đếm qua Admin API: 1.453/3.175 biến thể đang bán (45,8%) ở trạng thái
   *     tồn 0 + DENY ⇒ dòng hàng hết nằm sẵn trong giỏ là chuyện HẰNG NGÀY.
   *   · change.js {id:<variantId>, quantity:0} khi CÙNG một biến thể nằm trên
   *     HAI dòng (một dòng mang properties — quà tặng theo ngưỡng chiếm 10,4%
   *     dòng đơn) → 200 và gỡ CẢ HAI DÒNG. Khách bấm thùng rác ở dòng quà thì
   *     mất luôn dòng đã trả tiền. Cùng cảnh đó, địa chỉ bằng LINE KEY chỉ gỡ
   *     ĐÚNG MỘT dòng (đo được, ca M).
   *   · change.js / update.js với địa chỉ KHÔNG có trong giỏ → 422
   *     {"status":422,"message":"Cart Error","description":"Cannot find variant"},
   *     thân KHÔNG có item_count.
   *     🔴 25/9 ĐO LẠI VỚI LINE KEY LẠ/CŨ — dòng trên SAI với line key (chưa
   *       ca nào tái hiện "Cannot find variant"): change.js → 400 "no valid id
   *       or line parameter" (giỏ trống thì 200 + giỏ rỗng); update.js → 200 và
   *       gỡ DÒNG ĐẦU mang biến thể = phần trước dấu ':' (key bịa cũng vậy),
   *       chỉ 422 "updates parameter is invalid" khi biến thể vắng hẳn. Tức
   *       update.js trả 2xx KHÔNG chứng minh địa chỉ có thật — xem `dsCua`.
   *   · Bốn cửa đều xoá được một dòng hàng ĐÃ HẾT: change.js (variantId hoặc
   *     line key) · update.js (variantId hoặc line key) · cửa FORM /cart/change.
   *
   * BẢN CŨ có ĐÚNG MỘT cửa (/cart/change.js) và ĐÚNG MỘT địa chỉ (variantId).
   * Cửa đó trả non-2xx là HẾT ĐƯỜNG: dòng hàng ở lại, khách nhận một toast 4
   * giây rồi kẹt — không bỏ được món ra mà cũng không thanh toán được. Đây là
   * dạng hỏng đắt nhất trong giỏ vì nó chặn CẢ ĐƠN chứ không chỉ một dòng.
   * Và bản cũ chấm điểm bằng MÃ HTTP ("r.ok VÀ thân có item_count"), tức là hỏi
   * "máy chủ có trả lời tử tế không", chứ không hỏi "DÒNG HÀNG ĐI CHƯA".
   *
   * NAY: thử đủ cửa CHO TỚI KHI GIỎ CHỨNG MINH DÒNG ĐÓ ĐÃ BIẾN MẤT.
   *   địa chỉ  : LINE KEY trước (trỏ đúng một dòng), variantId chỉ là đường lùi
   *   cửa      : /cart/change.js → /cart/update.js → /cart/change (cửa FORM)
   *   phán quyết: KHÔNG đọc mã HTTP. Đọc GIỎ trả về rồi hỏi "dòng đó còn không".
   *              200 mà dòng còn nguyên thì vẫn tính là HỎNG.
   * Lượt bình thường vẫn ĐÚNG MỘT request như cũ: cửa 1 trả về cả giỏ nên tự nó
   * chứng minh được, các cửa sau chỉ chạy khi cửa trước KHÔNG chứng minh được.
   * Đây là CỘNG THÊM đường lùi, không đổi bảo đảm nào lấy lời gọi: mọi nhánh
   * hỏng cũ vẫn kết thúc bằng toast + trả `false` để bên gọi lùi giao diện về.
   * ⛔ Cố ý KHÔNG chặn hiển thị dòng hàng hết — khách vẫn cần THẤY nó để bỏ ra.
   * Người gác: scripts/test-xoa-duoc-hang-het.js */

  /* Dòng hàng còn nằm trong giỏ không?  true = còn · false = đã gỡ · null = không biết.
     `null` là trạng thái THỨ BA có chủ ý: thân trả lời không đọc được thì phải
     nói "không biết", tuyệt đối không được quy về "đã gỡ". */
  function conNamTrongGio(cart, vid, key) {
    if (!cart || !cart.items || typeof cart.item_count !== 'number') return null;
    if (Object.prototype.toString.call(cart.items) !== '[object Array]') return null;
    var i;
    for (i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (key) { if (String(it.key) === String(key)) return true; }
      else if (String(it.id) === String(vid)) return true;
    }
    return false;
  }

  /* Có bao nhiêu DÒNG đang mang cùng một biến thể.
     Đây là con số quyết định variantId có an toàn hay không: bằng 1 thì "gỡ
     theo biến thể" và "gỡ đúng dòng" là MỘT việc; từ 2 trở lên thì gỡ theo
     biến thể là gỡ lan. Trả null khi không đọc được giỏ — "không biết" KHÁC
     "1". [[reference_qua_tang_gia_0_lam_hong_thuoc_so_luong]] */
  function demDongCungBienThe(cart, vid) {
    if (!cart || !cart.items || typeof cart.item_count !== 'number') return null;
    if (Object.prototype.toString.call(cart.items) !== '[object Array]') return null;
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].id) === String(vid)) n++;
    }
    return n;
  }

  /* ── HẠN GIỜ CHO TỪNG CỬA ────────────────────────────────────────────────
     🔴 21/9/2026 — đường xoá này chạy TRÊN HÀNG ĐỢI CHUNG của cả giỏ
     (`window.__aefCartAddQueue`). Mọi lượt THÊM hàng của ~12 bề mặt khác (chip
     free-ship, cross-sell, mua lại nhanh, để dành, quiz, FBT…) xếp sau nó.
     Mà một lượt xoá hỏng gõ tới 6 lượt GHI (2 địa chỉ × 3 cửa — đếm thẳng trên
     `dsDiaChi` và `dsCua` dưới đây) cộng các lượt ĐỌC canh xen giữa, tất cả nối
     TIẾP NHAU, và KHÔNG lượt nào có hạn giờ: `fetch` KHÔNG tự bỏ cuộc — treo
     mãi. Chỉ cần MỘT lượt kẹt là cả hàng đợi khoá: khách bấm "+" ở bất cứ đâu
     trên trang cũng không có gì vào giỏ, không toast, không một dấu hiệu nào.
     Nay mỗi lượt có AbortController 8 giây.

     ⚠️ BẪY 1 cho người sau: cắt ở MÁY KHÁCH không huỷ việc ở MÁY CHỦ. Lượt ghi
     bị abort vẫn có thể đã gỡ xong dòng hàng. Nên TUYỆT ĐỐI không được đọc
     "hết giờ" thành "chưa xoá": abort ném lỗi ⇒ rơi vào đúng nhánh `null` cũ
     = "cửa này không nói được gì", rồi lượt ĐỌC LẠI ở cuối removeLine() mới là
     thứ ra phán quyết. Không nhánh nào kết luận theo mã HTTP hay theo lỗi mạng.

     ⚠️ BẪY 2: CỐ Ý KHÔNG clearTimeout khi vừa có Response. Thân trả lời đọc ở
     bước sau (`r.json()`) và nó cũng treo được — nhả hẹn sớm là bỏ trống đúng
     nửa sau của lượt gọi. Hẹn nổ sau khi lượt gọi đã xong thì `abort()` là việc
     vô hại, nên giữ hẹn là phía an toàn.

     ⚠️ BẪY 3 (thêm 21/9 sau khi ĐO): `soLuotBiCat` chỉ được cộng khi hẹn nổ
     lúc lượt gọi CÒN ĐANG BAY. Vì BẪY 2 cố ý không clearTimeout, mọi lượt gọi
     — kể cả lượt trả lời trong 1 giây — đều còn một cái hẹn nổ muộn 8 giây sau.
     Đếm thẳng "hẹn đã nổ" là đếm cả những lượt CHƯA HỀ bị cắt: một lượt xoá đi
     qua 3 cửa nhanh sẽ thấy 3 tiếng nổ ở giây thứ 9-11 và tưởng mạng đang treo.
     `dangBay` là thứ phân biệt CẮT THẬT với NỔ MUỘN. Ai bỏ nó đi thì ngưỡng
     `TRAN_CAT` dưới kia sẽ cắt ngang đường xoá của một cái mạng hoàn toàn khoẻ.

     Trình duyệt không có AbortController (rất cũ) thì chạy y như trước — thà
     không có hạn giờ còn hơn ném lỗi làm chết cả đường xoá. */
  var HAN_GIO_CUA_MS = 8000;
  /* Bao nhiêu lượt gọi đã bị CẮT vì hết giờ — cộng dồn cả đời trang. removeLine
     chụp mốc lúc bắt đầu rồi chỉ nhìn PHẦN CHÊNH, nên không cần dọn. */
  var soLuotBiCat = 0;
  function fetchCoHan(url, opt) {
    var o = opt || {};
    if (typeof AbortController !== 'function') return fetch(url, o);
    var ac = new AbortController();
    var dangBay = true;
    setTimeout(function () {
      if (dangBay) soLuotBiCat++;
      try { ac.abort(); } catch (e) {}
    }, HAN_GIO_CUA_MS);
    var cf = {};
    for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) cf[k] = o[k]; }
    cf.signal = ac.signal;
    /* Hạ cờ khi CÓ Response (hoặc lỗi) — KHÔNG gỡ hẹn: hẹn vẫn phải canh nốt
       `r.json()` (BẪY 2). Hạ cờ sớm chỉ làm phép ĐẾM dè dặt hơn, mà đếm thiếu
       thì ngả về "đi tiếp", tức là ngả về phía an toàn cho khách. */
    return fetch(url, cf).then(
      function (r) { dangBay = false; return r; },
      function (e) { dangBay = false; throw e; }
    );
  }

  /* Thân trả lời của một cửa .js — chỉ nhận khi CẢ HAI đúng (r.ok VÀ đọc ra
     item_count), vì hai thứ đó hỏng độc lập với nhau. Không đạt thì trả `null`
     = "cửa này không nói được gì", để vòng ngoài đi tiếp chứ không kết luận. */
  function thanGio(r) {
    var ok = r.ok;
    return r.json().catch(function () { return null; }).then(function (j) {
      return (ok && j && typeof j.item_count === 'number') ? j : null;
    });
  }
  function docGio() {
    return fetchCoHan('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j && typeof j.item_count === 'number') ? j : null; })
      .catch(function () { return null; });
  }

  /* ---- BA CỬA XOÁ. Mỗi cửa trả về GIỎ SAU KHI ĐỔI, hoặc null nếu không nói được. */
  function cuaChangeJs(dc) {
    return fetchCoHan('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: String(dc), quantity: 0 }),
    }).then(thanGio, function () { return null; });
  }
  function cuaUpdateJs(dc) {
    var u = {};
    u[String(dc)] = 0;
    return fetchCoHan('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: u }),
    }).then(thanGio, function () { return null; });
  }
  /* Cửa FORM: đo được là 302 về /cart và KHÔNG trả JSON, nên phải tự đi hỏi
     /cart.js mới có phán quyết (chưa rõ lượt đo 302 đó có kèm XRW không — hàm
     này KHÔNG đọc thân, nên thân là gì cũng đúng). Nó là cửa thứ ba, PHÒNG HỜ
     — KHÔNG phải vì đo được nó kiểm khác hai cửa trên (đo lại 25/9: cặp
     add.js/add ở đầu khối này khác nhau vì header XRW chứ không vì cửa, và cửa
     này cũng gửi XRW). Gỡ nó là đổi hành vi, phải đo riêng. */
  function cuaChangeForm(dc) {
    return fetchCoHan('/cart/change', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: 'id=' + encodeURIComponent(String(dc)) + '&quantity=0',
    }).then(function () { return docGio(); }, function () { return null; });
  }

  function removeLine(vid, key) {
    /* 1/11/2026 (fix-gio) — cú +/− còn chờ hẹn gom của chính dòng này thì bỏ (card-stepper.js), kẻo nó
       bay sau lượt xoá tới line key đã vắng rồi hiện toast đỏ giả. Trong cú bấm, trước khi xếp hàng. */
    if (window.aefHuyHenGomDong) { try { window.aefHuyHenGomDong(vid, key); } catch (e) {} }
    var gioXong = null;       // giỏ của lượt ĐÃ CHỨNG MINH gỡ được; null = chưa chứng minh
    var daThayDong = false;   // đã TẬN MẮT thấy dòng đó trong một cái giỏ đọc được

    /* 🔴 LỖ HỔNG PHẢI BỊT: "vắng mặt" KHÔNG tự nó là "đã bị gỡ".
       Nếu `data-line-key` trên dòng hàng sai/cũ thì địa chỉ đó KHÔNG BAO GIỜ có
       trong giỏ, mà dòng thật vẫn nằm nguyên — đọc giỏ thấy vắng rồi reo lên
       "xoá xong" là dựng lại đúng lời nói dối vừa đi vá. Nên phán quyết cần MỐC:
         · cửa change.js trả 2xx kèm giỏ ⇒ tự nó chứng minh địa chỉ CÓ THẬT
           (line key lạ thì nó trả 400 — đo lại 25/9), nên "sau lượt đó không
           còn" là bằng chứng đủ. update.js thì KHÔNG: line key lạ vẫn 200 và
           gỡ dòng đầu cùng biến thể (25/9) ⇒ nó phải đọc giỏ trước như cửa FORM.
         · cửa FORM và lượt hỏi lại cuối cùng KHÔNG nói được địa chỉ có thật hay
           không ⇒ chỉ tính là đã gỡ khi TRƯỚC ĐÓ đã thấy dòng đó, hoặc khi giỏ
           sạch bóng CẢ BIẾN THỂ (lúc ấy món đã đi thật, dòng trên màn hình chỉ
           là bản cũ). */
    function ghiNhan(cart) {
      if (conNamTrongGio(cart, vid, key) === true) daThayDong = true;
      return cart;
    }
    function daDiThat(cart) {
      if (conNamTrongGio(cart, vid, key) !== false) return false;
      if (daThayDong) return true;
      return conNamTrongGio(cart, vid, null) === false;
    }
    /* ẢNH CHỤP NGĂN GIỎ ĐÚNG LÚC BẤM — chụp ĐỒNG BỘ ngay đây, trước khi xếp
       hàng đợi: cả hai bên gọi (nút 🗑, saveForLater) gọi removeLine ngay trong
       cú click, nên đây chính là cái khách THẤY khi bấm.
       🔴 25/9/2026 (soi lại code-cart#1) — bản trước hỏi DOM ở lúc KIỂM (sau ~3
       lượt mạng). Mở ngăn giỏ thì open() luôn gọi lightUpdate/fullRefresh, và
       hàng mang line key cũ được vẽ lại CHÍNH món đó dưới key mới đúng lúc
       removeLine đang chạy ⇒ nó tưởng đó là dòng anh em, reo "xong" mà không
       gõ gì: món còn nguyên, không toast, còn "Save for later" thì ghi món vào
       danh sách để dành trong khi món VẪN trong giỏ — một món ở HAI nơi.
       Người gác: CA 8 của scripts/test-xoa-duoc-hang-het.js */
    function chupHang() {
      var ds = [];
      try {
        $all('[data-aef-drawer-items] .aef-drawer__row', drawer).forEach(function (row) {
          ds.push({ k: row.getAttribute('data-line-key'), v: row.getAttribute('data-variant-id') });
        });
      } catch (e) {}
      return ds;
    }
    var hangLucBam = chupHang();
    /* Cửa diện rộng đã đếm được ĐÚNG MỘT dòng mang biến thể này. Dòng đó là
       dòng nào, so với cái khách thấy LÚC BẤM (`hangLucBam`)?
         'anh-em' — key của nó là một hàng KHÁC có trên ngăn giỏ lúc bấm ⇒ dòng
                    bị bấm đã rời giỏ (một lượt vẽ = mỗi dòng một hàng) ⇒ coi
                    là đã gỡ, KHÔNG bắn.
         'mo-ho'  — key lạ, mà lúc bấm biến thể này CÒN hàng khác ngoài hàng bị
                    bấm ⇒ không biết dòng còn lại là dòng bị bấm (key cũ) hay
                    dòng anh em (key cũng cũ) ⇒ KHÔNG bắn, để lời báo "không
                    chắc". Đoán sai là gỡ mất dòng đã trả tiền.
         'ban'    — chính key bị bấm, hoặc key lạ mà lúc bấm biến thể này chỉ có
                    ĐÚNG hàng bị bấm ⇒ đường cứu "line key trên DOM đã cũ" (kể
                    cả khi ngăn giỏ vẽ lại hàng đó dưới key mới giữa chừng).
       So chuỗi thuộc tính, không nhét key vào bộ chọn CSS. */
    function dongConLaiLa(cart) {
      if (!key || !cart || !cart.items) return 'ban';
      var k = null;
      for (var j = 0; j < cart.items.length; j++) {
        if (String(cart.items[j].id) === String(vid)) { k = String(cart.items[j].key); break; }
      }
      if (k === null || k === String(key)) return 'ban';
      var ds = hangLucBam;
      var coHangKhac = false;
      for (var h = 0; h < ds.length; h++) {
        var hk = ds[h].k;
        if (hk === k) return 'anh-em';
        if (hk !== String(key) && (ds[h].v === String(vid) || String(hk || '').split(':')[0] === String(vid))) {
          coHangKhac = true;
        }
      }
      return coHangKhac ? 'mo-ho' : 'ban';
    }

    /* ── "DỪNG SỚM KHI ĐỊA CHỈ VẮNG MẶT" — ĐÃ CÓ SẴN, ĐỪNG DỰNG LẠI ──────────
       🔴 21/9/2026 — vòng này đã thử dựng một bảng "địa chỉ nào giỏ nói là
       không có" để bỏ qua các cửa còn lại của chính địa chỉ đó. ĐO RỒI GỠ ĐI:
       nhánh bỏ qua chạy ĐÚNG 0 LẦN trên cả 5 hình dạng giỏ thật (line key
       đúng · line key cũ · line key cũ + dòng anh em cùng biến thể · dòng
       không có line key · món đã rời giỏ), và đường đi của mọi lượt giống
       HỆT bản trước đó, từng lượt gọi một.

       Lý do nó không bao giờ chạy (đo 21/9) — cấu trúc LÚC ĐÓ đã tự lo rồi:
         · Hồi ấy cửa DUY NHẤT có đọc giỏ trước khi gõ là cửa FORM, mà cửa FORM
           lại là cửa CUỐI của mỗi địa chỉ ⇒ lúc biết "địa chỉ vắng mặt" thì
           địa chỉ đó đã hết cửa để mà bỏ qua.
           🔴 25/9 (code-cart#1) — câu trên KHÔNG CÒN ĐÚNG: update.js nay cũng
           đọc giỏ trước (`dsCua`) mà KHÔNG phải cửa cuối. Hình dạng "line key
           cũ" giờ đi: POST change.js(key) → GET (trước update.js) → GET (trước
           cửa FORM) → GET (cửa canh diện rộng) → POST change.js(variantId) —
           BA lượt GET /cart.js liền nhau cho cùng một câu trả lời. Bảng "bỏ
           qua" nay bớt được lượt GET trước cửa FORM; CHƯA dựng lại, vì dựng
           thì phải đo lại cả 5 hình dạng giỏ như 21/9.
         · Địa chỉ variantId (diện rộng) đọc lại giỏ TRƯỚC MỖI phát bắn (cửa
           canh) và tự dừng hẳn khi không đọc được, khi biến thể nằm trên ≠1
           dòng, hoặc khi dòng còn lại có thể là dòng anh em. Lượt đọc của cửa
           canh CHÍNH là lượt đọc trước của bước diện rộng — `chay` không đọc
           thêm lượt nào nữa cho bước đó.
       CỐ Ý KHÔNG gộp lượt đọc của cửa canh vào các lượt trước nó: nó là điều
       kiện để được bắn diện rộng, gộp lại là làm nó CŨ ĐI để đổi lấy một lượt
       mạng — đúng kiểu đổi BẢO ĐẢM lấy LỜI GỌI mà chú thích "CỬA DIỆN RỘNG"
       bên dưới dựng lên để chặn.
       Cái thật sự thiếu là HẠN GIỜ, đã vá ở `fetchCoHan` + ngân sách dưới đây. */

    var dsDiaChi = [];
    if (key) dsDiaChi.push(String(key));
    if (vid != null && vid !== '' && String(vid) !== String(key)) dsDiaChi.push(String(vid));
    if (!dsDiaChi.length) return Promise.resolve(false);
    /* `chacChan` = cửa này trả 2xx thì địa chỉ chắc chắn có thật.
       🔴 25/9/2026 — update.js HẠ xuống `false` (code-cart#1). Đo LIVE: line
       key cũ gửi vào update.js ⇒ 200 và máy chủ gỡ DÒNG ĐẦU cùng biến thể —
       nếu đó là dòng anh em (dòng đã trả tiền nằm cạnh dòng quà) thì dòng ấy
       bốc hơi, còn nhánh `chacChan` thấy "key vắng mặt" liền reo xong, không
       toast. Hạ xuống thì ở bước LINE KEY cửa này đọc giỏ TRƯỚC và chỉ gõ khi
       key đó CÓ trong giỏ (bước variantId do cửa canh diện rộng đọc — xem
       `chay`); đường bình thường không đổi (change.js thắng ngay ở lượt 1),
       chỉ đường lùi tốn thêm một GET /cart.js. */
    var dsCua = [
      { f: cuaChangeJs, chacChan: true },
      { f: cuaUpdateJs, chacChan: false },
      { f: cuaChangeForm, chacChan: false },
    ];

    window.__aefCartAddQueue = window.__aefCartAddQueue || Promise.resolve();
    window.__aefCartAddPending = (window.__aefCartAddPending || 0) + 1;
    window.__aefCartAddQueue = window.__aefCartAddQueue.then(function () {
      /* (địa chỉ × cửa) theo thứ tự: cả ba cửa với LINE KEY trước, rồi mới tới
         variantId. variantId gỡ lan sang dòng cùng biến thể (đo được 19/9: cùng
         biến thể nằm trên hai dòng thì change.js theo variantId gỡ CẢ HAI), nên
         nó chỉ được chạm tới khi địa chỉ chính xác đã thua cả ba cửa. */
      var buoc = [];
      for (var a = 0; a < dsDiaChi.length; a++) {
        /* 20/9/2026 — bước đi bằng variantId TRONG KHI vẫn có line key thì bị
           canh; xem chú thích "CỬA DIỆN RỘNG" ngay dưới. */
        var dienRong = !!key && String(dsDiaChi[a]) !== String(key);
        for (var c = 0; c < dsCua.length; c++) {
          buoc.push({ dc: dsDiaChi[a], cua: dsCua[c], dienRong: dienRong });
        }
      }
      var i = 0;
      /* ── KHI NÀO THÌ NGỪNG MỞ CỬA MỚI ───────────────────────────────────────
         Hạn 8s/cửa mới chỉ chặn được MỘT lượt treo; cửa nào cũng hết giờ thì
         riêng 6 lượt ghi đã là 48 giây khoá hàng đợi chung — đúng cái hỏng đang
         đi vá, chỉ chậm hơn. Nên còn cần một cái phanh cho CẢ vòng. Ngừng mở cửa
         mới KHÔNG chặn lượt ĐỌC LẠI ở cuối hàm (nó nằm ngoài vòng này): nó mới
         là thứ ra phán quyết, và một lượt ghi bị cắt giữa chừng vẫn có thể đã gỡ
         xong ở máy chủ.

         🔴 21/9/2026 — PHANH NÀY TỪNG LÀ MỘT ĐỒNG HỒ 15 GIÂY, VÀ NÓ CẮT NHẦM.
         Đo bằng jsdom, nạp đúng file này, giỏ hình dạng "line key trên DOM đã CŨ
         · biến thể nằm trên ĐÚNG MỘT dòng", mạng KHÔNG treo, chỉ CHẬM 6 giây mỗi
         lượt (3G thật / Shopify lúc cao điểm — không lượt nào bị abort):
             bản HEAD        30s · /cart/change.js → update.js → cart.js →
                                   cart.js → change.js(variantId) ⇒ XOÁ ĐƯỢC
             đồng hồ 15 giây 24s · dừng sau 4 lượt ⇒ MÓN CÒN NGUYÊN, dòng hàng
                                   sáng lại, toast "không chắc đã xoá"
         Vì sao: cửa diện rộng — đường cứu DUY NHẤT cho line key cũ, dựng ngày
         20/9 — là cửa thứ TƯ, mở ở mốc 3 lượt gọi. Đồng hồ khởi động từ lượt gọi
         ĐẦU nên hễ mỗi lượt quá 5 giây là nó tắt đường cứu đó, và khách bấm lại
         cũng hỏng y hệt vì line key vẫn cũ. Đồng hồ đo THỜI GIAN, mà bệnh đang
         chữa là TREO — hai thứ khác nhau; mạng chậm bị tính oan thành mạng treo.

         Nay phanh đọc ĐÚNG cái bệnh: đếm số lượt THẬT SỰ BỊ CẮT vì hết giờ
         (`soLuotBiCat`, xem BẪY 3 ở `fetchCoHan`). Hai lượt bị cắt = 16 giây
         chết không đổi lấy được một câu trả lời nào ⇒ mạng treo ⇒ dừng.
         Đo lại sau khi đổi: treo hoàn toàn 24s (y như đồng hồ cũ) · chậm 6s thì
         xoá được ở 30s (y như HEAD) · bốn hình dạng giỏ khoẻ đi ĐÚNG đường cũ.

         45s chỉ còn là TRẦN CỨNG cho ca không lượt nào bị cắt mà lượt nào cũng
         lết gần 8 giây. Nó CỐ Ý lớn hơn 3×8s để không bao giờ cắt được cửa diện
         rộng: mọi lượt quá 8 giây đều đã bị abort và rơi vào `TRAN_CAT` rồi.
         ⚠️ Ai hạ con số 45 xuống dưới 24 là dựng lại đúng lỗi vừa vá ở trên. */
      var NGAN_SACH_MS = 45000;
      var TRAN_CAT = 2;
      var hanChot = Date.now() + NGAN_SACH_MS;
      var catLucDau = soLuotBiCat;
      function tiep() {
        if (gioXong || i >= buoc.length) return Promise.resolve();
        if (soLuotBiCat - catLucDau >= TRAN_CAT) return Promise.resolve();
        if (Date.now() > hanChot) return Promise.resolve();
        var b = buoc[i++];
        /* ── CỬA DIỆN RỘNG ────────────────────────────────────────────────
           🔴 20/9/2026 — trước bản vá này, khi line key thua cả ba cửa thì
           vòng chạy tiếp sang variantId. Mà chính chú thích phía trên đã đo
           được: change.js theo variantId, khi cùng biến thể nằm trên HAI
           dòng, gỡ CẢ HAI. Tức đường lùi MỞ LẠI đúng cái bug mà commit dựng
           đường này đi vá — bấm thùng rác trên dòng quà $0 là mất luôn dòng
           đã trả tiền, mà hàm vẫn trả true, vẫn phát cart:updated, KHÔNG
           toast: khách không có một tín hiệu nào về dòng hàng vừa bốc hơi.
           Dựng lại được ở hai cảnh: (a) line key trên DOM đã cũ, (b) mạng
           rớt SAU khi máy chủ đã gỡ đúng dòng.

           "Địa chỉ chính xác thua cả ba cửa" nghĩa là KHÔNG BIẾT. Không biết
           thì phải kết thúc bằng lời báo, chứ không phải bằng một phát bắn
           diện rộng. Chỉ mở cửa này khi vừa ĐỌC giỏ và thấy biến thể nằm
           trên ĐÚNG MỘT dòng — lúc ấy "diện rộng" và "đúng dòng" là một.
           Không đọc được giỏ ⇒ ĐÓNG: "không biết" KHÁC "1".
           (key rỗng ngay từ đầu thì dienRong là false — không có địa chỉ
            chính xác nào để mà thua, variantId là thứ duy nhất có.)

           🔴 25/9/2026 (code-cart#1) — "ĐÚNG MỘT dòng" CHƯA đủ: dòng duy nhất
           còn lại có thể là DÒNG ANH EM đang hiện ngay trên ngăn giỏ, không
           phải dòng khách bấm. Cảnh thật: giỏ QUÀ + ĐÃ-TRẢ cùng biến thể, dòng
           quà đã đi (nhát bấm thứ nhất, hoặc tab khác) mà dòng quà còn nằm mờ
           trên màn hình ⇒ bấm nữa là change.js(variantId) gỡ dòng ĐÃ TRẢ TIỀN,
           vẫn trả true. Nên: dòng còn lại mang key KHÁC và LÚC BẤM ngăn giỏ
           đang vẽ nó thành một hàng RIÊNG ⇒ dòng bị bấm không còn là một dòng
           trong giỏ ⇒ coi là đã gỡ (cart:updated tự dọn hàng cũ, không báo
           động giả), KHÔNG bắn. Key lạ mà lúc bấm biến thể này còn hàng khác ⇒
           không phân được ⇒ dừng, không bắn. Đường cứu "key trên DOM đã cũ,
           dòng thật sống dưới key mới" vẫn còn: lúc bấm key mới đó chưa có
           hàng nào — xem `dongConLaiLa`. */
        if (b.dienRong) {
          return docGio().then(function (g) {
            ghiNhan(g);
            if (daDiThat(g)) { gioXong = g; return; }
            if (demDongCungBienThe(g, vid) !== 1) return;   /* dừng hẳn, KHÔNG bắn */
            var conLai = dongConLaiLa(g);
            if (conLai === 'anh-em') { gioXong = g; return; }   /* KHÔNG bắn */
            if (conLai !== 'ban') return;   /* 'mo-ho': dừng hẳn, KHÔNG bắn */
            return chay(b);
          });
        }
        return chay(b);
      }
      function chay(b) {
        /* Cửa không tự chứng minh được thì đọc giỏ TRƯỚC — vừa lấy mốc, vừa khỏi
           gõ một cửa vào địa chỉ không có ở đó. Lượt đọc này KHÔNG tốn gì ở
           đường bình thường: nó chỉ chạy sau khi cửa change.js đã thua (từ
           25/9 update.js cũng đi đường này — xem `dsCua`).
           Bước DIỆN RỘNG thì KHÔNG đọc thêm: cửa canh ngay trên vừa đọc giỏ và
           xét đúng địa chỉ của bước này (variantId). Lượt đọc dưới đây hỏi theo
           LINE KEY — ở bước diện rộng key đó thường đã cũ, tức luôn "vắng" — nên
           nó từng biến update.js(variantId) và cửa FORM(variantId) thành cửa
           chết: đường cứu line key cũ chỉ còn change.js(variantId), rớt mạng một
           lượt là toast đỏ, món còn nguyên (CA 8 của test-xoa-duoc-hang-het.js). */
        var truoc = (b.cua.chacChan || b.dienRong)
          ? Promise.resolve(true)
          : docGio().then(function (g) {
              ghiNhan(g);
              if (daDiThat(g)) { gioXong = g; return false; }
              return conNamTrongGio(g, vid, key) === true;
            });
        return truoc.then(function (dangGo) {
          if (gioXong || !dangGo) return gioXong ? undefined : tiep();
          return b.cua.f(b.dc).then(function (cart) {
            ghiNhan(cart);
            /* Cửa change.js trả về giỏ = 2xx = địa chỉ có thật và đã áp dụng ⇒
               vắng mặt sau lượt đó là bằng chứng đủ, không cần mốc. */
            var xong = b.cua.chacChan
              ? (conNamTrongGio(cart, vid, key) === false)
              : daDiThat(cart);
            if (xong) { gioXong = cart; return; }
            return tiep();
          });
        });
      }
      return tiep()
        .then(function () {
          /* Không cửa nào chứng minh được ⇒ hỏi thẳng giỏ một lần cuối: có thể
             một cửa đã gỡ thật mà thân trả lời không nói được. Thà tốn một lượt
             mạng còn hơn kết luận sai về một thứ khách sắp trả tiền. */
          if (gioXong) return;
          return docGio().then(function (cart) {
            ghiNhan(cart);
            if (daDiThat(cart)) gioXong = cart;
          });
        })
        .then(function () {
          if (gioXong) {
            /* `items_subtotal_price` chứ không phải `total_price`: change.js trả
               total_price PHỒNG (BUG-H đã ghi ở đường thêm hàng). */
            var reliable = typeof gioXong.items_subtotal_price === 'number'
              ? gioXong.items_subtotal_price : gioXong.total_price;
            // hand totals to the single sources (badge/header via mini-cart, FSB)
            try {
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { source: 'cart-drawer-remove', count: gioXong.item_count, total: reliable, anhGio: gioXong }
              }));
            } catch (e) {}
            chupSauKhiPhat(gioXong);   // bản chụp giỏ cho cổng trần (khối đợt 5b, LU4-29)
          } else {
            /* Cả ba cửa, cả hai địa chỉ, và một lượt hỏi lại giỏ đều KHÔNG chứng
               minh được dòng hàng đã đi. Đó là "KHÔNG CHẮC đã xoá" ⇒ phải nói ra,
               không được để dòng hàng mờ tiếp như thể đã xoá xong. */
            try { showAddErrorToast(422, 'xoa'); } catch (e) {}
          }
        })
        .catch(function () { try { showAddErrorToast(0, 'xoa'); } catch (e) {} })
        .then(function () {
          window.__aefCartAddPending = Math.max(0, (window.__aefCartAddPending || 1) - 1);
        });
    });
    // Trả PHÁN QUYẾT cho bên gọi (khuôn giống aefCartAdd): true = GIỎ đã chứng
    // minh dòng hàng biến mất, false = chưa chắc ⇒ bên gọi lùi giao diện về.
    return window.__aefCartAddQueue.then(function () { return !!gioXong; });
  }

  // ==========================================================================
  // CART DRAWER v2 — cohesive core (ticket_cart_drawer_v2_enhanced).
  //   ONE shared add fn + ONE fly animation that EVERY "+" button reuses
  //   (free-ship chips, cross-sell, combo, restore-saved). Keeps the single
  //   source of truth: add → /cart/add.js on the SHARED queue → authoritative
  //   /cart.js → ONE cart:updated event → all blocks (badge via mini-cart,
  //   drawer, FSB, chips, cross-sell, combo, coupon) repaint in one pass.
  // ==========================================================================

  /* ═══ 🔴 5/9/2026 vòng 42 — TRẦN MUA LÀ CỔNG CHỈ CÓ Ở MÁY KHÁCH ═══════════
   *
   * Trần mua đến từ hai metafield (custom.max_qty + inventory.purchaseMaxQuantity,
   * hợp nhất ở snippets/aef-tran-mua.liquid). Shopify KHÔNG đọc chúng, và repo
   * không có Shopify Function nào (không có extensions/, không có
   * shopify.extension.toml) — nên đường nào bỏ qua cổng ấy là đi thẳng tới
   * thanh toán. `aefCartAdd` là đường THÊM HÀNG DÙNG CHUNG của ~12 bề mặt
   * (chip free-ship, cross-sell, mua lại nhanh, để dành, quiz, FBT, gap-closer,
   * seasonal, market deals, vừa xem, PDP oos-alts…) và nó chưa bao giờ hỏi trần.
   *
   * Đo được (chromium, máy chủ giỏ giả đúng ngữ nghĩa Shopify — /cart/add.js CỘNG
   * DỒN và chỉ 422 khi vượt TỒN KHO, cố ý không biết metafield trần mua):
   *   trần 1, giỏ đang có 1 · đường THẺ  → nút "+" aria-disabled, 0 request
   *   trần 1, giỏ đang có 1 · aefCartAdd → 1 request ADD, giỏ ra 2, im lặng
   * Đổi đúng một giá trị data-max-qty 1→5 thì đường thẻ mới cho qua ⇒ chính
   * thuộc tính đó là thứ đang chặn, và aefCartAdd không hề đọc nó.
   *
   * VÌ SAO ĐỌC THẺ TRÊN TRANG chứ không tự tính lại: cặp (trần, đang có bao
   * nhiêu) đã có ĐÚNG MỘT chủ — assets/card-stepper.js. Nó dựng `rules` từ
   * data-max-qty/data-stock-qty do máy chủ in ra, và nó là người ghi duy nhất
   * của [data-step-qty] (sơn lại từ /cart.js sau mọi cart:updated). Hỏi lại
   * chính hai ô đó là ĐỌC KẾT QUẢ của chủ sở hữu, không đẻ nguồn thứ hai cho
   * cùng một khái niệm [[feedback_one_concept_two_sources]]. Tự gọi /cart.js ở
   * đây thì thêm một vòng mạng cho MỌI cú bấm (bẫy 429 trong sổ) và hai bên
   * vẫn có thể trả lời khác nhau.
   *
   * ĐÃ CHẠM TRẦN (`đang có >= trần`) ⇒ TỪ CHỐI cả lượt, toast 422. Khi đó nút "+"
   * của chính thẻ đó cũng đang từ chối (card-stepper.js:347-359 + class
   * card__step--maxed), nên đây là làm cho trang nhất quán với chính nó.
   * CHƯA chạm mà `đang có + qty > trần` ⇒ KẸP về phần còn lại và NÓI RA (23/10,
   * xem khối đợt 5b ngay dưới) — đúng luật đường thẻ/PDP đang chạy
   * (mini-cart-popup.js queueAdd kẹp vào [min..max] rồi báo "Max reached (N)").
   * Kẹp mà IM mới là nói dối; kẹp kèm câu báo thì không.
   * NGOẠI LỆ GIỮ NGUYÊN: cú mua ĐẦU TIÊN (đang có 0) của món có min_qty LỚN HƠN
   * trần (hàng mồi $0.99 ⇒ tối thiểu 4, trần 1) được đi đủ số tối thiểu — kẹp
   * xuống trần thì dòng nằm dưới sàn, ngăn giỏ khoá thanh toán (veKhoaSan) mà
   * nút "+" lại đứng ở trần: KHÔNG MUA ĐƯỢC BẰNG ĐƯỜNG NÀO.
   * Người gác: scripts/test-them-gio-khong-vuot-tran.js (đường có thẻ chủ) ·
   * scripts/test-moi-duong-them-gio-hoi-mot-tran.js (đường KHÔNG thẻ chủ + aefCartAddMany) */

  /* ═══ 🔴 23/10/2026 vòng 53 đợt 5b (LU4-29) — HAI NỬA CÒN HỞ NAY ĐÃ ĐÓNG ════════
   *
   * Khai cũ (5/9): "1. bề mặt tự dựng nút mà trên trang KHÔNG có thẻ nào khai
   * biến thể đó (aef-quiz · aef-reorder · aef-fbt…) · 2. aefCartAddMany POST
   * thẳng items[], KHÔNG đi qua cổng". Người soi 18/10 đo trên LIVE (giỏ giả):
   * khối "Buy it again" trang chủ bấm 2 lần Three Crabs 24 oz (trần 1) ⇒ 2 POST,
   * giỏ lên 2; nút "Add all" bài phở/pad-thai gửi Three Crabs ×1 khi giỏ đã có 1.
   * Gốc: aefDaChamTran gặp "trang không khai gì ⇒ không đoán" là trả false.
   *
   * MỘT NGUỒN cho cả hai câu "trần bao nhiêu" và "trong giỏ đang có bao nhiêu":
   *   · TRẦN — chỉ một chỗ tính: snippets/aef-tran-mua.liquid (+ tồn kho, luật
   *     rulesFor). Trang đọc nó ở hai dạng ĐỀU do máy chủ in: thẻ chủ trên trang
   *     (như cũ) và DÒNG NGĂN GIỎ (sections/aef-cart-drawer.liquid:242-266 in
   *     data-max-qty/data-stock-qty/data-min-qty cho MỌI dòng giỏ). Dòng ngăn
   *     giỏ có sẵn lúc tải trang (layout dựng ngăn giỏ ở mọi trang); món vào giỏ
   *     SAU lúc tải thì hỏi lại đúng section đó (/cart?section_id=aef-cart-drawer
   *     — cùng URL taiNganGio() đang dùng) — một lượt cho cả giỏ.
   *   · ĐANG CÓ — giỏ MÁY CHỦ: bản chụp từ gói giỏ mà chính tệp này cầm sau mỗi
   *     lượt ghi (aefCartAdd · aefCartAddMany · xoá dòng · lưu quà — khoá `cart`
   *     của sự kiện hoặc ghi thẳng ngay sau lượt phát), dòng ngăn giỏ lúc tải
   *     trang, hoặc lượt hỏi section ở trên. Bản chụp có HẠN theo lượt đổi giỏ:
   *     sự kiện nào không mang giỏ đó (và không vá được bằng `line` có key) làm
   *     bản chụp hết hạn ⇒ lượt sau phải hỏi lại, không đoán.
   *   · Cộng số đang XẾP HÀNG (gọi rồi mà máy chủ chưa trả lời) ⇒ gọi dồn
   *     nhiều lượt trong một nhịp cũng không lọt.
   * KHÔNG thêm lượt GET /cart.js nào: chỉ ĐỌC gói đã có. Lượt hỏi section chỉ nổ
   * khi THIẾU dữ kiện — món không có thẻ chủ VÀ (bản chụp hết hạn, hoặc món
   * đang nằm trong giỏ mà chưa biết trần). Món chưa có trong giỏ mà chưa biết
   * trần thì KHÔNG hỏi: section chỉ dựng dòng giỏ, hỏi cũng không ra trần.
   * Chỗ hở còn lại (khai thật): món CHƯA trong giỏ, bề mặt gửi qty > trần mà
   * trang không có thẻ chủ (vd ae_bought_items cũ ghi m > trần) — lượt đầu vẫn
   * đi; từ lượt thứ hai cổng biết trần qua section và chặn. */
  var tranBiet = {};   // vid → trần hiệu lực máy chủ in (0 = KHÔNG trần) — chưa có khoá = chưa biết
  var minBiet = {};    // vid → data-min-qty máy chủ in ở dòng ngăn giỏ
  var tenBiet = {};    // vid → tên món, để câu báo nói được món nào
  var gioChup = null;  // { dong: { lineKey: { v, q } }, the } — giỏ máy chủ gần nhất
  var theGio = 0;      // tăng ở MỌI cart:updated; bản chụp còn hạn khi the === theGio
  var dangXep = {};    // vid → số đã gửi vào hàng đợi chung mà máy chủ chưa trả lời
  function coKhoa(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function soTrongChup(vid) {
    var n = 0, d = gioChup ? gioChup.dong : {};
    for (var k in d) { if (coKhoa(d, k) && String(d[k].v) === String(vid)) n += d[k].q; }
    return n;
  }
  function chupTuGio(gio, the) {
    if (!gio || !gio.items || typeof gio.items.length !== 'number') return;
    var dong = {};
    for (var i = 0; i < gio.items.length; i++) {
      var it = gio.items[i] || {};
      var v = it.variant_id != null ? it.variant_id : it.id;
      if (v == null) continue;
      dong[String(it.key || (v + ':' + i))] = { v: String(v), q: parseInt(it.quantity, 10) || 0 };
      if (it.product_title) tenBiet[String(v)] = String(it.product_title);
    }
    gioChup = { dong: dong, the: the };
  }
  /* Đọc DÒNG NGĂN GIỎ do máy chủ dựng (lúc tải trang, hoặc thân section vừa hỏi).
     `ghiChup` = false khi chỉ học trần (thân không chắc là giỏ hiện tại). */
  function hocTuDongNganGio(root, the, ghiChup) {
    var vung = root && root.querySelector && root.querySelector('[data-aef-drawer-items]');
    if (!vung) return false;
    var rows = vung.querySelectorAll('.aef-drawer__row[data-variant-id]');
    var dong = {}, tranLuot = {};
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i], v = String(r.getAttribute('data-variant-id') || '');
      if (!v) continue;
      // Lượt dựng MỚI NHẤT của máy chủ thắng (Boss có thể vừa sửa trần); hai
      // dòng cùng biến thể trong CÙNG lượt thì lấy con số chặt hơn.
      var eff = aefTranCuaHost(r);
      tranLuot[v] = coKhoa(tranLuot, v) && tranLuot[v] > 0 && (eff === 0 || tranLuot[v] < eff) ? tranLuot[v] : eff;
      tranBiet[v] = tranLuot[v];
      var mn = parseInt(r.getAttribute('data-min-qty'), 10);
      if (mn >= 1) minBiet[v] = mn;
      var nm = r.querySelector('.aef-drawer__name');
      if (nm && nm.textContent.trim()) tenBiet[v] = nm.textContent.replace(/\s+/g, ' ').trim();
      var qe = r.querySelector('[data-step-qty]');
      dong[String(r.getAttribute('data-line-key') || (v + ':' + i))] = { v: v, q: parseInt(qe && qe.textContent, 10) || 0 };
    }
    if (ghiChup) gioChup = { dong: dong, the: the };
    return true;
  }
  var dangHoiTran = null;
  /* 🔴 24/10/2026 (P3 người soi soi-5b-gio) — HỎI HỎNG THÌ HÃM THEO THỜI GIAN.
     Bản 48310206 nhớ lượt hỏng theo "giỏ chưa đổi" (theGio). Nhưng hỏng ⇒ cổng mở ⇒
     lượt thêm ĐI ⇒ giỏ ĐỔI ⇒ cú bấm sau lại hỏi — tức hỏi lại ở MỌI cú bấm đúng lúc
     Shopify đang bóp 429, và mỗi lượt hỏng còn lùi về tải NGUYÊN trang /cart (taiNganGio)
     ⇒ 2 request/cú. Nay: hỏng (mạng, 429/5xx, thân không có vùng hàng) ⇒ KHÔNG hỏi lại
     trong HOI_HONG_NGHI_MS, và lượt hỏi của cổng chỉ hỏi ĐÚNG section, không lùi trang.
     Trong khoảng nghỉ cổng giữ luật cũ "không đoán" (cho đi) — giỏ vẫn mua được.
     Người gác: Đ5 + đột biến M10 trong --tu-thu của scripts/test-moi-duong-them-gio-hoi-mot-tran.js */
  var HOI_HONG_NGHI_MS = 30000;
  var hoiHongLuc = 0;   // Date.now() của lượt hỏi section HỎNG gần nhất (0 = chưa hỏng)
  function hoiTranNganGio() {
    if (dangHoiTran) return dangHoiTran;
    var theLucHoi = 0;
    /* Chờ các lượt ĐÃ xếp trong hàng đợi chung xong rồi mới hỏi: hỏi trước thì
       thân section là giỏ của TRƯỚC những lượt đó (bấm dồn trên bề mặt không có
       thẻ chủ ⇒ cả loạt cùng đọc "chưa có trong giỏ"). */
    dangHoiTran = Promise.resolve(window.__aefCartAddQueue)
      .catch(function () {})
      .then(function () {
        theLucHoi = theGio;
        return fetch(NGAN_GIO_URL, { credentials: 'same-origin', cache: 'no-store' });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      })
      // Thân về mà giỏ đã đổi trong lúc chờ ⇒ chỉ học TRẦN, không ghi bản chụp.
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!hocTuDongNganGio(doc, theLucHoi, theLucHoi === theGio)) hoiHongLuc = Date.now();
      })
      .catch(function () { hoiHongLuc = Date.now(); })
      .then(function () { dangHoiTran = null; });
    return dangHoiTran;
  }
  // Lúc tải trang: ngăn giỏ máy chủ vừa dựng CHÍNH LÀ giỏ hiện tại.
  function gieoTuTrang() { if (!gioChup) hocTuDongNganGio(document, theGio, true); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gieoTuTrang);
  else gieoTuTrang();
  /* Bắt pha CAPTURE để bản chụp đổi TRƯỚC mọi người nghe khác của cùng sự kiện.
     Chỉ đọc khoá `cart` (gói /cart.js của CHÍNH ngăn giỏ — aefCartAdd đính, người nghe
     cuối tệp cũng đọc nó). KHÔNG đọc `anhGio`: khoá đó của thanh free-ship và khung quà
     aef-qua-tang.js, ngăn giỏ không đọc (S2 của scripts/test-noi-phat-gio-khong-chop-add.js). Nơi phát
     TRONG tệp này chỉ đính anhGio (aefCartAddMany · xoá dòng · lưu quà) thì tự ghi bản
     chụp ngay sau lượt phát (chupSauKhiPhat); nơi phát ở tệp khác ⇒ bản chụp hết hạn ⇒
     lượt thêm sau (nếu thiếu dữ kiện) hỏi lại section — một lượt, không phải /cart.js. */
  document.addEventListener('cart:updated', function (e) {
    theGio++;
    var d = (e && e.detail) || {};
    var g = d.cart;
    if (g && g.items) { chupTuGio(g, theGio); return; }
    var l = d.line;
    /* Đường thẻ "+" (mini-cart-popup queueAdd) chỉ mang dòng /cart/add.js: số
       TÍCH LUỸ của đúng dòng đó, có `key` ⇒ vá đúng dòng ấy vào bản chụp. */
    if (l && l.key != null && l.variant_id != null && typeof l.quantity === 'number'
        && gioChup && gioChup.the === theGio - 1) {
      gioChup.dong[String(l.key)] = { v: String(l.variant_id), q: l.quantity };
      gioChup.the = theGio;
      if (l.product_title) tenBiet[String(l.variant_id)] = String(l.product_title);
    }
  }, true);
  // Nơi phát trong tệp này vừa phát cart:updated kèm giỏ máy chủ trong tay ⇒ ghi bản chụp.
  function chupSauKhiPhat(gio) { try { chupTuGio(gio, theGio); } catch (e) {} }
  // Trang lấy lại từ bfcache: giỏ có thể đã đổi ở nơi khác ⇒ bản chụp hết hạn, hàng ngăn giỏ hết hạn
  // (1/11/2026, fix-gio: `dirty` để lần mở sau đọc lại; đang mở thì đọc ngay).
  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted) return;
    theGio++;
    dirty = true;
    if (isOpen) { gioTuSuKien = null; scheduleLightUpdate(); }
  });
  function aefHostCuaBienThe(vid) {
    try {
      return document.querySelectorAll(
        '.wbproduct-container[data-variant-id="' + vid + '"],' +
        ' [data-aef-stepper-host][data-variant-id="' + vid + '"]'
      );
    } catch (e) { return []; }
  }
  // Trần HIỆU LỰC của một thẻ = min(trần mua, tồn kho) — chép ĐÚNG luật
  // rulesFor() của card-stepper.js:88-104. 0 = không có trần; -1/NaN ở
  // data-stock-qty = không theo dõi tồn ⇒ không phải trần.
  function aefTranCuaHost(host) {
    var max = parseInt(host.getAttribute('data-max-qty'), 10);
    var stock = parseInt(host.getAttribute('data-stock-qty'), 10);
    if (!(max >= 1)) max = 0;
    if (!(stock >= 0)) stock = -1;
    var eff = max;
    if (stock >= 0 && (eff === 0 || stock < eff)) eff = stock;
    return eff;
  }
  /* 🔴 25/9/2026, vòng 53 (nợ 8 của card-stepper.js) — biến thể nằm trên ≥2
     dòng giỏ thì Ô CỦA MỖI DÒNG nay hiện SỐ CỦA DÒNG, không còn hiện tổng biến
     thể (một dòng thì hai số là một). Thẻ ngoài trang/PDP vẫn hiện tổng. Nên
     "đang có bao nhiêu" = số CAO nhất của thẻ KHÔNG mang line key, hoặc TỔNG
     các dòng giỏ (mỗi line key đếm một lần) — lấy cái lớn hơn. Chỉ lấy MAX như
     trước thì giỏ quà 1 + đã trả 5 (trần 6) ở trang không có thẻ ngoài đọc ra
     5 < 6 ⇒ cổng mở, thêm được món thứ 7.
     Người gác: CA 7 của scripts/test-them-gio-khong-vuot-tran.js */
  /* MỘT hàm trả lời cả bộ ba cho một biến thể: { tran, dangCo, min, ten }.
     tran   = trần hiệu lực (0 = không trần, null = trang chưa biết)
     dangCo = số trong giỏ máy chủ + số đang xếp hàng (null = chưa biết)
     Thẻ chủ trên trang (đường cũ, nguyên văn) đi TRƯỚC; dòng ngăn giỏ / bản chụp
     giỏ máy chủ bù vào chỗ trang không có thẻ chủ (23/10, LU4-29). */
  function xetTran(vid) {
    vid = String(vid);
    var hosts = aefHostCuaBienThe(vid);
    var tran = null, dangCo = null, min = 1, ten = '';
    if (hosts && hosts.length) {
      var t = 0, coTran = false, theoDong = 0, daDem = {}, dc = 0;
      for (var i = 0; i < hosts.length; i++) {
        var eff = aefTranCuaHost(hosts[i]);
        // Trần NGHIÊM NGẶT NHẤT trong các thẻ cùng biến thể (chúng phải bằng nhau;
        // lệch thì tin con số chặt hơn, đúng luật của snippets/aef-tran-mua.liquid).
        if (eff > 0 && (!coTran || eff < t)) { t = eff; coTran = true; }
        var mn = parseInt(hosts[i].getAttribute('data-min-qty'), 10);
        if (mn > min) min = mn;
        var q = hosts[i].querySelector('[data-step-qty]');
        var n = parseInt(q && q.textContent, 10);
        if (!(n > 0)) continue;
        var lk = hosts[i].getAttribute('data-line-key');
        if (lk) {
          if (!daDem[lk]) { daDem[lk] = true; theoDong += n; } // mỗi dòng giỏ một lần
        } else if (n > dc) {
          dc = n; // thẻ chưa kịp sơn lại đọc ra 0 — lấy số CAO nhất
        }
      }
      if (theoDong > dc) dc = theoDong;
      tran = coTran ? t : 0;          // biết thẻ nhưng thẻ nói "không trần" ⇒ 0
      dangCo = dc;
    }
    if (coKhoa(tranBiet, vid)) {
      var tb = tranBiet[vid];
      if (tran === null) tran = tb;
      else if (tb > 0 && (tran === 0 || tb < tran)) tran = tb;
    }
    if (minBiet[vid] > min) min = minBiet[vid];
    if (gioChup && gioChup.the === theGio) {
      var s = soTrongChup(vid);
      if (dangCo === null || s > dangCo) dangCo = s;
    }
    if (dangCo !== null) dangCo += dangXep[vid] || 0;
    ten = tenBiet[vid] || '';
    return { tran: tran, dangCo: dangCo, min: min, ten: ten };
  }
  function aefDaChamTran(vid) {
    var x = xetTran(vid);
    if (!(x.tran > 0) || x.dangCo === null) return false; // không trần / chưa biết ⇒ không đoán
    return x.dangCo >= x.tran;      // đã chạm/vượt trần ⇒ không thêm được nữa
  }
  /* PHÉP KẸP và CON SỐ của câu báo đi từ CÙNG MỘT lần xét (P2 người soi soi-5b-gio,
     24/10): con = còn thêm được bao nhiêu cái (Infinity = không trần / chưa biết);
     apDung = mức giỏ sẽ đứng sau khi kẹp — chính là con số khách đọc trong câu báo.
     Cú mua ĐẦU TIÊN của món min_qty > trần được đi đủ số tối thiểu (khối 5/9 ở trên)
     ⇒ apDung = min, KHÔNG phải trần gốc: món min 4 trần 1 xin 6 thì giỏ đứng 4 và câu
     báo nói (4) — bản trước nói (1) trong khi giỏ nhận 4. */
  function xetKep(vid) {
    var x = xetTran(vid);
    if (!(x.tran > 0) || x.dangCo === null) return { con: Infinity, apDung: 0 };
    var tran = x.tran;
    if (x.dangCo === 0 && x.min > tran) tran = x.min;
    return { con: tran - x.dangCo, apDung: tran };
  }
  /* Cổng có đủ dữ kiện để phán chưa, hay phải hỏi ngăn giỏ một lượt. */
  function canHoiTran(vid) {
    vid = String(vid);
    if (aefHostCuaBienThe(vid).length) return false;          // thẻ chủ trả lời đủ (đường cũ)
    if (hoiHongLuc && Date.now() - hoiHongLuc < HOI_HONG_NGHI_MS) return false; // vừa hỏi hỏng ⇒ đang hãm, không dồn lượt
    var biet = coKhoa(tranBiet, vid);
    if (biet && tranBiet[vid] === 0) return false;            // máy chủ đã nói: không trần
    if (!(gioChup && gioChup.the === theGio)) return true;    // không biết giỏ đang có bao nhiêu
    if (soTrongChup(vid) + (dangXep[vid] || 0) === 0) return false; // chưa có trong giỏ
    return !biet;                                             // đang trong giỏ mà chưa biết trần
  }
  /* Câu báo khi cổng KẸP bớt hoặc BỎ một món mà lượt vẫn thêm được phần còn lại.
     Dùng lại ĐÚNG câu báo trần sẵn có của đường thẻ/PDP — `card.max_tooltip`
     ("Max reached" / "Đã đạt giới hạn mua") + "(số)" — nên không đẻ khoá i18n mới.
     TÊN món lấy LÚC DỰNG CÂU, tức SAU khi máy chủ trả lời: lúc đó giỏ máy chủ vừa về
     (gói /cart.js của lượt ghi) đã ghi tên của MỌI món trong giỏ vào tenBiet — kể cả món
     vừa bị kẹp mà trước lượt này chưa có trong giỏ (P2: bản trước dựng câu TRƯỚC khi
     gửi nên món mới bị kẹp in "Max reached — (6)" trống tên). `duPhong` = tên trong
     phản hồi /cart/add.js, cho lúc GET /cart.js hỏng. */
  function chuBaoTran(ds, duPhong, boTen) {
    return ds.map(function (d) {
      var ten = (duPhong && duPhong[d.v]) || tenBiet[d.v] || '';
      if (ten && ten === boTen) ten = '';   // toast đã in đúng tên này ở chữ chính
      return (ten ? ten + ' ' : '') + '(' + d.tran + ')';
    }).join(' · ');
  }
  /* Bản đồ tên vid → tên từ GÓI GIỎ máy chủ vừa về (cùng gói mà lượt ghi đính vào
     cart:updated), lùi về tên trong phản hồi /cart/add.js. Một nguồn: giỏ máy chủ. */
  function tenTheoGio(gio, tenTuAdd) {
    var m = {};
    for (var k in tenTuAdd) if (coKhoa(tenTuAdd, k)) m[k] = tenTuAdd[k];
    ((gio && gio.items) || []).forEach(function (it) {
      var v = it && (it.variant_id != null ? it.variant_id : it.id);
      if (v != null && it.product_title) m[String(v)] = String(it.product_title);
    });
    return m;
  }
  /* Lượt xếp hàng xong: trả số đang xếp. Máy chủ ĐÃ nhận mà không có gói giỏ nào
     theo sau (GET /cart.js hỏng) ⇒ bản chụp không còn đúng ⇒ cho hết hạn. */
  function xongXep(vid, q, hetHan) {
    dangXep[vid] = Math.max(0, (dangXep[vid] || 0) - q);
    if (!dangXep[vid]) delete dangXep[vid];
    if (hetHan) theGio++;
  }

  // Shared add — exposed as window.aefCartAdd so any "+" anywhere calls it.
  function aefCartAdd(variantId, qty, sourceEl) {
    qty = parseInt(qty, 10) || 1;
    if (!variantId) return Promise.resolve(false);
    /* 23/10 (LU4-29): trang không có thẻ chủ và thiếu dữ kiện ⇒ hỏi ngăn giỏ MỘT
       lượt rồi mới phán. Ảnh bay chờ phán quyết (bay rồi mới từ chối là nói dối). */
    if (canHoiTran(variantId)) {
      return hoiTranNganGio().then(function () { return aefCartAddDaBiet(variantId, qty, sourceEl); });
    }
    return aefCartAddDaBiet(variantId, qty, sourceEl);
  }
  function aefCartAddDaBiet(variantId, qty, sourceEl) {
    /* Cổng trần mua — đặt TRƯỚC flyToCart: ảnh bay là lời hứa "đã thêm", bay rồi
       mới từ chối là đúng cái nói dối vòng 24 đã vá ở nhánh kia. Toast dùng lại
       showAddErrorToast(422) — chính câu máy chủ nói khi chạm trần ("item limit
       reached or out of stock"), nên không đẻ chữ mới và không cần khoá i18n mới. */
    if (aefDaChamTran(variantId)) {
      try { showAddErrorToast(422); } catch (e) {}
      return Promise.resolve(false);
    }
    // Chưa chạm mà qty vượt phần còn lại ⇒ kẹp + báo sau khi máy chủ nhận.
    var baoTran = null;
    var xk = xetKep(variantId);
    if (xk.con > 0 && qty > xk.con) {
      baoTran = [{ v: String(variantId), tran: xk.apDung }];
      qty = xk.con;
    }
    var vidXep = String(variantId);
    dangXep[vidXep] = (dangXep[vidXep] || 0) + qty;
    /* Phán quyết RIÊNG của lượt add này — resolve ngay khi /cart/add.js trả lời,
     * KHÔNG chờ cả hàng đợi chung (hàng đợi có thể còn lượt của người khác nên
     * về muộn hơn nhiều). flyToCart chờ cái này rồi mới dám bật "+1". */
    var choPhanQuyet, phanQuyet = new Promise(function (res) { choPhanQuyet = res; });
    if (sourceEl) flyToCart(sourceEl, phanQuyet); // ảnh bay nổ ngay; "+1" chờ máy chủ
    /* Cờ RIÊNG của lượt gọi này (không phải của hàng đợi chung): máy chủ có nhận
     * hay không. Trước đây hàm trả về một promise resolve `undefined`, nên bên gọi
     * KHÔNG có cách nào biết add hỏng — và restoreSaved() đã xoá món khỏi danh
     * sách "để dành" TRƯỚC khi hỏi. Xem chú thích ở restoreSaved(). */
    var httpOk = false, daPhatGio = false, tenTuAdd = {};
    window.__aefCartAddQueue = window.__aefCartAddQueue || Promise.resolve();
    window.__aefCartAddPending = (window.__aefCartAddPending || 0) + 1;
    window.__aefCartAddQueue = window.__aefCartAddQueue.then(function () {
      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', qty);
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
      })
        .then(
          function (r) {
            /* 2026-08-16: ghi lại MÁY CHỦ CÓ NHẬN KHÔNG, để bên gọi biết mà xử.
             * Dùng r.ok chứ không dùng "line có phải null không": một lần add
             * THÀNH CÔNG mà thân phản hồi lỗi cú pháp cũng cho line = null, và
             * nếu coi đó là thất bại thì món vừa vào giỏ lại nằm nguyên trong
             * danh sách "để dành" ⇒ khách thêm lần hai, thành hai món. */
            if (r.ok) { httpOk = true; return r.json().catch(function () { return null; }); }
            /* 2026-08-14: trước đây dòng này là `r.ok ? … : null` — mọi lần máy
               chủ TỪ CHỐI thêm hàng đều biến mất không dấu vết, trong khi
               flyToCart + "+1" đã chạy ở trên. Ba ca có thật rơi vào đây: chạm
               trần số lượng (422), hết hàng giữa chừng, giỏ quá hạn. */
            try { showAddErrorToast(r.status); } catch (e) {}
            return null;
          },
          /* Nhánh THỨ HAI của .then, KHÔNG phải .catch cuối chuỗi: chỉ bắt lỗi
             mạng của chính lệnh add. Nếu gộp vào .catch cuối thì một lượt làm
             mới /cart.js hỏng (sau khi add ĐÃ thành công) cũng báo "không thêm
             được" — sai ngược. */
          function () { try { showAddErrorToast(0); } catch (e) {} return null; }
        )
        .then(function (line) {
          try { choPhanQuyet(httpOk); } catch (e) {}
          if (line && line.product_title) tenTuAdd[vidXep] = String(line.product_title);
          // Ghi vào danh sách "từng cho vào giỏ" để khối MUA LẠI NHANH có nguồn
          // cho khách vãng lai. CHỈ ghi khi máy chủ đã nhận (httpOk) — ghi cả
          // lần hỏng thì danh sách đầy những món chưa bao giờ vào được giỏ.
          if (httpOk && line) { try { recordBought(line, qty); } catch (e) {} }
          // authoritative cart state → single-source listeners read this
          return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (cart && typeof cart.item_count === 'number') {
                /* Hai khoá, hai hợp đồng: `cart` = gói /cart.js cho lightUpdate của
                   ngăn giỏ (vẽ cả total_price — chỉ /cart.js được vào, mệnh đề GÓI GIỎ);
                   `anhGio` = bản chụp giỏ máy chủ cho thanh free-ship — khoá DUY NHẤT
                   aef-fsb.js đọc, mọi nơi phát đang cầm giỏ máy chủ đều đính nó. */
                /* P1 (24/10): phần bị KẸP đi CÙNG sự kiện báo đã thêm — người ghi toast
                   duy nhất (showAddToast) gộp "✓ Đã thêm" + câu trần thành MỘT toast. */
                var tranGhiChu = (httpOk && baoTran) ? { ds: baoTran, ten: tenTheoGio(cart, tenTuAdd) } : null;
                try {
                  document.dispatchEvent(new CustomEvent('cart:updated', {
                    detail: { source: 'aef-cart-add', count: cart.item_count, total: cart.items_subtotal_price, line: line, cart: cart, anhGio: cart, tran: tranGhiChu }
                  }));
                } catch (e) {}
                daPhatGio = true;
              }
            });
        })
        .catch(function () {})
        .then(function () {
          window.__aefCartAddPending = Math.max(0, (window.__aefCartAddPending || 1) - 1);
          xongXep(vidXep, qty, httpOk && !daPhatGio);
          // Máy chủ đã nhận phần đã kẹp ⇒ nói ra phần bị kẹp (câu báo trần sẵn có).
          // Máy chủ nhận mà GET /cart.js hỏng (không có sự kiện) ⇒ vẫn nói đủ hai ý.
          if (httpOk && baoTran && !daPhatGio) {
            try { showAddToast(tenTuAdd[vidXep] || '', undefined, undefined, { ds: baoTran, ten: tenTuAdd }); } catch (e) {}
          }
        });
    });
    // Trả về KẾT QUẢ (true = máy chủ nhận) thay vì undefined. Bên gọi cũ không
    // đọc giá trị trả về nên không ảnh hưởng; bên gọi mới (restoreSaved) cần nó.
    return window.__aefCartAddQueue.then(function () { return httpOk; });
  }

  // Fly-to-cart "Kiểu 1 — Vòng cung & rơi vào giỏ" (ticket_fly_to_cart_style1,
  //   Boss chốt qua demo). Clone ảnh SP THẬT bay cung (lift −96) → thu nhỏ → RƠI
  //   HẲN vào TÂM icon giỏ; khi đáp (animationend): icon giỏ bump + badge pop +
  //   "+1" xanh trồi lên. Kỹ thuật CSS @keyframes lái bằng --fly-dx/--fly-dy —
  //   env này clone.animate (WAAPI) đo được "chết" 2026-06-10; CSS-var đã chứng
  //   minh chạy thật. prefers-reduced-motion → CHỈ badge pop.
  //   SINGLE-SOURCE: badge #Cartcount do mini-cart-popup.js sở hữu (ghi count);
  //   popBadge CHỈ thêm/gỡ class visual, KHÔNG ghi count → không writer thứ 2.
  function popBadge() {
    var b = document.getElementById('Cartcount');
    if (!b) return;
    b.classList.remove('aef-badge-pop');
    void b.offsetWidth; // reflow to restart the animation
    b.classList.add('aef-badge-pop');
  }
  function bumpCart() {
    var c = document.getElementById('cart-icon-bubble');
    if (!c) return;
    c.classList.remove('aef-cart-bump');
    void c.offsetWidth;
    c.classList.add('aef-cart-bump');
  }
  /* ─── MỤC TIÊU CÓ ĐANG NHÌN THẤY ĐƯỢC KHÔNG (18/8/2026) ───────────────────
     Trên 📱 ngăn kéo giỏ phủ KÍN màn hình. #cart-icon-bubble vẫn nằm trong DOM
     với toạ độ hợp lệ — nó ở DƯỚI lớp phủ — nên flyToCart tính ra một điểm đáp
     "đúng" mà khách không thấy gì: ảnh bay chui xuống dưới tấm màn, "+1" trôi
     lên phía sau nó. Cả hiệu ứng diễn cho một khán giả không có.

     Hỏi elementFromPoint chứ không đoán bằng @media: cách này đúng cho cả hai
     bề ngang, và đúng cả khi header đã cuộn khỏi màn hình.

     Ba lần "không biết" đều trả false (= cho chạy như cũ), không trả true:
       · rect toàn số 0  → để nhánh !t.width sẵn có xử lý
       · môi trường không có elementFromPoint
       · elementFromPoint trả null
     Đoán bừa là "bị che" sẽ giết hiệu ứng ở những chỗ nó vẫn đúng. */
  function biChe(el) {
    try {
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return false;
      var x = r.left + r.width / 2, y = r.top + r.height / 2;
      var W = window.innerWidth || document.documentElement.clientWidth || 0;
      var H = window.innerHeight || document.documentElement.clientHeight || 0;
      if (x < 0 || y < 0 || x > W || y > H) return true;   // cuộn khỏi màn hình
      if (typeof document.elementFromPoint !== 'function') return false;
      var tren = document.elementFromPoint(x, y);
      if (!tren) return false;
      return !(tren === el || el.contains(tren) || tren.contains(el));
    } catch (e) { return false; }
  }
  /* ─── ĐỒNG XU VÀNG (5/9/2026) ─────────────────────────────────────────────
     Boss chốt: đổi chữ "+1" xanh thành đồng tiền vàng cho đẹp. Mặt xu vẽ bằng
     CSS (.aef-plusone trong aef-cart-drawer.css) — ở đây chỉ đặt vị trí và chữ.

     ⛔ KHÔNG đổi tên class `.aef-plusone`, dù nay nó là đồng xu chứ không còn
     là chữ "+1". scripts/test-fly-honest.js ĐẾM ĐÚNG TÊN NÀY để chứng minh
     "giỏ bị che thì đừng diễn". Đổi tên thì nó đếm ra 0 rồi báo XANH — hỏng
     CÂM, đúng kiểu hợp đồng lệch tên đã dính trước đây. Tên là hợp đồng.

     ⛔ ĐỪNG để mặt xu TRỐNG. Xu trơn không nói gì cả; phải có một dấu trên mặt.

     MẶT XU LÀ "+$" (Boss chốt 5/9, đổi từ "+1"). Ghi lại đánh đổi đã cân:
     "+1" nói ĐÚNG việc vừa xảy ra (một món vào giỏ). "+$" thì ngầu hơn nhưng
     nói về TIỀN — mà ngăn kéo này có sẵn một dòng điểm thưởng thật
     (`data-aef-points` ở sections/aef-cart-drawer.liquid), nay đang ẩn vì chưa
     điền tỉ lệ Smile. Hôm nay hai thứ không đụng nhau vì dòng kia chưa hiện.
     🔴 NGÀY BẬT SMILE thì xem lại chỗ này: một đồng xu vàng có "$" bay lên ngay
     phía trên một dòng "+88 điểm" rất dễ bị đọc thành "vừa được thưởng tiền".

     CĂN GIỮA — trước đây trừ tay 8px (nửa bề ngang chữ "+1") và 26px chiều cao.
     Xu rộng 28px nên hai con số ấy lệch hẳn. Nay đưa ĐÚNG TÂM icon giỏ rồi để
     CSS `translate(-50%, -100%)` tự lùi theo KÍCH THƯỚC THẬT của xu; đổi cỡ xu
     sau này không phải sửa lại con số nào ở đây. 6px là khoảng hở giữa đáy xu
     và tâm icon, không phải nửa chiều cao của thứ gì. */
  function plusOneFloat() {
    var t = document.getElementById('cart-icon-bubble') || document.getElementById('Cartcount');
    if (!t || biChe(t)) return;
    var r = t.getBoundingClientRect();
    if (!r.width) return;
    var el = document.createElement('div');
    el.className = 'aef-plusone';
    el.textContent = '+$';
    el.style.left = (r.left + r.width / 2) + 'px';
    el.style.top = (r.top + r.height / 2 - 6) + 'px';
    document.body.appendChild(el);
    var gone = false;
    var rm = function () { if (gone) return; gone = true; if (el.parentNode) el.parentNode.removeChild(el); };
    el.addEventListener('animationend', rm);
    setTimeout(rm, 1000); // backstop (> 0,9s của aefXuBay) — xu KHÔNG ở lại DOM
  }
  // The cart "reacts" on land: bump + badge pop (+ đồng xu only when something flew).
  function landEffects(withFly) {
    popBadge();
    if (withFly) { bumpCart(); plusOneFloat(); }
  }
  /* ─── HẠ CÁNH CÓ ĐIỀU KIỆN (18/8/2026) ────────────────────────────────────
     Trước đây ảnh bay + giỏ nảy + "+1" nổi lên chạy VÔ ĐIỀU KIỆN sau ~620ms,
     kể cả khi máy chủ vừa từ chối. Vòng 15 đã vá NỬA CHỮ của lỗi này (thêm
     toast báo lỗi) nhưng chưa vá NỬA HÌNH: khách thấy "+1" xanh trôi lên trên
     giỏ trong đúng lúc dải đỏ nói "không thêm được". Hai câu trả lời ngược
     nhau trong cùng một khoảnh khắc, và cái động thì đập vào mắt trước.

     Ba ca có thật rơi vào đây: chạm trần số lượng (422) · hết hàng giữa chừng
     · giỏ quá hạn.

     Nay việc BAY vẫn nổ ngay (đó là phản hồi "máy nhận lệnh rồi", đúng và cần),
     nhưng việc KHẲNG ĐỊNH lúc đáp xuống thì phải chờ máy chủ.

     Hai lớp, cố ý chồng lên nhau:
       · phanQuyet — promise của chính lượt add đó. Chính xác nhất. Chỉ đường
         dùng chung (aefCartAdd / aefCartAddMany) truyền được.
       · lucTuChoi — mốc từ chối gần nhất. Không cần bên gọi làm gì, nên nó phủ
         luôn card-stepper và mini-cart-popup, và phủ cả người viết sau này quên
         truyền phanQuyet.

     Quá 1,4 giây chưa có phán quyết thì KHÔNG khẳng định gì. Mất một hiệu ứng
     trang trí trên mạng chậm còn hơn khẳng định một việc chưa xảy ra — con số
     trên giỏ vẫn tự cập nhật khi cart:updated về. */
  function haCanh(lucBay, phanQuyet, coBay) {
    var xong = false;
    var ha = function (ok) {
      if (xong) return;
      xong = true;
      if (ok === false) return;          // máy chủ từ chối → không khẳng định gì
      if (lucTuChoi >= lucBay) return;   // có lần từ chối sau khi cất cánh
      landEffects(coBay !== false);
    };
    if (phanQuyet && typeof phanQuyet.then === 'function') {
      phanQuyet.then(ha, function () { ha(false); });
      setTimeout(function () { ha(false); }, 1400);
    } else {
      ha(true);
    }
  }
  function flyToCart(sourceEl, phanQuyet) {
    var lucBay = Date.now();
    try {
      var target = document.getElementById('cart-icon-bubble') || document.getElementById('Cartcount');
      if (!target || !sourceEl) return;
      /* Giỏ đang bị che (📱: ngăn kéo phủ kín) → không diễn gì cả. Khách vẫn có
         phản hồi: hàng mới hiện thẳng trong ngăn kéo đang mở, và nút vừa bấm
         đã đeo .is-added. showAddToast cũng tự im khi ngăn kéo mở, cùng lý do. */
      if (biChe(target)) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { haCanh(lucBay, phanQuyet, false); return; } // chỉ badge pop
      var img = sourceEl.querySelector && sourceEl.querySelector('img');
      if (!img && sourceEl.closest) {
        // the "+" button itself has no image → fly the product thumbnail from
        // the nearest host: drawer saved-row/row, product card, PDP buy box.
        var card = sourceEl.closest('.aef-drawer__mini-it, .aef-drawer__row, .wbproduct-container, [data-aef-stepper-host]');
        if (card) img = card.querySelector('img');
      }
      if (!img && !(sourceEl.closest && sourceEl.closest('.wbproduct-container'))) {
        // PDP: nút Add nằm trong buy-box không có ảnh — bay từ ảnh gallery chính.
        // (Card "+" luôn nằm trong .wbproduct-container nên không lọt vào đây.)
        img = document.querySelector('.product__media-wrapper img, .product__media img');
      }
      var srcEl = img || sourceEl;
      var s = srcEl.getBoundingClientRect();
      var t = target.getBoundingClientRect();
      if (!s.width || !t.width) { haCanh(lucBay, phanQuyet, true); return; }
      // Clone ảnh thật, kích thước theo nguồn (cap 80px, giữ tỉ lệ) + đặt TÂM clone
      // trùng TÂM thumb nguồn (để cung bắt đầu từ tâm SP, kết ở tâm giỏ).
      var k = Math.min(80 / s.width, 80 / s.height, 1);
      var W = Math.max(24, s.width * k), H = Math.max(24, s.height * k);
      var sx = s.left + s.width / 2, sy = s.top + s.height / 2;
      var cx = t.left + t.width / 2, cy = t.top + t.height / 2;
      var clone = document.createElement('div');
      clone.className = 'aef-fly';
      if (img && img.src) clone.style.backgroundImage = 'url("' + img.src + '")';
      else clone.textContent = sourceEl.getAttribute('data-fly-emoji') || '🛒';
      clone.style.width = W + 'px';
      clone.style.height = H + 'px';
      clone.style.left = (sx - W / 2) + 'px';
      clone.style.top = (sy - H / 2) + 'px';
      // arc Kiểu 1: điểm cuối = TÂM giỏ (rơi hẳn vào); lift −96 ở giữa, lái bằng vars.
      clone.style.setProperty('--fly-dx', (cx - sx) + 'px');
      clone.style.setProperty('--fly-dy', (cy - sy) + 'px');
      document.body.appendChild(clone);
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        if (clone.parentNode) clone.parentNode.removeChild(clone);
        haCanh(lucBay, phanQuyet, true); // bump + badge pop + "+1" — CHỈ khi máy chủ đã nhận
      };
      clone.addEventListener('animationend', finish);
      setTimeout(finish, 520); // backstop (dur 380 + buffer) — clone KHÔNG ở lại DOM
    } catch (e) { try { haCanh(lucBay, phanQuyet, false); } catch (_) {} }
  }
  /* ────────────────────────────────────────────────────────────────────────
     KHOÁ NÚT TRONG LÚC ĐANG THÊM HÀNG — dùng chung cho mọi nút nhỏ.

     Vì sao có (17/8/2026): khảo sát 20 đường thêm hàng ra 7 đường mà bấm hai
     lần là THÊM ĐÔI THẬT. Bốn đường trong đó đi qua đây: dãy "Vừa xem" ·
     "Mua lại nhanh" · chip đóng khe free-ship · cross-sell trong giỏ.
     Chúng KHÔNG có nút `disabled`, không có cờ chống bấm trùng, và ba trong
     bốn cái dán `.is-added` NGAY LÚC BẤM rồi tự gỡ sau 900ms — tức khẳng định
     một chuyện chưa xảy ra. Riêng nhóm trong giỏ còn tệ hơn: giỏ đang mở thì
     `showAddToast` tự bỏ qua (`if (isOpen) return`), nên bấm xong KHÔNG có
     phản hồi nào cả.

     ⚠ Vì sao KHÔNG nhét thẳng vào aefCartAdd(vid, qty, sourceEl):
     `sourceEl` ở đó là chỗ để ẢNH BAY ĐI, không phải cái nút. aef-reorder
     truyền cả THẺ (`.aef-reorder__card`) vào để clone ảnh sản phẩm. Khoá nhầm
     cái thẻ thì nút bên trong vẫn bấm được, mà cả thẻ lại bị mờ đi. Nên phơi
     hai hàm rõ ràng, mỗi nơi gọi tự khai đúng cái nút của mình.

     Trả về false = ĐANG BAY, bên gọi phải dừng. Không có nút thì trả true —
     khoá là để bảo vệ khách khỏi bấm trùng, không phải điều kiện để chạy.
     ──────────────────────────────────────────────────────────────────────── */
  var nutDangBay = new WeakMap();
  function aefBtnLock(btn) {
    if (!btn || !btn.classList) return true;
    if (nutDangBay.get(btn)) return false;
    nutDangBay.set(btn, 1);
    btn.classList.add('aef-btn-busy');
    btn.setAttribute('aria-disabled', 'true');
    return true;
  }
  /* ok = MÁY CHỦ ĐÃ NHẬN. Chỉ khi đó mới dán ✓. Truyền `undefined` thì coi như
     không biết ⇒ im lặng — thà không nói gì còn hơn nói một chuyện chưa chắc. */
  function aefBtnUnlock(btn, ok) {
    if (!btn || !btn.classList) return;
    nutDangBay.delete(btn);
    btn.classList.remove('aef-btn-busy');
    btn.removeAttribute('aria-disabled');
    if (!ok) return;
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 900);
  }
  window.aefBtnLock = window.aefBtnLock || aefBtnLock;
  window.aefBtnUnlock = window.aefBtnUnlock || aefBtnUnlock;

  window.aefCartAdd = window.aefCartAdd || aefCartAdd;
  // Khối "Mua lại" trang chủ (sections/aef-reorder.liquid) — KHÔNG hãm: nó tự có lịch thử lại
  window.aefDocMuaLaiSo = window.aefDocMuaLaiSo || function (h) { return docMuaLaiSo(h, true); };
  window.aefFlyToCart = window.aefFlyToCart || flyToCart;
  /* Mở giỏ TỪ BÊN NGOÀI (bài công thức bấm "Thêm cả bộ"). Trước đây mỗi nơi tự
     bật/tắt class `.show` của dropdown Bootstrap cũ — mỗi nơi một người ghi vào
     cùng vùng giao diện giỏ. Phơi đúng hàm open() ra là chỉ còn một người mở. */
  window.aefOpenCartDrawer = window.aefOpenCartDrawer || function () { open(); };

  // TWIN of esc() in mini-cart-popup.js — both files are loaded; keep the two
  // implementations at the SAME hardening level when touching either
  // (review 2026-06-10: added ' to match esc()).
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Lượt mở drawer: MỘT lần /cart.js rồi vẽ coupon + cả 6 khối v2 từ đúng bản
  // trạng thái đó. Không khối nào được tự gọi mạng lấy giỏ — nếu không, mở giỏ
  // ra là bắn 7 request song song và chúng có thể về lệch thứ tự, mỗi khối vẽ
  // theo một ảnh chụp khác nhau (đúng cái đã đẻ ra BUG-U ở thanh free-ship).
  function refreshExtrasFromServer() {
    if (!isOpen) return;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        renderCouponRow(cart);
        var byKey = {};
        cart.items.forEach(function (it) { byKey[it.key] = it; });
        paintExtras(cart, byKey);
      })
      .catch(function () {});
  }

  // ==========================================================================
  // v2 — Save for later. localStorage-backed (guest-friendly); the Add button
  //   restores via aefCartAdd so the saved list feeds the SAME single pipeline.
  // ==========================================================================
  var SAVED_KEY = 'ae_saved_items';
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  // --- Save for later: move a cart line out → stash snapshot → re-add later
  function saveForLater(vid, rowEl) {
    var snap = { variantId: vid, qty: 1, title: '', image: '', price: '', url: '' };
    if (rowEl) {
      var nm = rowEl.querySelector('.aef-drawer__name');
      if (nm) { snap.title = nm.textContent.trim(); snap.url = nm.getAttribute('href') || ''; }
      var im = rowEl.querySelector('.aef-drawer__thumb img');
      if (im) snap.image = im.getAttribute('src') || '';
      /* 1/11/2026 (fix-gio): ô này nay là giá khách trả (`item.final_price`), giảm tự động tự áp lại khi
         thêm lại. Gói định kỳ thì khác: restoreSaved thêm hàng lẻ, chưa mang gói theo. */
      var pr = rowEl.querySelector('.aef-drawer__unit');
      if (pr) snap.price = pr.textContent.trim();
      var q = rowEl.querySelector('.card__step-qty');
      if (q) snap.qty = parseInt(q.textContent, 10) || 1;
      rowEl.style.opacity = '0.45';
    }
    /* 🔴 5/9/2026 vòng 42 — GHI DANH SÁCH SAU KHI MÁY CHỦ NHẬN, KHÔNG GHI TRƯỚC.
     *
     * Bản cũ đẩy món vào `ae_saved_items` NGAY rồi mới gọi `removeLine(vid)` và
     * VỨT phán quyết hàm đó trả về. Dựng lại đo được: /cart/change.js trả 422
     * (hoặc rớt mạng) ⇒ món VẪN CÒN trong giỏ mà ĐỒNG THỜI đã nằm trong danh
     * sách để dành; khách bấm "Add" ở đó là số lượng thành 2 — trả tiền gấp đôi.
     * Toast lỗi có hiện, nhưng tắt sau 4 giây; tải lại trang thì cùng một món
     * nằm ở HAI nơi, không còn một lời cảnh báo nào.
     *
     * Đây là chỗ DUY NHẤT trong ba nơi ghi SAVED_KEY còn thiếu kỷ luật ấy:
     * `restoreSaved` (vá 16/8) chỉ xoá khi `aefCartAdd` trả true, và nút thùng
     * rác (vá 20/8) đã có nhánh lùi `if (ok === false) row.style.opacity = ''`.
     * Nay `saveForLater` đi đúng khuôn đó: máy chủ quyết, giao diện theo sau.
     * Người gác: scripts/test-de-danh-cho-may-chu-quyet.js */
    return Promise.resolve(removeLine(vid, rowEl && rowEl.getAttribute('data-line-key'))).then(
      function (ok) {
        if (ok === false) {
          // Máy chủ KHÔNG nhận ⇒ món vẫn nằm trong giỏ. Trả dòng hàng về như cũ
          // và TUYỆT ĐỐI không ghi vào danh sách để dành (removeLine đã tự bật
          // toast "Couldn't remove it…" nên khách biết vì sao).
          if (rowEl) rowEl.style.opacity = '';
          return false;
        }
        var list = lsGet(SAVED_KEY).filter(function (x) { return String(x.variantId) !== String(vid); });
        list.unshift(snap);
        lsSet(SAVED_KEY, list.slice(0, 20));
        renderSaved();
        return true;
      },
      function () {
        if (rowEl) rowEl.style.opacity = '';
        return false;
      }
    );
  }
  /* 2026-08-16 — XOÁ SAU KHI MÁY CHỦ NHẬN, KHÔNG XOÁ TRƯỚC.
   *
   * Bản cũ gỡ món khỏi danh sách "để dành" NGAY (lsSet trước, aefCartAdd sau) và
   * không bao giờ hoàn tác. Khách lưu hộp bánh để mua sau, lúc quay lại bấm "Add"
   * thì hàng đã hết (hoặc chạm trần số lượng) → /cart/add.js trả 422 → món KHÔNG
   * vào giỏ, mà cũng KHÔNG còn trong danh sách đã lưu. Mất luôn thứ khách tự tay
   * đánh dấu, và không có đường nào lấy lại ngoài việc đi tìm lại sản phẩm.
   *
   * Nay chỉ xoá khi aefCartAdd trả về true (máy chủ nhận). Hỏng thì giữ nguyên
   * món trong danh sách để khách bấm lại — toast lỗi đã có sẵn từ bản vá 14/8
   * (showAddErrorToast trong chính aefCartAdd) nên khách biết vì sao. */
  function restoreSaved(vid, srcEl) {
    var it = null;
    var all = lsGet(SAVED_KEY);
    for (var i = 0; i < all.length; i++) {
      if (String(all[i].variantId) === String(vid)) { it = all[i]; break; }
    }
    if (!it) return Promise.resolve(false);
    // srcEl → ONE fly animation (phối với fix tụt-vào-giỏ — saved Add giờ là
    // nguồn "+" duy nhất còn lại trong drawer, bay y như mọi nút khác)
    // TRẢ VỀ lời hứa (17/8 vòng 16): bên gọi cần biết máy chủ nhận hay không để
    // mở khoá nút và quyết có dán ✓ hay không. Trước đây hàm này nuốt kết quả.
    return Promise.resolve(aefCartAdd(it.variantId, it.qty || 1, srcEl)).then(function (ok) {
      if (!ok) return false; // giữ nguyên trong danh sách — khách còn đường thử lại
      lsSet(SAVED_KEY, lsGet(SAVED_KEY).filter(function (x) { return String(x.variantId) !== String(vid); }));
      renderSaved();
      return true;
    });
  }
  function removeSaved(vid) {
    lsSet(SAVED_KEY, lsGet(SAVED_KEY).filter(function (x) { return String(x.variantId) !== String(vid); }));
    renderSaved();
  }
  function savedRowHtml(it, restoreAttr) {
    // price snapshot (review 2026-06-10): saveForLater stores a formatted
    // string ("$12.99"); normalize (number=cents legacy) so the customer sees
    // what they saved at.
    var pr = typeof it.price === 'number' ? money(it.price) : (it.price || '');
    /* 🔴 14/9/2026 vòng 48 — NGƯỜI EM THỨ BA còn sót của cú vá vòng 42.
     *
     * Giá in ở trên là ĐƠN GIÁ MỘT CÁI (`saveForLater` chụp từ
     * `.aef-drawer__unit` = `{{ item.final_price | money }}`), nhưng nút Add gọi
     * `restoreSaved` → `aefCartAdd(it.variantId, it.qty || 1)` tức thêm `it.qty`
     * CÁI. Đo lại được: món $0.99 (99 xu < 120 ⇒ aef-min-qty trả 4) lưu lúc dòng
     * giỏ đang là 4 ⇒ dòng để dành in đúng "Banh trang cuon $0.99 Add", bấm một
     * cái là giỏ cộng $3.96. Đổi qty 4→1 thì HTML giống TỪNG BYTE ⇒ chữ khách
     * đọc mang 0 bit thông tin về số lượng. Danh sách giữ 20 món, không hạn
     * dùng, nên tuần sau khách mở ra đọc thì trí nhớ "hồi đó tôi để 4 cái" đã
     * bay sạch — đúng lúc đó nó thành bất ngờ toàn phần y như hai anh em kia
     * (sections/aef-cart-drawer.liquid:370 và renderReorder ở :1331 dưới đây).
     *
     * Chép ĐÚNG khuôn của renderReorder: nhãn nằm trong [data-i18n], con số và
     * tiền là node ANH EM (BUG-J — applyTranslations ghi đè textContent của
     * [data-i18n] nên nhét số vào trong là mất số). Lớp `.aef-drawer__mini-min`
     * dùng lại luôn, KHÔNG đẻ lớp thứ hai — nó sống trong {% style %} của
     * sections/aef-cart-drawer.liquid:490, mà danh sách này nằm trong chính
     * section đó nên ăn kiểu bình thường.
     *
     * HAI CHỖ CỐ Ý LÀM KHÁC renderReorder:
     * ① Khoá là `card.qty` ("Qty" / "Số lượng"), KHÔNG phải `card.min_hint`
     *    ("Min order:" / "Mua tối thiểu"). Ở khối mua-lại, N là số MÁY CHỦ ép
     *    (trần 4); ở đây N là số CHÍNH KHÁCH vừa để trong giỏ — khách tự bấm lên
     *    12 thì in "Mua tối thiểu 12" cho món min_qty=4 là đẻ ra một lời nói dối
     *    mới. `card.qty` đã có sẵn CẢ HAI tiếng trong từ điển ae-delivery-widget
     *    (:165 EN, :699 VI) nên không có nửa câu tiếng Anh nào rơi lại cho VI.
     * ② Thành tiền CHỈ in khi `it.price` là SỐ (bản ghi cũ dạng xu). Bản ghi mới
     *    lưu CHUỖI "$0.99", bóc chữ ra xu là đẻ nguồn dữ liệu thứ hai cho cùng
     *    một khái niệm — không làm. Khi đó dòng dừng ở "Số lượng 4", đủ lấp cái
     *    lỗ 0-bit mà không hứa một con số tiền lấy từ giá đã ĐÓNG BĂNG lúc cất.
     *
     * ĐO BỀ NGANG 📱 390×844 (Chromium, CSS thật): dòng vẫn CAO 36px như cũ, không
     * tràn ngang ca nào, nút Add còn nguyên trong khung. Khối nhắc rộng 28px (EN
     * "Qty 4") · 56px (VI "Số lượng 4") · 63px ("Số lượng 12") · 95px (bản ghi cũ
     * "Số lượng 4 · $3.96"); tên món co lại bằng ellipsis 259→221/192/179/153px.
     * `.aef-drawer__mini-min` mang `white-space: nowrap` nên phải đo — người anh
     * vòng 42 in câu DÀI HƠN ("Mua tối thiểu 4 · $3.96") trong cùng lớp này, còn
     * dòng để dành lại có thêm nút ✕ nên hẹp hơn một chút; đo xong mới yên tâm.
     * Người gác: scripts/test-de-danh-noi-so-luong.js
     * 26/9/2026 (vòng 53 gộp): đi qua cầu aefTFb — aefT trả CHÍNH CHUỖI KHOÁ khi
     * thiếu, chuỗi đó truthy nên `|| fb` là nhánh chết (sổ nợ của
     * scripts/test-cau-dich-co-duong-lui-that.js: đây là món thứ bảy, nợ MỚI). */
    var t = function (k, fb) { return window.aefTFb ? window.aefTFb(k, fb) : fb; };
    var sq = parseInt(it.qty, 10) || 1;
    return '<div class="aef-drawer__mini-it">'
      + '<span class="aef-drawer__mini-nm">' + escapeHtml(it.title) + '</span>'
      + (pr ? '<span class="aef-drawer__mini-pr">' + escapeHtml(pr) + '</span>' : '')
      + (sq > 1
          ? '<span class="aef-drawer__mini-min"><span data-i18n="card.qty">'
            + escapeHtml(t('card.qty', 'Qty')) + '</span> ' + sq
            + (typeof it.price === 'number'
                ? ' · <span class="aef-drawer__mini-mintotal">' + escapeHtml(money(it.price * sq)) + '</span>'
                : '')
            + '</span>'
          : '')
      + '<span class="aef-drawer__mini-act">'
      + '<button type="button" class="aef-drawer__mini-add" ' + restoreAttr + '="' + it.variantId + '"><span data-i18n="drawer.add">Add</span></button>'
      + (restoreAttr === 'data-aef-restore' ? '<button type="button" class="aef-drawer__mini-rm" data-aef-unsave="' + it.variantId + '" aria-label="Remove">&times;</button>' : '')
      + '</span></div>';
  }
  function renderSaved() {
    var list = lsGet(SAVED_KEY);
    $all('[data-aef-saved-count]', drawer).forEach(function (el) { el.textContent = list.length; });
    var body = $('[data-aef-saved-list]', drawer);
    var acc = body && body.closest('.aef-drawer__acc');
    if (acc) acc.style.display = list.length ? '' : 'none';
    // P3 (2026-06-10): giỏ trống vẫn hiện "Saved (N)" — CSS .is-empty.has-saved
    // mở RIÊNG acc này. renderSaved là writer duy nhất của has-saved.
    drawer.classList.toggle('has-saved', list.length > 0);
    if (body) {
      body.innerHTML = list.map(function (it) { return savedRowHtml(it, 'data-aef-restore'); }).join('');
      if (window.applyTranslations) { try { window.applyTranslations(); } catch (e) {} }
    }
  }

  // ==========================================================================
  // Add-to-cart TOAST — thay auto-open drawer (ticket_cart_add_toast_no_autoopen,
  // Boss chốt 2026-06-11). Add bất kỳ (PDP / card "+" / stepper-up) → KHÔNG mở
  // full drawer nữa: fly-to-cart + badge nảy (đường riêng) + toast nhẹ
  // "✓ Đã thêm [tên] · Xem giỏ" tự tắt ~2.5s. Full drawer CHỈ mở khi bấm icon
  // giỏ hoặc nút Xem giỏ của toast.
  //   SINGLE WRITER (anti-regression Pattern 1): .aef-add-toast do DUY NHẤT
  //   showAddToast() ghi — MỘT instance tái dùng; rapid-add THAY nội dung +
  //   reset timer (không bao giờ chồng đống). Phát hiện add qua detail.count
  //   (server-derived) của cart:updated TĂNG — giảm/xoá không toast.
  // ==========================================================================
  var TOAST_MS = 2500;
  var toastEl = null, toastTimer = null, toastBurst = 0, toastBaseCount = null, lastCartCount = null;
  /* 30/10/2026 (/code-review 287d9d08 #6) — ghi chú trần của CẢ cửa sổ toast đang hiện
     ({ ds: [{ v, tran }], ten: vid → tên }), không chỉ của lần gọi mới nhất. Xem showAddToast. */
  var toastTran = null;
  function hideToast() {
    if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }
    toastBurst = 0;
    toastTran = null;      // burst kết thúc → ghi chú trần cũng hết
    toastBaseCount = null; // burst kết thúc → mốc tính lại ở lần add kế
    if (toastEl) toastEl.classList.remove('is-show');
  }
  // burst counter = SỐ MÓN THẬT thêm trong cửa sổ toast đang hiện, suy ra THUẦN từ
  // count server (preCount→postCount của cart:updated), KHÔNG đếm số lần gọi. Vì sao:
  // đếm +1/lần gọi thì click lệch nhịp / event cart:updated gộp (count nhảy 1→3) →
  // hụt (3 add ra "2 items"); còn mốc-trừ thì burst = postCount − baseCount LUÔN bằng
  // tổng món đã thêm — món ĐẦU (đã hiện tên) vẫn nằm trong tổng, qty>1 cũng đúng
  // (ticket_cart_polish_round2 #3 + follow-up).
  /* `tran` (24/10/2026, P1 người soi soi-5b-gio) — lượt thêm ĐÃ VÀO GIỎ nhưng cổng trần
     vừa kẹp bớt / bỏ một món ({ ds: [{ v, tran }], ten: vid → tên }). Bản 48310206 vẽ
     "✓ Added · View cart" rồi hai microtask sau ghi đè bằng dải ĐỎ "⚠️ Max reached…"
     (showAddErrorToast 'tran') ⇒ khách chỉ thấy đỏ dù món đã vào. Nay MỘT toast, MỘT
     người ghi, đủ hai ý: "✓ Added <món|N món> · ⚠️ Max reached — <tên> (số)", nền thường,
     giữ nút View cart, sống lâu như toast lỗi (nhiều chữ hơn). Có ghi chú thì vẫn hiện
     khi ngăn giỏ đang mở — khách thấy món vào nhưng KHÔNG thấy phần bị kẹp.
     Không món nào vào (chạm trần sẵn) thì vẫn là toast TỪ CHỐI 422 như cũ.
     Người gác: CA A11 của scripts/test-moi-duong-them-gio-hoi-mot-tran.js */
  function showAddToast(title, preCount, postCount, tran) {
    var coTran = !!(tran && tran.ds && tran.ds.length);
    if (isOpen && !coTran) return; // drawer đang mở — khách thấy món vào trực tiếp, khỏi toast
    // Burst MỚI = toast đang ẩn (lần add đầu sau khi tắt) → chốt mốc = count TRƯỚC add.
    var freshBurst = !toastEl || !toastEl.classList.contains('is-show');
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'aef-add-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.addEventListener('click', function (e) {
        var v = e.target.closest && e.target.closest('[data-aef-toast-view]');
        if (v) { e.preventDefault(); hideToast(); open(); }
      });
      document.body.appendChild(toastEl);
    }
    if (freshBurst || toastBaseCount == null) {
      toastBaseCount = (typeof preCount === 'number') ? preCount
        : (typeof postCount === 'number' ? postCount - 1 : 0);
    }
    /* 🔴 30/10/2026 (/code-review 287d9d08 #6) — CÂU TRẦN SỐNG HẾT CỬA SỔ TOAST, không chỉ một lần gọi.
       Bản trước dựng ghi chú từ `tran` của ĐÚNG lần gọi này: thêm A (kẹp 6→4, toast "✓ Added A ·
       ⚠️ Max reached — A (6)") rồi ~1 s sau thêm B ⇒ lần gọi của B không mang `tran` ⇒ toast bị thay
       bằng "✓ Added 3 items", khách không còn biết A bị cắt. Nay ghi chú GỘP theo cả burst (cùng vòng
       đời với toastBurst: toast tắt — hideToast, chỗ DUY NHẤT gỡ is-show — hay toast lỗi ⇒ xoá), mỗi
       biến thể một mục (mục mới thay mục cũ cùng biến thể). Vẫn MỘT người ghi toastEl. Người gác: A13 +
       Đ6 của scripts/test-moi-duong-them-gio-hoi-mot-tran.js */
    if (coTran) {
      var gop = toastTran || { ds: [], ten: {} };
      tran.ds.forEach(function (d) {
        gop.ds = gop.ds.filter(function (x) { return String(x.v) !== String(d.v); });
        gop.ds.push(d);
      });
      var tenMoi = tran.ten || {};
      for (var kTen in tenMoi) if (Object.prototype.hasOwnProperty.call(tenMoi, kTen)) gop.ten[kTen] = tenMoi[kTen];
      toastTran = gop;
    }
    var coGhiChu = !!(toastTran && toastTran.ds.length);
    toastBurst = (typeof postCount === 'number') ? (postCount - toastBaseCount) : (toastBurst + 1);
    if (toastBurst < 1) toastBurst = 1;
    var t = function (k, fb) { return (window.aefT && window.aefT(k)) || fb; };
    // 1 add trong cửa sổ toast → tên món; burst nhiều add → "N món" (gộp,
    // không liệt kê — tên cuối cùng sẽ gây hiểu lầm khi mixed products).
    var what = toastBurst > 1
      ? t('drawer.toast_items', '{n} items').replace('{n}', String(toastBurst))
      : (title || '');
    var ghiChu = coGhiChu
      ? ' · ⚠️ ' + escapeHtml(t('card.max_tooltip', 'Max reached')) + ' — ' + escapeHtml(chuBaoTran(toastTran.ds, toastTran.ten, what))
      : '';
    toastEl.innerHTML =
      '<span class="aef-add-toast__txt">✓ ' + escapeHtml(t('drawer.toast_added', 'Added'))
      + (what ? ' <b>' + escapeHtml(what) + '</b>' : '') + ghiChu + '</span>'
      + '<button type="button" class="aef-add-toast__view" data-aef-toast-view>'
      + escapeHtml(t('drawer.toast_view', 'View cart')) + '</button>';
    toastEl.classList.remove('is-error');
    toastEl.classList.add('is-show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, coGhiChu ? 4000 : TOAST_MS);
  }

  // Toast BÁO LỖI — khi máy chủ TỪ CHỐI thêm hàng (2026-08-14).
  //   Trước đây `/cart/add.js` trả 4xx là bị nuốt hoàn toàn (`r.ok ? … : null`
  //   + `.catch(){}`), trong khi flyToCart + "+1" đã chạy TRƯỚC đó. Khách bấm
  //   "+", thấy món bay vào giỏ, thấy "+1", rồi giỏ không đổi và không một lời
  //   giải thích — đó là lời nói dối, và là nửa "rollback" còn thiếu của luật
  //   optimistic UI trong kế hoạch.
  //   SINGLE WRITER giữ nguyên: dùng ĐÚNG một `toastEl` với showAddToast, chỉ
  //   khác nội dung + class `is-error`; hai hàm loại trừ nhau (cái sau ghi đè
  //   cái trước và reset timer) nên không bao giờ chồng đống.
  //   Chữ lấy từ dict ae_lang → theo đúng ngôn ngữ khách đang xem; KHÔNG in lại
  //   câu mô tả của Shopify vì nó chỉ có tiếng Anh.
  /* Mốc lần MÁY CHỦ TỪ CHỐI gần nhất. flyToCart đọc mốc này lúc ảnh bay đáp
     xuống, để biết có được phép khẳng định "+1" hay không.

     Vì sao một biến là đủ cho cả BỐN đường thêm hàng: mọi nhánh thất bại —
     aefCartAdd · aefCartAddMany · card-stepper (luiVe) · mini-cart-popup —
     đều gọi về đúng hàm này qua window.aefShowAddError. */
  var lucTuChoi = 0;
  /* `kieu` (20/8/2026, vòng 24) — mặc định là chuyện THÊM hàng, giữ nguyên mọi
     bên gọi cũ. Truyền 'xoa' khi lượt XOÁ thất bại: câu chữ phải khác hẳn, vì
     "Không thêm được vào giỏ" nói ngược hoàn toàn sự thật lúc đó — khách vừa
     bấm BỎ một món và điều cần biết là món ĐÓ VẪN CÒN.
     Vẫn đúng MỘT người ghi `toastEl`: chỉ thêm nhánh chọn chữ, không đẻ hàm
     mới, không đẻ phần tử mới.
     'cap-nhat' (25/9/2026, vòng 53) — lượt BỚT số lượng (3→2) hỏng. Trước hôm
     nay luiVe() của card-stepper.js gọi hàm này KHÔNG kèm kiểu, nên nút "−"
     (kể cả lúc nó thành 🗑 ở sàn) hỏng mạng/429/422 là khách đọc "Couldn't
     add to cart" / "Không thêm được vào giỏ" — nói ngược việc vừa làm. Nay
     luiVe tự biết chiều: về 0 ⇒ 'xoa', dưới số máy chủ ⇒ 'cap-nhat'. */
  function showAddErrorToast(status, kieu) {
    /* KHÔNG chạm `lucTuChoi` cho nhánh xoá hay bớt. Mốc này có đúng một người
       đọc — flyToCart — và nó dùng để quyết định có dám khẳng định "+1" hay
       không. Đó là chuyện của đường THÊM; nhuộm nó bằng một lần xoá/bớt hỏng
       là bắt một lượt thêm hoàn toàn lành phải im tiếng. */
    if (kieu !== 'xoa' && kieu !== 'cap-nhat') lucTuChoi = Date.now();
    var t = function (k, fb) { return (window.aefT && window.aefT(k)) || fb; };
    var msg = (kieu === 'xoa')
      ? t('drawer.toast_err_remove', "Couldn't remove it — the item is still in your cart")
      : (kieu === 'cap-nhat')
      ? t('drawer.toast_err_update', "Couldn't change the quantity — please try again")
      : (status === 422)
      ? t('drawer.toast_err_limit', "Couldn't add — item limit reached or out of stock")
      : t('drawer.toast_err_generic', "Couldn't add to cart — please try again");
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'aef-add-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.addEventListener('click', function (e) {
        var v = e.target.closest && e.target.closest('[data-aef-toast-view]');
        if (v) { e.preventDefault(); hideToast(); open(); }
      });
      document.body.appendChild(toastEl);
    }
    // burst của toast THÀNH CÔNG phải tính lại từ đầu sau một lần lỗi, nếu không
    // mốc cũ sẽ làm lần add kế tiếp hiện sai số món.
    toastBaseCount = null;
    toastBurst = 0;
    toastTran = null;   // #6 (30/10): toast lỗi thay nội dung ⇒ ghi chú trần của burst cũ hết theo
    toastEl.innerHTML = '<span class="aef-add-toast__txt">⚠️ ' + escapeHtml(msg) + '</span>';
    toastEl.classList.add('is-error');
    toastEl.classList.add('is-show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4000); // lâu hơn toast thường — có chữ để đọc
  }

  // Phơi ra window để ĐƯỜNG THÊM HÀNG THỨ HAI dùng lại (2026-08-16).
  //   Nút "+" trên THẺ sản phẩm không đi qua aefCartAdd() ở trên — nó đi qua
  //   hàng đợi riêng trong assets/mini-cart-popup.js (queueAdd), và ở đó lỗi
  //   4xx/5xx đang bị nuốt im lặng y như lỗi đã vá ngày 14/8 tại đây.
  //   Phơi hàm ra thay vì chép lại: SINGLE WRITER của Pattern 1 đòi
  //   `.aef-add-toast` chỉ có DUY NHẤT một nơi ghi. Chép sang file kia là đẻ
  //   ra người ghi thứ hai — đúng cái bẫy đã sinh ra BUG-7 và BUG-C.
  //   Gán ở cấp IIFE (không nằm trong init()) để nó có mặt cả trên trang
  //   không dựng được drawer; bên gọi tra window LÚC CHẠY vì mini-cart-popup.js
  //   nạp TRƯỚC aef-app.js (header-group ở theme.liquid:431, aef-app ở :533).
  window.aefShowAddError = showAddErrorToast;

  // --- Auto-applied coupon row (footer). HONEST: shows ONLY a REAL applied
  //     cart-level discount from /cart.js — no fake "best code" until Phase 2
  //     (Shopify Functions / auto-discount app). Repaints in the same pass.
  function renderCouponRow(cart) {
    var el = $('[data-aef-coupon]', drawer);
    if (!el) return;
    var apps = (cart && cart.cart_level_discount_applications) || [];
    if (!apps.length) { el.hidden = true; el.innerHTML = ''; return; }
    var a = apps[0];
    var label = (window.aefT && window.aefT('drawer.auto_coupon')) || 'Auto-applied';
    el.innerHTML = '🎟️ ' + label + ' <b>' + escapeHtml(a.title) + '</b> &minus;' + money(a.total_allocated_amount) + ' ✓';
    el.hidden = false;
  }

  // ==========================================================================
  // CART DRAWER v2 — 6 khối Boss chốt 16/8/2026 (Artifacts/cart-drawer-v2-enhanced)
  //
  //   LUẬT CHUNG CHO CẢ SÁU: mọi khối chỉ ĐỌC /cart.js do paintFooter đưa vào —
  //   không khối nào tự gọi mạng để lấy trạng thái giỏ, không khối nào ghi
  //   #Cartcount / #CartTotalText / thanh free-ship. Vẫn đúng MỘT đường ống một
  //   lượt vẽ như HARD GATE đòi; sáu khối chỉ là sáu người ĐỌC thêm.
  //
  //   LUẬT THỨ HAI: khối nào không có DỮ LIỆU THẬT thì ẩn hẳn, không đoán. Điểm
  //   thưởng không có tỉ lệ → ẩn. Combo không có metafield → ẩn. Gợi ý không có
  //   món nào đủ bù khoảng thiếu → ẩn. Vòng 10 đã cho thấy hứa sai tiền là nhóm
  //   lỗi đắt nhất; một khối trống im lặng rẻ hơn một khối nói sai.
  // ==========================================================================

  // ---- 1) CHIP GỢI Ý ĐỦ NGƯỠNG FREE-SHIP -----------------------------------
  var chipPool = null;
  // Bản trạng thái giỏ của lượt vẽ chip gần nhất — CHỈ để vẽ lại khi thanh
  // free-ship đổi phán quyết (xem theoDoiThanhShip). Không ai khác đọc nó, và
  // nó không bao giờ được dùng thay cho /cart.js.
  var chipGioCuoi = null;
  function getChipPool() {
    if (chipPool) return chipPool;
    var el = $('[data-aef-chip-pool]', drawer);
    if (!el) return (chipPool = []);
    try { chipPool = JSON.parse(el.textContent || '[]'); } catch (e) { chipPool = []; }
    if (!Array.isArray(chipPool)) chipPool = [];
    return chipPool;
  }
  function renderChips(cart) {
    var box = $('[data-aef-chips]', drawer);
    if (!box) return;
    chipGioCuoi = cart || null; // để theoDoiThanhShip() vẽ lại mà không gọi mạng
    var row = $('[data-aef-chips-row]', box);
    var hide = function () { box.hidden = true; if (row) row.innerHTML = ''; };

    // Ngưỡng do zone-detection.js sở hữu; drawer chỉ đọc. Vùng không có ngưỡng
    // (AK/HI/PR) → threshold null → KHÔNG gợi ý gì, vì không có gì để mở khoá.
    var zone = window.AE_ZONE;
    if (!zone || zone.threshold == null) return hide();
    if (!cart || !cart.item_count) return hide();

    /* 🔴 5/9/2026 vòng 42 — MỘT LỜI HỨA, HAI NGƯỜI PHÁN.
     *
     * Khối chip này tự kết luận "đã được miễn phí giao chưa" bằng BẢNG NGƯỠNG
     * `zone.threshold` (bản sao trong zone-detection.js), trong khi thanh
     * free-ship cách nó đúng 20px đã được vá 18/8 để tin GIÁ SHIP THẬT (khi đó
     * /cart/shipping_rates.json, từ 27/9/2026 giỏ phụ Storefront) — bản gốc nằm ở
     * hồ sơ giao hàng trong Admin.
     * Dựng lại (jsdom + trang render thật): giỏ $65, bảng nói ngưỡng $79, máy
     * chủ trả phí $0.00 ⇒ THANH hô "🎉 You've unlocked FREE shipping!" còn CHIP
     * ngay dưới vẫn rao "Add one of these — free shipping unlocked" kèm ba món
     * $14.99–$25.99. Khách tin chip là trả oan tiền cho thứ họ đã có.
     *
     * Sửa bằng cách cho chip ĐỌC PHÁN QUYẾT của thanh chứ không phán lại: đúng
     * luật `server-says-free` mà sections/aef-gap-closer.liquid:747 đã dùng.
     * `data-state="success"` là thứ chính renderOne() của snippets/free-shipping-bar
     * ghi ra, nên đây là ĐỌC KẾT QUẢ của người sở hữu, không phải nguồn thứ hai
     * (cùng khuôn seedDrawerCount() soi #Cartcount).
     * Người gác: scripts/test-chip-khong-cai-thanh-freeship.js */
    var thanhShip = $('.aef-drawer__ship .free-shipping-bar', drawer);
    if (thanhShip && thanhShip.getAttribute('data-state') === 'success') return hide();
    var gap = zone.threshold - (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    if (gap <= 0) return hide(); // đã đủ — thanh free-ship tự ăn mừng, khỏi bán thêm

    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[String(it.variant_id || it.id)] = true; });

    // ĐIỀU KIỆN CỐT LÕI: giá × số lượng tối thiểu ≥ khoảng thiếu. Chip chỉ được
    // hiện khi bấm vào là ĐỦ ngưỡng thật — không phải "tiến gần hơn". Rẻ nhất
    // trước: cách đóng khoảng thiếu ít tốn tiền nhất của khách.
    var cands = getChipPool()
      .filter(function (x) { return x && x.v && !inCart[String(x.v)] && (x.p * (x.m || 1)) >= gap; })
      .sort(function (a, b) { return (a.p * (a.m || 1)) - (b.p * (b.m || 1)); })
      .slice(0, 3);
    if (!cands.length) return hide();

    row.innerHTML = cands.map(function (x) {
      var eff = x.p * (x.m || 1);
      return '<button type="button" class="aef-drawer__chip" data-aef-add="' + x.v + '" data-aef-add-qty="' + (x.m || 1) + '">'
        + (x.i ? '<img class="aef-drawer__chip-img" src="' + escapeHtml(x.i) + '" alt="" width="24" height="24" loading="lazy">' : '')
        + '<span class="aef-drawer__chip-tx">'
        + '<span class="aef-drawer__chip-nm">' + escapeHtml(x.t || '') + '</span>'
        + '<b class="aef-drawer__chip-pr">+' + money(eff) + ((x.m || 1) > 1 ? ' <small>&times;' + x.m + '</small>' : '') + '</b>'
        + '</span><span class="aef-drawer__chip-plus" aria-hidden="true">+</span></button>';
    }).join('');
    box.hidden = false;
    if (window.applyTranslations) { try { window.applyTranslations(); } catch (e) {} }
  }

  /* 🔴 5/9/2026 vòng 42 — thanh free-ship trả lời MUỘN: nó phải đợi giá ship
     thật (khi đó /cart/shipping_rates.json, từ 27/9/2026 giỏ phụ Storefront) rồi
     mới biết máy chủ có thu tiền không, và khi biết
     thì nó chỉ vẽ lại CHÍNH NÓ (renderOne trong snippets/free-shipping-bar.liquid).
     Hỏi nó một lần lúc vẽ chip là chưa đủ — lúc đó nó còn đang `loading`, chip hiện
     ra, rồi 300ms sau thanh hô "đã mở khoá" mà ba cái chip nằm nguyên. Nghe đúng ô
     `data-state` ấy đổi rồi vẽ lại chip bằng CHÍNH bản trạng thái giỏ vừa dùng —
     không gọi thêm một request nào (bẫy 429 trong sổ). */
  function theoDoiThanhShip() {
    var thanh = $('.aef-drawer__ship .free-shipping-bar', drawer);
    if (!thanh || typeof MutationObserver !== 'function') return;
    var mo = new MutationObserver(function () {
      if (!chipGioCuoi) return;
      try { renderChips(chipGioCuoi); } catch (e) {}
    });
    mo.observe(thanh, { attributes: true, attributeFilter: ['data-state'] });
  }

  // ---- 2) KHÁCH THƯỜNG MUA CHUNG -------------------------------------------
  // Lấy thẻ do MÁY CHỦ dựng (sections/aef-drawer-crosssell.liquid) để nút "+"
  // biết số lượng tối thiểu — /recommendations/products.json không mang metafield.
  // Chỉ gọi lại khi MÓN ĐẦU GIỎ đổi: tăng/giảm số lượng không đổi gợi ý, gọi lại
  // mỗi nhịp +/- là tự bắn mình bằng vài chục request.
  var csKey = null, csBusy = false, csLoiLuc = 0;
  /* 🔴 17/8 vòng 16 — PHẢI TÁCH "máy chủ nói KHÔNG CÓ" khỏi "KHÔNG HỎI ĐƯỢC".
     Bản cũ trả `null` cho cả hai ⇒ bên gọi không phân biệt nổi. Hậu quả tuỳ
     cách bên gọi xử: ướp mốc vô điều kiện thì một lần rớt mạng làm khối cross-
     sell chết vĩnh viễn cho món đó; không ướp thì mỗi `cart:updated` lại bắn
     2 request cho một câu trả lời đã biết là rỗng (đúng bẫy 429 trong sổ).
     Nay: { ok:false } = không hỏi được · { ok:true, html:null } = hỏi được,
     không có gì · { ok:true, html:'…' } = có thẻ. */
  function csFetch(pid, intent) {
    return fetch('/recommendations/products?section_id=aef-drawer-crosssell&product_id=' + encodeURIComponent(pid)
      + '&limit=8&intent=' + intent, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error(String(r.status))); })
      .then(function (html) {
        if (!html) return { ok: true, html: null };
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('[data-aef-cs-cards]');
        if (!box || !box.querySelector('.aef-drawer__cs-card')) return { ok: true, html: null };
        return { ok: true, html: box.innerHTML };
      })
      .catch(function () { return { ok: false, html: null }; });
  }
  function renderCrossSell(cart) {
    var box = $('[data-aef-crosssell]', drawer);
    if (!box) return;
    var row = $('[data-aef-cs-row]', box);
    /* 🎁 Dòng quà $0 được Shopify chèn lên đầu giỏ mà sản phẩm Unlisted không có gợi ý: tính từ món khách mua. */
    var hangMua = ((cart && cart.items) || []).filter(function (it) { return it.original_price !== 0; });
    if (!hangMua.length) {
      csKey = null; box.hidden = true; if (row) row.innerHTML = '';
      return;
    }
    var pid = hangMua[0].product_id;
    if (!pid || String(pid) === String(csKey) || csBusy) return;
    // Vừa rớt mạng trong 5 giây qua thì đừng thử lại ngay — mở/đóng giỏ vài
    // lần lúc mạng chập là bắn hàng chục request. 5s đủ để một lần chập qua đi
    // mà khách không cảm thấy khối này "chết".
    if (csLoiLuc && Date.now() - csLoiLuc < 5000) return;
    csBusy = true;
    // `complementary` = danh sách Boss cấu hình trong Search & Discovery, mới thật
    // sự là "khách thường mua chung". Không có thì lùi về `related` VÀ ĐỔI NHÃN —
    // related là hàng tương tự, gọi nó là "mua chung" là mượn uy tín dữ liệu khác.
    csFetch(pid, 'complementary')
      .then(function (a) {
        if (a.html) return { ok: true, html: a.html, key: 'drawer.cross_sell' };
        return csFetch(pid, 'related').then(function (b) {
          // Chỉ coi là "hỏi được" khi CẢ HAI lượt đều hỏi được. Một lượt rớt
          // mạng là chưa đủ căn cứ để kết luận món này không có gợi ý.
          return { ok: a.ok && b.ok, html: b.html, key: 'drawer.cs_related' };
        });
      })
      .then(function (res) {
        csBusy = false;
        /* 🔴 17/8 vòng 16 — GHI MỐC Ở CẢ NHÁNH KHÔNG CÓ GỢI Ý.
           Bản cũ chỉ đặt `csKey` khi CÓ THẺ. Món đầu giỏ mà chưa cấu hình
           Search & Discovery — hoặc mọi gợi ý đã nằm sẵn trong giỏ, máy chủ
           lọc hết ở aef-drawer-crosssell.liquid:30 — thì mốc không được ghi,
           nên lượt vẽ sau lại thấy `pid !== csKey` và bắn tiếp. Mỗi lượt là
           HAI request (complementary rồi lùi về related), mà `paintExtras`
           chạy ở MỌI `cart:updated` và ở mỗi lần mở giỏ ⇒ bấm +/− năm nhịp là
           10 request section cho một câu trả lời đã biết là rỗng. Đúng bẫy 429.
           Câu trả lời "không có gì" CŨNG là câu trả lời, và nó cũng chỉ đổi
           khi món đầu giỏ đổi — nên ướp nó y như ướp câu trả lời có thẻ.
           Nhưng CHỈ ướp khi thật sự HỎI ĐƯỢC: rớt mạng mà ướp là khối này chết
           vĩnh viễn cho món đó. */
        if (res.ok) csKey = String(pid); else csLoiLuc = Date.now();
        if (!res.html) { box.hidden = true; if (row) row.innerHTML = ''; return; }
        if (row) row.innerHTML = res.html;
        var title = $('[data-aef-cs-title]', box);
        if (title) title.setAttribute('data-i18n', res.key);
        box.hidden = false;
        if (window.applyTranslations) { try { window.applyTranslations(); } catch (e) {} }
      })
      .catch(function () { csBusy = false; });
  }

  // ---- 6) MUA LẠI NHANH ----------------------------------------------------
  // Hai nguồn, KHÔNG trộn lời hứa (xem chú thích trong section):
  //   • đăng nhập → dòng máy chủ dựng từ đơn gần nhất = hàng ĐÃ MUA
  //   • vãng lai  → ae_bought_items = món TỪNG CHO VÀO GIỎ ở máy này
  var BOUGHT_KEY = 'ae_bought_items';
  var reorderHasServerRows = false;
  function recordBought(line, qty) {
    if (!line || !line.variant_id) return;
    try {
      var list = lsGet(BOUGHT_KEY).filter(function (x) { return String(x.v) !== String(line.variant_id); });
      list.unshift({
        v: line.variant_id,
        t: line.product_title || line.title || '',
        p: line.price,
        u: line.url || '',
        i: line.image || '',
        m: parseInt(qty, 10) || 1,
      });
      lsSet(BOUGHT_KEY, list.slice(0, 12));
    } catch (e) {}
  }
  function renderReorder(cart) {
    var acc = $('[data-aef-acc="reorder"]', drawer);
    if (!acc) return;
    var list = $('[data-aef-reorder-list]', acc);
    var sub = $('[data-aef-reorder-sub]', acc);
    var t = function (k, fb) { return (window.aefT && window.aefT(k)) || fb; };
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (it) { inCart[String(it.variant_id || it.id)] = true; });

    if (reorderHasServerRows) {
      // Máy chủ đã dựng từ đơn thật — CHỈ giấu dòng nào đang nằm trong giỏ,
      // tuyệt đối không ghi đè innerHTML (mất luôn dữ liệu đơn hàng).
      var any = 0;
      $all('.aef-drawer__mini-it', list).forEach(function (r) {
        var b = r.querySelector('[data-aef-add]');
        var vid = b && b.getAttribute('data-aef-add');
        var dup = vid && inCart[String(vid)];
        r.style.display = dup ? 'none' : '';
        if (!dup) any++;
      });
      if (sub) sub.textContent = t('drawer.reorder_sub_orders', 'from your last order');
      acc.style.display = any ? '' : 'none';
      return;
    }

    /* 🔴 23/10/2026 vòng 53 đợt 5b — GIÁ PHẢI SỐNG, Y NHƯ KHỐI SONG SINH TRANG CHỦ.
       Bản cũ in `x.p` = giá CHỤP lúc món vào giỏ lần trước (recordBought ghi
       line.price), trong khi sections/aef-reorder.liquid:39 ("GIÁ PHẢI SỐNG") cố
       ý hỏi lại /products/{handle}.js. Cùng khái niệm "Mua lại" mà hai bề mặt nói
       hai giá: hết sale / đổi giá là ngăn giỏ hứa giá cũ còn nút thêm tính giá mới.
       Nay đi ĐÚNG cách của trang chủ: cùng nguồn (từ 30/10 là docMuaLaiSo() dưới đây,
       trang chủ gọi chính hàm đó), tra ĐÚNG biến thể `x.v`, giá `v.price`, biến thể
       hết hàng thì LOẠI, handle chết thì bỏ.
       Không hỏi được giá sống thì KHÔNG in món đó — không bao giờ lùi về `x.p`.
       Mỗi handle hỏi MỘT lần cho cả lượt xem trang (nhớ promise); hỏng thoáng
       qua thì hãm rồi lượt vẽ sau hỏi lại. Không đụng /cart.js.
       Người gác: scripts/test-mua-lai-gio-gia-song.js */
    // Đánh số lượt TRƯỚC mọi lối thoát: lượt hỏi giá đang bay của lần vẽ trước không
    // được vẽ đè lên kết quả của lần vẽ này (kể cả khi lần này là "ẩn khối").
    var luot = ++luotMuaLai;
    var seeds = lsGet(BOUGHT_KEY).filter(function (x) {
      return x && x.v && !inCart[String(x.v)] && handleMuaLai(x.u);
    }).slice(0, 6);
    if (!seeds.length) { acc.style.display = 'none'; if (list) list.innerHTML = ''; return; }
    Promise.all(seeds.map(function (x) {
      return docMuaLaiSo(handleMuaLai(x.u)).then(function (kq) {
        var p = kq && kq.p;
        if (!p) return null;
        var v = null;
        for (var k = 0; k < p.variants.length; k++) {
          if (p.variants[k].id === String(x.v)) { v = p.variants[k]; break; }
        }
        if (!v || !v.available || typeof v.price !== 'number') return null;
        /* GIÁ SỐNG (không phải x.p) và MUA TỐI THIỂU SỐNG (không phải x.m = số khách
           thêm LẦN TRƯỚC — /code-review #3: Min nâng 2→6 thì thêm 2 là dưới sàn; x.m 3
           mà campaign Max 1 thì vượt trần). Đúng con số nhánh máy chủ đang thêm. */
        return { v: x.v, t: p.title || x.t, p: v.price, m: v.min };
      });
    })).then(function (rows) {
      if (luot !== luotMuaLai || reorderHasServerRows) return;   // đã có lượt vẽ mới hơn
      veMuaLaiVangLai(acc, list, sub, t, rows.filter(Boolean));
    });
  }
  var luotMuaLai = 0;
  function handleMuaLai(u) {
    var m = String(u || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  /* 🔴 30/10/2026 (/code-review 287d9d08..main #2 #3 #5) — NGUỒN DUY NHẤT của hai khối
     "Mua lại" khách VÃNG LAI: ngăn giỏ (renderReorder ở trên) và trang chủ
     (sections/aef-reorder.liquid nhánh `local`, gọi window.aefDocMuaLaiSo).
     Trước đây cả hai hỏi /products/<h>.js — JSON đó KHÔNG có metafield, nên hai khối
     thêm `m` = số khách thêm lần trước, và cổng trần mù với biến thể chưa có trong giỏ
     (canHoiTran: chưa có trong giỏ ⇒ không hỏi; mà ngăn giỏ cũng chỉ biết trần của món
     ĐANG trong giỏ) ⇒ Three Crabs campaign Max 1, khách từng thêm 3 ⇒ /cart/add.js
     nhận 3. Nay hỏi section sections/aef-mua-lai-so.liquid trên URL của chính SP:
     giá + còn hàng + Mua tối thiểu + trần hiệu lực, qua ba snippet nguồn duy nhất.
     Trần đọc được thì GHI vào tranBiet/minBiet — cổng trần (xetTran) biết luôn, nên
     dù bề mặt nào thêm biến thể đó sau này cũng bị kẹp đúng.
     Kết quả: { p } · { chet: true } (handle không còn SP — section trả 200 với dấu
     data-aef-mls-trong, KHÔNG phải 404 như .js; đo LIVE 30/10 — dấu đó là bằng chứng
     DUY NHẤT) · { loi: true } (404 thiếu section/429/5xx/mạng/thân lạ ⇒ thoáng qua). Mỗi handle hỏi MỘT lần cho cả lượt xem trang; hỏng thì
     HÃM MLS_HONG_NGHI_MS rồi mới hỏi lại (#5: bản cũ xoá nhớ ⇒ mỗi cart:updated bắn
     lại tới 6 request đúng lúc Shopify đang bóp 429).
     Người gác: scripts/test-mua-lai-vang-lai-dung-min-tran.js */
  /* `khongHam`: trang chủ tự có lịch thử lại (sections/aef-reorder.liquid LAN_THU/GIAN —
     0,9 s rồi 2,6 s) và hết lượt thì ghi cờ tắt-đặt-chỗ VĨNH VIỄN ⇒ hãm 60 s ở đây sẽ biến
     mọi lượt thử lại của nó thành { loi } không gọi mạng ⇒ một nhịp 429 tắt khối luôn.
     Chỉ đường vẽ lại của NGĂN GIỎ (mỗi cart:updated) mới hãm — đúng chỗ #5 than. */
  var MLS_HONG_NGHI_MS = 60000;
  var mlsHua = {};       // handle → Promise<kết quả>
  var mlsHongLuc = {};   // handle → Date.now() của lượt hỏi hỏng gần nhất
  function docMuaLaiSo(h, khongHam) {
    h = String(h || '');
    if (!h) return Promise.resolve({ chet: true });
    if (mlsHua[h]) return mlsHua[h];
    if (!khongHam && mlsHongLuc[h] && Date.now() - mlsHongLuc[h] < MLS_HONG_NGHI_MS) return Promise.resolve({ loi: true });
    /* `h` bóc từ URL (line.url / product.url) ⇒ ĐÃ mã hoá phần trăm sẵn: handle có dấu
       hay chữ Hàn/Hoa (6 SP, vd pine-mark-assorted-herb-canh-thu%E1%BB%91c-b%E1%BA%AFc-3oz)
       mà encodeURIComponent thêm lượt nữa ⇒ %25E1… ⇒ 404 (đo LIVE 30/10) ⇒ bản đầu ngày
       30/10 coi là chết và XOÁ món khỏi ae_bought_items. Ghép thẳng như bản .js cũ; regex
       bóc handle đã loại / ? # nên không lọt ra ngoài đoạn đường dẫn. */
    mlsHua[h] = fetch('/products/' + h + '?section_id=aef-mua-lai-so', { credentials: 'same-origin' })
      .then(function (r) {
        /* 404 KHÔNG phải "SP chết": SP chết thì section trả 200 + dấu trống (dưới). 404
           0 byte = theme THIẾU tệp section (đo LIVE 30/10 khi chưa đẩy) ⇒ coi 404 là chết
           thì một lần đồng bộ trượt tệp này xoá kho nhớ mua hàng của MỌI khách ghé trang
           chủ. Mọi mã lỗi ⇒ thoáng qua. */
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('[data-aef-mls]');
        if (!g) throw new Error('thân không có [data-aef-mls]');
        if (g.hasAttribute('data-aef-mls-trong')) return { chet: true };
        var p = { handle: g.getAttribute('data-handle') || h, title: g.getAttribute('data-title') || '', img: g.getAttribute('data-img') || '', variants: [] };
        var els = g.querySelectorAll('[data-variant-id]');
        for (var i = 0; i < els.length; i++) {
          var el = els[i], vid = String(el.getAttribute('data-variant-id') || '');
          if (!vid) continue;
          var mn = parseInt(el.getAttribute('data-min-qty'), 10);
          if (!(mn >= 1)) mn = 1;
          var tran = aefTranCuaHost(el);   // trần hiệu lực = min(trần mua, tồn) — ĐÚNG luật dòng ngăn giỏ
          tranBiet[vid] = tran;
          minBiet[vid] = mn;
          p.variants.push({
            id: vid,
            price: parseInt(el.getAttribute('data-price'), 10),
            available: el.getAttribute('data-available') === 'true',
            min: mn,
            tran: tran,
            img: el.getAttribute('data-img') || ''
          });
        }
        return { p: p };
      })
      .catch(function () { delete mlsHua[h]; mlsHongLuc[h] = Date.now(); return { loi: true }; });
    return mlsHua[h];
  }
  function veMuaLaiVangLai(acc, list, sub, t, items) {
    if (!items.length) { acc.style.display = 'none'; if (list) list.innerHTML = ''; return; }
    if (list) {
      list.innerHTML = items.map(function (x) {
        var xm = parseInt(x.m, 10) || 1;
        return '<div class="aef-drawer__mini-it">'
          + '<span class="aef-drawer__mini-nm">' + escapeHtml(x.t) + '</span>'
          + (typeof x.p === 'number' ? '<span class="aef-drawer__mini-pr">' + money(x.p) + '</span>' : '')
          /* 🔴 5/9/2026 vòng 42 — NHÁNH SONG SINH của khối máy chủ ở
             sections/aef-cart-drawer.liquid: giá in MỘT cái, nút thêm `x.m` cái, và
             giữa hai con số đó không có một chữ nào. Đo trên món $0.99 / tối thiểu 4:
             khách đọc "$0.99 Add", bấm một cái là $3.96. Nói số tối thiểu thì nói cả
             THÀNH TIỀN (khuôn 18/8 của sections/aef-reorder.liquid:441) — `money()` có
             sẵn ngay trong file này nên không đẻ công thức thứ hai. Nhãn nằm trong
             [data-i18n], con số và tiền là node ANH EM (BUG-J).
             Người gác: scripts/test-mua-lai-trong-gio-noi-so-luong.js */
          + (xm > 1 && typeof x.p === 'number'
              ? '<span class="aef-drawer__mini-min"><span data-i18n="card.min_hint">'
                + escapeHtml(t('card.min_hint', 'Min order:')) + '</span> ' + xm
                + ' · <span class="aef-drawer__mini-mintotal">' + escapeHtml(money(x.p * xm)) + '</span></span>'
              : '')
          + '<span class="aef-drawer__mini-act">'
          + '<button type="button" class="aef-drawer__mini-add" data-aef-add="' + x.v + '" data-aef-add-qty="' + xm + '"><span data-i18n="drawer.add">Add</span></button>'
          + '</span></div>';
      }).join('');
    }
    if (sub) sub.textContent = t('drawer.reorder_sub_local', 'you added these before');
    acc.style.display = '';
    if (window.applyTranslations) { try { window.applyTranslations(); } catch (e) {} }
  }

  // ---- 9) QUÀ TẶNG & LỜI NHẮN ----------------------------------------------
  // Ghi vào THUỘC TÍNH GIỎ — Shopify mang thẳng sang đơn, người đóng gói đọc
  // được trong Admin. Đây là toàn bộ phần "quà tặng" theme làm được THẬT.
  var GIFT_FLAG = 'Gift', GIFT_MSG = 'Gift message';
  function renderGift(cart) {
    var acc = $('[data-aef-acc="gift"]', drawer);
    if (!acc) return;
    acc.style.display = (cart && cart.item_count) ? '' : 'none';
    var attrs = (cart && cart.attributes) || {};
    var cb = $('[data-aef-gift-toggle]', acc);
    var ta = $('[data-aef-gift-note]', acc);
    // Không đè lên thứ khách đang gõ dở (ô đang có tiêu điểm).
    if (cb && document.activeElement !== cb) cb.checked = String(attrs[GIFT_FLAG] || '').toLowerCase() === 'yes';
    if (ta && document.activeElement !== ta) ta.value = attrs[GIFT_MSG] || '';
  }
  function saveGift() {
    var acc = $('[data-aef-acc="gift"]', drawer);
    if (!acc) return;
    var cb = $('[data-aef-gift-toggle]', acc);
    var ta = $('[data-aef-gift-note]', acc);
    var st = $('[data-aef-gift-status]', acc);
    var t = function (k, fb) { return (window.aefT && window.aefT(k)) || fb; };
    var body = { attributes: {} };
    body.attributes[GIFT_FLAG] = (cb && cb.checked) ? 'Yes' : '';
    body.attributes[GIFT_MSG] = (ta && ta.value.trim()) || '';
    if (st) st.textContent = '…';
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        if (st) st.textContent = t('drawer.gift_saved', 'Saved ✓');
        setTimeout(function () { if (st) st.textContent = ''; }, 2500);
        // Số món KHÔNG đổi ⇒ không toast "đã thêm"; sự kiện chỉ để các khối khác
        // đọc lại trạng thái giỏ mới (thuộc tính vừa ghi).
        if (cart && typeof cart.item_count === 'number') {
          try {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { source: 'cart-drawer-gift', count: cart.item_count, total: cart.items_subtotal_price, anhGio: cart }
            }));
          } catch (e) {}
          chupSauKhiPhat(cart);
        }
      })
      .catch(function () {
        // Im lặng là đúng cái đã vá 14/8 — báo hỏng thì khách còn biết bấm lại.
        if (st) st.textContent = t('drawer.gift_err', "Couldn't save — try again");
      });
  }

  // ---- 7) ĐIỂM THƯỞNG ------------------------------------------------------
  // Tỉ lệ nằm ở shop metafield custom.points_per_dollar (Boss điền theo đúng
  // Smile.io đang chạy). Chưa có → ẩn hẳn. KHÔNG đoán một con số nào.
  function renderPoints(cart) {
    var el = $('[data-aef-points]', drawer);
    if (!el) return;
    /* HAI con số, hai vai trò khác nhau — đừng gộp:
         rate   = kiếm được mấy ĐIỂM cho mỗi $1 tiêu        (custom.points_per_dollar)
         doi    = cần mấy ĐIỂM để đổi được $1 giảm giá      (custom.points_per_redeem_dollar)
       Tỉ lệ hoàn lại thật = rate / doi. Với 1 điểm/$1 và 100 điểm/$1 thì đúng 1%.
       Với 1 điểm/$1 và 10 điểm/$1 thì là 10% — cùng một câu "1 đô 1 điểm" mà lệch
       nhau MƯỜI LẦN tiền. Nên theme không suy ra con số thứ hai từ con số thứ nhất,
       và thiếu con số nào thì im về phần đó. */
    var rate = parseFloat(drawer.getAttribute('data-aef-points-rate') || '0');
    var doi = parseFloat(drawer.getAttribute('data-aef-points-redeem') || '0');
    var sub = cart && (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    if (!(rate > 0) || !cart || !cart.item_count || !sub) { el.hidden = true; el.innerHTML = ''; return; }
    var t = function (k, fb) { return (window.aefT && window.aefT(k)) || fb; };
    var pts = Math.floor((sub / 100) * rate);
    if (pts < 1) { el.hidden = true; el.innerHTML = ''; return; }

    var ve = '+' + pts + ' ' + escapeHtml(t('drawer.points_post', 'points'));
    /* Chỉ nói ra thành TIỀN khi biết tỉ lệ quy đổi thật. Không biết thì chỉ nói số
       điểm — nói "≈ $X" bằng một con số đoán là hứa sai tiền. */
    if (doi > 0) {
      var tien = pts / doi;
      if (tien >= 0.01) ve += ' <small>(≈ ' + money(Math.round(tien * 100)) + ')</small>';
    }
    el.innerHTML = '<span>⭐ ' + escapeHtml(t('drawer.points_pre', 'This order earns')) + '</span>'
      + '<span>' + ve + '</span>';
    el.hidden = false;
  }

  // ---- 11) GỢI Ý COMBO THEO MÓN --------------------------------------------
  function renderCombo(cart, byKey) {
    var t = function (k, fb) { return (window.aefT && window.aefT(k)) || fb; };
    $all('[data-aef-drawer-items] .aef-drawer__row', drawer).forEach(function (row) {
      var el = row.querySelector('[data-aef-combo]');
      if (!el) return;
      /* 🔴 4/9/2026 — MÁY CHỦ đã quyết rồi, ở đây chỉ ĐỌC lại quyết định đó.
         Trước đây dòng dưới tự kết luận "có combo" CHỈ từ qty rồi gỡ `hidden`,
         trong khi Liquid gác bằng CẢ HAI (combo_q > 1 AND combo_p > 0). Sản phẩm
         có custom.combo_qty = 3 mà chưa có custom.combo_price cho ra đúng một hàng
         chữ trên mỗi dòng giỏ: "🏷 Mua 3 chỉ $0.00 (thêm 2 nữa)" — HỨA SAI TIỀN.
         Trạng thái nửa dữ liệu ấy là đường đi tự nhiên của người nhập liệu (điền
         số lượng trước, giá sau), không phải ca hiếm. Một khái niệm thì một nguồn.
         Người gác: scripts/test-combo-khong-hua-gia-0.js */
      if (el.getAttribute('data-combo-on') !== 'true') { el.hidden = true; return; }
      var need = parseInt(el.getAttribute('data-combo-qty'), 10) || 0;
      if (need < 2) { el.hidden = true; return; } // không có dữ liệu → im
      var it = byKey && byKey[row.getAttribute('data-line-key')];
      var have = it ? it.quantity : 0;
      var more = el.querySelector('[data-aef-combo-more]');
      if (more) {
        more.textContent = have >= need
          ? t('drawer.combo_ok', '✓ combo applies')
          : t('drawer.combo_more', '(add {n} more)').replace('{n}', String(need - have));
      }
      el.hidden = false;
    });
  }

  // ---- THÊM NHIỀU MÓN TRONG MỘT LƯỢT ---------------------------------------
  // `/cart/add.js` nhận `items[]`. Bộ 5 nguyên liệu của một bài công thức trước
  // đây tốn 10 request (5 × add + 5 × cart.js) vì nối chuỗi aefCartAdd; nay còn
  // 2. Vẫn đi qua ĐÚNG hàng đợi chung và vẫn kết bằng MỘT `cart:updated`, nên
  // không đẻ ra người ghi thứ hai (HARD GATE Pattern 1).
  //   items = [{ id, quantity }]  →  Promise<boolean> (máy chủ có nhận không)
  function aefCartAddMany(items, sourceEl) {
    var clean = (items || [])
      .map(function (x) { return { id: x.id, quantity: parseInt(x.quantity, 10) || 1 }; })
      .filter(function (x) { return x.id; });
    if (!clean.length) return Promise.resolve(false);
    /* 23/10 (LU4-29): cùng MỘT cổng trần với aefCartAdd — thiếu dữ kiện cho món
       nào thì hỏi ngăn giỏ một lượt (chung cho cả bộ) rồi mới phán. */
    if (clean.some(function (c) { return canHoiTran(c.id); })) {
      return hoiTranNganGio().then(function () { return aefCartAddManyDaBiet(clean, sourceEl); });
    }
    return aefCartAddManyDaBiet(clean, sourceEl);
  }
  function aefCartAddManyDaBiet(clean, sourceEl) {
    /* "HAI NỬA CÒN HỞ" số 2 của khối 5/9 — nay đã có nhánh "bỏ bớt món nào":
       món ĐÃ CHẠM trần thì BỎ khỏi lượt, món còn chỗ mà xin quá thì KẸP; các món
       khác vẫn đi trong MỘT lượt items[] như cũ. Không còn món nào ⇒ từ chối
       bằng đúng toast 422 của aefCartAdd. Còn món ⇒ máy chủ nhận xong mới nói
       ra món nào bị bỏ/kẹp (câu báo trần sẵn có). Hai mục cùng một biến thể
       trong một bộ thì mục sau thấy phần mục trước đã giữ chỗ (daGiu). */
    var bao = [], daGiu = {};
    clean = clean.filter(function (c) {
      var v = String(c.id);
      dangXep[v] = (dangXep[v] || 0) + (daGiu[v] || 0);   // tạm tính phần mục trước của bộ
      var cham = aefDaChamTran(v), xk = xetKep(v), tranGoc = xetTran(v).tran;
      dangXep[v] -= daGiu[v] || 0;
      if (!dangXep[v]) delete dangXep[v];
      if (cham) { bao.push({ v: v, tran: tranGoc }); return false; }
      if (xk.con > 0 && c.quantity > xk.con) { bao.push({ v: v, tran: xk.apDung }); c.quantity = xk.con; }
      daGiu[v] = (daGiu[v] || 0) + c.quantity;
      return true;
    });
    if (!clean.length) {
      try { showAddErrorToast(422); } catch (e) {}
      return Promise.resolve(false);
    }
    Object.keys(daGiu).forEach(function (v) { dangXep[v] = (dangXep[v] || 0) + daGiu[v]; });
    /* Phán quyết RIÊNG của lượt add này — resolve ngay khi /cart/add.js trả lời,
     * KHÔNG chờ cả hàng đợi chung (hàng đợi có thể còn lượt của người khác nên
     * về muộn hơn nhiều). flyToCart chờ cái này rồi mới dám bật "+1". */
    var choPhanQuyet, phanQuyet = new Promise(function (res) { choPhanQuyet = res; });
    if (sourceEl) flyToCart(sourceEl, phanQuyet); // ảnh bay nổ ngay; "+1" chờ máy chủ
    var httpOk = false, daPhatGio = false, tenTuAdd = {};
    window.__aefCartAddQueue = window.__aefCartAddQueue || Promise.resolve();
    window.__aefCartAddPending = (window.__aefCartAddPending || 0) + 1;
    window.__aefCartAddQueue = window.__aefCartAddQueue.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: clean }),
      })
        .then(
          function (r) {
            if (r.ok) { httpOk = true; return r.json().catch(function () { return null; }); }
            /* Shopify xử lý `items[]` theo kiểu ĐƯỢC ĂN CẢ: một món hỏng là cả
               lượt bị từ chối, không có món nào vào giỏ. Nên báo lỗi một lần là
               đúng sự thật — KHÔNG được nói "đã thêm một phần". */
            try { showAddErrorToast(r.status); } catch (e) {}
            return null;
          },
          function () { try { showAddErrorToast(0); } catch (e) {} return null; }
        )
        .then(function (res) {
          try { choPhanQuyet(httpOk); } catch (e) {}
          /* 🔴 14/9/2026 vòng 48 — BUG-B TÁI PHÁT Ở ĐƯỜNG ADD-NHIỀU.
           *
           * Dòng cũ là `recordBought(l, l.quantity)`. `l` là LINE ITEM của phản
           * hồi `/cart/add.js`, và `l.quantity` là TỔNG TÍCH LUỸ của biến thể
           * trong giỏ SAU khi thêm — không phải delta vừa gửi. Đo lại trên
           * aefoodstore.com với một giỏ vãng lai riêng, dạng `items[]` y hệt
           * dòng dưới: gửi 1 → trả 1, gửi tiếp 1 → trả 2, gửi tiếp 2 → trả 4.
           * Ghi chú `assets/card-stepper.js:562` đã nói đúng chuyện đó, và HARD
           * GATE ghi sẵn nó là "BUG-B"; chỉ có đường add-NHIỀU là chưa vá.
           *
           * Hậu quả: `ae_bought_items[].m` bị bơm lên mỗi lượt và KHÔNG có trần.
           * Khách đang có 3 chai trong giỏ, bấm "Thêm cả bộ" (bộ mang 1 chai) ⇒
           * lưu m=4; bấm bộ đó ba lần ⇒ m=10. Con số đó chảy thẳng ra HAI bề
           * mặt: renderReorder ở :1331 dưới đây in "Mua tối thiểu 4 · $25.96" và
           * đặt `data-aef-add-qty="4"`, còn sections/aef-reorder.liquid:404 (khối
           * TRANG CHỦ, templates/index.json) đọc CÙNG khoá `m` làm `qty` của nút.
           * Tức một mức mua tối thiểu KHÔNG luật nào của tiệm sinh ra, kèm thành
           * tiền khớp với nó nên đọc rất thuyết phục — và bấm Thêm là POST đúng
           * số bịa đó (cổng `aefDaChamTran` :461 không với tới: trong ngăn giỏ
           * biến thể không có thẻ ⇒ `hosts` rỗng ⇒ return false).
           *
           * Nay ghi DELTA — đúng số đã gửi đi, cùng nghĩa với đường add ĐƠN ở
           * :530 (`recordBought(line, qty)`), nên hai đường thôi ghi hai nghĩa
           * khác nhau vào cùng một khoá.
           * BA chi tiết cố ý:
           * ① Tra theo `variant_id`, KHÔNG ghép theo chỉ số: máy chủ GỘP các dòng
           *    cùng biến thể (đo được: gửi 2 mục cùng id → trả về MỘT dòng), nên
           *    `res.items` có thể ngắn hơn `clean` và ghép theo `i` là lệch hết.
           * ② Cộng dồn khi dựng map — `clean` lỡ mang cùng một biến thể hai lần
           *    thì ghi đè sẽ nuốt mất một nửa delta.
           * ③ Không tra ra thì THÔI ghi, đừng mượn `l.quantity`: thà thiếu một
           *    dòng "mua lại" còn hơn rao một con số bịa.
           * Thêm cổng `httpOk` cho đối xứng với :530 (hiện `res` đã null khi hỏng
           * nên chưa có ca thật, nhưng hai đường phải cùng một luật).
           * Người gác: scripts/test-mua-lai-ghi-dung-so-luong.js */
          if (res && res.items) res.items.forEach(function (l) { if (l && l.product_title) tenTuAdd[String(l.variant_id)] = String(l.product_title); });
          if (httpOk && res && res.items) {
            var delta = {};
            clean.forEach(function (c) {
              delta[String(c.id)] = (delta[String(c.id)] || 0) + c.quantity;
            });
            res.items.forEach(function (l) {
              var d = l && delta[String(l.variant_id)];
              if (d > 0) recordBought(l, d);
            });
          }
          return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (cart && typeof cart.item_count === 'number') {
                var tranGhiChu = (httpOk && bao.length) ? { ds: bao, ten: tenTheoGio(cart, tenTuAdd) } : null;
                try {
                  document.dispatchEvent(new CustomEvent('cart:updated', {
                    detail: { source: 'aef-cart-add-many', count: cart.item_count, total: cart.items_subtotal_price, anhGio: cart, tran: tranGhiChu }
                  }));
                } catch (e) {}
                chupSauKhiPhat(cart);
                daPhatGio = true;
              }
            });
        })
        .catch(function () {})
        .then(function () {
          window.__aefCartAddPending = Math.max(0, (window.__aefCartAddPending || 1) - 1);
          var hetHan = httpOk && !daPhatGio;
          Object.keys(daGiu).forEach(function (v) { xongXep(v, daGiu[v], false); });
          if (hetHan) theGio++;
          // Máy chủ nhận phần còn lại ⇒ nói ra món nào bị bỏ / kẹp vì trần.
          if (httpOk && bao.length && !daPhatGio) {
            try { showAddToast('', undefined, undefined, { ds: bao, ten: tenTuAdd }); } catch (e) {}
          }
        });
    });
    return window.__aefCartAddQueue.then(function () { return httpOk; });
  }
  window.aefCartAddMany = window.aefCartAddMany || aefCartAddMany;

  // ---- wiring --------------------------------------------------------------
  function init() {
    drawer = $('[data-aef-cart-drawer]');
    if (!drawer) return;
    panel = $('[data-aef-drawer-panel]', drawer);
    backdrop = $('[data-aef-drawer-backdrop]', drawer);

    // open via the cart icon (it's an <a href="/cart"> — intercept, open drawer)
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      var trigger = bubble.querySelector('#toggleCountCart') || bubble;
      trigger.addEventListener('click', function (e) {
        // allow modified clicks (open /cart in new tab) to pass through
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        e.stopPropagation();
        open();
      });
    }

    // close: backdrop, ✕, ESC
    if (backdrop) backdrop.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-aef-drawer-close]');
      if (c) { e.preventDefault(); close(); }
      // v2: mọi "+" mang [data-aef-add] → dùng chung một đường thêm + một hiệu
      // ứng bay. Nguồn hiện tại: chip gợi ý free-ship · thẻ mua chung · mua lại
      // nhanh. `data-aef-add-qty` KHÔNG được bỏ qua: 955 SP có số lượng mua tối
      // thiểu > 1, thêm 1 cái là giỏ nằm dưới mức bán được mà không báo gì —
      // đúng lỗi vòng 10 ở thẻ sản phẩm. Thiếu thuộc tính thì mới về 1.
      var add = e.target.closest && e.target.closest('[data-aef-add]');
      if (add) {
        e.preventDefault();
        e.stopPropagation();
        var addVid = add.getAttribute('data-aef-add');
        var addQty = parseInt(add.getAttribute('data-aef-add-qty'), 10) || 1;
        if (addVid && addVid !== 'null') {
          /* 2026-08-17 — ba nút này là nhóm CÂM NHẤT theme: không cờ chống bấm
             trùng, không hình đang-gửi, và toast "✓ Đã thêm" thì tự bỏ qua khi
             giỏ đang mở (`showAddToast`: `if (isOpen) return`). Nên khách bấm
             xong KHÔNG thấy gì ngoài ảnh bay 620ms — rồi bấm lại.
             Với chip đóng khe free-ship còn tệ hơn: thêm đôi là vượt ngưỡng
             rồi chip biến mất, khách đã trả thừa mà không hiểu vì sao. */
          if (aefBtnLock(add)) {
            Promise.resolve(aefCartAdd(addVid, addQty, add)).then(
              function (ok) { aefBtnUnlock(add, ok !== false); },
              function () { aefBtnUnlock(add, false); }
            );
          }
        }
        return;
      }
      // v2: lưu tuỳ chọn quà tặng (ghi vào thuộc tính giỏ)
      var gs = e.target.closest && e.target.closest('[data-aef-gift-save]');
      if (gs) { e.preventDefault(); saveGift(); return; }
      // v2: accordion toggle
      var acch = e.target.closest && e.target.closest('[data-aef-acc-toggle]');
      if (acch) {
        e.preventDefault();
        var accEl = acch.closest('.aef-drawer__acc');
        if (accEl) accEl.classList.toggle('is-open');
        return;
      }
      // v2: save for later / restore / remove-from-saved
      var sv = e.target.closest && e.target.closest('[data-aef-save]');
      /* 🔴 6/9/2026 vòng 43 — NHÁNH MẠNG PHÁ HUỶ CUỐI CÙNG CÒN THIẾU KHOÁ.
         Hai nhánh sát bên đã có khoá từ lâu: [data-aef-restore] (vòng 16) và
         [data-aef-drawer-remove] (vòng 24). Riêng "Save for later" bị sót.
         Cửa sổ lọt nhát thứ hai KHÔNG chỉ là một RTT: dòng hàng chỉ biến mất
         sau cart:updated → debounce 160ms → thêm một lượt lấy /cart nữa, nên
         ngón tay nảy trên 📱 lọt rất dễ. Lượt POST /cart/change.js thứ hai bắn
         vào một biến thể ĐÃ không còn trong giỏ; máy chủ trả non-2xx là
         removeLine bật showAddErrorToast(422, "xoa") — mà showAddErrorToast
         KHÔNG có `if (isOpen) return` (khác showAddToast), nên toast đỏ hiện
         THẬT ngay sau khi món đã được lưu và xoá thành công. Giao diện nói dối
         đúng ở bước sắp trả tiền.
         ⚠ KHÔNG đụng rowEl.style.opacity ở đây: saveForLater đã tự lùi mờ ở cả
         hai nhánh hỏng của nó. Thêm người ghi thứ hai vào cùng một thuộc tính
         của cùng một phần tử là phá luật "một người ghi".
         Người gác: scripts/test-luu-de-sau-khong-bam-doi.js */
      if (sv) {
        e.preventDefault();
        if (!aefBtnLock(sv)) return;
        var svVid = sv.getAttribute('data-variant-id');
        var svRow = sv.closest('.aef-drawer__row');
        // KHÔNG dán ✓ — dòng hàng sắp biến mất, dán ✓ lên một nút sắp bị gỡ là
        // nhấp nháy vô nghĩa (cùng lý do đã ghi ở nhánh thùng rác).
        /* 🔴 25/9/2026 vòng 53 (nợ 10) — THÀNH CÔNG THÌ GIỮ KHOÁ, NÚT ĐI CÙNG DÒNG.
           Bản cũ nhả khoá NGAY khi saveForLater trả về, bất kể phán quyết. Mà
           dòng hàng chỉ rời DOM ở lightUpdate: cart:updated → debounce 160ms →
           thêm một lượt /cart.js (sự kiện của removeLine không kèm giỏ). Suốt
           khoảng ấy (đo được +431ms → +993ms ở RTT 400) nút đã bấm lại được
           trên một dòng đã đi ⇒ nhát hai gọi removeLine với line key đã chết,
           tốn thêm lượt ghi trên hàng đợi giỏ dùng chung.
           Nay chỉ nhả khi máy chủ KHÔNG chứng minh được dòng đã đi (dòng ở lại,
           khách cần bấm lại được). Thành công thì khoá sống tới lúc lightUpdate
           gỡ dòng — gỡ dòng là gỡ luôn cái nút. Đóng ngăn giỏ trước lúc đó thì
           `dirty` đã bật từ cart:updated ⇒ lần mở sau fullRefresh thay mới hàng.
           lightUpdate rớt mạng thì dòng mờ + vòng quay đứng tới lần mở sau (cùng
           lối fullRefresh đó); món ĐÃ rời giỏ thật nên không sai tiền. CỐ Ý không
           hẹn giờ tự nhả: nhả lúc ấy là mở lại đúng đường line key đã chết.
           ⚠ `ok !== true` chứ không `ok === false`: hàm nào lỡ trả `undefined`
           thì ngả về phía NHẢ — thừa một lượt ghi còn hơn kẹt vòng quay mãi.
           Người gác: scripts/test-luu-de-sau-khong-bam-doi.js (nhịp chậm) */
        Promise.resolve(saveForLater(svVid, svRow)).then(
          function (ok) { if (ok !== true) aefBtnUnlock(sv, false); },
          function () { aefBtnUnlock(sv, false); }
        );
        return;
      }
      /* 🔴 17/8 vòng 16 — NÚT THÊM HÀNG CUỐI CÙNG CÒN THIẾU KHOÁ CHỐNG BẤM TRÙNG.
         Đợt khảo sát 20 đường thêm hàng ở vòng 14 vá 4 đường qua `aefBtnLock`,
         nhưng SÓT đúng nhánh này vì nút "Add" của danh sách "Để dành" khai bằng
         `data-aef-restore` chứ không phải `data-aef-add` — nó rơi ra ngoài lưới
         quét, và ra ngoài cả luật CSS `.aef-btn-busy`.
         Vì sao bấm hai lần là THÊM HAI LẦN THẬT: `restoreSaved` chỉ xoá món khỏi
         danh sách SAU khi máy chủ nhận (đúng, vá 16/8), nên suốt 400–1500ms chờ
         mạng nút vẫn còn đó và món vẫn còn trong danh sách ⇒ cú bấm thứ hai tìm
         thấy món và gọi `aefCartAdd` lần nữa. Hàng đợi chạy nối tiếp nên KHÔNG
         mất request nào — cả hai lần đều thành công.
         Nặng thêm vì đây là nút CÂM: `showAddToast` tự bỏ qua khi giỏ đang mở
         (`if (isOpen) return`), mà nút này chỉ tồn tại trong giỏ đang mở ⇒ bấm
         xong không có một tín hiệu nào ngoài ảnh bay 620ms. Không thấy gì thì
         người ta bấm lại — đó là hành vi đúng của khách, không phải lỗi của họ. */
      var rs = e.target.closest && e.target.closest('[data-aef-restore]');
      if (rs) {
        e.preventDefault();
        if (aefBtnLock(rs)) {
          Promise.resolve(restoreSaved(rs.getAttribute('data-aef-restore'), rs)).then(
            function (ok) { aefBtnUnlock(rs, ok !== false); },
            function () { aefBtnUnlock(rs, false); }
          );
        }
        return;
      }
      var un = e.target.closest && e.target.closest('[data-aef-unsave]');
      if (un) { e.preventDefault(); removeSaved(un.getAttribute('data-aef-unsave')); return; }
      /* 🔴 20/8/2026 vòng 24 — NỬA CÒN THIẾU CỦA OPTIMISTIC UI Ở NÚT THÙNG RÁC.
         Bản cũ làm mờ dòng hàng NGAY khi chạm rồi bỏ mặc: `removeLine` trả về
         `undefined` nên ở đây không có cách nào biết máy chủ có nhận không, và
         chính `removeLine` thì nuốt hết lỗi. Rớt mạng hoặc 422 là dòng hàng
         nằm lại, mờ y như đã xoá, không một lời nào — rồi trang thanh toán vẫn
         tính tiền món đó. Đây là cùng một lỗi đã vá cho đường THÊM ngày 14/8
         (`showAddErrorToast`), chỉ khác là đường XOÁ bị bỏ sót, mà xoá hỏng thì
         khách MẤT TIỀN chứ không chỉ mất công. */
      var t = e.target.closest && e.target.closest('[data-aef-drawer-remove]');
      if (t) {
        e.preventDefault();
        var vid = t.getAttribute('data-variant-id');
        var row = t.closest('.aef-drawer__row');
        if (!vid) return;
        /* Khoá nút trong lúc chờ. Trên 📱 ngón tay nảy hai cú rất dễ, và hai
           lượt /cart/change.js cùng variant xếp nối tiếp: lượt hai chạy khi món
           đã biến mất, máy chủ vẫn trả 200 kèm giỏ mới ⇒ không sai số tiền,
           nhưng tốn một vòng mạng và làm giỏ nháy hai lần. */
        if (!aefBtnLock(t)) return;
        if (row) row.style.opacity = '0.45'; // optimistic dim; cart:updated removes it
        Promise.resolve(removeLine(vid, row && row.getAttribute('data-line-key'))).then(
          function (ok) {
            // KHÔNG dán ✓ — xoá xong thì dòng hàng biến mất, chẳng còn gì để
            // khoe, mà dán ✓ lên một nút sắp bị gỡ là nhấp nháy vô nghĩa.
            // 25/9/2026 vòng 53 (nợ 10): thành công thì GIỮ khoá tới lúc
            // lightUpdate gỡ dòng — lý do đủ ở nhánh [data-aef-save] phía trên.
            if (ok !== true) aefBtnUnlock(t, false);
            if (ok === false && row) row.style.opacity = '';
          },
          function () {
            aefBtnUnlock(t, false);
            if (row) row.style.opacity = '';
            try { showAddErrorToast(0, 'xoa'); } catch (e2) {}
          }
        );
      }
    });
    // 2026-08-16 — BẪY TIÊU ĐIỂM. sections/aef-cart-drawer.liquid:22-29 khai
    //   role="dialog" aria-modal="true". Khai như vậy là hứa với trình đọc màn
    //   hình rằng phần còn lại của trang KHÔNG tồn tại khi hộp đang mở. Trước đây
    //   file này chỉ nghe Escape, không có một dòng nào giữ tiêu điểm lại: khách
    //   dùng bàn phím ngoài / Switch Control mở giỏ trên điện thoại (drawer phủ
    //   kín màn hình), Tab qua nút "Thanh toán" rồi Tab thêm một lần là tiêu điểm
    //   rơi ra trang phía sau — thấy chữ đọc lên nhưng không thấy con trỏ ở đâu,
    //   và không có đường nào quay lại ngoài việc Tab vòng hết cả trang.
    //   Đây đúng họ lỗi đã vá cho popup chào mừng ở `5858f51`; drawer bị sót.
    //   Bẫy HAI CHIỀU — chỉ chặn chiều tiến thì Shift+Tab vẫn lùi ra được.
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.keyCode === 27) { close(); return; }
      if (e.key !== 'Tab' && e.keyCode !== 9) return;
      var panelEl = panel || $('[data-aef-drawer-panel]', drawer);
      if (!panelEl) return;
      var list = Array.prototype.filter.call(
        panelEl.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        /* 🔴 17/8 vòng 16 — BỘ LỌC CŨ CHỈ BIẾT `[hidden]`, KHÔNG BIẾT `display:none`.
           Giỏ này giấu đồ bằng CẢ HAI cách:
             · ba khối gập mang `style="display:none"` từ máy chủ
               (aef-cart-drawer.liquid:271, :300, :314) và bị JS bật/tắt
             · giỏ TRỐNG thì CSS ẩn cả chân giỏ lẫn khối gập bằng
               `display:none !important` (aef-cart-drawer.css:124, :126)
           Không cái nào mang thuộc tính `hidden` ⇒ chúng vẫn lọt vào danh sách
           "phần tử nhận tiêu điểm được". Giỏ trống thì `last` hoá ra là một nút
           đang `display:none`; điều kiện `document.activeElement === last`
           KHÔNG BAO GIỜ đúng ⇒ không có `preventDefault` ⇒ Tab từ "Tiếp tục mua
           sắm" rơi thẳng ra trang phía sau, trong khi `aria-modal="true"` đã
           hứa với trình đọc màn hình rằng phần còn lại của trang không tồn tại.
           Chiều ngược lại còn kẹt hẳn: Shift+Tab gọi `.focus()` lên phần tử
           `display:none` — không làm gì cả, mà `preventDefault` thì đã chạy.
           `offsetParent !== null` bắt được cả hai cách giấu. Đây đúng bộ lọc mà
           popup chào mừng (welcome-popup.liquid:243) và menu 📱
           (ae-delivery-widget.js:1461) đã dùng — chỉ giỏ dùng bộ yếu hơn. */
        function (el) {
          if (el.hasAttribute('hidden')) return false;
          if (el.getAttribute('aria-hidden') === 'true') return false;
          /* ⚠️ KHÔNG dùng `el.offsetParent !== null` — thử rồi và nó SAI HAI CHIỀU:
             · `offsetParent` là null cho MỌI phần tử có tổ tiên `position: fixed`
               ở một số trình duyệt, mà panel giỏ chính là `position: fixed`
             · trong jsdom nó LUÔN null vì không có layout ⇒ danh sách rỗng ⇒
               `if (!list.length) return` ⇒ bẫy tiêu điểm biến mất hoàn toàn.
               Bộ gác test-drawer-modal-contract.js bắt được ngay, 3 mệnh đề.
             Đi ngược cây và hỏi `display`/`visibility` thì đúng ở cả trình duyệt
             thật lẫn jsdom, và bắt được cả `style="display:none"` viết thẳng
             trong markup lẫn `display:none !important` đến từ file CSS. */
          var win = (el.ownerDocument && el.ownerDocument.defaultView) || window;
          for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
            if (n.hasAttribute && n.hasAttribute('hidden')) return false;
            var st = null;
            try { st = win.getComputedStyle(n); } catch (e) {}
            if (st && (st.display === 'none' || st.visibility === 'hidden')) return false;
            if (n === panelEl) break;
          }
          return true;
        }
      );
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!panelEl.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    });

    // any cart change marks the server-rendered rows stale (re-pulled on next open)
    // and, while open, triggers a lightweight totals/line refresh from /cart.js.
    document.addEventListener('cart:updated', function (e) {
      dirty = true;
      /* Gói /cart.js do chính lượt ghi giỏ vừa rồi trả về (aefCartAdd đính vào
         detail). CHỈ nhận khi ngăn giỏ ĐANG MỞ: nhận lúc đóng thì gói nằm chờ vô
         thời hạn và có thể bị dùng cho một lượt vẽ rất lâu sau, khi giỏ đã khác.
         Sự kiện không mang giỏ ⇒ đặt lại null để lightUpdate tự đi hỏi. */
      if (isOpen) {
        gioTuSuKien = (e && e.detail && e.detail.cart) || null;
        scheduleLightUpdate();
      }
      // Toast khi COUNT TĂNG (add từ PDP / card "+" / stepper-up — mọi add path
      // đều dispatch count server-derived). Event thiếu count (vd wbcartdropdown
      // bare dispatch) → bỏ qua; lần có count kế tiếp tự sync lại mốc.
      var d = (e && e.detail) || {};
      if (typeof d.count === 'number') {
        if (lastCartCount != null && d.count > lastCartCount) {
          // pass pre+post count so the burst counter = postCount − burst-base, the
          // true total added in the toast window — immune to coalesced/off-tempo
          // events and qty>1 (ticket_cart_polish_round2 #3 + follow-up)
          showAddToast((d.line && (d.line.product_title || d.line.title)) || '', lastCartCount, d.count, d.tran);
        }
        lastCartCount = d.count;
      }
    });

    // v2: on a runtime EN⇄VI flip, rebuild the JS-built blocks (coupon, saved
    // rows) in the new language — data-i18n nodes are already handled
    // by applyTranslations; this repaints the innerHTML-built ones via the pipeline.
    document.addEventListener('aef:lang-changed', function () { if (isOpen) scheduleLightUpdate(); });

    // Câu hứa giao hàng trong giỏ là BẢN SAO của câu trên header, nên phải chép
    // lại mỗi khi bản gốc đổi: đổi ngôn ngữ, đổi ZIP, hoặc lúc vùng vừa dò xong.
    // fillZip() chỉ đọc rồi ghi vào [data-aef-drawer-promise] — không tính lại,
    // không tranh chấp với ae-delivery-widget.js.
    // ⏱ Chờ 150ms rồi mới chép: ae-delivery-widget.js render() ghi câu hứa TRONG
    //    một setTimeout 80ms (nhịp fade). Chép ngay lúc sự kiện nổ là chép trúng
    //    bản CŨ — sai lặng lẽ, và chỉ lộ ra khi khách đổi ZIP.
    // 🔴 9/10/2026 (vòng 53, dot3b — K8) — NGHE THÊM `aef:rate-days`. Viên header vẽ
    //    lại cả khi số ngày của Shopify VỀ (aef-fsb.js congBoNgay phơi gói, widget
    //    nghe aef:rate-days) — mà gói thường về SAU khi vùng đã dò xong. Khách mở
    //    ngăn giỏ trước lúc đó thì dòng "Deliver to" chép câu TIER_DEFS (bảng khoảng
    //    cách, 80202 "📦 2-day delivery") rồi KẸT, trong khi viên + dòng PDP đã đổi
    //    sang câu không số / số metafield (người soi df5da3c, jsdom: giỏ phụ trễ
    //    800 ms, ngăn mở lúc 250 ms). Cùng hẹn 150 ms: widget vẽ trong .then của bảng
    //    ZIP rồi 80 ms fade. Vẫn chỉ ĐỌC câu của viên — fillZip là nơi ghi duy nhất.
    //    Người gác: ca (e) của scripts/test-vien-giao-hang-mat-so-ngay-khong-hua-nhanh.js
    ['aef:lang-changed', 'ae-zone-ready', 'aef:zone-changed', 'aef:rate-days'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        setTimeout(function () { try { fillZip(); } catch (e) {} }, 150);
      });
    });

    // KHÔNG còn auto-open khi add (ticket_cart_add_toast_no_autoopen — Boss chốt
    // 2026-06-11, kiểu Amazon/Weee: grocery add 10-20 món/lần, pop full drawer
    // mỗi add là rất cản trở). Thay bằng toast (xem showAddToast). Full drawer
    // CHỈ mở khi bấm icon giỏ / nút Xem giỏ. Seed mốc đếm cho toast từ badge
    // hiện tại — chỉ ĐỌC một lần lúc init (badge vẫn do mini-cart-popup.js ghi).
    var badge = document.getElementById('Cartcount');
    if (badge) lastCartCount = parseInt((badge.textContent || '0').trim(), 10) || 0;

    // v2: MÁY CHỦ có dựng sẵn dòng "mua lại" từ đơn hàng thật không? Đo MỘT LẦN
    // lúc dựng, trước khi bất kỳ lượt vẽ nào có thể ghi đè danh sách. Có thì
    // renderReorder() tuyệt đối không đụng innerHTML (mất luôn dữ liệu đơn hàng),
    // chỉ ẩn/hiện từng dòng.
    reorderHasServerRows = !!$('[data-aef-reorder-list] .aef-drawer__mini-it', drawer);

    // v2: seed the saved-for-later count
    renderSaved();

    // 🔴 5/9/2026 vòng 42 — chip phải im khi thanh free-ship nói "đã miễn phí".
    theoDoiThanhShip();
  }

  /* ══════════════════════════════════════════════════════════════════════════
     🔴 21/9/2026 — TRANG /cart: CHỈ CẤT WIDGET SMILE KHI CON SỐ TỔNG TIỀN THẬT
     SỰ ĐI VÀO DẢI CỦA NÓ.

     BẢN CŨ (19/9, assets/aef-cart-drawer.css:877) treo `body.template-cart` vào
     luật `display:none` của launcher Rewards ⇒ ẩn HẲN widget suốt cả trang giỏ.
     Nó cứu được con số tiền, và phép đo hôm đó có thật (ghi nguyên ở file CSS):
     📱 61,9% bề ngang con số bị launcher cướp, 🖥 85,7%. Nhưng cái giá là CẢ
     ĐƯỜNG ĐỔI ĐIỂM: launcher đó là cửa đổi điểm DUY NHẤT của theme này — quét
     templates/ sections/ snippets/ layout/ ngày 21/9 không có template
     page.rewards nào, không có khối Smile nhúng nào, ba chỗ nhắc tới "Smile"
     đều chỉ là CHÚ THÍCH. Khách có điểm, đứng đúng chỗ sắp trả tiền, mà không
     còn nút nào để tiêu điểm. Ẩn một widget là việc nhỏ; khoá một đường đổi
     điểm ngay tại giỏ là việc lớn.

     Mà va chạm CHỈ xảy ra trên một dải cuộn: launcher neo cứng đáy-phải bằng
     position:fixed, con số tổng thì CUỘN. Nên câu hỏi đúng là "con số có đang ở
     trong dải đó không", và IntersectionObserver trả lời được mà không cần một
     người nghe `scroll` nào.

     ĐÚNG KHUÔN `body.aef-mua-trong-tam` (PDP, 25/8, cùng file CSS): một cờ trên
     <body> · ẩn bằng opacity + pointer-events chứ KHÔNG display · có transition
     để không giật một nhịp reflow mỗi lần cuộn qua. Không đẻ khuôn mới.

     ⚠️ BỐN CÁI BẪY, người sau đừng dẫm lại:

     1. CON SỐ BỊ THAY RUỘT. `.totals__subtotal-value` nằm trong `.js-contents`
        của #main-cart-footer, và assets/cart.js:424-427 thay SẠCH innerHTML của
        `.js-contents` sau MỖI lượt đổi số lượng (Section Rendering). Observer
        treo trên node cũ thì chết CÂM: không lỗi, không log, cờ kẹt ở trạng
        thái cuối cùng nó thấy. Vì vậy phải có MutationObserver trên chính
        `.js-contents` — node ĐÓ sống, chỉ ruột bị thay — để bắt lại node mới.

     2. rootMargin ĐÓNG BĂNG LÚC DỰNG. Dải đo tính từ `innerHeight`, mà trên
        điện thoại thanh địa chỉ thu vào/nhả ra đổi `innerHeight` cỡ 60-90px,
        đúng bằng bề cao cái dải. Không dựng lại khi đổi khổ là dải trôi đi chỗ
        khác, và hỏng theo kiểu im lặng nhất: cờ vẫn bật/tắt, chỉ sai chỗ.

     3. KHÔNG CÓ IntersectionObserver (trình duyệt rất cũ) ⇒ bật cờ VĨNH VIỄN,
        tức quay về đúng hành vi cũ (ẩn cả trang). Thà mất đường đổi điểm còn
        hơn để con số tiền bị che mà KHÔNG ai canh.

     4. CỐ Ý KHÔNG bọc @media: đã đo, 🖥 dính NẶNG HƠN 📱 (85,7% so với 61,9%).
        Ai thấy "widget nổi" rồi phản xạ bọc mobile-only là lật lại đúng bẫy mà
        chú thích 19/9 trong file CSS đã kể.

     DẢI 140px: launcher đo được 🖥 142×60 neo bottom:20 (đỉnh ở vh−80) và
     📱 84×44 neo bottom:16 (đỉnh ở vh−60). 140 phủ cả hai kèm ~60px dằn cho
     ngày Smile đổi kích thước. CỐ Ý KHÔNG đo getBoundingClientRect() của chính
     launcher: Smile tiêm nó BẤT ĐỒNG BỘ nên lúc dựng thường chưa có trong DOM,
     và đi đo một thứ mà mình đang ẩn là tự dựng một vòng lẩn quẩn.

     🚨 NGƯỜI GÁC PHẢI SỬA THEO: scripts/test-tong-tien-khong-bi-che.js:180 lọc
     khối luật bằng /template-cart/ và :191 rút tên lớp bằng
     /body\.([A-Za-z0-9_-]*template-cart[A-Za-z0-9_-]*)\s+#smile…/. Bản vá này
     gỡ `template-cart` khỏi luật đó nên người gác sẽ báo ĐỎ OAN
     ("bản gộp KHÔNG có luật nào bám trang giỏ"). Việc cần làm là dạy nó đo cờ
     `aef-tong-tien-trong-tam`, KHÔNG phải dựng lại luật ẩn cả trang.
     ══════════════════════════════════════════════════════════════════════════ */
  function canhTongTienCart() {
    var CO = 'aef-tong-tien-trong-tam';
    var than = document.body;
    if (!than || !than.classList || !than.classList.contains('template-cart')) return;

    if (typeof window.IntersectionObserver !== 'function') {
      than.classList.add(CO);   /* bẫy 3: về đúng hành vi cũ */
      return;
    }

    var DAI_PX = 140;
    var khoiRuot = document.querySelector('#main-cart-footer .js-contents');
    var io = null;
    var hen = null;

    function batTat(bat) {
      try { than.classList.toggle(CO, !!bat); } catch (e) {}
    }

    function dungLai() {
      if (io) { try { io.disconnect(); } catch (e) {} io = null; }
      var soTong = document.querySelector('#main-cart-footer .totals__subtotal-value')
                || document.querySelector('.totals__subtotal-value');
      /* Không tìm ra dòng tổng ⇒ không có gì để che ⇒ trả widget lại.
         ⚠️ ĐÂY KHÔNG PHẢI NHÁNH "GIỎ RỖNG" — bản vá đầu ghi vậy là SAI, đã sửa.
         sections/main-cart-footer.liquid:6 in khối blocks VÔ ĐIỀU KIỆN, nên giỏ
         rỗng vẫn có `.totals__subtotal-value` (mang $0.00) nằm trong DOM; thứ
         biến mất chỉ là hình ảnh, do `.is-empty .cart__footer { display:none }`
         ở assets/component-cart.css:12. Giỏ rỗng đi vào nhánh BÌNH THƯỜNG, và ra
         đúng kết quả nhờ một lý do KHÁC: IntersectionObserver không bao giờ báo
         giao nhau cho phần tử `display:none` ⇒ cờ tắt ⇒ widget hiện.
         Nhánh `!soTong` này chỉ còn là lưới an toàn cho ngày ai đó đổi markup
         chân giỏ. Đừng gỡ nó vì "giỏ rỗng đã có nhánh khác lo". */
      if (!soTong) { batTat(false); return; }
      var tren = Math.max(0, (window.innerHeight || 0) - DAI_PX);
      try {
        io = new IntersectionObserver(function (ds) {
          for (var i = 0; i < ds.length; i++) batTat(ds[i].isIntersecting);
        }, { root: null, rootMargin: '-' + tren + 'px 0px 0px 0px', threshold: 0 });
        io.observe(soTong);
      } catch (e) {
        /* Dựng không nổi (rootMargin bị từ chối chẳng hạn) ⇒ cùng đường lùi với
           bẫy 3: thà ẩn cả trang còn hơn bỏ con số tiền không ai canh. */
        io = null;
        batTat(true);
      }
    }

    function henDungLai() {
      if (hen) clearTimeout(hen);
      hen = setTimeout(function () { hen = null; dungLai(); }, 200);
    }

    /* Bẫy 1: ruột `.js-contents` bị thay sau mỗi lượt đổi số lượng. Dựng lại
       observer chứ không cố đoán node còn sống hay không — dựng lại một
       IntersectionObserver rẻ hơn nhiều so với một cờ kẹt sai. */
    if (khoiRuot && typeof window.MutationObserver === 'function') {
      try {
        new MutationObserver(henDungLai).observe(khoiRuot, { childList: true, subtree: true });
      } catch (e) {}
    }
    /* Bẫy 2: rootMargin đóng băng lúc dựng ⇒ đổi khổ màn hình là phải dựng lại. */
    window.addEventListener('resize', henDungLai);
    window.addEventListener('orientationchange', henDungLai);

    dungLai();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Đăng ký RIÊNG, không nhét vào init(): init() `return` ngay khi trang không
     có [data-aef-cart-drawer]. Người canh con số tổng tiền phải sống độc lập
     với chuyện ngăn kéo có dựng được hay không. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', canhTongTienCart);
  else canhTongTienCart();
})();

;

/* ===== aef-email-inline.js ===== */
/* Kiểm ô email NGAY TẠI CHỖ, thay vì đợi bấm gửi.
 *
 * VÌ SAO
 *   Bảy chỗ trong theme có ô email (liên hệ · chân trang · newsletter · banner
 *   đăng ký · popup chào mừng · lp-sameday · đáy bài viết). Cả bảy đều đã có
 *   `required` + `type="email"`, tức trình duyệt CÓ chặn khi bấm gửi — nhưng
 *   chặn bằng bong bóng mặc định, xuất hiện sau khi khách đã rời ô từ lâu, và
 *   luôn bằng tiếng của TRÌNH DUYỆT chứ không theo nút đổi ngôn ngữ của tiệm.
 *   Khách gõ "ban@gmail" rồi đi tiếp, mãi tới lúc bấm gửi mới biết.
 *
 *   Bộ này báo ngay khi rời ô, bằng đúng thứ tiếng đang xem, và xoá lời báo
 *   ngay khi khách gõ tiếp — chứ không để một dòng đỏ nằm lì đó.
 *
 * BA ĐIỀU CỐ Ý KHÔNG LÀM
 *   1. KHÔNG chặn submit. Việc đó `required` đã lo và lo đúng; chen vào là dễ
 *      khoá luôn nút gửi khi bộ này hiểu sai một địa chỉ hợp lệ.
 *   2. KHÔNG báo khi ô đang RỖNG. Rời một ô chưa gõ gì mà bị mắng là thù địch;
 *      ô bắt buộc để trống thì `required` xử lý lúc gửi.
 *   3. KHÔNG tự viết luật email. Dùng chính `input.validity.typeMismatch` của
 *      trình duyệt — cùng một quan toà với lúc submit, nên không bao giờ xảy ra
 *      cảnh ở đây báo sai mà bấm gửi lại qua (hoặc ngược lại).
 *
 * Gắn listener ở tầng document (capture) nên ô do JS bơm vào sau — popup chào
 * mừng, khối đăng ký lazy — vẫn được canh mà không cần gắn lại.
 */
(function () {
  'use strict';

  var LOP = 'aef-email-err';

  function chu() {
    return (window.aefT && window.aefT('form.email_invalid'))
      || 'Please enter a valid email — e.g. you@example.com';
  }
  function chuNhac() {
    return (window.aefT && window.aefT('form.email_hint_tld'))
      || 'Did you forget the ending? e.g. .com';
  }

  function oBao(input) {
    var next = input.nextElementSibling;
    return next && next.classList && next.classList.contains(LOP) ? next : null;
  }

  function xoa(input) {
    var el = oBao(input);
    if (el) el.remove();
    input.classList.remove('aef-email-invalid');
    input.removeAttribute('aria-invalid');
  }

  function bao(input, nhac) {
    var el = oBao(input);
    if (!el) {
      el = document.createElement('div');
      el.className = LOP;
      /* role=alert để trình đọc màn hình đọc ngay, không phải chờ khách tự dò
         tới. Kiểu dáng nằm trong aef-product-card.css (đã ở bundle đầu trang). */
      el.setAttribute('role', 'alert');
      if (input.parentNode) input.parentNode.insertBefore(el, input.nextSibling);
    }
    el.textContent = nhac ? chuNhac() : chu();
    el.classList.toggle('aef-email-err--hint', !!nhac);
    el.dataset.aefHint = nhac ? '1' : '';
    input.classList.toggle('aef-email-invalid', !nhac);
    /* Lời NHẮC không phải lỗi: không khai aria-invalid, không tô đỏ ô, không
       chặn gì. Khai sai chỗ này là trình đọc màn hình báo "trường không hợp lệ"
       cho một địa chỉ trình duyệt chấp nhận — mâu thuẫn với lúc bấm gửi. */
    if (nhac) input.removeAttribute('aria-invalid');
    else input.setAttribute('aria-invalid', 'true');
  }

  /* THIẾU ĐUÔI TÊN MIỀN — lời NHẮC, không phải lỗi.
     Chuẩn HTML coi `ban@gmail` là email HỢP LỆ (phần sau @ không bắt buộc có
     dấu chấm), nên `type="email"` không bắt, và bấm gửi cũng qua. Đó lại đúng
     là lỗi gõ hay gặp nhất: quên `.com`. Nhắc thì được, chặn thì không —
     chặn là có ngày từ chối một địa chỉ nội bộ hợp lệ.
     Không tự chế luật email ở đây: chỉ hỏi đúng một câu "phần sau @ có dấu
     chấm không". */
  function thieuDuoi(v) {
    var i = v.lastIndexOf('@');
    if (i < 1) return false;                    // sai kiểu khác → đã có nhánh lỗi lo
    var mien = v.slice(i + 1);
    return mien.length > 0 && mien.indexOf('.') < 0;
  }

  function laOEmail(el) {
    return el && el.tagName === 'INPUT' && String(el.type).toLowerCase() === 'email';
  }

  function kiem(input) {
    if (!laOEmail(input)) return;
    var v = (input.value || '').trim();
    if (!v) { xoa(input); return; }              // rỗng → để `required` lo lúc gửi
    // Cùng quan toà với lúc submit: không tự chế biểu thức email.
    if (input.validity && input.validity.typeMismatch) bao(input, false);
    else if (thieuDuoi(v)) bao(input, true);
    else xoa(input);
  }

  // blur không nổi bọt → phải bắt ở pha capture.
  document.addEventListener('blur', function (e) { kiem(e.target); }, true);

  // Gõ tiếp là xoá lời báo ngay — đừng để dòng đỏ nằm lì trong lúc khách đang sửa.
  document.addEventListener('input', function (e) {
    if (laOEmail(e.target) && oBao(e.target)) xoa(e.target);
  }, true);

  /* Đổi ngôn ngữ giữa chừng thì lời báo đang hiện phải đổi theo — nó do JS dựng
     nên applyTranslations() (chỉ quét [data-i18n]) không với tới. */
  document.addEventListener('aef:lang-changed', function () {
    document.querySelectorAll('.' + LOP).forEach(function (el) {
      el.textContent = el.dataset.aefHint === '1' ? chuNhac() : chu();
    });
  });
})();

;

/* ===== tiny-img-link-preloader.js ===== */
let urlToPreload,mouseoverTimer,lastTouchTimestamp;const prefetcher=document.createElement("link"),isSupported=prefetcher.relList&&prefetcher.relList.supports&&prefetcher.relList.supports("prefetch"),isDataSaverEnabled=navigator.connection&&navigator.connection.saveData,allowQueryString="instantAllowQueryString"in document.body.dataset,allowExternalLinks="instantAllowExternalLinks"in document.body.dataset;if(isSupported&&!isDataSaverEnabled){prefetcher.rel="prefetch",document.head.appendChild(prefetcher);const e={capture:!0,passive:!0};document.addEventListener("touchstart",touchstartListener,e),document.addEventListener("mouseover",mouseoverListener,e)}function touchstartListener(e){lastTouchTimestamp=performance.now();const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("touchcancel",touchendAndTouchcancelListener,{passive:!0}),t.addEventListener("touchend",touchendAndTouchcancelListener,{passive:!0}),urlToPreload=t.href,preload(t.href))}function touchendAndTouchcancelListener(){urlToPreload=void 0,stopPreloading()}function mouseoverListener(e){if(performance.now()-lastTouchTimestamp<1100)return;const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("mouseout",mouseoutListener,{passive:!0}),urlToPreload=t.href,mouseoverTimer=setTimeout(()=>{preload(t.href),mouseoverTimer=void 0},65))}function mouseoutListener(e){e.relatedTarget&&e.target.closest("a")==e.relatedTarget.closest("a")||(mouseoverTimer?(clearTimeout(mouseoverTimer),mouseoverTimer=void 0):(urlToPreload=void 0,stopPreloading()))}function isPreloadable(e){if(!e||!e.href)return;if(urlToPreload==e.href)return;const t=new URL(e.href);if("/cart" == t.pathname || t.pathname.startsWith("/cart/"))return;return!(!(allowExternalLinks||t.origin==location.origin||"instant"in e.dataset)||!["http:","https:"].includes(t.protocol)||"http:"==t.protocol&&"https:"==location.protocol||!(allowQueryString||!t.search||"instant"in e.dataset)||t.hash&&t.pathname+t.search==location.pathname+location.search||"noInstant"in e.dataset)||void 0}function preload(e){prefetcher.href=e}function stopPreloading(){prefetcher.removeAttribute("href")}
;

/* ===== aef-swipe.js ===== */
/* ═══════════════════════════════════════════════════════════════════════════
   aef-swipe.js — LƯỚT DÃY NGANG KHÔNG CẦN NÚT, và tự chạy cho dãy banner.

   Boss chốt 24/8/2026: *"khách có thể lượt được không cần nút bấm qua … đừng
   xài cái thanh kéo nhìn quê mùa, mình phải đánh vào trải nghiệm khách hàng."*

   Trên điện thoại vuốt đã sẵn chạy. Vấn đề là MÁY TÍNH: một `overflow-x:auto`
   với chuột thì chỉ còn cách kéo thanh cuộn — thứ vừa xấu vừa khó trúng. Bộ này
   cho kéo-thả bằng chuột ngay trên chính dãy, nên nút mũi tên chỉ còn là lối
   phụ chứ không phải lối duy nhất.

   GẮN BẰNG THUỘC TÍNH, không gắn bằng tên class — một file lo cho mọi dãy:
     data-aef-swipe            → bật kéo-thả bằng chuột
     data-aef-auto="6000"      → tự lướt, 6000 ms một nhịp

   TỰ LƯỚT PHẢI BIẾT DỪNG. Nội dung tự chạy mà khách không dừng được là lỗi
   WCAG 2.2.2, và thực tế thì nó cướp quyền điều khiển ngay lúc người ta đang
   đọc. Nên nó dừng khi: rê chuột vào · có phần tử bên trong nhận tiêu điểm ·
   khách chạm/kéo · tab bị ẩn · máy khai `prefers-reduced-motion`.
   Và khách đã tự lướt một lần thì nó TẮT HẲN — không giành lái nữa.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var itDong = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ── MỘT ĐƯỜNG CUỘN DUY NHẤT, VÀ NÓ PHẢI ĐI THẬT ─────────────────────────
     Trước đây mỗi chỗ tự gọi `scrollBy/scrollTo({behavior: muot()})`. Ba chỗ, ba
     lời gọi, và KHÔNG chỗ nào kiểm lại xem dãy có nhúc nhích hay không.

     🔴 30/8/2026 — vì sao có lưới an toàn ở đây. Người điều phối đo được trên máy
     của mình: `scrollBy({behavior:"smooth"})` trên dãy này KHÔNG nhích một pixel,
     trong khi `behavior:'auto'` và gán thẳng `scrollLeft` thì chạy.
     Mình KHÔNG tái hiện được — đo lại trên chính staging 186604421426 (Chrome 151,
     1920px) thì cả 4 tab đều cuộn đúng 0 → 276 bằng nút ‹ ›, kể cả khi dãy nằm
     ngoài khung nhìn và khi bật giảm chuyển động; 6 khung dựng riêng (snap
     proximity/mandatory · DOM đổi liên tục · scroll-padding · lề âm) cũng không
     ca nào chết. Nên KHÔNG kết luận bừa về nguyên nhân.

     Nhưng triệu chứng đó là một họ hỏng CÓ THẬT: cuộn mượt do trình duyệt chạy
     bằng hoạt ảnh, mà hoạt ảnh thì bị bóp khi tab chạy nền, khi hệ điều hành xin
     giảm chuyển động theo kiểu trình duyệt không khai qua media query, hoặc khi
     một cơ chế khác huỷ hoạt ảnh giữa chừng. Và cay nhất: `scrollBy` KHÔNG ném
     lỗi, không trả về gì — nó im lặng không làm gì cả, nên mọi bộ gác hỏi "có gọi
     cuộn không" đều xanh trong khi khách bấm nút thì dãy đứng im.

     Cách chữa: vẫn xin cuộn MƯỢT (Boss muốn "xịn", hạ hết xuống nhảy tức thì là
     vứt đúng thứ Boss xin), nhưng ĐO LẠI KẾT QUẢ. Nếu sau 400ms dãy chưa nhích
     một pixel nào thì gán thẳng `scrollLeft` — tới nơi bằng đường xấu còn hơn
     đứng im.
     Lưới này TỰ GỠ ngay khi có cú `scroll` đầu tiên, nên ở máy bình thường nó
     không bao giờ nổ: không giật, không cuộn hai lần. Nó chỉ tồn tại cho cái
     môi trường mà cuộn mượt chết.

     ⛔ Đừng thay bằng rAF tween: môi trường nào bóp hoạt ảnh cuộn mượt thì cũng
     bóp luôn rAF, nên tween chết y hệt mà lại thêm 30 dòng và tự đánh nhau với
     scroll-snap ở từng khung hình. */
  function cuonToi(el, dich) {
    var het = el.scrollWidth - el.clientWidth;
    if (het <= 0) return;
    dich = Math.max(0, Math.min(Math.round(dich), het));
    var dau = el.scrollLeft;
    if (Math.abs(dich - dau) < 1) return;
    /* Máy xin ít chuyển động thì nhảy tức thì — và `behavior:"smooth"` gọi từ JS
       KHÔNG tự nghe media query, phải tự hỏi. */
    if (itDong && itDong.matches) { el.scrollLeft = dich; return; }

    el.scrollTo({ left: dich, behavior: 'smooth' });

    goLuoi(el);
    el.__aefDich = dich;
    var thoi = function () { goLuoi(el); };
    el.addEventListener('scroll', thoi, { passive: true });
    el.__aefGo = function () { el.removeEventListener('scroll', thoi); };
    el.__aefLuoi = setTimeout(function () {
      var d = el.__aefDich;
      goLuoi(el);
      /* Chỉ cứu khi dãy đứng im HOÀN TOÀN. Nhích được dù một pixel nghĩa là cuộn
         mượt đang chạy (hoặc khách đã tự kéo) — đụng vào là cướp tay lái. */
      if (d != null && Math.abs(el.scrollLeft - dau) < 1) el.scrollLeft = d;
    }, 400);
  }

  /* Gỡ lưới: dùng cả khi có cú cuộn thật (không cần cứu nữa) lẫn khi căng lưới mới.
     Phải gỡ ĐÚNG cái listener đã gắn — mỗi lần căng lưới sinh một closure mới, cứ
     clearTimeout mà không gỡ thì listener cũ nằm lại, bấm nhiều lần là cộng dồn. */
  function goLuoi(el) {
    if (el.__aefGo) { el.__aefGo(); el.__aefGo = null; }
    if (el.__aefLuoi) { clearTimeout(el.__aefLuoi); el.__aefLuoi = 0; }
    el.__aefDich = null;
  }

  /* 🔴 MỐC ĐỂ CỘNG THÊM MỘT BƯỚC — KHÔNG PHẢI LÚC NÀO CŨNG LÀ `scrollLeft`.
     Trong môi trường cuộn mượt chết, `scrollLeft` đứng im cho tới lúc lưới nổ.
     Bấm nút 5 lần liên tiếp thì cả 5 lần đều tính từ 0 ⇒ ra cùng một đích, và dãy
     chỉ đi ĐÚNG MỘT bước cho 5 cú bấm. Đo được thật: 40 cú bấm mà dãy dừng ở
     312/2958. Nên khi còn một đích đang chờ thì cộng dồn LÊN ĐÍCH ĐÓ.
     Ở máy bình thường, cú `scroll` đầu tiên gỡ lưới ngay nên mốc luôn là vị trí
     thật — đúng hành vi đang chạy trên staging (10 cú bấm tới đúng 2484/2484). */
  /* Mốc để cộng dồn khi bấm liên tiếp: nếu còn một đích đang chờ thì cộng lên
     đích đó, không cộng lên vị trí hiện tại (vị trí hiện tại đang chạy dở).

     🔴 ĐO THẬT 30/8, TRÊN STAGING, TRÌNH DUYỆT HIỂN THỊ — CHỖ NÀY CHƯA ĂN:
       10 cú bấm cách nhau  60ms  → đi 1380/2484   (nuốt mất 4 cú)
       10 cú bấm cách nhau 700ms  → đi 2484/2484   ✅
     Số này GIỐNG HỆT trước và sau khi thêm `mocDich`, tức nó chưa cứu được ca
     bấm dồn. Lý do nằm ngay trong `cuonToi`: ở đó có một listener `scroll` gọi
     `goLuoi`, mà cuộn mượt bắn `scroll` liên tục, nên `__aefDich` bị xoá ngay
     khung hình ĐẦU TIÊN của hoạt ảnh. Cú bấm kế tiếp vì thế rơi về nhánh
     `el.scrollLeft` — đúng cái nhánh mà `mocDich` sinh ra để tránh.
     Muốn chữa cho đúng thì phải phân biệt cú `scroll` DO MÌNH gây ra với cú do
     KHÁCH kéo, chứ không thể gỡ lưới ở mọi cú scroll.

     ĐỂ NGUYÊN CÓ CHỦ Ý, và ghi ra đây để không ai đọc tên hàm rồi tưởng đã xong:
     bấm thong thả — tức cách người ta bấm thật — đi đúng tới cuối; bấm dồn thì
     đi ít hơn chứ KHÔNG sai, không kẹt, không hiện gì sai. Sửa nó đòi đụng vào
     lưới an toàn, và lưới đó mới là thứ đang giữ cho nút không chết im lặng.
     Là việc KHÁC, commit KHÁC. [[reference_do_ket_qua_dung_do_loi_goi]] */
  function mocDich(el) {
    return (el.__aefLuoi && el.__aefDich != null) ? el.__aefDich : el.scrollLeft;
  }

  /* Bước nhảy = bề ngang một ô + khe. ĐO, không gõ cứng: bề ngang ô đổi theo
     khổ màn hình (46% / 62% / 86% ở dãy banner), gõ cứng là mỗi khổ nhảy sai
     một kiểu. */
  function buoc(el) {
    var o = el.firstElementChild;
    if (!o) return el.clientWidth;
    var cs = getComputedStyle(el);
    var khe = parseFloat(cs.columnGap || cs.gap || 0) || 0;
    return Math.round(o.getBoundingClientRect().width + khe);
  }

  /* ── KÉO–THẢ BẰNG CHUỘT ────────────────────────────────────────────────── */
  /* ⛔ MỘT KHÁI NIỆM, MỘT CON SỐ. "Thế nào là kéo chứ không phải bấm" từng
     được trả lời ở BA chỗ với BA con số khác nhau (>3 để gắn class, >3 để bắt
     con trỏ, >6 để nuốt cú click). Ba con số cho một khái niệm thì sớm muộn
     cũng lệch nhau — và lần này đã lệch thật, đẻ ra vùng chết 4–6px. Nay đúng
     một hằng số, dùng cho cả ba việc. Đừng tách nó ra lại. */
  var NGUONG_KEO = 6;

  function ganKeo(el) {
    if (el.__aefKeo) return;
    el.__aefKeo = true;

    var dangKeo = false, batDauX = 0, batDauScroll = 0, daDi = 0, snapCu = '', daBat = false;

    el.addEventListener('pointerdown', function (e) {
      /* Reset ĐỨNG TRƯỚC chốt "chỉ chuột": cú CHẠM cũng phải xoá dấu vết của cú
         kéo trước. Để sau chốt thì trên máy vừa có chuột vừa có cảm ứng, `daDi`
         của cú kéo bằng chuột đọng lại và nuốt đúng một cú chạm kế tiếp. */
      daDi = 0;
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dangKeo = true; daBat = false;
      batDauX = e.clientX;
      batDauScroll = el.scrollLeft;
      /* `scroll-snap-type: mandatory` giằng lại từng khung hình trong lúc kéo,
         cảm giác như dãy bị dính. Tắt trong lúc kéo, trả lại khi thả — lúc thả
         nó tự neo về ô gần nhất, đúng thứ mình muốn. */
      snapCu = el.style.scrollSnapType;
      el.style.scrollSnapType = 'none';
      /* ⛔ 24/8/2026 — KHÔNG gắn `aef-keo` ở đây, và KHÔNG gọi
         `setPointerCapture` ở đây. Xem khối chú thích dài trong pointermove. */
    });

    el.addEventListener('pointermove', function (e) {
      if (!dangKeo) return;
      var dx = e.clientX - batDauX;
      /* ⛔⛔ ĐỌC HẾT TRƯỚC KHI HẠ NGƯỠNG NÀY XUỐNG. Đã sai HAI LẦN ở đây.
         Cùng một họ lỗi "41 link chết trên máy tính", vá hụt một lần rồi.

         Có HAI cơ chế độc lập cùng cướp đích của cú click, và gỡ một cái thì
         cái kia vẫn giết. Cả hai đều nổ tại thời điểm `pointerup`, tức SAU khi
         mình đã quyết "đây là kéo":
           (1) `[data-aef-swipe].aef-keo * { pointer-events: none }` trong
               base.css — mọi con tàng hình ⇒ `pointerup` rơi ra khung cuộn.
               ĐÃ GỠ khỏi base.css, xem chú thích dài ở đó.
           (2) `setPointerCapture` — khung cuộn bắt con trỏ ⇒ `pointerup` bị
               ĐỔI ĐÍCH về khung cuộn, `mouseup` đi theo. Cơ chế này KHÔNG
               liên quan gì tới CSS, nên vá (1) xong nó vẫn giết y nguyên.
         Rồi trình duyệt bắn `click` vào TỔ TIÊN CHUNG GẦN NHẤT của đích
         mousedown (thẻ a) và đích mouseup (khung cuộn) ⇒ click nổ ở
         `div.row.rless`, hành vi kích hoạt của <a> KHÔNG BAO GIỜ chạy.
         Trang im hoàn toàn: không lỗi, không log, không gì cả.

         Nhật ký sự kiện đo được ở ngưỡng cũ (>3), sau khi ĐÃ gỡ (1):
             pointerdown→A#btn1
             pointerup→DIV.row.rless.aef-keo   ← vẫn chết, thủ phạm là (2)
             click→DIV.row.rless
         Gỡ class hay nhả con trỏ trong listener đều LUÔN LUÔN MUỘN: trình duyệt
         dò đích NGAY LÚC sự kiện xảy ra, listener chạy sau đó. Đây là tính chất
         của trình duyệt, không phải chuyện xếp lại thứ tự mã cho khéo.

         ⇒ Cách duy nhất đúng: đừng làm gì trong cái vùng mà khách vẫn còn đang
         BẤM. Ngưỡng kéo mặc định của Windows (`SM_CXDRAG`) là 4px, nên ngưỡng
         3px cũ hẹp hơn cả mức hệ điều hành còn coi là một cú bấm — tay hơi run
         là mất link. Nay dùng `NGUONG_KEO` cho CẢ BA việc (gắn class, bắt con
         trỏ, nuốt click) nên không còn vùng nào mà "đã giết link mà chưa tính
         là kéo". Dưới ngưỡng thì dãy không nhích — 6px là mức mắt không thấy,
         đổi lấy việc mọi cú bấm đều sống. */
      if (Math.abs(dx) > NGUONG_KEO) {
        if (!daBat) {
          daBat = true;
          if (el.setPointerCapture) { try { el.setPointerCapture(e.pointerId); } catch (_) {} }
          el.classList.add('aef-keo');
        }
        daDi = Math.max(daDi, Math.abs(dx));
        el.scrollLeft = batDauScroll - dx;
        e.preventDefault();
      }
    });

    function thaRa() {
      if (!dangKeo) return;
      dangKeo = false; daBat = false;
      el.style.scrollSnapType = snapCu;
      el.classList.remove('aef-keo');
    }
    el.addEventListener('pointerup', thaRa);
    el.addEventListener('pointercancel', thaRa);
    el.addEventListener('lostpointercapture', thaRa);

    /* Kéo xong thì cú `click` vẫn nổ, và nó sẽ mở link của ô mà khách chỉ định
       kéo qua. Nuốt đúng MỘT cú click ngay sau khi kéo. Cùng `NGUONG_KEO` với
       nhánh trên, nên hai quyết định "đây là cú kéo" không bao giờ lệch pha. */
    el.addEventListener('click', function (e) {
      if (daDi > NGUONG_KEO) { e.preventDefault(); e.stopPropagation(); }
      daDi = 0;
    }, true);
  }

  /* ── TỰ LƯỚT ───────────────────────────────────────────────────────────── */
  function ganTuLuot(el, nhip) {
    if (el.__aefAuto) return;
    el.__aefAuto = true;

    /* 🔴 "ĐANG TRONG TẦM MẮT" CHỈ CÓ MỘT NGƯỜI TRẢ LỜI — và người đó là
       IntersectionObserver ở cuối hàm. Trước đây khái niệm này KHÔNG có chỗ
       chứa: nó chỉ tồn tại trong đầu cái IO, nên mọi người gọi `chay()` khác
       (rời chuột, mất tiêu điểm, tab sáng lại, đổi prefers-reduced-motion) bật
       lại interval cho một dãy đang nằm ngoài màn hình — và IO KHÔNG bắn thêm
       lần nào để sửa, vì giao cắt có đổi đâu mà bắn. Dãy cứ tự nhảy ô dưới đáy
       trang cho tới lúc khách cuộn ngược lên và thấy nó đứng ở ô lạ.
       Mặc định `true` để nhánh KHÔNG có IntersectionObserver (:279) giữ nguyên
       hành vi cũ. [[feedback_one_concept_two_sources]] */
    var hen = null, tat = false, trongTam = true;

    function dung() { if (hen) { clearInterval(hen); hen = null; } }
    function chay() {
      if (tat || hen) return;
      /* ⛔ CHỐT NÀY NẰM TRONG `chay()`, KHÔNG nằm ở từng chỗ gọi. Vá ở chỗ gọi
         thì hôm nay đủ bốn chỗ, mai thêm chỗ thứ năm là lỗ mở lại y hệt — và
         lần trước nó mở lại đúng kiểu đó. Một cửa, mọi người đi qua cùng một
         câu hỏi. */
      if (!trongTam) return;                  /* dãy đang ngoài màn hình */
      if (itDong && itDong.matches) return;   /* máy xin ít chuyển động */
      if (el.scrollWidth <= el.clientWidth + 4) return;  /* không có gì để lướt */
      hen = setInterval(function () {
        if (document.hidden) return;
        var het = el.scrollWidth - el.clientWidth;
        /* Tới cuối thì quay về đầu — nếu không, dãy đứng im mãi và khách tưởng hỏng. */
        if (el.scrollLeft >= het - 4) cuonToi(el, 0);
        else cuonToi(el, mocDich(el) + buoc(el));
      }, nhip);
    }
    /* Khách đã tự lướt thì TẮT HẲN. Giành lái với người đang đọc là cách nhanh
       nhất khiến người ta bỏ đi. */
    function tatHan() { tat = true; dung(); }

    el.addEventListener('pointerenter', dung);
    el.addEventListener('pointerleave', function () { if (!tat) chay(); });
    el.addEventListener('focusin', dung);
    el.addEventListener('focusout', function () { if (!tat) chay(); });
    el.addEventListener('pointerdown', tatHan);
    el.addEventListener('keydown', tatHan);
    el.addEventListener('touchstart', tatHan, { passive: true });
    /* Nút mũi tên nằm NGOÀI vùng cuộn (anh em, không phải con) nên cú bấm vào
       nó không nổi lên tới đây. Section nào có nút thì bắn sự kiện này để tắt
       tự lướt — không có nó thì khách bấm mũi tên xong dãy vẫn tự chạy tiếp,
       giành lái đúng lúc khách vừa ra hiệu là họ muốn tự điều khiển. */
    el.addEventListener('aef:dung-tu-luot', tatHan);
    document.addEventListener('visibilitychange', function () { if (document.hidden) dung(); else if (!tat) chay(); });
    if (itDong && itDong.addEventListener) {
      itDong.addEventListener('change', function () { dung(); if (!tat) chay(); });
    }

    /* Chỉ chạy khi dãy thật sự nằm trong tầm mắt — lướt một thứ ngoài màn hình
       là đốt pin và làm rối bộ đọc màn hình mà không ai thấy gì. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (mm) {
        mm.forEach(function (m) {
          trongTam = m.isIntersecting;        /* NGƯỜI GHI DUY NHẤT của biến này */
          if (trongTam) { if (!tat) chay(); } else dung();
        });
      }, { threshold: 0.35 }).observe(el);
    } else { chay(); }
  }

  /* ── BÀN PHÍM ──────────────────────────────────────────────────────────── */
  /* Vùng cuộn mang `tabindex="0"` thì Chrome/Firefox ĐÃ cho mũi tên cuộn — nhưng
     theo NHỊP DÒNG (~40px), tức 4-5 lần bấm mới qua nổi một thẻ, ~60 lần bấm mới
     đi hết một dãy 14 thẻ. Nay MỘT nhịp = MỘT THẺ, đúng bằng bước của nút mũi tên
     và của cú vuốt: ba lối đi cùng một đơn vị, đo bằng `buoc()` chứ không gõ cứng.
     Home/End nhảy hai đầu.

     ⛔ `e.target !== el` là chốt BẮT BUỘC, đừng bỏ. Trong thẻ sản phẩm có ô số
     lượng, ô chọn biến thể, nút bấm — nuốt mũi tên của chúng là khách không gõ
     được số, không đổi được biến thể. Chỉ chặn khi CHÍNH khung cuộn giữ tiêu điểm. */
  function ganPhim(el) {
    if (el.__aefPhim) return;
    el.__aefPhim = true;
    el.addEventListener('keydown', function (e) {
      if (e.target !== el) return;
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      var k = e.key, di = null;
      if (k === 'ArrowRight' || k === 'Right') di = buoc(el);
      else if (k === 'ArrowLeft' || k === 'Left') di = -buoc(el);
      else if (k === 'Home') { e.preventDefault(); cuonToi(el, 0); return; }
      /* ĐÍCH của End là `scrollWidth - clientWidth`, KHÔNG phải `scrollWidth`.
         Xin quá đích rồi trông chờ trình duyệt cắt bớt thì `scroll-snap` xen vào
         giữa chừng và neo lại ở điểm neo GẦN NHẤT nó tìm được — đo trên Chrome
         1440px, dãy 14 thẻ: xin 4368 thì dừng ở 2739 trong khi đích thật là 2958,
         tức thẻ CUỐI vẫn bị cắt mất 219px và phím End không bao giờ tới được cuối. */
      else if (k === 'End') { e.preventDefault(); cuonToi(el, el.scrollWidth - el.clientWidth); return; }
      else return;
      e.preventDefault();
      cuonToi(el, mocDich(el) + di);
    });
  }

  /* ── NÚT MŨI TÊN ‹ › ───────────────────────────────────────────────────── */
  /* Ở ĐÂY chứ không chép vào từng section, cùng lý do đã ghi ở base.css:3740:
     nhiều dãy dùng CHUNG một hành vi, mà một hành vi có nhiều nguồn thì sớm muộn
     cũng lệch nhau ([[feedback_one_concept_two_sources]]).
     (sections/offerbanner.liquid còn giữ bản inline `data-ofr-nav` có trước bộ
     này — chỗ đó có `aria-roledescription="carousel"` và cách bố trí riêng, dời
     sang đây là một việc khác, không gộp tiện tay vào cùng một lần sửa.)

     Khai bằng thuộc tính, KHÔNG bằng tên class:
       data-aef-nav-scope   → vùng chứa CẢ nút lẫn dãy cuộn
       data-aef-nav="-1|1"  → nút lùi / nút tiến

     VÌ SAO TÌM DÃY LÚC BẤM chứ không ghim sẵn một id: dãy có tab (aef-rail-tabs)
     đổi hẳn phần tử `<ul>` mỗi lần khách đổi tab — nạp mới rồi CẤT/TRẢ ruột panel.
     Ghim id là bấm nút xong cuộn nhầm cái dãy đang ẩn. */
  function timDay(vung) {
    var ds = vung.querySelectorAll('[data-aef-swipe]');
    for (var i = 0; i < ds.length; i++) {
      /* `getClientRects().length` = phần tử có hộp để vẽ. Dãy nằm trong panel
         `hidden` thì rỗng ⇒ bị bỏ qua, đúng ý. Hỏi `offsetParent` thì trượt ở
         `position: fixed`; hỏi cái này thì không. */
      if (ds[i].getClientRects().length) return ds[i];
    }
    return null;
  }

  function capNhatNut(vung) {
    var nut = vung.querySelectorAll('[data-aef-nav]');
    if (!nut.length) return;
    var day = timDay(vung);
    var het = day ? (day.scrollWidth - day.clientWidth) : 0;
    for (var i = 0; i < nut.length; i++) {
      var lui = Number(nut[i].getAttribute('data-aef-nav')) < 0;
      /* Ẩn nút đã hết đường thay vì để nó bấm ra không có gì. Biên 2px: scrollLeft
         là số THỰC, so bằng nhau tuyệt đối thì cạnh phải không bao giờ khớp và nút
         "tiến" không bao giờ tắt. Không có dãy, hoặc dãy ngắn hơn khung ⇒ ẩn cả hai. */
      var con = (!day || het <= 2) ? false
        : (lui ? day.scrollLeft > 2 : day.scrollLeft < het - 2);
      nut[i].hidden = !con;
    }
  }

  function ganNut(vung) {
    var nut = vung.querySelectorAll('[data-aef-nav]');
    if (!nut.length || vung.__aefNut) return;
    vung.__aefNut = true;
    [].forEach.call(nut, function (n) {
      n.addEventListener('click', function () {
        var day = timDay(vung);
        if (!day) return;
        /* Nút nằm NGOÀI vùng cuộn (anh em, không phải con) nên cú bấm không nổi
           lên tới nó — dãy tự lướt phải được báo bằng sự kiện riêng, nếu không
           khách bấm mũi tên xong nó vẫn tự chạy tiếp, giành lái đúng lúc khách
           vừa ra hiệu là họ muốn tự điều khiển. */
        try { day.dispatchEvent(new CustomEvent('aef:dung-tu-luot')); } catch (_) {}
        cuonToi(day, mocDich(day) + buoc(day) * (Number(n.getAttribute('data-aef-nav')) < 0 ? -1 : 1));
      });
    });
  }

  function quetNut(goc) {
    (goc || document).querySelectorAll('[data-aef-nav-scope]').forEach(function (vung) {
      ganNut(vung);
      /* Cuộn tới đâu thì hai nút phải biết tới đó — kể cả khi khách vuốt tay hay
         kéo chuột chứ không bấm nút. Gắn trên CHÍNH dãy, một lần cho mỗi dãy. */
      vung.querySelectorAll('[data-aef-swipe]').forEach(function (day) {
        if (day.__aefBaoCuon) return;
        day.__aefBaoCuon = true;
        day.addEventListener('scroll', function () { capNhatNut(vung); }, { passive: true });
      });

      /* Dãy có tab THAY HẲN phần tử cuộn giữa chừng: bấm tab → khung xương (không
         có dãy nào) → hàng về → dãy mới. Nghe `scroll` là chưa đủ, vì giữa hai
         nhịp đó không có cú cuộn nào cả, và hai nút sẽ giữ nguyên trạng thái của
         TAB CŨ — chỉ ra vài trăm mili giây, nhưng đúng lúc khách đang nhìn.
         Không bắn thêm sự kiện để chữa: `aef:cards-injected` đang được người gác
         neo ở ĐÚNG 1 lần mỗi cú bấm tab, thêm một tiếng nữa là đổi hợp đồng.
         Nghe thẳng cây DOM thì đúng chỗ hơn — và tự lo cho mọi dãy khác về sau.
         Chỉ nghe `childList`: `capNhatNut` viết thuộc tính `hidden`, mà thuộc tính
         thì không nằm trong tầm nghe này ⇒ không có vòng tự kích. */
      if (!vung.__aefDoi && window.MutationObserver) {
        vung.__aefDoi = true;
        var hen = null;
        new MutationObserver(function () {
          if (hen) return;
          hen = setTimeout(function () { hen = null; capNhatNut(vung); }, 60);
        }).observe(vung, { childList: true, subtree: true });
      }

      capNhatNut(vung);
    });
  }

  function quet(goc) {
    (goc || document).querySelectorAll('[data-aef-swipe]').forEach(function (el) {
      ganKeo(el);
      ganPhim(el);
    });
    (goc || document).querySelectorAll('[data-aef-auto]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-aef-auto'), 10);
      if (n > 0) ganTuLuot(el, n);
    });
    quetNut(goc);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { quet(); });
  else quet();
  /* Theme editor dựng lại section thì DOM cũ biến mất — phải gắn lại cho DOM mới. */
  document.addEventListener('shopify:section:load', function (e) { quet(e.target); });

  /* 🔴 30/8/2026 — HAI SỰ KIỆN TRÊN KHÔNG ĐỦ, VÀ CHỖ THIẾU LÀ CHỖ ĐAU NHẤT.
     `quet()` chỉ chạy lúc dựng trang và lúc theme editor dựng lại section. Nhưng
     nhiều dãy THAY HẲN phần tử cuộn lúc chạy, bằng `innerHTML`:
       · sections/aef-rail-tabs.liquid — bấm tab 2/3/4 thì nạp ruột panel bằng
         Section Rendering API rồi `body.innerHTML = …`; và cơ chế CẤT/TRẢ ruột
         panel (`catHang`/`traHang`, chống trùng id) dựng LẠI cả tab 1 từ chuỗi.
       · assets/aef-recently-viewed.js, assets/facets.js, cart drawer… cũng vậy.
     Phần tử mới thì mọi cờ `__aefKeo` / `__aefPhim` nằm trên phần tử CŨ đã lìa
     DOM ⇒ dãy mới KHÔNG có kéo-thả, KHÔNG có mũi tên, KHÔNG có bàn phím. Đo trên
     mã: 3/4 tab của trang chủ chưa bao giờ kéo được bằng chuột, và tab 1 mất
     kéo-thả ngay lần khách quay lại nó.
     `aef:cards-injected` là HỢP ĐỒNG SẴN CÓ của theme cho đúng việc này —
     ae-delivery-widget.js dịch lại, card-stepper.js dựng lại số lượng. Bám vào
     nó chứ đừng đẻ sự kiện thứ hai cho cùng một khái niệm. Mọi hàm gắn đều có
     cờ chống trùng nên chạy lại bao nhiêu lần cũng không cộng dồn listener. */
  document.addEventListener('aef:cards-injected', function () { quet(document); });

  /* Đổi cỡ cửa sổ đổi số cột (5/4/3/2 thẻ) ⇒ dãy đang tràn có thể vừa khít, hoặc
     ngược lại. Hai nút phải tính lại, nếu không chúng đứng sai trạng thái tới lần
     cuộn kế tiếp. Chỉ tính lại trạng thái, không gắn lại gì. */
  var henNut = null;
  window.addEventListener('resize', function () {
    if (henNut) clearTimeout(henNut);
    henNut = setTimeout(function () { henNut = null; quetNut(document); }, 150);
  });
})();

;
